webpackJsonp([2],{

/***/ "./src/__shared__/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__("./src/members/state/auth/api.js");
	
	Object.keys(_api).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api[key];
	    }
	  });
	});
	
	var _api2 = __webpack_require__("./src/members/state/user/api.js");
	
	Object.keys(_api2).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api2[key];
	    }
	  });
	});
	
	var _api3 = __webpack_require__("./src/members/state/mail/api.js");
	
	Object.keys(_api3).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api3[key];
	    }
	  });
	});
	
	var _api4 = __webpack_require__("./src/members/state/chat/api.js");
	
	Object.keys(_api4).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api4[key];
	    }
	  });
	});
	
	var _api5 = __webpack_require__("./src/members/state/magazine/api.js");
	
	Object.keys(_api5).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api5[key];
	    }
	  });
	});
	
	var _api6 = __webpack_require__("./src/members/state/categories/api.js");
	
	Object.keys(_api6).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api6[key];
	    }
	  });
	});
	
	var _api7 = __webpack_require__("./src/members/state/topics/api.js");
	
	Object.keys(_api7).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api7[key];
	    }
	  });
	});
	
	var _api8 = __webpack_require__("./src/members/state/goals/api.js");
	
	Object.keys(_api8).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api8[key];
	    }
	  });
	});
	
	var _api9 = __webpack_require__("./src/members/state/journal/api.js");
	
	Object.keys(_api9).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api9[key];
	    }
	  });
	});
	
	var _api10 = __webpack_require__("./src/members/state/feedback/api.js");
	
	Object.keys(_api10).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api10[key];
	    }
	  });
	});
	
	var _api11 = __webpack_require__("./src/members/state/comments/api.js");
	
	Object.keys(_api11).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api11[key];
	    }
	  });
	});
	
	var _api12 = __webpack_require__("./src/members/state/f2f/api.js");
	
	Object.keys(_api12).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api12[key];
	    }
	  });
	});
	
	var _api13 = __webpack_require__("./src/members/state/feed/api.js");
	
	Object.keys(_api13).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api13[key];
	    }
	  });
	});
	
	var _api14 = __webpack_require__("./src/members/state/search/api.js");
	
	Object.keys(_api14).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api14[key];
	    }
	  });
	});
	
	var _api15 = __webpack_require__("./src/members/state/links/api.js");
	
	Object.keys(_api15).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api15[key];
	    }
	  });
	});
	
	var _api16 = __webpack_require__("./src/members/state/forum/api.js");
	
	Object.keys(_api16).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api16[key];
	    }
	  });
	});
	
	var _api17 = __webpack_require__("./src/members/state/localAuthorities/api.js");
	
	Object.keys(_api17).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api17[key];
	    }
	  });
	});
	exports.homePageFetch = homePageFetch;
	exports.teamMembersFetch = teamMembersFetch;
	
	var _api18 = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	function homePageFetch() {
	  return (0, _api18.callApi)('/homepage').then(function (json) {
	    return json.articles;
	  });
	}
	
	function teamMembersFetch() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { online: 'all', sort: 'alphabetical_asc' };
	
	  return (0, _api18.callApi)('/more/meet-the-team', {
	    query: {
	      online: options.online,
	      sort: options.sort,
	      limit: 1000,
	      offset: 0
	    }
	  });
	}

/***/ },

/***/ "./node_modules/redux-saga/effects.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./node_modules/redux-saga/lib/effects.js")

/***/ },

/***/ "./src/__shared__/bbCodeRemover.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (string) {
	  return string.replace(/\[\/?(?:b|i|u|url|quote|code|img|color|size)*?.*?\]/img, '');
	};

/***/ },

/***/ "./src/__shared__/quantity.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quantity;
	function quantity(count, singular, plural) {
	  if (count == 0 || count > 1) {
	    return plural;
	  }
	
	  return singular;
	}

/***/ },

/***/ "./src/members/Main/ChatBubble/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChatBubble = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/ChatBubble/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatBubble = exports.ChatBubble = function (_Component) {
	  _inherits(ChatBubble, _Component);
	
	  function ChatBubble() {
	    _classCallCheck(this, ChatBubble);
	
	    var _this = _possibleConstructorReturn(this, (ChatBubble.__proto__ || Object.getPrototypeOf(ChatBubble)).call(this));
	
	    _this.handleClicked = _this.handleClicked.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatBubble, [{
	    key: 'handleClicked',
	    value: function handleClicked() {
	      this.props.onSelected();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatBubble', onClick: this.handleClicked },
	        _react2.default.createElement('span', { className: 'icon-chat-circle' }),
	        function () {
	          if (_this2.props.showsUnreadMessagesCount) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'notification' },
	              _this2.props.unreadMessagesCount
	            );
	          }
	        }()
	      );
	    }
	  }]);
	
	  return ChatBubble;
	}(_react.Component);
	
	ChatBubble.propTypes = {
	  unreadMessagesCount: _react.PropTypes.number,
	  showsUnreadMessagesCount: _react.PropTypes.bool,
	  onSelected: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var unreadMessagesCount = (0, _selectors.getChatState)(state).unreadMessagesCount;
	
	  return {
	    unreadMessagesCount: unreadMessagesCount,
	    showsUnreadMessagesCount: unreadMessagesCount > 0
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onSelected: function onSelected() {
	      dispatch(actions.chatOpen());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatBubble);

/***/ },

/***/ "./src/members/Main/ChatResources/ChatResourcesPageSelector/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageSelector = __webpack_require__("./src/members/Main/__shared__/components/PageSelector/index.js");
	
	var _PageSelector2 = _interopRequireDefault(_PageSelector);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatResourcesPageSelector = function ChatResourcesPageSelector(props) {
	  return _react2.default.createElement(_PageSelector2.default, props);
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return (0, _selectors.getChatPaging)(state, 'chatResources');
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onPrevClick: function onPrevClick(currentPage) {
	      dispatch(actions.chatResourcesFetch(currentPage - 1));
	    },
	    onNextClick: function onNextClick(currentPage) {
	      dispatch(actions.chatResourcesFetch(currentPage + 1));
	    },
	    onPossiblePageUpdate: function onPossiblePageUpdate(newPossiblePage) {
	      dispatch(actions.chatResourcesUpdatePossiblePage(newPossiblePage));
	    },
	    onPageUpdate: function onPageUpdate(newPage, pagesCount) {
	      if (newPage >= 1 && newPage <= pagesCount) {
	        dispatch(actions.chatResourcesFetch(newPage));
	      }
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatResourcesPageSelector);

/***/ },

/***/ "./src/members/Main/ChatResources/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("./src/members/Main/ChatResources/style.scss");
	
	var _ResourcesList = __webpack_require__("./src/members/Main/__shared__/components/ResourcesList/index.js");
	
	var _ResourcesList2 = _interopRequireDefault(_ResourcesList);
	
	var _Resource = __webpack_require__("./src/members/Main/__shared__/components/ResourcesList/Resource/index.js");
	
	var _Resource2 = _interopRequireDefault(_Resource);
	
	var _ResourcesListLoading = __webpack_require__("./src/members/Main/__shared__/components/ResourcesListLoading/index.js");
	
	var _ResourcesListLoading2 = _interopRequireDefault(_ResourcesListLoading);
	
	var _ChatResourcesPageSelector = __webpack_require__("./src/members/Main/ChatResources/ChatResourcesPageSelector/index.js");
	
	var _ChatResourcesPageSelector2 = _interopRequireDefault(_ChatResourcesPageSelector);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatResources = function (_Component) {
	  _inherits(ChatResources, _Component);
	
	  function ChatResources() {
	    _classCallCheck(this, ChatResources);
	
	    return _possibleConstructorReturn(this, (ChatResources.__proto__ || Object.getPrototypeOf(ChatResources)).apply(this, arguments));
	  }
	
	  _createClass(ChatResources, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onFetchCurrentPage();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'content-wrapper has-background' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            "Chat resources"
	          ),
	          function () {
	            if (_this2.props.chatResources.length > 0) {
	              return _react2.default.createElement(
	                _ResourcesList2.default,
	                { showsAll: true },
	                _this2.props.chatResources.map(function (chatResource) {
	                  var key = chatResource.sentAt + '_' + chatResource.data.url;
	
	                  return _react2.default.createElement(_Resource2.default, {
	                    key: key,
	                    title: chatResource.metadata.title,
	                    authorName: chatResource.sender,
	                    since: (0, _moment2.default)(chatResource.sentAt).fromNow(),
	                    isWebsite: true,
	                    url: chatResource.data.url
	                  });
	                })
	              );
	            } else if (_this2.props.isFetching) {
	              return _react2.default.createElement(_ResourcesListLoading2.default, null);
	            }
	          }()
	        ),
	        function () {
	          if (_this2.props.showsPageSelector) {
	            return _react2.default.createElement(_ChatResourcesPageSelector2.default, null);
	          }
	        }()
	      );
	    }
	  }]);
	
	  return ChatResources;
	}(_react.Component);
	
	ChatResources.propTypes = {
	  pagesCount: _react.PropTypes.number,
	  isFetching: _react.PropTypes.bool,
	  chatResources: _react.PropTypes.arrayOf(_entities.ChatResourceShape),
	  page: _react.PropTypes.number,
	  onFetchCurrentPage: _react.PropTypes.func,
	  showsPageSelector: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _getChatPaging = (0, _selectors.getChatPaging)(state, 'chatResources'),
	      page = _getChatPaging.page,
	      isFetching = _getChatPaging.isFetching,
	      pagesCount = _getChatPaging.pagesCount;
	
	  return {
	    chatResources: (0, _selectors.getChatResources)(state, { page: page }),
	    isFetching: isFetching,
	    pagesCount: pagesCount,
	    page: page,
	    showsPageSelector: pagesCount > 1
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onFetchCurrentPage: function onFetchCurrentPage() {
	      dispatch(actions.chatResourcesFetch());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatResources);

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatFeedback/ChatFeedbackQuestion/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/ChatWindow/ChatFeedback/ChatFeedbackQuestion/style.scss");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatFeedbackQuestion = function ChatFeedbackQuestion(props) {
	  var name = props.question.id;
	
	  function handleLabelClick(answerId, answerValue) {
	    props.onAnswer(props.question, answerId, answerValue);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ChatFeedbackQuestion' },
	    _react2.default.createElement(
	      'h5',
	      null,
	      props.question.text
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'choose row align-justify' },
	      props.question.options.map(function (option) {
	        return _react2.default.createElement(
	          'div',
	          { key: props.question.id + '_' + option.id, className: 'column option' },
	          _react2.default.createElement('input', {
	            type: 'radio',
	            name: name,
	            id: name + '-' + option.id,
	            value: option.value,
	            checked: props.question.answer === option.id,
	            onChange: function onChange() {} }),
	          _react2.default.createElement(
	            'label',
	            { className: 'answer', htmlFor: name, onClick: function onClick() {
	                return handleLabelClick(option.id, option.value);
	              } },
	            option.text
	          )
	        );
	      })
	    )
	  );
	};
	
	ChatFeedbackQuestion.propTypes = {
	  question: _entities.QuestionShape,
	  onAnswer: _react.PropTypes.func
	};
	
	exports.default = ChatFeedbackQuestion;

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatFeedback/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChatFeedback = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ChatFeedbackQuestion = __webpack_require__("./src/members/Main/ChatWindow/ChatFeedback/ChatFeedbackQuestion/index.js");
	
	var _ChatFeedbackQuestion2 = _interopRequireDefault(_ChatFeedbackQuestion);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	__webpack_require__("./src/members/Main/ChatWindow/ChatFeedback/style.scss");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatFeedback = exports.ChatFeedback = function ChatFeedback(props) {
	
	  function handleSubmit(event) {
	    event.preventDefault();
	
	    if (props.canSubmit) {
	      props.onSubmit(props.questionnaire);
	    }
	  }
	
	  function handleAnswer(question, answerId, answerValue) {
	    if (!props.isSubmitting) {
	      props.onQuestionAnswer(props.questionnaire, question, answerId, answerValue);
	    }
	  }
	
	  function handleCloseClick(event) {
	    event.preventDefault();
	    props.onClose(props.questionnaire);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ChatFeedback' },
	    _react2.default.createElement(
	      'div',
	      { className: 'head' },
	      _react2.default.createElement(
	        _Link2.default,
	        { to: '_', onClick: handleCloseClick, iconName: 'search-close' },
	        "Back"
	      ),
	      _react2.default.createElement(
	        'h4',
	        null,
	        "Session feedback"
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper-full' },
	      _react2.default.createElement(
	        'div',
	        { className: 'questions-list' },
	        _react2.default.createElement(
	          'form',
	          null,
	          function () {
	            if (props.questionnaire) {
	              return props.questionnaire.questions.map(function (question) {
	                return _react2.default.createElement(_ChatFeedbackQuestion2.default, { key: question.id, onAnswer: handleAnswer, question: question });
	              });
	            }
	          }(),
	          _react2.default.createElement(
	            _Button2.default,
	            { isDisabled: !props.canSubmit || props.isSubmitting, isYellow: true, onClick: handleSubmit },
	            props.isSubmitting ? "Submitting..." : "Submit"
	          )
	        )
	      )
	    )
	  );
	};
	
	ChatFeedback.propTypes = {
	  questionnaire: _entities.QuestionnaireShape,
	  onQuestionAnswer: _react.PropTypes.func,
	  onSubmit: _react.PropTypes.func,
	  onClose: _react.PropTypes.func,
	  canSubmit: _react.PropTypes.bool,
	  isSubmitting: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    questionnaire: (0, _selectors.getChatQuestionnaire)(state, 'eos'),
	    canSubmit: (0, _selectors.getChatFeedbackIsFilled)(state),
	    isSubmitting: (0, _selectors.getChatFeedbackSubmission)(state).isSubmitting
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onQuestionAnswer: function onQuestionAnswer(questionnaire, question, answer, value) {
	      dispatch(actions.chatQuestionUpdate(questionnaire.id, question.id, { answer: answer, value: value }));
	    },
	    onSubmit: function onSubmit(questionnaire) {
	      dispatch(actions.chatQuestionnaireSubmit(questionnaire));
	    },
	    onClose: function onClose(questionnaire) {
	      dispatch(actions.chatQuestionnaireUpdate(questionnaire.id, { declined: true }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatFeedback);

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/ChatDocument/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/ChatWindow/ChatItems/ChatDocument/style.scss");
	
	var _DetailLabel = __webpack_require__("./src/members/Main/__shared__/components/DetailLabel/index.js");
	
	var _DetailLabel2 = _interopRequireDefault(_DetailLabel);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatDocument = function (_Component) {
	  _inherits(ChatDocument, _Component);
	
	  function ChatDocument() {
	    _classCallCheck(this, ChatDocument);
	
	    return _possibleConstructorReturn(this, (ChatDocument.__proto__ || Object.getPrototypeOf(ChatDocument)).apply(this, arguments));
	  }
	
	  _createClass(ChatDocument, [{
	    key: 'render',
	    value: function render() {
	      var chatDocument = this.props.chatDocument;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatResource ChatDocument' },
	        _react2.default.createElement(
	          'div',
	          { className: 'preview' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'a',
	              { className: 'Link', target: '_blank', href: chatDocument.url },
	              chatDocument.name
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _DetailLabel2.default,
	          null,
	          "File added to your chat resources."
	        )
	      );
	    }
	  }]);
	
	  return ChatDocument;
	}(_react.Component);
	
	ChatDocument.propTypes = {
	  chatDocument: _entities.ChatDocumentShape
	};
	
	exports.default = ChatDocument;

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/ChatGoals/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	__webpack_require__("./src/members/Main/ChatWindow/ChatItems/ChatGoals/style.scss");
	
	var _DetailLabel = __webpack_require__("./src/members/Main/__shared__/components/DetailLabel/index.js");
	
	var _DetailLabel2 = _interopRequireDefault(_DetailLabel);
	
	var _Goals = __webpack_require__("./src/members/Main/__shared__/containers/Goals/index.js");
	
	var _Goals2 = _interopRequireDefault(_Goals);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatGoals = function (_Component) {
	  _inherits(ChatGoals, _Component);
	
	  function ChatGoals() {
	    _classCallCheck(this, ChatGoals);
	
	    return _possibleConstructorReturn(this, (ChatGoals.__proto__ || Object.getPrototypeOf(ChatGoals)).apply(this, arguments));
	  }
	
	  _createClass(ChatGoals, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatResource ChatGoals' },
	        _react2.default.createElement(
	          'div',
	          { className: 'preview' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(_Goals2.default, { goals: this.props.goals, source: ("USER_CHAT") })
	          )
	        ),
	        _react2.default.createElement(
	          _DetailLabel2.default,
	          null,
	          (0, _moment2.default)(this.props.lastUpdated).fromNow()
	        )
	      );
	    }
	  }]);
	
	  return ChatGoals;
	}(_react.Component);
	
	ChatGoals.propTypes = {
	  lastRefresh: _react.PropTypes.object,
	  lastUpdated: _react.PropTypes.object,
	  goals: _react.PropTypes.arrayOf(_entities.GoalShape)
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var goalsUpdates = ownProps.goals.map(function (goal) {
	    return goal.updatedAt;
	  });
	  goalsUpdates.sort(function (date1, date2) {
	    return date2 - date1;
	  });
	
	  return {
	    lastUpdated: goalsUpdates[0]
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatGoals);

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/ChatMessage/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	__webpack_require__("./src/members/Main/ChatWindow/ChatItems/ChatMessage/style.scss");
	
	var _DetailLabel = __webpack_require__("./src/members/Main/__shared__/components/DetailLabel/index.js");
	
	var _DetailLabel2 = _interopRequireDefault(_DetailLabel);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatMessage = function (_Component) {
	  _inherits(ChatMessage, _Component);
	
	  function ChatMessage() {
	    _classCallCheck(this, ChatMessage);
	
	    return _possibleConstructorReturn(this, (ChatMessage.__proto__ || Object.getPrototypeOf(ChatMessage)).apply(this, arguments));
	  }
	
	  _createClass(ChatMessage, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var chatMessage = this.props.chatMessage;
	
	      var className = (0, _classnames2.default)('ChatMessage', {
	        'by-counsellor': chatMessage.fromCounsellor,
	        'by-user': !chatMessage.fromCounsellor
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        function () {
	          if (_this2.props.avatarImageUrl) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'avatar' },
	              _react2.default.createElement(_UserAvatar2.default, { hasImage: true, imageUrl: _this2.props.avatarImageUrl })
	            );
	          }
	        }(),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bubble' },
	            this.props.children
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'meta' },
	            _react2.default.createElement(
	              _DetailLabel2.default,
	              null,
	              (0, _moment2.default)(chatMessage.createdAt).fromNow()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChatMessage;
	}(_react.Component);
	
	ChatMessage.propTypes = {
	  chatMessage: _entities.ChatMessageShape,
	  avatarImageUrl: _react.PropTypes.string,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.arrayOf(_react.PropTypes.node)])
	};
	
	exports.default = ChatMessage;

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/ChatQuestionnaire/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _Questionnaire = __webpack_require__("./src/members/Main/__shared__/components/Questionnaire/index.js");
	
	var _Questionnaire2 = _interopRequireDefault(_Questionnaire);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    lastUpdated: ownProps.questionnaire.updatedAt
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onQuestionAnswer: function onQuestionAnswer(questionnaire, question, answer, value) {
	      dispatch(actions.chatQuestionUpdate(questionnaire.id, question.id, { answer: answer, value: value }));
	      dispatch(actions.chatQuestionnaireUpdate(questionnaire.id, { updatedAt: new Date() }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Questionnaire2.default);

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/ChatWebsite/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/ChatWindow/ChatItems/ChatWebsite/style.scss");
	
	var _DetailLabel = __webpack_require__("./src/members/Main/__shared__/components/DetailLabel/index.js");
	
	var _DetailLabel2 = _interopRequireDefault(_DetailLabel);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatWebsite = function (_Component) {
	  _inherits(ChatWebsite, _Component);
	
	  function ChatWebsite() {
	    _classCallCheck(this, ChatWebsite);
	
	    return _possibleConstructorReturn(this, (ChatWebsite.__proto__ || Object.getPrototypeOf(ChatWebsite)).apply(this, arguments));
	  }
	
	  _createClass(ChatWebsite, [{
	    key: 'render',
	    value: function render() {
	      var chatWebsite = this.props.chatWebsite;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatResource ChatWebsite' },
	        _react2.default.createElement(
	          'div',
	          { className: 'preview' },
	          function () {
	            if (chatWebsite.image) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'image' },
	                _react2.default.createElement('img', { src: chatWebsite.image })
	              );
	            }
	          }(),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            function () {
	              if (chatWebsite) {
	                return _react2.default.createElement(
	                  'h5',
	                  null,
	                  chatWebsite.title
	                );
	              }
	            }(),
	            function () {
	              if (chatWebsite.description) {
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  chatWebsite.description
	                );
	              }
	            }(),
	            _react2.default.createElement(
	              'p',
	              { className: 'url' },
	              chatWebsite.url
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'Link', href: chatWebsite.url, target: '_blank' },
	            '\xA0'
	          )
	        ),
	        _react2.default.createElement(
	          _DetailLabel2.default,
	          null,
	          "Link added to your chat resources."
	        )
	      );
	    }
	  }]);
	
	  return ChatWebsite;
	}(_react.Component);
	
	ChatWebsite.propTypes = {
	  chatWebsite: _entities.ChatWebsiteShape
	};
	
	exports.default = ChatWebsite;

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFlipMove = __webpack_require__("./node_modules/react-flip-move/lib/index.js");
	
	var _reactFlipMove2 = _interopRequireDefault(_reactFlipMove);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reactEmojione = __webpack_require__("./node_modules/react-emojione/lib/react-emojione.js");
	
	var _ChatMessage = __webpack_require__("./src/members/Main/ChatWindow/ChatItems/ChatMessage/index.js");
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _ChatGoals = __webpack_require__("./src/members/Main/ChatWindow/ChatItems/ChatGoals/index.js");
	
	var _ChatGoals2 = _interopRequireDefault(_ChatGoals);
	
	var _ChatWebsite = __webpack_require__("./src/members/Main/ChatWindow/ChatItems/ChatWebsite/index.js");
	
	var _ChatWebsite2 = _interopRequireDefault(_ChatWebsite);
	
	var _ChatDocument = __webpack_require__("./src/members/Main/ChatWindow/ChatItems/ChatDocument/index.js");
	
	var _ChatDocument2 = _interopRequireDefault(_ChatDocument);
	
	var _ChatQuestionnaire = __webpack_require__("./src/members/Main/ChatWindow/ChatItems/ChatQuestionnaire/index.js");
	
	var _ChatQuestionnaire2 = _interopRequireDefault(_ChatQuestionnaire);
	
	__webpack_require__("./src/members/Main/ChatWindow/ChatItems/style.scss");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatItems = function (_Component) {
	  _inherits(ChatItems, _Component);
	
	  function ChatItems() {
	    _classCallCheck(this, ChatItems);
	
	    return _possibleConstructorReturn(this, (ChatItems.__proto__ || Object.getPrototypeOf(ChatItems)).apply(this, arguments));
	  }
	
	  _createClass(ChatItems, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.chatItems.length !== this.props.chatItems.length) {
	        this.refs.chatItemsContainer.scrollTop = this.refs.chatItemsContainer.scrollHeight;
	      }
	    }
	  }, {
	    key: 'renderChatItems',
	    value: function renderChatItems() {
	      var _this2 = this;
	
	      return this.props.chatItems.map(function (chatItem) {
	        var chatMessage = chatItem.chatMessage,
	            chatDocument = chatItem.chatDocument,
	            chatWebsite = chatItem.chatWebsite,
	            goals = chatItem.goals,
	            chatQuestionnaire = chatItem.chatQuestionnaire;
	
	
	        if (chatMessage) {
	          return _react2.default.createElement(
	            _ChatMessage2.default,
	            {
	              key: chatMessage.id,
	              chatMessage: chatMessage,
	              avatarImageUrl: chatMessage.fromCounsellor ? _this2.props.counsellorAvatarImageURL : null },
	            (0, _reactEmojione.emojify)(chatMessage.text, { output: 'unicode' })
	          );
	        } else if (chatDocument) {
	          return _react2.default.createElement(_ChatDocument2.default, { key: chatDocument.id, chatDocument: chatDocument });
	        } else if (chatWebsite) {
	          return _react2.default.createElement(_ChatWebsite2.default, { key: chatWebsite.id, chatWebsite: chatWebsite });
	        } else if (goals) {
	          return _react2.default.createElement(_ChatGoals2.default, { key: 'chatGoals', lastRefresh: _this2.props.lastRefresh, goals: goals });
	        } else if (chatQuestionnaire) {
	          return _react2.default.createElement(_ChatQuestionnaire2.default, { key: chatQuestionnaire.id, lastRefresh: _this2.props.lastRefresh, questionnaire: chatQuestionnaire });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatItems', ref: 'chatItemsContainer' },
	        _react2.default.createElement(
	          _reactFlipMove2.default,
	          { duration: 200, enterAnimation: 'fade', leaveAnimation: 'fade' },
	          this.renderChatItems()
	        )
	      );
	    }
	  }]);
	
	  return ChatItems;
	}(_react.Component);
	
	ChatItems.propTypes = {
	  chatItems: _react.PropTypes.arrayOf(_entities.ChatItemShape),
	  counsellorAvatarImageURL: _react.PropTypes.string,
	  lastRefresh: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    chatItems: (0, _selectors.getChatItems)(state),
	    lastRefresh: (0, _selectors.getTimeLastRefresh)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatItems);

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatTextInput/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChatTextInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reactAutosizeTextarea = __webpack_require__("./node_modules/react-autosize-textarea/index.js");
	
	var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Emojis = __webpack_require__("./src/members/Main/__shared__/components/Emojis/index.js");
	
	var _Emojis2 = _interopRequireDefault(_Emojis);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	__webpack_require__("./src/members/Main/ChatWindow/ChatTextInput/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatTextInput = exports.ChatTextInput = function (_Component) {
	  _inherits(ChatTextInput, _Component);
	
	  function ChatTextInput() {
	    _classCallCheck(this, ChatTextInput);
	
	    var _this = _possibleConstructorReturn(this, (ChatTextInput.__proto__ || Object.getPrototypeOf(ChatTextInput)).call(this));
	
	    _this.pendingCaretPosition = -1;
	
	    _this.handleTextAreaKeyPress = _this.handleTextAreaKeyPress.bind(_this);
	    _this.handleMessageTextChange = _this.handleMessageTextChange.bind(_this);
	    _this.handleSendClick = _this.handleSendClick.bind(_this);
	    _this.handleEmojisClick = _this.handleEmojisClick.bind(_this);
	    _this.handleEmojiSelected = _this.handleEmojiSelected.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatTextInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.isDisabled && !nextProps.isDisabled) {
	        this.focusIfNecessary();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.pendingCaretPosition > 0) {
	        this.refs.textarea.getTextareaDOMNode().selectionStart = this.pendingCaretPosition;
	        this.refs.textarea.getTextareaDOMNode().selectionEnd = this.pendingCaretPosition;
	        this.pendingCaretPosition = -1;
	      }
	
	      if (!prevProps.isChatOpened && this.props.isChatOpened) {
	        // A bad hack to focus the input as we don't know when the animation ends (it won't focus if not in viewport).
	        setTimeout(function () {
	          _this2.focusIfNecessary();
	        }, 200);
	      }
	    }
	  }, {
	    key: 'focusIfNecessary',
	    value: function focusIfNecessary() {
	      if (window.innerWidth > (768)) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.refs.textarea.getTextareaDOMNode().focus();
	    }
	  }, {
	    key: 'handleTextAreaKeyPress',
	    value: function handleTextAreaKeyPress(event) {
	      if (event.charCode === 13) {
	        event.preventDefault();
	
	        if (this.props.canSend) {
	          this.props.onAddMessage(this.props.chatMessageText);
	        }
	      }
	    }
	  }, {
	    key: 'handleMessageTextChange',
	    value: function handleMessageTextChange(event) {
	      var messageText = event.target.value;
	      var isWritingNow = messageText.length > 0;
	
	      this.props.onMessageTextChange(messageText);
	
	      if (isWritingNow !== this.props.isUserWriting) {
	        this.props.onMessageUpdateWritingIndicator(isWritingNow);
	      }
	    }
	  }, {
	    key: 'handleSendClick',
	    value: function handleSendClick(event) {
	      event.preventDefault();
	
	      if (this.props.canSend) {
	        this.props.onAddMessage(this.props.chatMessageText);
	      }
	    }
	  }, {
	    key: 'handleEmojisClick',
	    value: function handleEmojisClick(event) {
	      event.preventDefault();
	
	      if (!this.props.isDisabled) {
	        this.props.onEmojisToggle(this.props.showsEmojis);
	      }
	    }
	  }, {
	    key: 'handleEmojiSelected',
	    value: function handleEmojiSelected(shortName) {
	      this.pendingCaretPosition = this.getTextSelectionStart();
	      this.props.onEmojiSelected(this.props.chatMessageText, shortName, this.pendingCaretPosition);
	      this.focus();
	    }
	  }, {
	    key: 'getTextSelectionStart',
	    value: function getTextSelectionStart() {
	      return this.refs.textarea.getTextareaDOMNode().selectionStart;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatTextInput' },
	        _react2.default.createElement(
	          'div',
	          { className: 'textbox-holder' },
	          _react2.default.createElement(
	            'form',
	            null,
	            _react2.default.createElement(_reactAutosizeTextarea2.default, {
	              ref: 'textarea',
	              value: this.props.chatMessageText,
	              disabled: this.props.isDisabled,
	              placeholder: "Send a message...",
	              onChange: this.handleMessageTextChange,
	              onKeyPress: this.handleTextAreaKeyPress })
	          )
	        ),
	        _react2.default.createElement(
	          _Link2.default,
	          { isDisabled: this.props.isDisabled, iconName: 'emoji', onClick: this.handleEmojisClick },
	          "Emoji"
	        ),
	        _react2.default.createElement(
	          _Link2.default,
	          { isDisabled: !this.props.canSend, onClick: this.handleSendClick, iconName: 'send' },
	          "Send"
	        ),
	        _react2.default.createElement(_Emojis2.default, { isVisible: this.props.showsEmojis, onEmojiSelected: this.handleEmojiSelected })
	      );
	    }
	  }]);
	
	  return ChatTextInput;
	}(_react.Component);
	
	ChatTextInput.propTypes = {
	  onMessageUpdateWritingIndicator: _react.PropTypes.func,
	  onMessageTextChange: _react.PropTypes.func,
	  chatMessageText: _react.PropTypes.string,
	  onAddMessage: _react.PropTypes.func,
	  isDisabled: _react.PropTypes.bool,
	  canSend: _react.PropTypes.bool,
	  isChatOpened: _react.PropTypes.bool,
	  isUserWriting: _react.PropTypes.bool,
	  showsEmojis: _react.PropTypes.bool,
	  onEmojisToggle: _react.PropTypes.func,
	  onEmojiSelected: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var textEditingState = (0, _selectors.getChatTextEditing)(state, 'chatMessage');
	  var chatMessageText = textEditingState.text;
	
	  return {
	    chatMessageText: chatMessageText,
	    canSend: chatMessageText.length > 0,
	    isChatOpened: (0, _selectors.getChatState)(state).isOpened,
	    isUserWriting: (0, _selectors.getChatWritingIndicator)(state),
	    showsEmojis: (0, _selectors.getChatEmojis)(state, 'chatMessage').areVisible
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onMessageTextChange: function onMessageTextChange(text) {
	      dispatch(actions.chatMessageEditingUpdateText({ text: text }));
	    },
	    onAddMessage: function onAddMessage(text) {
	      dispatch(actions.chatMessageAdd(text));
	      dispatch(actions.chatMessageUpdateWritingIndicator(false));
	    },
	    onMessageUpdateWritingIndicator: function onMessageUpdateWritingIndicator(isWriting) {
	      dispatch(actions.chatMessageUpdateWritingIndicator(isWriting));
	    },
	    onEmojisToggle: function onEmojisToggle(showsEmojis) {
	      if (!showsEmojis) {
	        dispatch(actions.chatEmojisShow('chatMessage'));
	      } else {
	        dispatch(actions.chatEmojisHide('chatMessage'));
	      }
	    },
	    onEmojiSelected: function onEmojiSelected(text, emojiShortName, selectionStart) {
	      dispatch(actions.chatMessageEditingUpdateText({ text: text, emojiShortName: emojiShortName, selectionStart: selectionStart }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatTextInput);

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatWritingIndicator/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/ChatWindow/ChatWritingIndicator/styles.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*eslint-disable react/no-danger*/
	var ChatWritingIndicator = function ChatWritingIndicator(props) {
	  var counsellorName = props.counsellorName,
	      isVisible = props.isVisible;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ChatWritingIndicator' },
	    isVisible && _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: '<strong>' + counsellorName + '</strong> is typing' } })
	  );
	};
	
	ChatWritingIndicator.propTypes = {
	  isVisible: _react.PropTypes.bool,
	  counsellorName: _react.PropTypes.string
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var chatActiveState = (0, _selectors.getChatActiveState)(state);
	  var isVisible = chatActiveState.counsellorWriting === true;
	  var counsellorName = chatActiveState.counsellor && chatActiveState.counsellor.userName;
	
	  return {
	    isVisible: isVisible,
	    counsellorName: counsellorName
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatWritingIndicator);

/***/ },

/***/ "./src/members/Main/ChatWindow/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChatWindow = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	__webpack_require__("./src/members/Main/ChatWindow/style.scss");
	
	var _ChatFeedback = __webpack_require__("./src/members/Main/ChatWindow/ChatFeedback/index.js");
	
	var _ChatFeedback2 = _interopRequireDefault(_ChatFeedback);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _ChatTextInput = __webpack_require__("./src/members/Main/ChatWindow/ChatTextInput/index.js");
	
	var _ChatTextInput2 = _interopRequireDefault(_ChatTextInput);
	
	var _ChatItems = __webpack_require__("./src/members/Main/ChatWindow/ChatItems/index.js");
	
	var _ChatItems2 = _interopRequireDefault(_ChatItems);
	
	var _ChatWritingIndicator = __webpack_require__("./src/members/Main/ChatWindow/ChatWritingIndicator/index.js");
	
	var _ChatWritingIndicator2 = _interopRequireDefault(_ChatWritingIndicator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatWindow = exports.ChatWindow = function (_Component) {
	  _inherits(ChatWindow, _Component);
	
	  function ChatWindow() {
	    _classCallCheck(this, ChatWindow);
	
	    var _this = _possibleConstructorReturn(this, (ChatWindow.__proto__ || Object.getPrototypeOf(ChatWindow)).call(this));
	
	    _this.handleMinimize = _this.handleMinimize.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatWindow, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.isMinimized !== this.props.isMinimized) {
	        // better scrolling for mobile chat
	        var addOrRemove = this.props.isMinimized ? 'remove' : 'add';
	        document.documentElement.classList[addOrRemove]('chat-visible');
	      }
	    }
	  }, {
	    key: 'handleMinimize',
	    value: function handleMinimize() {
	      this.props.onMinimize();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var className = (0, _classnames2.default)('ChatWindow', {
	        'is-minimised': this.props.isMinimized,
	        'has-emoji-visible': this.props.showsEmojis
	      });
	
	      var counsellorName = this.props.counsellor && this.props.counsellor.userName;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'chatHeader' },
	          _react2.default.createElement('span', { className: 'icon-minus', onClick: this.handleMinimize }),
	          function () {
	            if (_this2.props.isLoading) {
	              return _react2.default.createElement(
	                'h5',
	                null,
	                "Loading..."
	              );
	            }
	
	            return _react2.default.createElement(
	              'h5',
	              null,
	              'Chat with ' + counsellorName
	            );
	          }()
	        ),
	        _react2.default.createElement(_ChatItems2.default, { counsellorAvatarImageURL: this.props.counsellor ? this.props.counsellor.avatar.url : null }),
	        _react2.default.createElement(_ChatTextInput2.default, { isDisabled: this.props.isLoading }),
	        _react2.default.createElement(_ChatWritingIndicator2.default, null),
	        function () {
	          if (_this2.props.isWaitingForFeedback) {
	            return _react2.default.createElement(_ChatFeedback2.default, null);
	          }
	        }()
	      );
	    }
	  }]);
	
	  return ChatWindow;
	}(_react.Component);
	
	ChatWindow.propTypes = {
	  isMinimized: _react.PropTypes.bool,
	  onMinimize: _react.PropTypes.func,
	  counsellor: _react.PropTypes.object,
	  isLoading: _react.PropTypes.bool,
	  isWaitingForFeedback: _react.PropTypes.bool,
	  updatedFromNewChatItem: _react.PropTypes.bool,
	  showsEmojis: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var chatState = (0, _selectors.getChatState)(state);
	  var chatItems = (0, _selectors.getChatItems)(state);
	  var counsellor = (0, _selectors.getChatActiveState)(state).counsellor;
	
	  return {
	    isMinimized: (!chatState.isOpened || !chatState.isActive) && !chatState.isWaitingForFeedback,
	    counsellor: counsellor,
	    isLoading: chatItems.length === 0 || !counsellor,
	    isWaitingForFeedback: chatState.isWaitingForFeedback,
	    showsEmojis: (0, _selectors.getChatEmojis)(state, 'chatMessage').areVisible
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onMinimize: function onMinimize() {
	      dispatch(actions.chatClose());
	    },
	    onMessageTextChange: function onMessageTextChange(text) {
	      dispatch(actions.chatMessageEditingUpdateText({ text: text }));
	    },
	    onAddMessage: function onAddMessage(text) {
	      dispatch(actions.chatMessageAdd(text));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatWindow);

/***/ },

/***/ "./src/members/Main/Feed/FeedButtonItem/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactAddonsShallowCompare = __webpack_require__("./node_modules/react-addons-shallow-compare/index.js");
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	__webpack_require__("./src/members/Main/Feed/FeedButtonItem/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedButtonItem = function (_Component) {
	  _inherits(FeedButtonItem, _Component);
	
	  function FeedButtonItem() {
	    _classCallCheck(this, FeedButtonItem);
	
	    return _possibleConstructorReturn(this, (FeedButtonItem.__proto__ || Object.getPrototypeOf(FeedButtonItem)).apply(this, arguments));
	  }
	
	  _createClass(FeedButtonItem, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          text = _props.text,
	          button = _props.button,
	          to = _props.to;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'FeedButtonItem' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          text
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { isYellow: true, to: to },
	          button
	        )
	      );
	    }
	  }]);
	
	  return FeedButtonItem;
	}(_react.Component);
	
	FeedButtonItem.propTypes = {
	  title: _react.PropTypes.string,
	  text: _react.PropTypes.string,
	  button: _react.PropTypes.string,
	  to: _react.PropTypes.string
	};
	
	exports.default = FeedButtonItem;

/***/ },

/***/ "./src/members/Main/Feed/FeedGoals/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Goals = __webpack_require__("./src/members/Main/__shared__/containers/Goals/index.js");
	
	var _Goals2 = _interopRequireDefault(_Goals);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	__webpack_require__("./src/members/Main/Feed/FeedGoals/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeedGoals = function FeedGoals(props) {
	  var title = props.title,
	      goals = props.goals;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'FeedGoals' },
	    _react2.default.createElement(
	      'h4',
	      null,
	      title
	    ),
	    _react2.default.createElement(_Goals2.default, { goals: goals, source: ("USER_FEED") })
	  );
	};
	
	FeedGoals.propTypes = {
	  title: _react.PropTypes.string,
	  goals: _react.PropTypes.arrayOf(_entities.GoalShape)
	};
	
	exports.default = FeedGoals;

/***/ },

/***/ "./src/members/Main/Feed/FeedInfiniteLoader/PersistedCellSizeCache.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PersistedCellSizeCache = function () {
	  function PersistedCellSizeCache() {
	    _classCallCheck(this, PersistedCellSizeCache);
	
	    this.rowHeightCache = {};
	    this.columnWidthCache = {};
	  }
	
	  // method to manually clear all caches
	
	
	  _createClass(PersistedCellSizeCache, [{
	    key: "clearCaches",
	    value: function clearCaches() {
	      this.rowHeightCache = {};
	      this.columnWidthCache = {};
	    }
	  }, {
	    key: "clearAllColumnWidths",
	    value: function clearAllColumnWidths() {}
	  }, {
	    key: "clearAllRowHeights",
	    value: function clearAllRowHeights() {}
	  }, {
	    key: "clearColumnWidth",
	    value: function clearColumnWidth() {}
	  }, {
	    key: "clearRowHeight",
	    value: function clearRowHeight() {}
	  }, {
	    key: "getColumnWidth",
	    value: function getColumnWidth(index) {
	      return this.columnWidthCache[index];
	    }
	  }, {
	    key: "getRowHeight",
	    value: function getRowHeight(index) {
	      return this.rowHeightCache[index];
	    }
	  }, {
	    key: "hasColumnWidth",
	    value: function hasColumnWidth(index) {
	      return this.columnWidthCache[index];
	    }
	  }, {
	    key: "hasRowHeight",
	    value: function hasRowHeight(index) {
	      return this.rowHeightCache[index];
	    }
	  }, {
	    key: "setColumnWidth",
	    value: function setColumnWidth(index, value) {
	      this.columnWidthCache[index] = value;
	    }
	  }, {
	    key: "setRowHeight",
	    value: function setRowHeight(index, value) {
	      this.rowHeightCache[index] = value;
	    }
	  }]);
	
	  return PersistedCellSizeCache;
	}();
	
	var cache = new PersistedCellSizeCache();
	exports.default = cache;

/***/ },

/***/ "./src/members/Main/Feed/FeedInfiniteLoader/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__("./node_modules/react-virtualized/dist/commonjs/index.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _PersistedCellSizeCache = __webpack_require__("./src/members/Main/Feed/FeedInfiniteLoader/PersistedCellSizeCache.js");
	
	var _PersistedCellSizeCache2 = _interopRequireDefault(_PersistedCellSizeCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedInfiniteLoader = function (_Component) {
	  _inherits(FeedInfiniteLoader, _Component);
	
	  function FeedInfiniteLoader() {
	    _classCallCheck(this, FeedInfiniteLoader);
	
	    var _this = _possibleConstructorReturn(this, (FeedInfiniteLoader.__proto__ || Object.getPrototypeOf(FeedInfiniteLoader)).call(this));
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.forceRerenderRows = _this.forceRerenderRows.bind(_this);
	    return _this;
	  }
	
	  _createClass(FeedInfiniteLoader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Measure all rows to restore scroll position.
	      if (this._list && this.props.list.length > 0) this._list.measureAllRows();
	      // Reset the measurements when the list is reset.
	      if (this.props.page === 1) this.forceRerenderRows();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // Reset the measurements when the list is reset to the first page.
	      if (this.props.page === 1) this.forceRerenderRows();
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(_ref) {
	      var width = _ref.width;
	
	      // Only recompute list measurements if width changes.
	      if (!this.width) this.width = width;
	      if (this.width !== width) {
	        this.forceRerenderRows();
	        this.width = width;
	      }
	    }
	  }, {
	    key: 'forceRerenderRows',
	    value: function forceRerenderRows() {
	      if (this._list && this.props.list.length > 0) {
	        // Manually clear the cache and recompute.
	        _PersistedCellSizeCache2.default.clearCaches();
	        this._list.measureAllRows();
	        this._list.recomputeRowHeights();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          totalCount = _props.totalCount,
	          isNextPageLoading = _props.isNextPageLoading,
	          hasFetchedManually = _props.hasFetchedManually,
	          list = _props.list,
	          loadNextPage = _props.loadNextPage,
	          isRowLoaded = _props.isRowLoaded,
	          rowRenderer = _props.rowRenderer,
	          otherProps = _objectWithoutProperties(_props, ['totalCount', 'isNextPageLoading', 'hasFetchedManually', 'list', 'loadNextPage', 'isRowLoaded', 'rowRenderer']);
	
	      // Only load 1 page of items at a time after the first manual fetch
	
	
	      var loadMoreRows = hasFetchedManually && !isNextPageLoading ? loadNextPage : function () {};
	
	      return _react2.default.createElement(
	        _reactVirtualized.InfiniteLoader,
	        {
	          minimumBatchSize: (10),
	          threshold: 1,
	          isRowLoaded: isRowLoaded,
	          loadMoreRows: loadMoreRows,
	          rowCount: totalCount
	        },
	        function (_ref2) {
	          var onRowsRendered = _ref2.onRowsRendered,
	              registerChild = _ref2.registerChild;
	          return _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            { disableHeight: true, onResize: _this2.handleResize },
	            function (_ref3) {
	              var width = _ref3.width;
	              return _react2.default.createElement(
	                _reactVirtualized.CellMeasurer,
	                {
	                  ref: function ref(_ref8) {
	                    return _this2._cellMeasurer = _ref8;
	                  },
	                  width: width,
	                  rowCount: list.length,
	                  cellRenderer: function cellRenderer(_ref4) {
	                    var rowIndex = _ref4.rowIndex,
	                        rest = _objectWithoutProperties(_ref4, ['rowIndex']);
	
	                    return rowRenderer(_extends({ index: rowIndex }, rest));
	                  },
	                  cellSizeCache: _PersistedCellSizeCache2.default,
	                  columnCount: 1
	                },
	                function (_ref5) {
	                  var getRowHeight = _ref5.getRowHeight;
	                  return _react2.default.createElement(
	                    _reactVirtualized.WindowScroller,
	                    null,
	                    function (_ref6) {
	                      var height = _ref6.height,
	                          scrollTop = _ref6.scrollTop;
	                      return _react2.default.createElement(_reactVirtualized.List, _extends({}, otherProps, {
	                        ref: function ref(_ref7) {
	                          // Store the reference and pass it on to InfiniteLoader as well
	                          _this2._list = _ref7;
	                          registerChild(_ref7);
	                        },
	                        width: width,
	                        height: height,
	                        autoHeight: true,
	                        scrollTop: scrollTop,
	                        rowCount: list.length,
	                        rowHeight: getRowHeight,
	                        rowRenderer: rowRenderer,
	                        onRowsRendered: onRowsRendered
	                      }));
	                    }
	                  );
	                }
	              );
	            }
	          );
	        }
	      );
	    }
	  }]);
	
	  return FeedInfiniteLoader;
	}(_react.Component);
	
	FeedInfiniteLoader.propTypes = {
	  page: _react.PropTypes.number,
	  totalCount: _react.PropTypes.number,
	  isNextPageLoading: _react.PropTypes.bool,
	  hasFetchedManually: _react.PropTypes.bool,
	  list: _react.PropTypes.arrayOf(_entities.FeedItemShape),
	  loadNextPage: _react.PropTypes.func,
	  isRowLoaded: _react.PropTypes.func,
	  rowRenderer: _react.PropTypes.func,
	  cellRenderer: _react.PropTypes.func
	};
	
	exports.default = FeedInfiniteLoader;

/***/ },

/***/ "./src/members/Main/Feed/FeedQuestionnaire/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _Questionnaire = __webpack_require__("./src/members/Main/__shared__/components/Questionnaire/index.js");
	
	var _Questionnaire2 = _interopRequireDefault(_Questionnaire);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__("./src/members/Main/Feed/FeedQuestionnaire/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedQuestionnaire = function (_Component) {
	  _inherits(FeedQuestionnaire, _Component);
	
	  function FeedQuestionnaire() {
	    _classCallCheck(this, FeedQuestionnaire);
	
	    var _this = _possibleConstructorReturn(this, (FeedQuestionnaire.__proto__ || Object.getPrototypeOf(FeedQuestionnaire)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(FeedQuestionnaire, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	
	      this.props.onQuestionnaireSubmit(this.props.questionnaire);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          questionnaire = _props.questionnaire,
	          onQuestionAnswer = _props.onQuestionAnswer,
	          isSubmitting = _props.isSubmitting;
	
	      var questionsWithNoAnswer = this.props.questionnaire.questions.filter(function (question) {
	        // If question is required
	        if (!question.hasOwnProperty('required') || question.required === true) {
	          if (question.type !== 'radio') {
	            // If answer is null or answer length is less than 1 then no answer
	            if (question.type === 'checkbox') {
	              return question.answer === null || !question.answer.length;
	            }
	            return question.answer === null || question.value === null || !question.value.length;
	          }
	          // Otherwise if answer is null then no answer
	          return question.answer === null;
	        }
	        // If not required then no further check required
	        return false;
	      });
	      var hasUnansweredQuestion = questionsWithNoAnswer.length > 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'FeedQuestionnaire' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          "Questionnaire"
	        ),
	        _react2.default.createElement(_Questionnaire2.default, {
	          metaHidden: true,
	          questionnaire: questionnaire,
	          onQuestionAnswer: onQuestionAnswer
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            isYellow: true,
	            iconType: 'preloader-dark',
	            hasIcon: isSubmitting,
	            isDisabled: isSubmitting || hasUnansweredQuestion,
	            onClick: this.handleSubmit
	          },
	          "Submit"
	        )
	      );
	    }
	  }]);
	
	  return FeedQuestionnaire;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isSubmitting: (0, _selectors.getFeedQuestionnairesIsSubmitting)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onQuestionAnswer: function onQuestionAnswer(questionnaire, question, answer, value) {
	      dispatch(actions.feedQuestionUpdate(questionnaire.id, question.id, { answer: answer, value: value }));
	      dispatch(actions.feedQuestionnaireUpdate(questionnaire.id, { updatedAt: new Date() }));
	    },
	    onQuestionnaireSubmit: function onQuestionnaireSubmit(questionnaire) {
	      dispatch(actions.feedQuestionnaireSubmit(questionnaire));
	    }
	  };
	};
	
	FeedQuestionnaire.propTypes = {
	  questionnaire: _entities.QuestionnaireShape,
	  onQuestionAnswer: _react.PropTypes.func,
	  onQuestionnaireSubmit: _react.PropTypes.func,
	  isSubmitting: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FeedQuestionnaire);

/***/ },

/***/ "./src/members/Main/Feed/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _MagazineArticle = __webpack_require__("./src/members/Main/__shared__/containers/MagazineArticle/index.js");
	
	var _MagazineArticle2 = _interopRequireDefault(_MagazineArticle);
	
	var _JournalEntryForm = __webpack_require__("./src/members/Main/__shared__/containers/JournalEntryForm/index.js");
	
	var _JournalEntryForm2 = _interopRequireDefault(_JournalEntryForm);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EmptyArticle = __webpack_require__("./src/members/Main/__shared__/components/EmptyArticle/index.js");
	
	var _EmptyArticle2 = _interopRequireDefault(_EmptyArticle);
	
	var _InfoBar = __webpack_require__("./src/members/Main/__shared__/components/InfoBar/index.js");
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	var _FeedInfiniteLoader = __webpack_require__("./src/members/Main/Feed/FeedInfiniteLoader/index.js");
	
	var _FeedInfiniteLoader2 = _interopRequireDefault(_FeedInfiniteLoader);
	
	var _FeedGoals = __webpack_require__("./src/members/Main/Feed/FeedGoals/index.js");
	
	var _FeedGoals2 = _interopRequireDefault(_FeedGoals);
	
	var _FeedQuestionnaire = __webpack_require__("./src/members/Main/Feed/FeedQuestionnaire/index.js");
	
	var _FeedQuestionnaire2 = _interopRequireDefault(_FeedQuestionnaire);
	
	var _FeedButtonItem = __webpack_require__("./src/members/Main/Feed/FeedButtonItem/index.js");
	
	var _FeedButtonItem2 = _interopRequireDefault(_FeedButtonItem);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/Feed/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Feed = function (_Component) {
	  _inherits(Feed, _Component);
	
	  function Feed() {
	    _classCallCheck(this, Feed);
	
	    var _this = _possibleConstructorReturn(this, (Feed.__proto__ || Object.getPrototypeOf(Feed)).call(this));
	
	    _this.checkRowLoaded = _this.checkRowLoaded.bind(_this);
	    _this.renderRow = _this.renderRow.bind(_this);
	    _this.renderFeedInfiniteLoader = _this.renderFeedInfiniteLoader.bind(_this);
	    _this.handleLoadMore = _this.handleLoadMore.bind(_this);
	    _this.handleLoadMoreViaButton = _this.handleLoadMoreViaButton.bind(_this);
	    _this.handleInfoBarClose = _this.handleInfoBarClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(Feed, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.items.length && this.props.onLoadMore) {
	        this.props.onLoadMore(this.props.page, false);
	      }
	    }
	  }, {
	    key: 'handleInfoBarClose',
	    value: function handleInfoBarClose() {
	      if (this.props.onInfoBarClose) {
	        this.props.onInfoBarClose();
	      }
	    }
	  }, {
	    key: 'handleLoadMoreViaButton',
	    value: function handleLoadMoreViaButton(e) {
	      e.preventDefault();
	      this.props.onLoadMore(this.props.page, true);
	    }
	  }, {
	    key: 'handleLoadMore',
	    value: function handleLoadMore() {
	      if (this.props.totalCount > this.props.items.length) {
	        this.props.onLoadMore(this.props.page, this.props.hasFetchedManually);
	      }
	    }
	  }, {
	    key: 'checkRowLoaded',
	    value: function checkRowLoaded(_ref) {
	      var index = _ref.index;
	
	      var hasNextPage = this.props.items.length <= this.props.totalCount;
	      return hasNextPage && index < this.props.items.length;
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(_ref2) {
	      var index = _ref2.index,
	          key = _ref2.key,
	          style = _ref2.style;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: key,
	          style: style
	        },
	        this.checkRowLoaded({ index: index }) && this.renderItem(this.props.items[index])
	      );
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(item) {
	      var feedChat = item.feedChat,
	          feedInterests = item.feedInterests,
	          feedJournal = item.feedJournal,
	          feedQuestionnaire = item.feedQuestionnaire,
	          feedGoals = item.feedGoals,
	          magazineArticle = item.magazineArticle;
	
	
	      if (feedChat) return this.renderFeedButton({ item: feedChat, to: '/messages' });
	      if (feedInterests) return this.renderFeedButton({ item: feedInterests, to: '/interests' });
	      if (feedJournal) return this.renderFeedJournal(feedJournal);
	      if (feedQuestionnaire) return this.renderFeedQuestionnaire(feedQuestionnaire);
	      if (feedGoals) return this.renderFeedGoals(feedGoals);
	      if (magazineArticle) return this.renderMagazineArticle(magazineArticle);
	    }
	  }, {
	    key: 'renderFeedButton',
	    value: function renderFeedButton(_ref3) {
	      var item = _ref3.item,
	          to = _ref3.to;
	
	      return _react2.default.createElement(_FeedButtonItem2.default, _extends({}, item, { to: to }));
	    }
	  }, {
	    key: 'renderFeedJournal',
	    value: function renderFeedJournal(feedJournal) {
	      return _react2.default.createElement(_JournalEntryForm2.default, {
	        shouldRenderOnOneLine: true,
	        title: feedJournal.title,
	        text: feedJournal.text,
	        emojis: feedJournal.emojis
	      });
	    }
	  }, {
	    key: 'renderFeedQuestionnaire',
	    value: function renderFeedQuestionnaire(feedQuestionnaire) {
	      return _react2.default.createElement(_FeedQuestionnaire2.default, {
	        questionnaire: feedQuestionnaire
	      });
	    }
	  }, {
	    key: 'renderFeedGoals',
	    value: function renderFeedGoals(feedGoals) {
	      return _react2.default.createElement(_FeedGoals2.default, { title: feedGoals.title, goals: feedGoals.goals });
	    }
	  }, {
	    key: 'renderMagazineArticle',
	    value: function renderMagazineArticle(magazineArticle) {
	      return _react2.default.createElement(_MagazineArticle2.default, {
	        magazineArticle: magazineArticle,
	        imageUrl: magazineArticle.thumbnail.main.lowRes,
	        inFeed: true,
	        shouldOpenProfileFromImage: true
	      });
	    }
	  }, {
	    key: 'renderEmptyArticles',
	    value: function renderEmptyArticles() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_EmptyArticle2.default, { isDarker: true }),
	        _react2.default.createElement(_EmptyArticle2.default, { isDarker: true }),
	        _react2.default.createElement(_EmptyArticle2.default, { isDarker: true })
	      );
	    }
	  }, {
	    key: 'renderFeedInfiniteLoader',
	    value: function renderFeedInfiniteLoader() {
	      var _this2 = this;
	
	      var _props = this.props,
	          items = _props.items,
	          page = _props.page,
	          totalCount = _props.totalCount,
	          hasFetchedManually = _props.hasFetchedManually,
	          isFetching = _props.isFetching;
	
	      // Use pass-thru props to trigger update & re-render on the FeedInfiniteLoader
	
	      var passThruGoals = items.find(function (item) {
	        return item.feedGoals;
	      });
	      var passThruQuestionnaire = items.find(function (item) {
	        return item.feedQuestionnaire;
	      });
	
	      return _react2.default.createElement(_FeedInfiniteLoader2.default, {
	        ref: function ref(_ref4) {
	          return _this2._infiniteLoader = _ref4;
	        },
	        page: page,
	        totalCount: totalCount,
	        hasFetchedManually: hasFetchedManually,
	        isNextPageLoading: isFetching,
	        isRowLoaded: this.checkRowLoaded,
	        rowRenderer: this.renderRow,
	        list: items,
	        loadNextPage: this.handleLoadMore,
	        passThruGoals: passThruGoals,
	        passThruQuestionnaire: passThruQuestionnaire
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          items = _props2.items,
	          isFetching = _props2.isFetching,
	          hasFetchedManually = _props2.hasFetchedManually,
	          isSuccessInfoBarVisible = _props2.isSuccessInfoBarVisible,
	          successInfoBarTitle = _props2.successInfoBarTitle,
	          successInfoBarMessage = _props2.successInfoBarMessage;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'Feed content-wrapper has-background' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-collapsed is-padded-vertical' },
	          _react2.default.createElement(
	            'div',
	            { className: 'feed-layout' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              isSuccessInfoBarVisible && _react2.default.createElement(_InfoBar2.default, {
	                onClose: this.handleInfoBarClose,
	                type: 'primary',
	                title: successInfoBarTitle,
	                message: successInfoBarMessage }),
	              _react2.default.createElement(
	                'div',
	                { className: 'wrapper-small is-collapsed' },
	                items.length === 0 && isFetching ? this.renderEmptyArticles() : this.renderFeedInfiniteLoader(),
	                hasFetchedManually || _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    isYellow: true,
	                    iconType: 'preloader-dark',
	                    hasIcon: isFetching,
	                    isDisabled: isFetching,
	                    onClick: this.handleLoadMoreViaButton
	                  },
	                  "Load more"
	                ),
	                hasFetchedManually && isFetching && _react2.default.createElement(_EmptyArticle2.default, { isDarker: true })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Feed;
	}(_react.Component);
	
	Feed.propTypes = {
	  onLoadMore: _react.PropTypes.func,
	  items: _react.PropTypes.arrayOf(_entities.FeedItemShape),
	  isFetching: _react.PropTypes.bool,
	  page: _react.PropTypes.number,
	  totalCount: _react.PropTypes.number,
	  hasFetchedManually: _react.PropTypes.bool,
	  isSuccessInfoBarVisible: _react.PropTypes.bool,
	  successInfoBarMessage: _react.PropTypes.string,
	  successInfoBarTitle: _react.PropTypes.string,
	  onInfoBarClose: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var successState = (0, _selectors.getInfoState)(state, 'success');
	  var isSuccessInfoBarVisible = successState.visible;
	  var successInfoBarMessage = successState.message;
	  var successInfoBarTitle = successState.title;
	
	  return _extends({
	    items: (0, _selectors.getFeedItems)(state)
	  }, (0, _selectors.getFeedPaging)(state), {
	    isSuccessInfoBarVisible: isSuccessInfoBarVisible,
	    successInfoBarMessage: successInfoBarMessage,
	    successInfoBarTitle: successInfoBarTitle
	  });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onLoadMore: function onLoadMore(page, isManualFetch) {
	      dispatch(actions.feedFetch(page + 1, isManualFetch));
	    },
	    onInfoBarClose: function onInfoBarClose() {
	      dispatch(actions.infoClose('success'));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Feed);

/***/ },

/***/ "./src/members/Main/Feedback/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _TextEditor = __webpack_require__("./src/members/Main/__shared__/components/TextEditor/index.js");
	
	var _TextEditor2 = _interopRequireDefault(_TextEditor);
	
	var _InfoBar = __webpack_require__("./src/members/Main/__shared__/components/InfoBar/index.js");
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/Feedback/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable react/no-danger*/
	
	
	var Feedback = function (_Component) {
	  _inherits(Feedback, _Component);
	
	  function Feedback() {
	    _classCallCheck(this, Feedback);
	
	    var _this = _possibleConstructorReturn(this, (Feedback.__proto__ || Object.getPrototypeOf(Feedback)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleSubjectUpdate = _this.handleSubjectUpdate.bind(_this);
	    _this.handleInfoBarClose = _this.handleInfoBarClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(Feedback, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(text) {
	      var subject = this.props.subject;
	      this.props.onSubmit(subject, text);
	    }
	  }, {
	    key: 'handleSubjectUpdate',
	    value: function handleSubjectUpdate(e) {
	      var subject = e.target.value;
	      this.props.onSubjectUpdate(subject);
	    }
	  }, {
	    key: 'handleInfoBarClose',
	    value: function handleInfoBarClose() {
	      if (this.props.onInfoBarClose) {
	        this.props.onInfoBarClose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'section',
	        { className: 'content-wrapper has-background-medium' },
	        this.props.isSuccessInfoBarVisible && _react2.default.createElement(_InfoBar2.default, { onClose: this.handleInfoBarClose, isStatic: true, type: 'primary', title: this.props.successInfoBarTitle, message: this.props.successInfoBarMessage }),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-padded-top' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            "Feedback"
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'Feedback' },
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: "If you have any questions about KOOTH, or want to give feedback, please complete and send the form below. Here is our <a href='https://xenzone.com/make-a-complaint/' class='Link' target='_blank'>complaints policy</a>." } }),
	            _react2.default.createElement(
	              'div',
	              { className: 'feedback-form' },
	              _react2.default.createElement(
	                'label',
	                null,
	                "Subject"
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                placeholder: "Subject",
	                value: this.props.subject,
	                onChange: this.handleSubjectUpdate
	              }),
	              _react2.default.createElement(_TextEditor2.default, _extends({}, this.props, {
	                onSubmit: this.handleSubmit,
	                maxChars: (10000),
	                contentTitle: "Content",
	                placeholder: "Please give us your feedback, it is important for us.",
	                isExpanded: true,
	                isAutosized: true
	              }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Feedback;
	}(_react.Component);
	
	Feedback.propTypes = {
	  subject: _react.PropTypes.string,
	  isSuccessInfoBarVisible: _react.PropTypes.bool,
	  successInfoBarMessage: _react.PropTypes.string,
	  successInfoBarTitle: _react.PropTypes.string,
	  onSubjectUpdate: _react.PropTypes.func,
	  onSubmit: _react.PropTypes.func,
	  onInfoBarClose: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var feedbackSubject = (0, _selectors.getFeedbackSubject)(state);
	  var feedbackTextEditing = (0, _selectors.getFeedbackTextEditing)(state);
	
	  var isSubmitDisabled = feedbackTextEditing.isSubmitting || !feedbackSubject.subject.length || !feedbackTextEditing.text.length;
	
	  var successState = (0, _selectors.getInfoState)(state, 'success');
	  var isSuccessInfoBarVisible = successState.visible;
	  var successInfoBarMessage = successState.message;
	  var successInfoBarTitle = successState.title;
	
	  return _extends({}, feedbackTextEditing, feedbackSubject, {
	    isSubmitDisabled: isSubmitDisabled,
	    isSuccessInfoBarVisible: isSuccessInfoBarVisible,
	    successInfoBarMessage: successInfoBarMessage,
	    successInfoBarTitle: successInfoBarTitle,
	    showsEmojis: (0, _selectors.getFeedbackEmojis)(state).areVisible
	  });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onSubjectUpdate: function onSubjectUpdate(subject) {
	      dispatch(actions.feedbackEditingUpdateSubject(subject));
	    },
	    onTextUpdate: function onTextUpdate(text) {
	      dispatch(actions.feedbackEditingUpdateText({ text: text }));
	    },
	    onSubmit: function onSubmit(subject, text) {
	      dispatch(actions.feedbackCreate(subject, text, "Your feedback was successfully sent!"));
	    },
	    onWillUnmount: function onWillUnmount() {
	      dispatch(actions.feedbackEmojisHide('feedback'));
	      dispatch(actions.feedbackEditingReset());
	    },
	    onEmojisToggled: function onEmojisToggled(showsEmojis) {
	      if (showsEmojis) {
	        dispatch(actions.feedbackEmojisHide('feedback'));
	      } else {
	        dispatch(actions.feedbackEmojisShow('feedback'));
	      }
	    },
	    onEmojiSelected: function onEmojiSelected(text, emojiShortName, selectionStart) {
	      dispatch(actions.feedbackEditingUpdateText({ text: text, emojiShortName: emojiShortName, selectionStart: selectionStart }));
	    },
	    onInfoBarClose: function onInfoBarClose() {
	      dispatch(actions.infoClose('success'));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Feedback);

/***/ },

/***/ "./src/members/Main/Forum/ForumAskKooth/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ForumContribute = __webpack_require__("./src/members/Main/Forum/ForumContribute/index.js");
	
	var _ForumContribute2 = _interopRequireDefault(_ForumContribute);
	
	var _ForumFilteredThreadsList = __webpack_require__("./src/members/Main/Forum/ForumFilteredThreadsList/index.js");
	
	var _ForumFilteredThreadsList2 = _interopRequireDefault(_ForumFilteredThreadsList);
	
	__webpack_require__("./src/members/Main/Forum/ForumAskKooth/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ForumAskKooth = function ForumAskKooth() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'has-background' },
	    _react2.default.createElement(_ForumContribute2.default, { askKooth: true, isNarrow: true, hasBackgroundWhite: true }),
	    _react2.default.createElement(_ForumFilteredThreadsList2.default, { location: { query: { askKooth: 'true' } } })
	  );
	};
	
	exports.default = ForumAskKooth;

/***/ },

/***/ "./src/members/Main/Forum/ForumCategories/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResourceCategoriesAccordion = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCategoriesAccordion/index.js");
	
	var _ResourceCategoriesAccordion2 = _interopRequireDefault(_ResourceCategoriesAccordion);
	
	var _AccordionItem = __webpack_require__("./src/members/Main/__shared__/components/Accordion/AccordionItem/index.js");
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForumCategories = function (_Component) {
	  _inherits(ForumCategories, _Component);
	
	  function ForumCategories() {
	    _classCallCheck(this, ForumCategories);
	
	    return _possibleConstructorReturn(this, (ForumCategories.__proto__ || Object.getPrototypeOf(ForumCategories)).apply(this, arguments));
	  }
	
	  _createClass(ForumCategories, [{
	    key: 'renderTopic',
	    value: function renderTopic(topic, countInfo) {
	      return _react2.default.createElement(_AccordionItem2.default, {
	        isForForum: true,
	        key: topic.id,
	        title: topic.title,
	        countInfo: countInfo(topic),
	        url: '/forum?topic=' + topic.id + '&title=' + topic.title
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'wrapper-full is-collapsed is-collapsed-top has-background', ref: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-padded-top' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            "Categories"
	          ),
	          _react2.default.createElement(_ResourceCategoriesAccordion2.default, {
	            isForForum: true,
	            resourceType: 'forumThreads',
	            resourceNameSingular: "thread",
	            resourceNamePlural: "threads",
	            renderTopic: this.renderTopic,
	            scrollElementGetter: function scrollElementGetter() {
	              return _this2.refs.wrapper.parentElement;
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return ForumCategories;
	}(_react.Component);
	
	exports.default = ForumCategories;

/***/ },

/***/ "./src/members/Main/Forum/ForumContribute/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _Contribute = __webpack_require__("./src/members/Main/__shared__/components/Contribute/index.js");
	
	var _Contribute2 = _interopRequireDefault(_Contribute);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var contributeSubject = (0, _selectors.getForumContributeSubject)(state);
	  var forumContributeTextEditing = (0, _selectors.getForumTextEditing)(state, 'forumContribute');
	  var isSubmitDisabled = forumContributeTextEditing.isSubmitting || !contributeSubject.subject.length || !forumContributeTextEditing.text.length;
	  var successState = (0, _selectors.getInfoState)(state, 'success');
	  var isSuccessInfoBarVisible = successState.visible;
	  var successInfoBarMessage = successState.message;
	  var successInfoBarTitle = successState.title;
	
	  return _extends({}, forumContributeTextEditing, contributeSubject, {
	    isSubmitDisabled: isSubmitDisabled,
	    isSuccessInfoBarVisible: isSuccessInfoBarVisible,
	    successInfoBarMessage: successInfoBarMessage,
	    successInfoBarTitle: successInfoBarTitle,
	    showsEmojis: (0, _selectors.getForumEmojis)(state, 'forumContribute').areVisible,
	    title: props.askKooth ? "Ask Kooth" : "Start new Discussion",
	    isAutosized: props.askKooth ? false : true,
	    isExpanded: props.askKooth ? forumContributeTextEditing.isExpanded : true
	  });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  var askKooth = props.askKooth;
	
	
	  return {
	    onSubjectUpdate: function onSubjectUpdate(subject) {
	      dispatch(actions.forumContributeEditingUpdateSubject(subject));
	    },
	    onFocus: function onFocus() {
	      dispatch(actions.forumContributeEditingExpand());
	    },
	    onTextUpdate: function onTextUpdate(text) {
	      dispatch(actions.forumContributeEditingUpdateText({ text: text }));
	    },
	    onSubmit: function onSubmit(title, text) {
	      dispatch(actions.forumThreadCreate({ title: title, text: text, askKooth: askKooth }));
	      dispatch(actions.forumEmojisHide('forumContribute'));
	    },
	    onWillUnmount: function onWillUnmount() {
	      dispatch(actions.forumEmojisHide('forumContribute'));
	      dispatch(actions.forumContributeEditingReset());
	    },
	    onEmojisToggled: function onEmojisToggled(showsEmojis) {
	      if (showsEmojis) {
	        dispatch(actions.forumEmojisHide('forumContribute'));
	      } else {
	        dispatch(actions.forumEmojisShow('forumContribute'));
	      }
	    },
	    onEmojiSelected: function onEmojiSelected(text, emojiShortName, selectionStart) {
	      dispatch(actions.forumContributeEditingUpdateText({ text: text, emojiShortName: emojiShortName, selectionStart: selectionStart }));
	    },
	    onInfoBarClose: function onInfoBarClose() {
	      dispatch(actions.infoClose('success'));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Contribute2.default);

/***/ },

/***/ "./src/members/Main/Forum/ForumFilteredThreadsList/ForumFilteredThreadsListPageSelector/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ForumFilteredThreadsListPageSelector = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _PageSelector = __webpack_require__("./src/members/Main/__shared__/components/PageSelector/index.js");
	
	var _PageSelector2 = _interopRequireDefault(_PageSelector);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ForumFilteredThreadsListPageSelector = function ForumFilteredThreadsListPageSelector(props) {
	  var query = props.query,
	      queryString = props.queryString,
	      otherProps = _objectWithoutProperties(props, ['query', 'queryString']); //eslint-disable-line no-unused-vars
	
	
	  return _react2.default.createElement(_PageSelector2.default, otherProps);
	};
	
	exports.ForumFilteredThreadsListPageSelector = ForumFilteredThreadsListPageSelector;
	var mapStateToProps = function mapStateToProps(state, props) {
	  var queryString = props.queryString;
	
	  return (0, _selectors.getForumPaging)(state, 'forumThreads', { queryString: queryString });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onPrevClick: function onPrevClick(currentPage) {
	      dispatch(actions.forumThreadsFetch(currentPage - 1, props.query, props.queryString));
	    },
	    onNextClick: function onNextClick(currentPage) {
	      dispatch(actions.forumThreadsFetch(currentPage + 1, props.query, props.queryString));
	    },
	    onPossiblePageUpdate: function onPossiblePageUpdate(newPossiblePage) {
	      dispatch(actions.forumThreadsUpdatePossiblePage(newPossiblePage, props.queryString));
	    },
	    onPageUpdate: function onPageUpdate(newPage, pagesCount) {
	      if (newPage >= 1 && newPage <= pagesCount) {
	        dispatch(actions.forumThreadsFetch(newPage, props.query, props.queryString));
	      }
	    }
	  };
	};
	
	ForumFilteredThreadsListPageSelector.propTypes = {
	  query: _react.PropTypes.object,
	  queryString: _react.PropTypes.string
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForumFilteredThreadsListPageSelector);

/***/ },

/***/ "./src/members/Main/Forum/ForumFilteredThreadsList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("./src/members/Main/Forum/ForumFilteredThreadsList/style.scss");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _ForumFilteredThreadsListPageSelector = __webpack_require__("./src/members/Main/Forum/ForumFilteredThreadsList/ForumFilteredThreadsListPageSelector/index.js");
	
	var _ForumFilteredThreadsListPageSelector2 = _interopRequireDefault(_ForumFilteredThreadsListPageSelector);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _forumQueries = __webpack_require__("./src/members/__shared__/forumQueries.js");
	
	var _ForumThreadsList = __webpack_require__("./src/members/Main/__shared__/containers/ForumThreadsList/index.js");
	
	var _ForumThreadsList2 = _interopRequireDefault(_ForumThreadsList);
	
	var _ForumThread = __webpack_require__("./src/members/Main/__shared__/containers/ForumThreadsList/ForumThread/index.js");
	
	var _ForumThread2 = _interopRequireDefault(_ForumThread);
	
	var _NoEntries = __webpack_require__("./src/members/Main/__shared__/components/NoEntries/index.js");
	
	var _NoEntries2 = _interopRequireDefault(_NoEntries);
	
	var _NoEntriesDetail = __webpack_require__("./src/members/Main/__shared__/components/NoEntries/NoEntriesDetail/index.js");
	
	var _NoEntriesDetail2 = _interopRequireDefault(_NoEntriesDetail);
	
	var _forumLiveStatus = __webpack_require__("./src/members/__shared__/forumLiveStatus.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForumFilteredThreadsList = function (_Component) {
	  _inherits(ForumFilteredThreadsList, _Component);
	
	  function ForumFilteredThreadsList() {
	    _classCallCheck(this, ForumFilteredThreadsList);
	
	    return _possibleConstructorReturn(this, (ForumFilteredThreadsList.__proto__ || Object.getPrototypeOf(ForumFilteredThreadsList)).apply(this, arguments));
	  }
	
	  _createClass(ForumFilteredThreadsList, [{
	    key: 'renderNoForumThreads',
	    value: function renderNoForumThreads() {
	      return [_react2.default.createElement(_ForumThreadsList2.default, { key: '1', title: this.props.title }), _react2.default.createElement(
	        _NoEntries2.default,
	        { key: '2', title: "No threads" },
	        _react2.default.createElement(
	          _NoEntriesDetail2.default,
	          null,
	          "The are currently no forum threads in this list."
	        )
	      )];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ForumFilteredThreadsList has-background has-pagination' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-narrow' },
	          function () {
	            if (_this2.props.forumThreads.length > 0) {
	              return _react2.default.createElement(
	                _ForumThreadsList2.default,
	                { title: _this2.props.title },
	                _this2.props.forumThreads.map(function (forumThread) {
	                  return _react2.default.createElement(_ForumThread2.default, {
	                    key: forumThread.id,
	                    isLive: (0, _forumLiveStatus.isLiveNow)(forumThread),
	                    forumThread: forumThread,
	                    timeInfo: (0, _moment2.default)(forumThread.createdAt).format(("MMMM Do YYYY, h:mm a"))
	                  });
	                })
	              );
	            } else {
	              if (_this2.props.isFetching) {
	                return _react2.default.createElement(
	                  _ForumThreadsList2.default,
	                  { title: _this2.props.title },
	                  _react2.default.createElement(_ForumThread2.default, { key: 'loader1', isEmpty: true }),
	                  _react2.default.createElement(_ForumThread2.default, { key: 'loader2', isEmpty: true }),
	                  _react2.default.createElement(_ForumThread2.default, { key: 'loader3', isEmpty: true })
	                );
	              }
	
	              return _this2.renderNoForumThreads();
	            }
	          }()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pagination-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper-xlarge' },
	            this.props.pagesCount > 1 && _react2.default.createElement(_ForumFilteredThreadsListPageSelector2.default, { query: this.props.query, queryString: this.props.queryString })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ForumFilteredThreadsList;
	}(_react.Component);
	
	ForumFilteredThreadsList.propTypes = {
	  forumThreads: _react.PropTypes.arrayOf(_entities.ForumThreadShape),
	  isFetching: _react.PropTypes.bool,
	  pagesCount: _react.PropTypes.number,
	  onFetchCurrentPage: _react.PropTypes.func,
	  queryString: _react.PropTypes.string,
	  query: _react.PropTypes.object,
	  allowsNewDiscussions: _react.PropTypes.bool,
	  startNewDiscussionUrl: _react.PropTypes.string,
	  title: _react.PropTypes.string,
	  canAskKooth: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var query = (0, _forumQueries.normalizeForumQuery)(props.location.query);
	  var queryString = JSON.stringify(query);
	
	  var _getForumPaging = (0, _selectors.getForumPaging)(state, 'forumThreads', { queryString: queryString }),
	      page = _getForumPaging.page,
	      isFetching = _getForumPaging.isFetching,
	      pagesCount = _getForumPaging.pagesCount;
	
	  var forumThreads = (0, _selectors.getForumThreadsOnFrontPage)(state, { page: page, queryString: queryString });
	
	  return {
	    forumThreads: forumThreads,
	    isFetching: isFetching,
	    queryString: queryString,
	    query: query,
	    pagesCount: pagesCount,
	    title: (0, _forumQueries.getQueryTitle)(query)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForumFilteredThreadsList);

/***/ },

/***/ "./src/members/Main/Forum/ForumLiveThreadLobby/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	__webpack_require__("./src/members/Main/Forum/ForumLiveThreadLobby/style.scss");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _forumLiveStatus = __webpack_require__("./src/members/__shared__/forumLiveStatus.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable react/no-danger*/
	
	
	var ForumLiveThreadLobby = function (_Component) {
	  _inherits(ForumLiveThreadLobby, _Component);
	
	  function ForumLiveThreadLobby() {
	    _classCallCheck(this, ForumLiveThreadLobby);
	
	    return _possibleConstructorReturn(this, (ForumLiveThreadLobby.__proto__ || Object.getPrototypeOf(ForumLiveThreadLobby)).apply(this, arguments));
	  }
	
	  _createClass(ForumLiveThreadLobby, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onDidMount && this.props.onDidMount();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.props.onDidUpdate && this.props.onDidUpdate(this.props.forumThread);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          forumThread = _props.forumThread,
	          startsInInfo = _props.startsInInfo;
	
	      var startTime = (0, _moment2.default)(forumThread.liveStart).format('hh:mm a');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ForumLiveThreadLobby wrapper-full is-collapsed is-collapsed-top' },
	        _react2.default.createElement(
	          'div',
	          { className: 'live-placeholder wrapper-small is-padded-top' },
	          _react2.default.createElement(
	            'div',
	            { className: 'text-center' },
	            forumThread && _react2.default.createElement(
	              'h1',
	              null,
	              forumThread.title
	            ),
	            _react2.default.createElement('div', { className: 'icon-live-holder' })
	          ),
	          !forumThread && _react2.default.createElement(
	            'h4',
	            { className: 'text-center' },
	            "Loading..."
	          ),
	          forumThread && _react2.default.createElement(
	            'h4',
	            { className: 'text-center' },
	            'This is a live forum which will start ' + startsInInfo
	          ),
	          forumThread && _react2.default.createElement('p', { className: 'text-center', dangerouslySetInnerHTML: { __html: 'At <time>' + startTime + '</time> you can discuss the topic with other people at the same time. It\u2019s like a group chat. You\'ll be redirected when the discussion starts.' } })
	        )
	      );
	    }
	  }]);
	
	  return ForumLiveThreadLobby;
	}(_react.Component);
	
	ForumLiveThreadLobby.propTypes = {
	  forumThread: _entities.ForumThreadShape,
	  startsInInfo: _react.PropTypes.string,
	  onDidMount: _react.PropTypes.func,
	  onDidUpdate: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var forumThread = (0, _selectors.getForumThread)(state, props.params.id);
	  var startsInInfo = forumThread && (0, _moment2.default)(forumThread.liveStart).fromNow();
	
	  return {
	    forumThread: forumThread,
	    startsInInfo: startsInInfo // It's here and not in the component in order to rerender to compoennt on TIME_REFRESH action.
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onDidMount: function onDidMount() {
	      dispatch(actions.forumThreadProfileFetch(props.params.id));
	    },
	    onDidUpdate: function onDidUpdate(forumThread) {
	      if (forumThread && (0, _forumLiveStatus.hasEnded)(forumThread)) {
	        dispatch((0, _reactRouterRedux.replace)('forum/threads/' + props.params.id));
	      }
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForumLiveThreadLobby);

/***/ },

/***/ "./src/members/Main/Forum/ForumLiveThreadsList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("./src/members/Main/Forum/ForumLiveThreadsList/style.scss");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _ForumThreadsList = __webpack_require__("./src/members/Main/__shared__/containers/ForumThreadsList/index.js");
	
	var _ForumThreadsList2 = _interopRequireDefault(_ForumThreadsList);
	
	var _ForumThread = __webpack_require__("./src/members/Main/__shared__/containers/ForumThreadsList/ForumThread/index.js");
	
	var _ForumThread2 = _interopRequireDefault(_ForumThread);
	
	var _NoEntries = __webpack_require__("./src/members/Main/__shared__/components/NoEntries/index.js");
	
	var _NoEntries2 = _interopRequireDefault(_NoEntries);
	
	var _NoEntriesDetail = __webpack_require__("./src/members/Main/__shared__/components/NoEntries/NoEntriesDetail/index.js");
	
	var _NoEntriesDetail2 = _interopRequireDefault(_NoEntriesDetail);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForumLiveThreadsList = function (_Component) {
	  _inherits(ForumLiveThreadsList, _Component);
	
	  function ForumLiveThreadsList() {
	    _classCallCheck(this, ForumLiveThreadsList);
	
	    return _possibleConstructorReturn(this, (ForumLiveThreadsList.__proto__ || Object.getPrototypeOf(ForumLiveThreadsList)).apply(this, arguments));
	  }
	
	  _createClass(ForumLiveThreadsList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onDidMount && this.props.onDidMount();
	    }
	  }, {
	    key: 'renderNoForumThreads',
	    value: function renderNoForumThreads() {
	      return _react2.default.createElement(
	        _NoEntries2.default,
	        { title: "No threads" },
	        _react2.default.createElement(
	          _NoEntriesDetail2.default,
	          null,
	          "The are currently no forum threads in this list."
	        )
	      );
	    }
	  }, {
	    key: 'renderCurrentlyLiveForumThreads',
	    value: function renderCurrentlyLiveForumThreads() {
	      return this.props.currentlyLiveForumThreads.map(function (forumThread) {
	        var endDate = (0, _moment2.default)(forumThread.liveEnd).fromNow();
	        return _react2.default.createElement(_ForumThread2.default, {
	          isLive: true,
	          key: forumThread.id,
	          forumThread: forumThread,
	          timeInfo: 'Ends ' + endDate
	        });
	      });
	    }
	  }, {
	    key: 'renderStartingSoonForumThreads',
	    value: function renderStartingSoonForumThreads() {
	      return this.props.startingSoonForumThreads.map(function (forumThread) {
	        var startDate = (0, _moment2.default)(forumThread.liveStart).fromNow();
	        return _react2.default.createElement(_ForumThread2.default, {
	          key: forumThread.id,
	          forumThread: forumThread,
	          timeInfo: 'Starts ' + startDate
	        });
	      });
	    }
	  }, {
	    key: 'renderEndedForumThreads',
	    value: function renderEndedForumThreads() {
	      return this.props.endedForumThreads.map(function (forumThread) {
	        var endedDate = (0, _moment2.default)(forumThread.liveEnd).fromNow();
	        return _react2.default.createElement(_ForumThread2.default, {
	          key: forumThread.id,
	          forumThread: forumThread,
	          timeInfo: 'Ended ' + endedDate
	        });
	      });
	    }
	  }, {
	    key: 'renderLoadingForumThreadsList',
	    value: function renderLoadingForumThreadsList() {
	      return _react2.default.createElement(
	        _ForumThreadsList2.default,
	        { title: "Live" },
	        _react2.default.createElement(_ForumThread2.default, { key: 'loader1', isEmpty: true }),
	        _react2.default.createElement(_ForumThread2.default, { key: 'loader2', isEmpty: true }),
	        _react2.default.createElement(_ForumThread2.default, { key: 'loader3', isEmpty: true })
	      );
	    }
	  }, {
	    key: 'renderCurrentlyLiveOrStartingSoonForumThreadsList',
	    value: function renderCurrentlyLiveOrStartingSoonForumThreadsList() {
	      return _react2.default.createElement(
	        _ForumThreadsList2.default,
	        { key: 'liveList', title: "Live" },
	        this.renderCurrentlyLiveForumThreads()
	      );
	    }
	  }, {
	    key: 'renderEndedForumThreadsList',
	    value: function renderEndedForumThreadsList() {
	      return _react2.default.createElement(
	        _ForumThreadsList2.default,
	        { key: 'recentlyEndedList', title: "Recently Ended" },
	        this.renderEndedForumThreads()
	      );
	    }
	  }, {
	    key: 'renderStartingSoonForumThreadsList',
	    value: function renderStartingSoonForumThreadsList() {
	      return _react2.default.createElement(
	        _ForumThreadsList2.default,
	        { key: 'rcoomingSoonList', title: "Coming Soon" },
	        this.renderStartingSoonForumThreads()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ForumLiveList has-background has-pagination' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-narrow' },
	          function () {
	            var lists = [];
	
	            if (_this2.props.currentlyLiveForumThreads.length > 0) {
	              lists.push(_this2.renderCurrentlyLiveOrStartingSoonForumThreadsList());
	            }
	
	            if (_this2.props.startingSoonForumThreads.length > 0) {
	              lists.push(_this2.renderStartingSoonForumThreadsList());
	            }
	
	            if (_this2.props.endedForumThreads.length > 0) {
	              lists.push(_this2.renderEndedForumThreadsList());
	            }
	
	            if (lists.length > 0) {
	              return lists;
	            }
	
	            if (_this2.props.isFetching) {
	              return _this2.renderLoadingForumThreadsList();
	            }
	
	            return _this2.renderNoForumThreads();
	          }()
	        )
	      );
	    }
	  }]);
	
	  return ForumLiveThreadsList;
	}(_react.Component);
	
	ForumLiveThreadsList.propTypes = {
	  endedForumThreads: _react.PropTypes.arrayOf(_entities.ForumThreadShape),
	  currentlyLiveForumThreads: _react.PropTypes.arrayOf(_entities.ForumThreadShape),
	  startingSoonForumThreads: _react.PropTypes.arrayOf(_entities.ForumThreadShape),
	  isFetching: _react.PropTypes.bool,
	  pagesCount: _react.PropTypes.number,
	  onFetchCurrentPage: _react.PropTypes.func,
	  queryString: _react.PropTypes.string,
	  query: _react.PropTypes.object,
	  onDidMount: _react.PropTypes.func
	};
	
	var query = { live: 'true', pageSize: (50) };
	var queryString = JSON.stringify(query);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _getForumPaging = (0, _selectors.getForumPaging)(state, 'forumThreads', { queryString: queryString }),
	      page = _getForumPaging.page,
	      isFetching = _getForumPaging.isFetching,
	      pagesCount = _getForumPaging.pagesCount;
	
	  var _getForumThreadsGroup = (0, _selectors.getForumThreadsGrouped)(state, { page: page, queryString: queryString }),
	      endedForumThreads = _getForumThreadsGroup.endedForumThreads,
	      currentlyLiveForumThreads = _getForumThreadsGroup.currentlyLiveForumThreads,
	      startingSoonForumThreads = _getForumThreadsGroup.startingSoonForumThreads;
	
	  return {
	    endedForumThreads: endedForumThreads,
	    currentlyLiveForumThreads: currentlyLiveForumThreads,
	    startingSoonForumThreads: startingSoonForumThreads,
	    isFetching: isFetching,
	    queryString: queryString,
	    query: query,
	    pagesCount: pagesCount
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onDidMount: function onDidMount() {
	      dispatch(actions.forumThreadsFetch(1, query, queryString));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForumLiveThreadsList);

/***/ },

/***/ "./src/members/Main/Forum/ForumThreadProfile/ForumLiveCommentsList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _CommentsList = __webpack_require__("./src/members/Main/__shared__/components/CommentsList/index.js");
	
	var _CommentsList2 = _interopRequireDefault(_CommentsList);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _ResourceComment = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCommentsList/ResourceComment/index.js");
	
	var _ResourceComment2 = _interopRequireDefault(_ResourceComment);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _Comment = __webpack_require__("./src/members/Main/__shared__/components/CommentsList/Comment/index.js");
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	var _InfoBar = __webpack_require__("./src/members/Main/__shared__/components/InfoBar/index.js");
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactFlipMove = __webpack_require__("./node_modules/react-flip-move/lib/index.js");
	
	var _reactFlipMove2 = _interopRequireDefault(_reactFlipMove);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForumLiveCommentsList = function (_Component) {
	  _inherits(ForumLiveCommentsList, _Component);
	
	  function ForumLiveCommentsList() {
	    _classCallCheck(this, ForumLiveCommentsList);
	
	    var _this = _possibleConstructorReturn(this, (ForumLiveCommentsList.__proto__ || Object.getPrototypeOf(ForumLiveCommentsList)).call(this));
	
	    _this.handleFetchOlderComments = _this.handleFetchOlderComments.bind(_this);
	    return _this;
	  }
	
	  _createClass(ForumLiveCommentsList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onDidMount && this.props.onDidMount();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.props.onDidUpdate && this.props.onDidUpdate(prevProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onWillUnmount && this.props.onWillUnmount();
	    }
	  }, {
	    key: 'renderComments',
	    value: function renderComments(comments) {
	      return comments.map(function (comment) {
	        return _react2.default.createElement(_ResourceComment2.default, {
	          key: comment.id,
	          comment: comment,
	          canBeRepliedTo: false
	        });
	      });
	    }
	  }, {
	    key: 'renderLoadingComments',
	    value: function renderLoadingComments() {
	      return [_react2.default.createElement(_Comment2.default, { key: 'loader1', isEmpty: true }), _react2.default.createElement(_Comment2.default, { key: 'loader2', isEmpty: true }), _react2.default.createElement(_Comment2.default, { key: 'loader3', isEmpty: true })];
	    }
	  }, {
	    key: 'handleFetchOlderComments',
	    value: function handleFetchOlderComments(event) {
	      event.preventDefault();
	      this.props.onFetchOlderComments && this.props.onFetchOlderComments(this.props.oldestComment);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: true },
	        this.props.isSuccessInfoBarVisible && _react2.default.createElement(_InfoBar2.default, {
	          type: 'primary',
	          message: this.props.successInfoBarMessage,
	          title: this.props.successInfoBarTitle,
	          onClose: this.props.onInfoBarClose }),
	        _react2.default.createElement(
	          _CommentsList2.default,
	          {
	            allowsSorting: false,
	            isFollowed: this.props.isFollowed,
	            onFollow: this.props.onFollow,
	            onUnfollow: this.props.onUnfollow },
	          _react2.default.createElement(
	            _reactFlipMove2.default,
	            { duration: 200, enterAnimation: 'fade', leaveAnimation: 'fade' },
	            function () {
	              if (_this2.props.comments.length > 0) {
	                return _this2.renderComments(_this2.props.comments);
	              } else {
	                return _this2.renderLoadingComments();
	              }
	            }()
	          )
	        ),
	        this.props.canFetchOlderComments && _react2.default.createElement(
	          _Button2.default,
	          {
	            onClick: this.handleFetchOlderComments,
	            isYellow: true,
	            iconType: 'preloader-dark',
	            hasIcon: this.props.isFetchingOlderComments,
	            isDisabled: this.props.isFetchingOlderComments },
	          "Load older comments"
	        )
	      );
	    }
	  }]);
	
	  return ForumLiveCommentsList;
	}(_react.Component);
	
	ForumLiveCommentsList.propTypes = {
	  comments: _react.PropTypes.arrayOf(_entities.CommentShape),
	  oldestComment: _entities.CommentShape,
	  isSuccessInfoBarVisible: _react.PropTypes.bool,
	  successInfoBarMessage: _react.PropTypes.string,
	  isFollowed: _react.PropTypes.bool,
	  isFetchingOlderComments: _react.PropTypes.bool,
	  canFetchOlderComments: _react.PropTypes.bool,
	  successInfoBarTitle: _react.PropTypes.string,
	  onDidMount: _react.PropTypes.func,
	  onWillUnmount: _react.PropTypes.func,
	  onDidUpdate: _react.PropTypes.func,
	  onInfoBarClose: _react.PropTypes.func,
	  onFollow: _react.PropTypes.func,
	  onUnfollow: _react.PropTypes.func,
	  onFetchOlderComments: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  // The first page of comments comes from the socket when we start watching the thread. Next pages are loaded via the http api.
	
	  var oldestComment = (0, _selectors.getOldestLiveComment)(state);
	  var comments = (0, _selectors.getComments)(state, { live: true });
	  var isFetchingOlderComments = false;
	
	  if (oldestComment) {
	    var query = {
	      resourceId: props.forumThread.id,
	      resourceType: 'forumThreads',
	      dateOffset: oldestComment.approvedAt
	    };
	    var queryString = JSON.stringify(query);
	
	    var _getCommentsPaging = (0, _selectors.getCommentsPaging)(state, null, { queryString: queryString }),
	        isFetching = _getCommentsPaging.isFetching;
	
	    isFetchingOlderComments = isFetching;
	  }
	
	  var canFetchOlderComments = comments.length > 0 && !(0, _selectors.getCommentsIsLiveListEndReached)(state);
	  var successState = (0, _selectors.getInfoState)(state, 'success');
	
	  return {
	    comments: comments,
	    isSuccessInfoBarVisible: successState.visible,
	    successInfoBarMessage: successState.message,
	    successInfoBarTitle: successState.title,
	    isFetchingOlderComments: isFetchingOlderComments,
	    canFetchOlderComments: canFetchOlderComments,
	    oldestComment: oldestComment
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  var reset = function reset() {
	    dispatch(actions.infoClose('success'));
	    dispatch(actions.forumThreadUnwatch(props.forumThread));
	    dispatch(actions.commentsResetLiveList());
	    dispatch(actions.commentReset('firstLevel'));
	    dispatch(actions.commentEmojisHide('firstLevel'));
	  };
	
	  return {
	    onDidMount: function onDidMount() {
	      dispatch(actions.forumThreadWatch(props.forumThread));
	    },
	    onDidUpdate: function onDidUpdate(prevProps) {
	      if (prevProps.forumThread.id !== props.forumThread.id) {
	        reset();
	        dispatch(actions.forumThreadWatch(props.forumThread));
	      }
	    },
	    onWillUnmount: function onWillUnmount() {
	      reset();
	    },
	    onInfoBarClose: function onInfoBarClose() {
	      dispatch(actions.infoClose('success'));
	    },
	    onFetchOlderComments: function onFetchOlderComments(oldestComment) {
	      var query = {
	        resourceId: props.forumThread.id,
	        resourceType: 'forumThreads',
	        dateOffset: oldestComment.approvedAt
	      };
	
	      dispatch(actions.commentsFetch(1, (10), query, true));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForumLiveCommentsList);

/***/ },

/***/ "./src/members/Main/Forum/ForumThreadProfile/ForumThreadProfileSidebar/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _Sidebar = __webpack_require__("./src/members/Main/__shared__/components/Sidebar/index.js");
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _SidebarGroup = __webpack_require__("./src/members/Main/__shared__/components/Sidebar/SidebarGroup/index.js");
	
	var _SidebarGroup2 = _interopRequireDefault(_SidebarGroup);
	
	var _SidebarGroupItem = __webpack_require__("./src/members/Main/__shared__/components/Sidebar/SidebarGroup/SidebarGroupItem/index.js");
	
	var _SidebarGroupItem2 = _interopRequireDefault(_SidebarGroupItem);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _forumQueries = __webpack_require__("./src/members/__shared__/forumQueries.js");
	
	var _forumQueries2 = _interopRequireDefault(_forumQueries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForumThreadProfileSidebar = function (_Component) {
	  _inherits(ForumThreadProfileSidebar, _Component);
	
	  function ForumThreadProfileSidebar() {
	    _classCallCheck(this, ForumThreadProfileSidebar);
	
	    return _possibleConstructorReturn(this, (ForumThreadProfileSidebar.__proto__ || Object.getPrototypeOf(ForumThreadProfileSidebar)).apply(this, arguments));
	  }
	
	  _createClass(ForumThreadProfileSidebar, [{
	    key: 'renderForumThreads',
	    value: function renderForumThreads(forumThreads) {
	      return forumThreads.map(function (forumThread) {
	        return _react2.default.createElement(_SidebarGroupItem2.default, {
	          key: forumThread.id,
	          title: forumThread.title,
	          authorName: forumThread.author.userName,
	          authorAvatarUrl: forumThread.author.avatar.url,
	          articleUrl: '/forum/threads/' + forumThread.id
	        });
	      });
	    }
	  }, {
	    key: 'renderForumThreadsGroups',
	    value: function renderForumThreadsGroups(forumThreadsGroups) {
	      var _this2 = this;
	
	      return forumThreadsGroups.map(function (forumThreadGroup) {
	        var forumThreads = forumThreadGroup.forumThreads;
	
	
	        return _react2.default.createElement(
	          _SidebarGroup2.default,
	          { key: forumThreadGroup.title, title: forumThreadGroup.title },
	          _this2.renderForumThreads(forumThreads)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Sidebar2.default,
	        null,
	        this.renderForumThreadsGroups(this.props.forumThreadsGroups)
	      );
	    }
	  }]);
	
	  return ForumThreadProfileSidebar;
	}(_react.Component);
	
	ForumThreadProfileSidebar.propTypes = {
	  forumThreadsGroups: _react.PropTypes.array
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var forumThreadsGroups = [];
	  var queryString = JSON.stringify(_forumQueries2.default['Popular']);
	  var allForumThreads = (0, _selectors.getForumThreadsOnSidebar)(state, { page: 1, queryString: queryString });
	  var forumThreads = allForumThreads.slice(0, Math.min(3, allForumThreads.length));
	
	  if (forumThreads.length > 0) {
	    forumThreadsGroups.push({
	      title: "Popular",
	      forumThreads: forumThreads
	    });
	  }
	
	  return {
	    forumThreadsGroups: forumThreadsGroups
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForumThreadProfileSidebar);

/***/ },

/***/ "./src/members/Main/Forum/ForumThreadProfile/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _bitterBbcode = __webpack_require__("./node_modules/bitter-bbcode/lib/bbcode.js");
	
	var _bitterBbcode2 = _interopRequireDefault(_bitterBbcode);
	
	var _reactEmojione = __webpack_require__("./node_modules/react-emojione/lib/react-emojione.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ResourceCommentsList = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCommentsList/index.js");
	
	var _ResourceCommentsList2 = _interopRequireDefault(_ResourceCommentsList);
	
	var _ForumLiveCommentsList = __webpack_require__("./src/members/Main/Forum/ForumThreadProfile/ForumLiveCommentsList/index.js");
	
	var _ForumLiveCommentsList2 = _interopRequireDefault(_ForumLiveCommentsList);
	
	var _ResourceCommentsTextEditor = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCommentsTextEditor/index.js");
	
	var _ResourceCommentsTextEditor2 = _interopRequireDefault(_ResourceCommentsTextEditor);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actions2 = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var _ForumThreadProfileSidebar = __webpack_require__("./src/members/Main/Forum/ForumThreadProfile/ForumThreadProfileSidebar/index.js");
	
	var _ForumThreadProfileSidebar2 = _interopRequireDefault(_ForumThreadProfileSidebar);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _commentsResourceTypes = __webpack_require__("./src/members/__shared__/commentsResourceTypes.js");
	
	var _forumLiveStatus = __webpack_require__("./src/members/__shared__/forumLiveStatus.js");
	
	__webpack_require__("./src/members/Main/Forum/ForumThreadProfile/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable react/no-danger*/
	
	var ForumThreadProfile = function (_Component) {
	  _inherits(ForumThreadProfile, _Component);
	
	  function ForumThreadProfile() {
	    _classCallCheck(this, ForumThreadProfile);
	
	    var _this = _possibleConstructorReturn(this, (ForumThreadProfile.__proto__ || Object.getPrototypeOf(ForumThreadProfile)).call(this));
	
	    _this.handleFollow = _this.handleFollow.bind(_this);
	    _this.handleUnfollow = _this.handleUnfollow.bind(_this);
	    _this.defaultForumThread = {};
	    return _this;
	  }
	
	  _createClass(ForumThreadProfile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onDidMount && this.props.onDidMount(this.props.forumThread);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.props.onDidUpdate && this.props.onDidUpdate(prevProps);
	    }
	  }, {
	    key: 'handleFollow',
	    value: function handleFollow() {
	      this.props.onFollow && this.props.onFollow(this.props.forumThread);
	    }
	  }, {
	    key: 'handleUnfollow',
	    value: function handleUnfollow() {
	      this.props.onUnfollow && this.props.onUnfollow(this.props.forumThread);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var forumThread = this.props.forumThread;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ForumThreadProfile', ref: 'forumThreadProfile' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-large is-collapsed' },
	          _react2.default.createElement(
	            'div',
	            { className: 'community-resource' },
	            forumThread && _react2.default.createElement(
	              'div',
	              { className: 'head' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                forumThread.title
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'forum-thread-meta' },
	                _react2.default.createElement(_UserAvatar2.default, { letter: forumThread.author.userName[0], imageUrl: forumThread.author.avatar.url }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'author' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    forumThread.author.userName
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'time' },
	                  (0, _moment2.default)(forumThread.createdAt).format(("MMMM Do YYYY, h:mm a"))
	                )
	              )
	            ),
	            function () {
	              if (forumThread) {
	                return _react2.default.createElement('div', { className: 'resource-text-content', dangerouslySetInnerHTML: { __html: (0, _reactEmojione.emojify)((0, _bitterBbcode2.default)(forumThread.body), { output: 'unicode' }) } });
	              }
	
	              return _react2.default.createElement(
	                'div',
	                { className: 'while-loading' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  "Loading..."
	                )
	              );
	            }(),
	            forumThread && _react2.default.createElement(
	              'div',
	              { className: 'resource-actions' },
	              _react2.default.createElement(
	                'div',
	                { className: 'resource-add-comment' },
	                _react2.default.createElement(_ResourceCommentsTextEditor2.default, {
	                  ref: 'textEditor',
	                  isForNewComments: true,
	                  resourceType: 'forumThreads',
	                  resourceId: forumThread.id
	                })
	              ),
	              function () {
	                if ((0, _forumLiveStatus.isLiveNow)(forumThread) || (0, _forumLiveStatus.isSoonToBeLive)(forumThread)) {
	                  return _react2.default.createElement(_ForumLiveCommentsList2.default, {
	                    forumThread: forumThread,
	                    isFollowed: forumThread.followed,
	                    onFollow: _this2.handleFollow,
	                    onUnfollow: _this2.handleUnfollow
	                  });
	                }
	
	                return _react2.default.createElement(_ResourceCommentsList2.default, {
	                  scrollElementGetter: function scrollElementGetter() {
	                    return _this2.refs.forumThreadProfile;
	                  },
	                  urlParams: _this2.props.params,
	                  isFollowed: forumThread.followed,
	                  resourceId: forumThread.id,
	                  canCommentsBeRepliedTo: !forumThread.live,
	                  resourceType: 'forumThreads',
	                  repliesResourceType: (0, _commentsResourceTypes.findCommentRepliesType)('forumThreads'),
	                  onFollow: _this2.handleFollow,
	                  onUnfollow: _this2.handleUnfollow
	                });
	              }()
	            )
	          ),
	          _react2.default.createElement(_ForumThreadProfileSidebar2.default, { isWider: true })
	        )
	      );
	    }
	  }]);
	
	  return ForumThreadProfile;
	}(_react.Component);
	
	ForumThreadProfile.propTypes = {
	  forumThread: _entities.ForumThreadShape,
	  params: _react.PropTypes.object,
	  onDidMount: _react.PropTypes.func,
	  onDidUpdate: _react.PropTypes.func,
	  onFollow: _react.PropTypes.func,
	  onUnfollow: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    forumThread: (0, _selectors.getForumThread)(state, props.params.id)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onDidMount: function onDidMount(forumThread) {
	      if (!forumThread) {
	        dispatch((0, _actions2.actionCausedByURLChangeFrom)(actions.forumThreadProfileFetch(props.params.id)));
	      }
	    },
	    onDidUpdate: function onDidUpdate(prevProps) {
	      if (prevProps.params.id !== props.params.id) {
	        dispatch((0, _actions2.actionCausedByURLChangeFrom)(actions.forumThreadProfileFetch(props.params.id)));
	      }
	    },
	    onFollow: function onFollow(forumThread) {
	      dispatch(actions.forumThreadUpdate(forumThread.id, forumThread, { followed: true }));
	    },
	    onUnfollow: function onUnfollow(forumThread) {
	      dispatch(actions.forumThreadUpdate(forumThread.id, forumThread, { followed: false }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForumThreadProfile);

/***/ },

/***/ "./src/members/Main/Forum/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SubNavigation = __webpack_require__("./src/members/Main/__shared__/components/SubNavigation/index.js");
	
	var _SubNavigation2 = _interopRequireDefault(_SubNavigation);
	
	var _SubNavigationItem = __webpack_require__("./src/members/Main/__shared__/components/SubNavigation/SubNavigationItem/index.js");
	
	var _SubNavigationItem2 = _interopRequireDefault(_SubNavigationItem);
	
	var _forumQueries = __webpack_require__("./src/members/__shared__/forumQueries.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/Forum/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Forum = function (_Component) {
	  _inherits(Forum, _Component);
	
	  function Forum() {
	    _classCallCheck(this, Forum);
	
	    return _possibleConstructorReturn(this, (Forum.__proto__ || Object.getPrototypeOf(Forum)).apply(this, arguments));
	  }
	
	  _createClass(Forum, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.dispatchEvent(new Event('resize')); // The Flickity component wouldn't layout properly if this page is opened directly.
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'section',
	        { className: 'Forum content-wrapper' },
	        _react2.default.createElement(
	          _SubNavigation2.default,
	          null,
	          _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForForum: true, to: '/forum?following=true' },
	            "Following"
	          ),
	           true ? _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForForum: true, to: '/forum/live' },
	            _react2.default.createElement('span', { className: (0, _classnames2.default)('dot', { 'is-live': this.props.hasRunningLiveThreads }) }),
	            ' ',
	            "Live"
	          ) : _react2.default.createElement('div', null),
	          _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForForum: true, to: '/forum?sort=popular', isActive: this.props.isPopularActive },
	            "Popular"
	          ),
	           true ? _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForForum: true, to: '/forum/ask-kooth' },
	            "Ask Kooth"
	          ) : _react2.default.createElement('div', null),
	          _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForForum: true, to: '/forum/categories' },
	            "Categories"
	          ),
	          _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForForum: true, to: '/forum/start-discussion' },
	            "Start new Discussion"
	          )
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Forum;
	}(_react.Component);
	
	Forum.propTypes = {
	  children: _react.PropTypes.element,
	  isPopularActive: _react.PropTypes.bool,
	  hasRunningLiveThreads: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var _props$location = props.location,
	      pathname = _props$location.pathname,
	      query = _props$location.query;
	
	  var normalizedQuery = (0, _forumQueries.normalizeForumQuery)(query);
	
	  var _getForumStatus = (0, _selectors.getForumStatus)(state),
	      hasRunningLiveThreads = _getForumStatus.hasRunningLiveThreads;
	
	  return {
	    isPopularActive: pathname === '/forum' && normalizedQuery.sort === 'popular',
	    hasRunningLiveThreads: hasRunningLiveThreads
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Forum);

/***/ },

/***/ "./src/members/Main/Interests/InterestsTopicCheckbox/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _AccordionCheckbox = __webpack_require__("./src/members/Main/__shared__/components/Accordion/AccordionCheckbox/index.js");
	
	var _AccordionCheckbox2 = _interopRequireDefault(_AccordionCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InterestsTopicCheckbox = function (_Component) {
	  _inherits(InterestsTopicCheckbox, _Component);
	
	  function InterestsTopicCheckbox() {
	    _classCallCheck(this, InterestsTopicCheckbox);
	
	    return _possibleConstructorReturn(this, (InterestsTopicCheckbox.__proto__ || Object.getPrototypeOf(InterestsTopicCheckbox)).apply(this, arguments));
	  }
	
	  _createClass(InterestsTopicCheckbox, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.topic !== this.props.topic;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$topic = this.props.topic,
	          id = _props$topic.id,
	          title = _props$topic.title,
	          interestedIn = _props$topic.interestedIn;
	
	      return _react2.default.createElement(_AccordionCheckbox2.default, {
	        id: id,
	        title: title,
	        isChecked: interestedIn,
	        onClick: this.props.onClick
	      });
	    }
	  }]);
	
	  return InterestsTopicCheckbox;
	}(_react.Component);
	
	InterestsTopicCheckbox.propTypes = {
	  topic: _entities.TopicShape,
	  onClick: _react.PropTypes.func
	};
	
	exports.default = InterestsTopicCheckbox;

/***/ },

/***/ "./src/members/Main/Interests/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _ResourceCategoriesAccordion = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCategoriesAccordion/index.js");
	
	var _ResourceCategoriesAccordion2 = _interopRequireDefault(_ResourceCategoriesAccordion);
	
	var _InterestsTopicCheckbox = __webpack_require__("./src/members/Main/Interests/InterestsTopicCheckbox/index.js");
	
	var _InterestsTopicCheckbox2 = _interopRequireDefault(_InterestsTopicCheckbox);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	__webpack_require__("./src/members/Main/Interests/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Interests = function (_Component) {
	  _inherits(Interests, _Component);
	
	  function Interests() {
	    _classCallCheck(this, Interests);
	
	    var _this = _possibleConstructorReturn(this, (Interests.__proto__ || Object.getPrototypeOf(Interests)).call(this));
	
	    _this.renderTopic = _this.renderTopic.bind(_this);
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Interests, [{
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(checkboxData) {
	      if (this.props.onTopicClick) {
	        this.props.onTopicClick(checkboxData);
	      }
	    }
	  }, {
	    key: 'renderTopic',
	    value: function renderTopic(topic) {
	      return _react2.default.createElement(_InterestsTopicCheckbox2.default, {
	        key: topic.id,
	        topic: topic,
	        onClick: this.handleCheckboxClick
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'Interests content-wrapper has-background', ref: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-padded-vertical' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            "Pick your interests"
	          ),
	          _react2.default.createElement(_ResourceCategoriesAccordion2.default, {
	            isForMagazine: true,
	            resourceType: 'articles',
	            resourceNameSingular: "article",
	            resourceNamePlural: "articles",
	            renderTopic: this.renderTopic,
	            scrollElementGetter: function scrollElementGetter() {
	              return _this2.refs.wrapper;
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Interests;
	}(_react.Component);
	
	Interests.propTypes = {
	  onTopicClick: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onTopicClick: function onTopicClick(data) {
	      var id = data.id,
	          isChecked = data.isChecked;
	
	      var interestedIn = !isChecked;
	      dispatch(actions.topicUpdate(id, { interestedIn: interestedIn }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Interests);

/***/ },

/***/ "./src/members/Main/Journal/JournalEntry/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactNl2br = __webpack_require__("./node_modules/react-nl2br/index.js");
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	var _reactEmojione = __webpack_require__("./node_modules/react-emojione/lib/react-emojione.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	__webpack_require__("./src/members/Main/Journal/JournalEntry/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JournalEntry = function (_Component) {
	  _inherits(JournalEntry, _Component);
	
	  function JournalEntry() {
	    _classCallCheck(this, JournalEntry);
	
	    return _possibleConstructorReturn(this, (JournalEntry.__proto__ || Object.getPrototypeOf(JournalEntry)).apply(this, arguments));
	  }
	
	  _createClass(JournalEntry, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isEmpty = _props.isEmpty,
	          _props$journalEntry = _props.journalEntry,
	          journalEntry = _props$journalEntry === undefined ? { emoji: '', text: '' } : _props$journalEntry;
	
	      var className = (0, _classnames2.default)('JournalEntry', { 'is-empty': isEmpty });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'icon' },
	                  (0, _reactEmojione.emojify)(journalEntry.emoji, { output: 'unicode' })
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'date' },
	                  (0, _moment2.default)(journalEntry.createdAt).fromNow()
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  (0, _reactNl2br2.default)((0, _reactEmojione.emojify)(journalEntry.text, { output: 'unicode' }))
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return JournalEntry;
	}(_react.Component);
	
	JournalEntry.propTypes = {
	  journalEntry: _entities.JournalEntryShape,
	  isEmpty: _react.PropTypes.bool,
	  onJournalEntriesFetch: _react.PropTypes.func
	};
	
	exports.default = JournalEntry;

/***/ },

/***/ "./src/members/Main/Journal/JournalPageSelector/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageSelector = __webpack_require__("./src/members/Main/__shared__/components/PageSelector/index.js");
	
	var _PageSelector2 = _interopRequireDefault(_PageSelector);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JournalPageSelector = function JournalPageSelector(props) {
	  return _react2.default.createElement(_PageSelector2.default, props);
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return (0, _selectors.getJournalPaging)(state);
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onPrevClick: function onPrevClick(currentPage) {
	      dispatch(actions.journalEntriesFetch(currentPage - 1));
	    },
	    onNextClick: function onNextClick(currentPage) {
	      dispatch(actions.journalEntriesFetch(currentPage + 1));
	    },
	    onPossiblePageUpdate: function onPossiblePageUpdate(newPossiblePage) {
	      dispatch(actions.journalEntriesUpdatePossiblePage(newPossiblePage));
	    },
	    onPageUpdate: function onPageUpdate(newPage, pagesCount) {
	      if (newPage >= 1 && newPage <= pagesCount) {
	        dispatch(actions.journalEntriesFetch(newPage));
	      }
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JournalPageSelector);

/***/ },

/***/ "./src/members/Main/Journal/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _JournalEntryForm = __webpack_require__("./src/members/Main/__shared__/containers/JournalEntryForm/index.js");
	
	var _JournalEntryForm2 = _interopRequireDefault(_JournalEntryForm);
	
	var _JournalEntry = __webpack_require__("./src/members/Main/Journal/JournalEntry/index.js");
	
	var _JournalEntry2 = _interopRequireDefault(_JournalEntry);
	
	var _JournalPageSelector = __webpack_require__("./src/members/Main/Journal/JournalPageSelector/index.js");
	
	var _JournalPageSelector2 = _interopRequireDefault(_JournalPageSelector);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/Journal/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Journal = function (_Component) {
	  _inherits(Journal, _Component);
	
	  function Journal() {
	    _classCallCheck(this, Journal);
	
	    var _this = _possibleConstructorReturn(this, (Journal.__proto__ || Object.getPrototypeOf(Journal)).call(this));
	
	    _this.renderJournalEntries = _this.renderJournalEntries.bind(_this);
	    return _this;
	  }
	
	  _createClass(Journal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onJournalEntriesFetch();
	      this.props.onJournalEmojisFetch();
	    }
	  }, {
	    key: 'renderJournalEntries',
	    value: function renderJournalEntries() {
	      return this.props.journalEntries.map(function (journalEntry) {
	        return _react2.default.createElement(_JournalEntry2.default, {
	          key: journalEntry.id,
	          journalEntry: journalEntry
	        });
	      });
	    }
	  }, {
	    key: 'renderJournalEntriesForLoading',
	    value: function renderJournalEntriesForLoading() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_JournalEntry2.default, { isEmpty: true }),
	        _react2.default.createElement(_JournalEntry2.default, { isEmpty: true }),
	        _react2.default.createElement(_JournalEntry2.default, { isEmpty: true }),
	        _react2.default.createElement(_JournalEntry2.default, { isEmpty: true }),
	        _react2.default.createElement(_JournalEntry2.default, { isEmpty: true })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'Journal content-wrapper has-background' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-collapsed is-padded-vertical' },
	          _react2.default.createElement(
	            'div',
	            { className: 'feed-layout' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                "Journal"
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrapper-small is-collapsed' },
	                _react2.default.createElement(_JournalEntryForm2.default, {
	                  title: "How do you feel today?",
	                  text: "Log your feeling every day so you can see your progress. This information is not publicly visible, but counselors can see it.",
	                  emojis: this.props.emojis
	                }),
	                function () {
	                  if (_this2.props.journalEntries.length > 0) {
	                    return _this2.renderJournalEntries();
	                  } else if (_this2.props.isFetching) {
	                    return _this2.renderJournalEntriesForLoading();
	                  }
	                }(),
	                this.props.pagesCount > 1 && _react2.default.createElement(_JournalPageSelector2.default, null)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Journal;
	}(_react.Component);
	
	Journal.propTypes = {
	  onJournalEntriesFetch: _react.PropTypes.func,
	  onJournalEmojisFetch: _react.PropTypes.func,
	  journalEntries: _react.PropTypes.arrayOf(_entities.JournalEntryShape),
	  emojis: _react.PropTypes.arrayOf(_react2.default.PropTypes.string),
	  pagesCount: _react.PropTypes.number,
	  isFetching: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _getJournalPaging = (0, _selectors.getJournalPaging)(state),
	      page = _getJournalPaging.page,
	      isFetching = _getJournalPaging.isFetching,
	      pagesCount = _getJournalPaging.pagesCount;
	
	  return {
	    journalEntries: (0, _selectors.getJournalEntries)(state, { page: page }),
	    emojis: (0, _selectors.getJournalEmojis)(state).emojis,
	    isFetching: isFetching,
	    pagesCount: pagesCount
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onJournalEntriesFetch: function onJournalEntriesFetch() {
	      dispatch(actions.journalEntriesFetch());
	    },
	    onJournalEmojisFetch: function onJournalEmojisFetch() {
	      dispatch(actions.journalEmojisFetch());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Journal);

/***/ },

/***/ "./src/members/Main/Links/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/Links/style.scss");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Links = function (_Component) {
	  _inherits(Links, _Component);
	
	  function Links() {
	    _classCallCheck(this, Links);
	
	    return _possibleConstructorReturn(this, (Links.__proto__ || Object.getPrototypeOf(Links)).apply(this, arguments));
	  }
	
	  _createClass(Links, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onDidMount) {
	        this.props.onDidMount();
	      }
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink(link, index) {
	      var image = link.image,
	          url = link.url,
	          title = link.title;
	
	      var className = (0, _classnames2.default)('link-inner', { 'has-logo': !!image });
	
	      // The next block uses classNames that are shared with index.html
	      // If you change them, please, rename in index.html too
	      return _react2.default.createElement(
	        'div',
	        { className: className, key: index },
	        image && _react2.default.createElement(
	          'div',
	          { className: 'logo' },
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: url },
	            _react2.default.createElement('img', { src: image, alt: title })
	          )
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: url, className: 'Link' },
	          url
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'Links content-wrapper has-background' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            "Links"
	          ),
	          function () {
	            if (_this2.props.isFetching) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'while-loading' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  "Loading..."
	                )
	              );
	            } else {
	              return _react2.default.createElement(
	                'div',
	                { className: 'outer-links is-inside-app' },
	                _this2.props.links.map(function (link, index) {
	                  return _this2.renderLink(link, index);
	                })
	              );
	            }
	          }()
	        )
	      );
	    }
	  }]);
	
	  return Links;
	}(_react.Component);
	
	Links.propTypes = {
	  onDidMount: _react.PropTypes.func,
	  isFetching: _react.PropTypes.bool,
	  links: _react.PropTypes.arrayOf(_entities.LinkShape)
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return _extends({}, (0, _selectors.getLinks)(state));
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onDidMount: function onDidMount() {
	      dispatch(actions.linksFetch());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Links);

/***/ },

/***/ "./src/members/Main/Magazine/MagazineArticleProfile/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _bitterBbcode = __webpack_require__("./node_modules/bitter-bbcode/lib/bbcode.js");
	
	var _bitterBbcode2 = _interopRequireDefault(_bitterBbcode);
	
	var _reactEmojione = __webpack_require__("./node_modules/react-emojione/lib/react-emojione.js");
	
	var _ResourceCommentsList = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCommentsList/index.js");
	
	var _ResourceCommentsList2 = _interopRequireDefault(_ResourceCommentsList);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	__webpack_require__("./src/members/Main/Magazine/MagazineArticleProfile/style.scss");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actions2 = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var _magazineQueries = __webpack_require__("./src/members/__shared__/magazineQueries.js");
	
	var _magazineQueries2 = _interopRequireDefault(_magazineQueries);
	
	var _MagazineArticlesSidebar = __webpack_require__("./src/members/Main/__shared__/containers/MagazineArticlesSidebar/index.js");
	
	var _MagazineArticlesSidebar2 = _interopRequireDefault(_MagazineArticlesSidebar);
	
	var _MagazineArticle = __webpack_require__("./src/members/Main/__shared__/containers/MagazineArticle/index.js");
	
	var _MagazineArticle2 = _interopRequireDefault(_MagazineArticle);
	
	var _EmptyArticle = __webpack_require__("./src/members/Main/__shared__/components/EmptyArticle/index.js");
	
	var _EmptyArticle2 = _interopRequireDefault(_EmptyArticle);
	
	var _ResourceCommentsTextEditor = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCommentsTextEditor/index.js");
	
	var _ResourceCommentsTextEditor2 = _interopRequireDefault(_ResourceCommentsTextEditor);
	
	var _commentsResourceTypes = __webpack_require__("./src/members/__shared__/commentsResourceTypes.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable react/no-danger*/
	
	var MagazineArticleProfile = function (_Component) {
	  _inherits(MagazineArticleProfile, _Component);
	
	  function MagazineArticleProfile() {
	    _classCallCheck(this, MagazineArticleProfile);
	
	    var _this = _possibleConstructorReturn(this, (MagazineArticleProfile.__proto__ || Object.getPrototypeOf(MagazineArticleProfile)).call(this));
	
	    _this.handleFollow = _this.handleFollow.bind(_this);
	    _this.handleUnfollow = _this.handleUnfollow.bind(_this);
	    _this.handleFavourite = _this.handleFavourite.bind(_this);
	    _this.handleUnfavourite = _this.handleUnfavourite.bind(_this);
	    _this.scrolledToComments = false;
	    _this.defaultArticle = { thumbnail: { main: { highRes: null } } };
	    return _this;
	  }
	
	  _createClass(MagazineArticleProfile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onDidMount) {
	        this.props.onDidMount();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.magazineArticle.text && this.props.location.hash === '#comments' && !this.scrolledToComments) {
	        this.scrolledToComments = true;
	        var textEditorElement = _reactDom2.default.findDOMNode(this.refs.textEditor);
	        window.scrollTo(0, textEditorElement.offsetTop - this.refs.magazineArticleProfile.offsetTop);
	      }
	
	      this.props.onDidUpdate && this.props.onDidUpdate(prevProps.params);
	    }
	  }, {
	    key: 'handleFollow',
	    value: function handleFollow() {
	      this.props.onFollow && this.props.onFollow(this.props.magazineArticle);
	    }
	  }, {
	    key: 'handleUnfollow',
	    value: function handleUnfollow() {
	      this.props.onFollow && this.props.onUnfollow(this.props.magazineArticle);
	    }
	  }, {
	    key: 'handleFavourite',
	    value: function handleFavourite(event) {
	      event.preventDefault();
	      this.props.onFavourite && this.props.onFavourite(this.props.magazineArticle);
	    }
	  }, {
	    key: 'handleUnfavourite',
	    value: function handleUnfavourite(event) {
	      event.preventDefault();
	      this.props.onUnfavourite && this.props.onUnfavourite(this.props.magazineArticle);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$magazineArticl = this.props.magazineArticle,
	          magazineArticle = _props$magazineArticl === undefined ? this.defaultArticle : _props$magazineArticl;
	
	      var html = magazineArticle.text ? (0, _bitterBbcode2.default)(magazineArticle.text) : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MagazineArticleProfile', ref: 'magazineArticleProfile' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-xlarge is-collapsed' },
	          function () {
	            if (magazineArticle.id) {
	              return _react2.default.createElement(_MagazineArticle2.default, {
	                magazineArticle: magazineArticle,
	                imageUrl: magazineArticle.thumbnail.preview.highRes,
	                isTitleOnTop: true,
	                showsReadMoreAndComments: false,
	                isFeatured: true
	              });
	            } else {
	              return _react2.default.createElement(_EmptyArticle2.default, { isFeatured: true });
	            }
	          }()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-large is-collapsed' },
	          _react2.default.createElement(
	            'div',
	            { className: 'community-resource' },
	            function () {
	              if (html) {
	                return _react2.default.createElement('div', { className: 'resource-text-content', dangerouslySetInnerHTML: { __html: (0, _reactEmojione.emojify)(html, { output: 'unicode' }) } });
	              }
	
	              return _react2.default.createElement(
	                'div',
	                { className: 'while-loading' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  "Loading..."
	                )
	              );
	            }(),
	            _react2.default.createElement(
	              'div',
	              { className: 'resource-actions' },
	              _react2.default.createElement(
	                'div',
	                { className: 'favourites-button float-left' },
	                function () {
	                  if (magazineArticle.favourite) {
	                    return _react2.default.createElement(
	                      _Button2.default,
	                      { isSmall: true, isYellow: true, hasIcon: true, iconType: 'star', onClick: _this2.handleUnfavourite },
	                      "Add to favourites"
	                    );
	                  }
	
	                  return _react2.default.createElement(
	                    _Button2.default,
	                    { isSmall: true, hasIcon: true, iconType: 'star', onClick: _this2.handleFavourite },
	                    "Remove from favourites"
	                  );
	                }()
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'resource-add-comment' },
	                _react2.default.createElement(_ResourceCommentsTextEditor2.default, { ref: 'textEditor', isForNewComments: true, resourceType: 'articles', resourceId: magazineArticle.id })
	              ),
	              magazineArticle.id && _react2.default.createElement(_ResourceCommentsList2.default, {
	                scrollElementGetter: function scrollElementGetter() {
	                  return _this2.refs.magazineArticleProfile;
	                },
	                urlParams: this.props.params,
	                isFollowed: magazineArticle.followed,
	                resourceId: magazineArticle.id,
	                canCommentsBeRepliedTo: true,
	                resourceType: 'articles',
	                repliesResourceType: (0, _commentsResourceTypes.findCommentRepliesType)('articles'),
	                onFollow: this.handleFollow,
	                onUnfollow: this.handleUnfollow
	              })
	            )
	          ),
	          _react2.default.createElement(_MagazineArticlesSidebar2.default, { queries: _defineProperty({}, 'Popular', _magazineQueries2.default['Popular']), isWider: true })
	        )
	      );
	    }
	  }]);
	
	  return MagazineArticleProfile;
	}(_react.Component);
	
	MagazineArticleProfile.propTypes = {
	  magazineArticle: _entities.MagazineArticleShape,
	  location: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  onResourceFollow: _react.PropTypes.func,
	  onDidMount: _react.PropTypes.func,
	  onFollow: _react.PropTypes.func,
	  onUnfollow: _react.PropTypes.func,
	  onFavourite: _react.PropTypes.func,
	  onUnfavourite: _react.PropTypes.func,
	  onDidUpdate: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    magazineArticle: (0, _selectors.getMagazineArticle)(state, props.params.id)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onDidMount: function onDidMount() {
	      dispatch((0, _actions2.actionCausedByURLChangeFrom)(actions.magazineArticleProfileFetch(props.params.id)));
	    },
	    onDidUpdate: function onDidUpdate(prevParams) {
	      if (prevParams.id !== props.params.id) {
	        dispatch((0, _actions2.actionCausedByURLChangeFrom)(actions.magazineArticleProfileFetch(props.params.id)));
	      }
	    },
	    onFollow: function onFollow(magazineArticle) {
	      dispatch(actions.magazineArticleUpdate(magazineArticle.id, magazineArticle, { followed: true }));
	    },
	    onUnfollow: function onUnfollow(magazineArticle) {
	      dispatch(actions.magazineArticleUpdate(magazineArticle.id, magazineArticle, { followed: false }));
	    },
	    onFavourite: function onFavourite(magazineArticle) {
	      dispatch(actions.magazineArticleUpdate(magazineArticle.id, magazineArticle, { favourite: true }));
	    },
	    onUnfavourite: function onUnfavourite(magazineArticle) {
	      dispatch(actions.magazineArticleUpdate(magazineArticle.id, magazineArticle, { favourite: false }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MagazineArticleProfile);

/***/ },

/***/ "./src/members/Main/Magazine/MagazineArticlesList/MagazineArticlesListPageSelector/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MagazineArticlesListPageSelector = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _PageSelector = __webpack_require__("./src/members/Main/__shared__/components/PageSelector/index.js");
	
	var _PageSelector2 = _interopRequireDefault(_PageSelector);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MagazineArticlesListPageSelector = function MagazineArticlesListPageSelector(props) {
	  var query = props.query,
	      queryString = props.queryString,
	      otherProps = _objectWithoutProperties(props, ['query', 'queryString']); //eslint-disable-line no-unused-vars
	
	
	  return _react2.default.createElement(_PageSelector2.default, otherProps);
	};
	
	exports.MagazineArticlesListPageSelector = MagazineArticlesListPageSelector;
	var mapStateToProps = function mapStateToProps(state, props) {
	  var queryString = props.queryString;
	
	  return (0, _selectors.getMagazinePaging)(state, 'magazineArticles', { queryString: queryString });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onPrevClick: function onPrevClick(currentPage) {
	      dispatch(actions.magazineArticlesFetch(currentPage - 1, props.query, props.queryString));
	    },
	    onNextClick: function onNextClick(currentPage) {
	      dispatch(actions.magazineArticlesFetch(currentPage + 1, props.query, props.queryString));
	    },
	    onPossiblePageUpdate: function onPossiblePageUpdate(newPossiblePage) {
	      dispatch(actions.magazineArticlesUpdatePossiblePage(newPossiblePage, props.queryString));
	    },
	    onPageUpdate: function onPageUpdate(newPage, pagesCount) {
	      if (newPage >= 1 && newPage <= pagesCount) {
	        dispatch(actions.magazineArticlesFetch(newPage, props.query, props.queryString));
	      }
	    }
	  };
	};
	
	MagazineArticlesListPageSelector.propTypes = {
	  query: _react.PropTypes.object,
	  queryString: _react.PropTypes.string
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MagazineArticlesListPageSelector);

/***/ },

/***/ "./src/members/Main/Magazine/MagazineArticlesList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _ArticleOuter = __webpack_require__("./src/members/Main/__shared__/components/ArticleOuter/index.js");
	
	var _ArticleOuter2 = _interopRequireDefault(_ArticleOuter);
	
	var _EmptyArticle = __webpack_require__("./src/members/Main/__shared__/components/EmptyArticle/index.js");
	
	var _EmptyArticle2 = _interopRequireDefault(_EmptyArticle);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _MagazineArticlesListPageSelector = __webpack_require__("./src/members/Main/Magazine/MagazineArticlesList/MagazineArticlesListPageSelector/index.js");
	
	var _MagazineArticlesListPageSelector2 = _interopRequireDefault(_MagazineArticlesListPageSelector);
	
	__webpack_require__("./src/members/Main/Magazine/MagazineArticlesList/style.scss");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _MagazineArticle = __webpack_require__("./src/members/Main/__shared__/containers/MagazineArticle/index.js");
	
	var _MagazineArticle2 = _interopRequireDefault(_MagazineArticle);
	
	var _MagazineArticlesSidebar = __webpack_require__("./src/members/Main/__shared__/containers/MagazineArticlesSidebar/index.js");
	
	var _MagazineArticlesSidebar2 = _interopRequireDefault(_MagazineArticlesSidebar);
	
	var _magazineQueries = __webpack_require__("./src/members/__shared__/magazineQueries.js");
	
	var _magazineQueries2 = _interopRequireDefault(_magazineQueries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MagazineArticlesList = function (_Component) {
	  _inherits(MagazineArticlesList, _Component);
	
	  function MagazineArticlesList() {
	    _classCallCheck(this, MagazineArticlesList);
	
	    return _possibleConstructorReturn(this, (MagazineArticlesList.__proto__ || Object.getPrototypeOf(MagazineArticlesList)).apply(this, arguments));
	  }
	
	  _createClass(MagazineArticlesList, [{
	    key: 'renderRestOfTheMagazineArticles',
	    value: function renderRestOfTheMagazineArticles() {
	      return this.props.magazineArticles.slice(1).map(function (magazineArticle) {
	        return _react2.default.createElement(
	          _ArticleOuter2.default,
	          { key: magazineArticle.id },
	          _react2.default.createElement(_MagazineArticle2.default, {
	            magazineArticle: magazineArticle,
	            imageUrl: magazineArticle.thumbnail.preview.lowRes,
	            shouldOpenProfileFromImage: true
	          })
	        );
	      });
	    }
	  }, {
	    key: 'renderEmptyArticles',
	    value: function renderEmptyArticles() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ArticleOuter2.default,
	          null,
	          _react2.default.createElement(_EmptyArticle2.default, null)
	        ),
	        _react2.default.createElement(
	          _ArticleOuter2.default,
	          null,
	          _react2.default.createElement(_EmptyArticle2.default, null)
	        ),
	        _react2.default.createElement(
	          _ArticleOuter2.default,
	          null,
	          _react2.default.createElement(_EmptyArticle2.default, null)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MagazineArticlesList' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-xlarge is-collapsed has-small-background' },
	          function () {
	            if (_this2.props.showsFeaturedArticle) {
	              return _react2.default.createElement(_MagazineArticle2.default, {
	                magazineArticle: _this2.props.magazineArticles[0],
	                isFeatured: true,
	                imageUrl: _this2.props.magazineArticles[0].thumbnail.preview.highRes,
	                shouldOpenProfileFromImage: true
	              });
	            } else if (_this2.props.isFetching) {
	              return _react2.default.createElement(_EmptyArticle2.default, { isFeatured: true });
	            }
	          }(),
	          _react2.default.createElement(
	            'div',
	            { className: 'articles-list-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'list' },
	              function () {
	                if (_this2.props.showsArticlesList) {
	                  return _this2.renderRestOfTheMagazineArticles();
	                } else if (_this2.props.isFetching) {
	                  return _this2.renderEmptyArticles();
	                }
	              }()
	            ),
	            _react2.default.createElement(_MagazineArticlesSidebar2.default, { queries: _magazineQueries2.default, selectedQueryString: this.props.queryString })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pagination-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper-xlarge' },
	            this.props.pagesCount > 1 && _react2.default.createElement(_MagazineArticlesListPageSelector2.default, { query: this.props.query, queryString: this.props.queryString })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MagazineArticlesList;
	}(_react.Component);
	
	MagazineArticlesList.propTypes = {
	  magazineArticles: _react.PropTypes.arrayOf(_entities.MagazineArticleShape),
	  isFetching: _react.PropTypes.bool,
	  pagesCount: _react.PropTypes.number,
	  onFetchCurrentPage: _react.PropTypes.func,
	  queryString: _react.PropTypes.string,
	  query: _react.PropTypes.object,
	  showsFeaturedArticle: _react.PropTypes.bool,
	  showsArticlesList: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var query = (0, _magazineQueries.normalizeMagazineQuery)(props.location.query);
	  var queryString = JSON.stringify(query);
	
	  var _getMagazinePaging = (0, _selectors.getMagazinePaging)(state, 'magazineArticles', { queryString: queryString }),
	      page = _getMagazinePaging.page,
	      isFetching = _getMagazinePaging.isFetching,
	      pagesCount = _getMagazinePaging.pagesCount;
	
	  var magazineArticles = (0, _selectors.getMagazineArticlesOnFrontPage)(state, { page: page, queryString: queryString });
	
	  return {
	    magazineArticles: magazineArticles,
	    showsFeaturedArticle: magazineArticles.length >= 1,
	    showsArticlesList: magazineArticles.length > 1,
	    isFetching: isFetching,
	    queryString: queryString,
	    query: query,
	    pagesCount: pagesCount
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MagazineArticlesList);

/***/ },

/***/ "./src/members/Main/Magazine/MagazineCategories/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResourceCategoriesAccordion = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCategoriesAccordion/index.js");
	
	var _ResourceCategoriesAccordion2 = _interopRequireDefault(_ResourceCategoriesAccordion);
	
	var _AccordionItem = __webpack_require__("./src/members/Main/__shared__/components/Accordion/AccordionItem/index.js");
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	__webpack_require__("./src/members/Main/Magazine/MagazineCategories/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MagazineCategories = function (_Component) {
	  _inherits(MagazineCategories, _Component);
	
	  function MagazineCategories() {
	    _classCallCheck(this, MagazineCategories);
	
	    return _possibleConstructorReturn(this, (MagazineCategories.__proto__ || Object.getPrototypeOf(MagazineCategories)).apply(this, arguments));
	  }
	
	  _createClass(MagazineCategories, [{
	    key: 'renderTopic',
	    value: function renderTopic(topic, countInfo) {
	      return _react2.default.createElement(_AccordionItem2.default, {
	        isForMagazine: true,
	        key: topic.id,
	        title: topic.title,
	        countInfo: countInfo(topic),
	        url: '/magazine?topic=' + topic.id
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MagazineCategories wrapper-full is-collapsed is-collapsed-top has-background', ref: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-padded-top' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            "Categories"
	          ),
	          _react2.default.createElement(_ResourceCategoriesAccordion2.default, {
	            isForMagazine: true,
	            resourceType: 'articles',
	            resourceNameSingular: "article",
	            resourceNamePlural: "articles",
	            renderTopic: this.renderTopic,
	            scrollElementGetter: function scrollElementGetter() {
	              return _this2.refs.wrapper.parentElement;
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return MagazineCategories;
	}(_react.Component);
	
	exports.default = MagazineCategories;

/***/ },

/***/ "./src/members/Main/Magazine/MagazineContribute/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _Contribute = __webpack_require__("./src/members/Main/__shared__/components/Contribute/index.js");
	
	var _Contribute2 = _interopRequireDefault(_Contribute);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var magazineContribute = (0, _selectors.getMagazineContribute)(state);
	  var magazineContributeTextEditing = (0, _selectors.getMagazineTextEditing)(state, 'magazineContribute');
	  var isSubmitDisabled = magazineContributeTextEditing.isSubmitting || !magazineContribute.subject.length || !magazineContributeTextEditing.text.length;
	  var successState = (0, _selectors.getInfoState)(state, 'success');
	  var isSuccessInfoBarVisible = successState.visible;
	  var successInfoBarMessage = successState.message;
	  var successInfoBarTitle = successState.title;
	
	  return _extends({}, magazineContributeTextEditing, magazineContribute, {
	    isSubmitDisabled: isSubmitDisabled,
	    isSuccessInfoBarVisible: isSuccessInfoBarVisible,
	    successInfoBarMessage: successInfoBarMessage,
	    successInfoBarTitle: successInfoBarTitle,
	    showsEmojis: (0, _selectors.getMagazineEmojis)(state, 'magazineContribute').areVisible,
	    title: "Contribute",
	    isExpanded: true,
	    isAutosized: true
	  });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onSubjectUpdate: function onSubjectUpdate(subject) {
	      dispatch(actions.magazineContributeEditingUpdateSubject(subject));
	    },
	    onTextUpdate: function onTextUpdate(text) {
	      dispatch(actions.magazineContributeEditingUpdateText({ text: text }));
	    },
	    onSubmit: function onSubmit(subject, text) {
	      dispatch(actions.magazineArticleCreate(subject, text, "Your article was successfully sent!"));
	      dispatch(actions.magazineEmojisHide('magazineContribute'));
	    },
	    onWillUnmount: function onWillUnmount() {
	      dispatch(actions.magazineEmojisHide('magazineContribute'));
	      dispatch(actions.magazineContributeEditingReset());
	    },
	    onEmojisToggled: function onEmojisToggled(showsEmojis) {
	      if (showsEmojis) {
	        dispatch(actions.magazineEmojisHide('magazineContribute'));
	      } else {
	        dispatch(actions.magazineEmojisShow('magazineContribute'));
	      }
	    },
	    onEmojiSelected: function onEmojiSelected(text, emojiShortName, selectionStart) {
	      dispatch(actions.magazineContributeEditingUpdateText({ text: text, emojiShortName: emojiShortName, selectionStart: selectionStart }));
	    },
	    onDidMount: function onDidMount() {
	      dispatch(actions.infoShow('success', "Writing an article can be a great way to help others and share your own stories which can make you feel a lot better! Your article must not contain any swearing.", "Write an article"));
	    },
	    onInfoBarClose: function onInfoBarClose() {
	      dispatch(actions.infoClose('success'));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Contribute2.default);

/***/ },

/***/ "./src/members/Main/Magazine/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _SubNavigation = __webpack_require__("./src/members/Main/__shared__/components/SubNavigation/index.js");
	
	var _SubNavigation2 = _interopRequireDefault(_SubNavigation);
	
	var _SubNavigationItem = __webpack_require__("./src/members/Main/__shared__/components/SubNavigation/SubNavigationItem/index.js");
	
	var _SubNavigationItem2 = _interopRequireDefault(_SubNavigationItem);
	
	var _MagazineArticlesList = __webpack_require__("./src/members/Main/Magazine/MagazineArticlesList/index.js");
	
	var _MagazineArticlesList2 = _interopRequireDefault(_MagazineArticlesList);
	
	var _MagazineArticleProfile = __webpack_require__("./src/members/Main/Magazine/MagazineArticleProfile/index.js");
	
	var _MagazineArticleProfile2 = _interopRequireDefault(_MagazineArticleProfile);
	
	var _magazineQueries = __webpack_require__("./src/members/__shared__/magazineQueries.js");
	
	__webpack_require__("./src/members/Main/Magazine/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Magazine = function (_Component) {
	  _inherits(Magazine, _Component);
	
	  function Magazine() {
	    _classCallCheck(this, Magazine);
	
	    return _possibleConstructorReturn(this, (Magazine.__proto__ || Object.getPrototypeOf(Magazine)).apply(this, arguments));
	  }
	
	  _createClass(Magazine, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.dispatchEvent(new Event('resize')); // The Flickity component wouldn't layout properly if this page is opened directly.
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var childrenType = this.props.children.type;
	      var paginatedChildren = [_MagazineArticlesList2.default, _MagazineArticleProfile2.default];
	      var className = (0, _classnames2.default)('Magazine', 'content-wrapper', {
	        'has-pagination': paginatedChildren.indexOf(childrenType) >= 0
	      });
	
	      return _react2.default.createElement(
	        'section',
	        { className: className },
	        _react2.default.createElement(
	          _SubNavigation2.default,
	          null,
	          _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForMagazine: true, to: '/magazine?sort=popular' },
	            "Popular"
	          ),
	          _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForMagazine: true, to: '/magazine/contribute' },
	            "Contribute"
	          ),
	          _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForMagazine: true, to: '/magazine?sort=recent', isActive: this.props.isNewActive },
	            "New"
	          ),
	          _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForMagazine: true, to: '/magazine?local=true' },
	            "Local"
	          ),
	          _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForMagazine: true, to: '/magazine/categories' },
	            "Categories"
	          ),
	          _react2.default.createElement(
	            _SubNavigationItem2.default,
	            { isForMagazine: true, to: '/magazine?favourite=true' },
	            "Favourites"
	          )
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Magazine;
	}(_react.Component);
	
	Magazine.propTypes = {
	  children: _react.PropTypes.element,
	  isNewActive: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var _props$location = props.location,
	      pathname = _props$location.pathname,
	      query = _props$location.query;
	
	  var normalizedQuery = (0, _magazineQueries.normalizeMagazineQuery)(query);
	
	  return {
	    isNewActive: pathname === '/magazine' && normalizedQuery.sort === 'recent'
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Magazine);

/***/ },

/***/ "./src/members/Main/Mail/MailTeamMessageEditor/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailTeamMessageEditor = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _TextEditor = __webpack_require__("./src/members/Main/__shared__/components/TextEditor/index.js");
	
	var _TextEditor2 = _interopRequireDefault(_TextEditor);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/Mail/MailTeamMessageEditor/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MailTeamMessageEditor = exports.MailTeamMessageEditor = function MailTeamMessageEditor(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'wrapper-narrow' },
	    _react2.default.createElement(_TextEditor2.default, _extends({}, props, {
	      maxChars: (10000),
	      isExpanded: true,
	      title: "Message the team",
	      placeholder: "Please write your message here then press the submit button."
	    }))
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return _extends({}, (0, _selectors.getMailTextEditing)(state, 'teamMessage'), {
	    showsEmojis: (0, _selectors.getMailEmojis)(state, 'teamMessage').areVisible
	  });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onTextUpdate: function onTextUpdate(text) {
	      dispatch(actions.mailmailMessageTheTeamEditingUpdateText({ text: text }));
	    },
	    onSubmit: function onSubmit(text) {
	      dispatch(actions.mailMessageTheTeam(text));
	    },
	    onWillUnmount: function onWillUnmount() {
	      dispatch(actions.mailEmojisHide('teamMessage'));
	      dispatch(actions.mailmailMessageTheTeamEditingReset());
	    },
	    onEmojisToggled: function onEmojisToggled(showsEmojis) {
	      if (showsEmojis) {
	        dispatch(actions.mailEmojisHide('teamMessage'));
	      } else {
	        dispatch(actions.mailEmojisShow('teamMessage'));
	      }
	    },
	    onEmojiSelected: function onEmojiSelected(text, emojiShortName, selectionStart) {
	      dispatch(actions.mailmailMessageTheTeamEditingUpdateText({ text: text, emojiShortName: emojiShortName, selectionStart: selectionStart }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MailTeamMessageEditor);

/***/ },

/***/ "./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessage/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailThreadMessage = undefined;
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactNl2br = __webpack_require__("./node_modules/react-nl2br/index.js");
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	var _reactEmojione = __webpack_require__("./node_modules/react-emojione/lib/react-emojione.js");
	
	var _reactLinkify = __webpack_require__("./node_modules/react-linkify/dist/Linkify.js");
	
	var _reactLinkify2 = _interopRequireDefault(_reactLinkify);
	
	var _Reply = __webpack_require__("./src/members/Main/__shared__/components/RepliesList/Reply/index.js");
	
	var _Reply2 = _interopRequireDefault(_Reply);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MailThreadMessage = exports.MailThreadMessage = function MailThreadMessage(props) {
	  var mailThreadMessage = props.mailThreadMessage;
	
	
	  return _react2.default.createElement(
	    _Reply2.default,
	    {
	      threadMessageId: mailThreadMessage.id,
	      isUnread: !mailThreadMessage.read,
	      isFromCounsellor: mailThreadMessage.fromCounsellor,
	      since: (0, _moment2.default)(mailThreadMessage.createdAt).fromNow(),
	      avatarLetter: mailThreadMessage.sender.charAt(0),
	      avatarImageUrl: mailThreadMessage.avatar.url,
	      authorName: mailThreadMessage.sender,
	      animateHover: false },
	    _react2.default.createElement(
	      _reactLinkify2.default,
	      { properties: { target: '_blank', style: { fontWeight: 'bold' } } },
	      (0, _reactNl2br2.default)((0, _reactEmojione.emojify)(mailThreadMessage.text, { output: 'unicode' }))
	    )
	  );
	};
	
	MailThreadMessage.propTypes = {
	  mailThreadMessage: _entities.MailThreadMessageShape
	};
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onDidBecomeVisible: function onDidBecomeVisible() {
	      if (props.mailThreadMessage.read && props.mailThreadMessage.fromCounsellor) {
	        dispatch(actions.mailThreadMessageUpdate(props.threadId, props.mailThreadMessage.id, { read: true }));
	      }
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MailThreadMessage);

/***/ },

/***/ "./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessageEditor/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _TextEditor = __webpack_require__("./src/members/Main/__shared__/components/TextEditor/index.js");
	
	var _TextEditor2 = _interopRequireDefault(_TextEditor);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessageEditor/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MailThreadMessageEditor = function MailThreadMessageEditor(props) {
	  return _react2.default.createElement(_TextEditor2.default, _extends({}, props, { maxChars: (10000) }));
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return _extends({}, (0, _selectors.getMailTextEditing)(state, 'replyToMessage'), {
	    showsEmojis: (0, _selectors.getMailEmojis)(state, 'replyToMessage').areVisible
	  });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onTextUpdate: function onTextUpdate(text) {
	      dispatch(actions.mailThreadMessageEditingUpdateText({ text: text }));
	    },
	    onSubmit: function onSubmit(text) {
	      dispatch(actions.mailThreadMessageCreate(props.threadId, text));
	      dispatch(actions.mailEmojisHide('replyToMessage'));
	    },
	    onFocus: function onFocus() {
	      dispatch(actions.mailThreadMessageEditingExpand());
	    },
	    onWillUnmount: function onWillUnmount() {
	      dispatch(actions.mailEmojisHide('replyToMessage'));
	      dispatch(actions.mailThreadMessageEditingReset());
	    },
	    onEmojisToggled: function onEmojisToggled(showsEmojis) {
	      if (showsEmojis) {
	        dispatch(actions.mailEmojisHide('replyToMessage'));
	      } else {
	        dispatch(actions.mailEmojisShow('replyToMessage'));
	      }
	    },
	    onEmojiSelected: function onEmojiSelected(text, emojiShortName, selectionStart) {
	      dispatch(actions.mailThreadMessageEditingUpdateText({ text: text, emojiShortName: emojiShortName, selectionStart: selectionStart }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MailThreadMessageEditor);

/***/ },

/***/ "./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessagesListPageSelector/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailMailThreadMessagesListPageSelector = undefined;
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageSelector = __webpack_require__("./src/members/Main/__shared__/components/PageSelector/index.js");
	
	var _PageSelector2 = _interopRequireDefault(_PageSelector);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MailMailThreadMessagesListPageSelector = function MailMailThreadMessagesListPageSelector(props) {
	  var threadId = props.threadId,
	      otherProps = _objectWithoutProperties(props, ['threadId']); //eslint-disable-line no-unused-vars
	
	
	  return _react2.default.createElement(_PageSelector2.default, otherProps);
	};
	
	exports.MailMailThreadMessagesListPageSelector = MailMailThreadMessagesListPageSelector;
	MailMailThreadMessagesListPageSelector.propTypes = {
	  threadId: _react.PropTypes.string
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return (0, _selectors.getMailPaging)(state, 'mailThreadMessages', { threadId: props.threadId });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onPrevClick: function onPrevClick(currentPage) {
	      dispatch(actions.mailThreadMessagesFetch(props.threadId, currentPage - 1));
	    },
	    onNextClick: function onNextClick(currentPage) {
	      dispatch(actions.mailThreadMessagesFetch(props.threadId, currentPage + 1));
	    },
	    onPossiblePageUpdate: function onPossiblePageUpdate(newPossiblePage) {
	      dispatch(actions.mailThreadMessagesUpdatePossiblePage(props.threadId, newPossiblePage));
	    },
	    onPageUpdate: function onPageUpdate(newPage, pagesCount) {
	      if (newPage >= 1 && newPage <= pagesCount) {
	        dispatch(actions.mailThreadMessagesFetch(props.threadId, newPage));
	      }
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MailMailThreadMessagesListPageSelector);

/***/ },

/***/ "./src/members/Main/Mail/MailThreadMessagesList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailThreadMessagesList = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _RepliesListLoading = __webpack_require__("./src/members/Main/__shared__/components/RepliesListLoading/index.js");
	
	var _RepliesListLoading2 = _interopRequireDefault(_RepliesListLoading);
	
	var _MailThreadMessageEditor = __webpack_require__("./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessageEditor/index.js");
	
	var _MailThreadMessageEditor2 = _interopRequireDefault(_MailThreadMessageEditor);
	
	var _MailThreadMessagesListPageSelector = __webpack_require__("./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessagesListPageSelector/index.js");
	
	var _MailThreadMessagesListPageSelector2 = _interopRequireDefault(_MailThreadMessagesListPageSelector);
	
	var _RepliesList = __webpack_require__("./src/members/Main/__shared__/components/RepliesList/index.js");
	
	var _RepliesList2 = _interopRequireDefault(_RepliesList);
	
	var _RepliesListContentMain = __webpack_require__("./src/members/Main/__shared__/components/RepliesList/RepliesListContentMain/index.js");
	
	var _RepliesListContentMain2 = _interopRequireDefault(_RepliesListContentMain);
	
	var _RepliesListContentSticky = __webpack_require__("./src/members/Main/__shared__/components/RepliesList/RepliesListContentSticky/index.js");
	
	var _RepliesListContentSticky2 = _interopRequireDefault(_RepliesListContentSticky);
	
	var _MailThreadMessage = __webpack_require__("./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessage/index.js");
	
	var _MailThreadMessage2 = _interopRequireDefault(_MailThreadMessage);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/Mail/MailThreadMessagesList/style.scss");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _actions2 = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-named-as-default
	
	
	var MailThreadMessagesList = exports.MailThreadMessagesList = function (_Component) {
	  _inherits(MailThreadMessagesList, _Component);
	
	  function MailThreadMessagesList() {
	    _classCallCheck(this, MailThreadMessagesList);
	
	    return _possibleConstructorReturn(this, (MailThreadMessagesList.__proto__ || Object.getPrototypeOf(MailThreadMessagesList)).apply(this, arguments));
	  }
	
	  _createClass(MailThreadMessagesList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onFetchCurrentPage();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          totalCount = _props.totalCount,
	          params = _props.params,
	          mailThreadMessages = _props.mailThreadMessages,
	          isFetching = _props.isFetching,
	          pagesCount = _props.pagesCount;
	
	      return _react2.default.createElement(
	        _RepliesList2.default,
	        null,
	        _react2.default.createElement(
	          _RepliesListContentMain2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper-full' },
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/messages', iconName: 'back' },
	              "Back"
	            ),
	            function () {
	              if (totalCount > 0) {
	                return _react2.default.createElement(
	                  'span',
	                  { className: 'float-right' },
	                  totalCount + ' messages'
	                );
	              }
	            }(),
	            _react2.default.createElement(_MailThreadMessageEditor2.default, { threadId: params.id, placeholder: "Click here to reply. Please remember not to be offensive." })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper-full is-small-collapsed' },
	            function () {
	              if (mailThreadMessages.length > 0) {
	                return _react2.default.createElement(
	                  'ul',
	                  null,
	                  mailThreadMessages.map(function (mailThreadMessage) {
	                    return _react2.default.createElement(_MailThreadMessage2.default, {
	                      key: mailThreadMessage.id,
	                      threadId: params.id,
	                      mailThreadMessage: mailThreadMessage
	                    });
	                  })
	                );
	              } else if (isFetching) {
	                return _react2.default.createElement(_RepliesListLoading2.default, null);
	              }
	            }()
	          )
	        ),
	        function () {
	          if (pagesCount > 1) {
	            return _react2.default.createElement(
	              _RepliesListContentSticky2.default,
	              null,
	              _react2.default.createElement(_MailThreadMessagesListPageSelector2.default, { threadId: params.id })
	            );
	          }
	        }()
	      );
	    }
	  }]);
	
	  return MailThreadMessagesList;
	}(_react.Component);
	
	MailThreadMessagesList.propTypes = {
	  mailThreadMessages: _react.PropTypes.arrayOf(_entities.MailThreadMessageShape),
	  isFetching: _react.PropTypes.bool,
	  pagesCount: _react.PropTypes.number,
	  totalCount: _react.PropTypes.number,
	  onFetchCurrentPage: _react.PropTypes.func,
	  params: _react.PropTypes.object,
	  lastRefresh: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var _getMailPaging = (0, _selectors.getMailPaging)(state, 'mailThreadMessages', { threadId: props.params.id }),
	      page = _getMailPaging.page,
	      pagesCount = _getMailPaging.pagesCount,
	      isFetching = _getMailPaging.isFetching,
	      totalCount = _getMailPaging.totalCount;
	
	  return {
	    mailThreadMessages: (0, _selectors.getMailThreadMessages)(state, { threadId: props.params.id, page: page }),
	    lastRefresh: (0, _selectors.getTimeLastRefresh)(state),
	    isFetching: isFetching,
	    pagesCount: pagesCount,
	    totalCount: totalCount
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onFetchCurrentPage: function onFetchCurrentPage() {
	      dispatch((0, _actions2.actionCausedByURLChangeFrom)(actions.mailThreadMessagesFetch(props.params.id)));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MailThreadMessagesList);

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/ChatInfo/ChatInfoScheduledSession/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__("./src/members/Main/Mail/MailThreadsList/ChatInfo/ChatInfoScheduledSession/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatInfoScheduledSession = function ChatInfoScheduledSession(props) {
	  var scheduledChatSessionStartDate = props.scheduledChatSessionStartDate;
	
	  var hasSession = scheduledChatSessionStartDate !== undefined;
	  if (!hasSession) return null;
	
	  var now = (0, _moment2.default)();
	  var sessionIsToday = scheduledChatSessionStartDate.isSame(now, 'day');
	  var hasStarted = scheduledChatSessionStartDate.diff(now) < 0;
	
	  // Do not show this panel if the session has started or there is no session to show
	  if (hasStarted) return null;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ChatInfoScheduledSession' },
	    sessionIsToday ? _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        "Next booked chat:"
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        scheduledChatSessionStartDate.fromNow(),
	        ' (',
	        scheduledChatSessionStartDate.format('hh:mm a'),
	        ')'
	      )
	    ) : _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        "Next booked chat:"
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        scheduledChatSessionStartDate.format('hh:mm a, D MMMM YYYY')
	      )
	    )
	  );
	};
	
	ChatInfoScheduledSession.propTypes = {
	  scheduledChatSessionStartDate: _react.PropTypes.object
	};
	
	exports.default = ChatInfoScheduledSession;

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/ChatInfo/ChatState/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	__webpack_require__("./src/members/Main/Mail/MailThreadsList/ChatInfo/ChatState/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable react/no-danger*/
	
	
	var ChatState = function (_Component) {
	  _inherits(ChatState, _Component);
	
	  function ChatState() {
	    _classCallCheck(this, ChatState);
	
	    var _this = _possibleConstructorReturn(this, (ChatState.__proto__ || Object.getPrototypeOf(ChatState)).call(this));
	
	    _this.handleEnqueue = _this.handleEnqueue.bind(_this);
	    _this.handleEnqueueCancel = _this.handleEnqueueCancel.bind(_this);
	    _this.handleStartChat = _this.handleStartChat.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onDidMount) {
	        this.props.onDidMount();
	      }
	    }
	  }, {
	    key: 'handleEnqueue',
	    value: function handleEnqueue(event) {
	      event.preventDefault();
	      this.props.onEnqueue();
	    }
	  }, {
	    key: 'handleEnqueueCancel',
	    value: function handleEnqueueCancel(event) {
	      event.preventDefault();
	      this.props.onEnqueueCancel();
	    }
	  }, {
	    key: 'handleStartChat',
	    value: function handleStartChat(event) {
	      event.preventDefault();
	      this.props.onStartChat();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var title = void 0;
	      var subTitle = void 0;
	      var icon = void 0;
	      var button = void 0;
	
	      var incrisisLink = ("http://dev.kooth.com") + '/incrisis.html';
	      var hasStartedScheduledChatSession = this.props.scheduledChatSessionStartDate !== undefined && this.props.scheduledChatSessionStartDate.diff((0, _moment2.default)()) < 0;
	
	      if (this.props.isRejectedFromQueue) {
	        title = _react2.default.createElement(
	          'h4',
	          null,
	          "You have been removed from the chat queue for the following reason:"
	        );
	        subTitle = _react2.default.createElement(
	          'p',
	          null,
	          this.props.queueRejectionReason,
	          ' ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          ' ',
	          "Time to wait:",
	          ' ',
	          (0, _moment2.default)(this.props.queueRejectionExpiritationDate).from(),
	          '.'
	        );
	        icon = _react2.default.createElement(
	          'div',
	          { className: 'mark-chat-state' },
	          _react2.default.createElement('img', { src: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/icon-chat-state.svg" }),
	          _react2.default.createElement('div', { className: 'color' })
	        );
	        button =  true ? _react2.default.createElement(
	          _Button2.default,
	          { isYellow: true, to: '/messages/new' },
	          "Message the team"
	        ) : '';
	      } else if (this.props.state === 'OFFLINE') {
	        title = _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: "We're currently <span class='current-state'>offline</span>." } });
	        subTitle = _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: 'You can send a message below and we will respond later or if you need urgent help you can contact one of <a class=\'Link\' target=\'_blank\' href=' + incrisisLink + '>these organisations</a>.' } });
	        icon = _react2.default.createElement(
	          'div',
	          { className: 'mark-chat-state' },
	          _react2.default.createElement('img', { src: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/icon-chat-state.svg" }),
	          _react2.default.createElement('div', { className: 'color' })
	        );
	        button =  true ? _react2.default.createElement(
	          _Button2.default,
	          { isYellow: true, to: '/messages/new' },
	          "Message the team"
	        ) : '';
	      } else if (this.props.state === 'ACTIVE_NOT_STARTED') {
	        title = _react2.default.createElement(
	          'h4',
	          null,
	          "Your counsellor is now available."
	        );
	        icon = _react2.default.createElement(
	          'div',
	          { className: 'mark-chat-state' },
	          _react2.default.createElement('img', { src: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/icon-chat-state.svg" }),
	          _react2.default.createElement(
	            'div',
	            { className: 'color is-ready' },
	            _react2.default.createElement('span', { className: 'icon-checkmark' })
	          )
	        );
	        button = _react2.default.createElement(
	          _Button2.default,
	          { isGreen: true, hasIcon: true, iconType: 'checkmark', hasIconAnimated: true, onClick: this.handleStartChat },
	          "Open chat"
	        );
	      } else if (this.props.state === 'ACTIVE_STARTED') {
	        title = _react2.default.createElement(
	          'h4',
	          null,
	          "You are in a chat session."
	        );
	        icon = _react2.default.createElement(
	          'div',
	          { className: 'mark-chat-state' },
	          _react2.default.createElement('img', { src: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/icon-chat-state.svg" }),
	          _react2.default.createElement('div', { className: 'color is-ready' })
	        );
	        button = _react2.default.createElement(
	          _Button2.default,
	          { isGreen: true, onClick: this.handleStartChat },
	          "Open chat"
	        );
	      } else if (this.props.state === 'WAITING_TO_CANCEL_ENQUEUE' || this.props.state === 'QUEUED') {
	        title = _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: "You’re in the chat queue.<br />Please be patient." } });
	        subTitle = _react2.default.createElement(
	          'p',
	          null,
	          "When your counsellor becomes available you'll receive a notification."
	        );
	        icon = _react2.default.createElement(
	          'div',
	          { className: 'mark-chat-state' },
	          _react2.default.createElement('img', { src: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/icon-chat-state.svg" }),
	          _react2.default.createElement(
	            'div',
	            { className: 'color is-loading' },
	            _react2.default.createElement('span', { className: 'icon-preloader' })
	          )
	        );
	        button = _react2.default.createElement(
	          _Button2.default,
	          { isBlue: true, hasIcon: true, iconType: 'preloader', hasIconAnimated: true, onClick: this.handleEnqueueCancel, isDisabled: this.props.state === 'WAITING_TO_CANCEL_ENQUEUE' },
	          "Cancel chat session"
	        );
	      } else if (hasStartedScheduledChatSession) {
	        title = _react2.default.createElement(
	          'h4',
	          null,
	          "You have a booked session."
	        );
	        subTitle = "" ? _react2.default.createElement(
	          'p',
	          null,
	          ""
	        ) : '';
	        icon = _react2.default.createElement(
	          'div',
	          { className: 'mark-chat-state' },
	          _react2.default.createElement('img', { src: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/icon-chat-state.svg" }),
	          _react2.default.createElement('div', { className: 'color' })
	        );
	        button = _react2.default.createElement(
	          _Button2.default,
	          { isGreen: true, onClick: this.handleEnqueue, isDisabled: this.props.state === 'WAITING_TO_ENQUEUE' },
	          "Chat now"
	        );
	      } else if (this.props.state === 'ONLINE' || this.props.state === 'WAITING_TO_ENQUEUE') {
	        title = _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: "We're <span class='current-state'>online</span> today until 10pm." } });
	        subTitle = _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: 'You can send a message below and we will respond later or if you need urgent help you can contact one of <a class=\'Link\' target=\'_blank\' href=' + incrisisLink + '>these organisations</a>.' } });
	        icon = _react2.default.createElement(
	          'div',
	          { className: 'mark-chat-state' },
	          _react2.default.createElement('img', { src: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/icon-chat-state.svg" }),
	          _react2.default.createElement('div', { className: 'color' })
	        );
	        button = _react2.default.createElement(
	          _Button2.default,
	          { isGreen: true, onClick: this.handleEnqueue, isDisabled: this.props.state === 'WAITING_TO_ENQUEUE' },
	          "Chat now"
	        );
	      }
	
	      var className = (0, _classnames2.default)('ChatState', {
	        'is-online': this.props.state !== 'OFFLINE' && !this.props.isRejectedFromQueue
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        title,
	        subTitle,
	        icon,
	        button,
	        this.props.isF2FAvailable && _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/referral' },
	            "Sign up for a face to face chat session?"
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChatState;
	}(_react.Component);
	
	ChatState.propTypes = {
	  onDidMount: _react.PropTypes.func,
	  state: _react.PropTypes.string,
	  onEnqueue: _react.PropTypes.func,
	  onEnqueueCancel: _react.PropTypes.func,
	  onStartChat: _react.PropTypes.func,
	  isRejectedFromQueue: _react.PropTypes.bool,
	  queueRejectionReason: _react.PropTypes.string,
	  queueRejectionExpiritationDate: _react.PropTypes.object,
	  isF2FAvailable: _react.PropTypes.bool,
	  scheduledChatSessionStartDate: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var queueRejection = (0, _selectors.getChatQueueRejection)(state);
	
	  return {
	    state: (0, _selectors.getChatState)(state).stringValue,
	    isRejectedFromQueue: queueRejection.isRejected,
	    queueRejectionReason: queueRejection.reason,
	    queueRejectionExpiritationDate: queueRejection.expirationDate,
	    isF2FAvailable: (0, _selectors.getF2F)(state).isAvailable
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onDidMount: function onDidMount() {
	      dispatch(actions.f2fStatusFetch());
	    },
	    onEnqueue: function onEnqueue() {
	      dispatch(actions.chatEnqueue());
	    },
	    onEnqueueCancel: function onEnqueueCancel() {
	      dispatch(actions.chatEnqueueCancel());
	    },
	    onStartChat: function onStartChat() {
	      dispatch(actions.chatOpen());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatState);

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/ChatInfo/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ResourcesList = __webpack_require__("./src/members/Main/__shared__/components/ResourcesList/index.js");
	
	var _ResourcesList2 = _interopRequireDefault(_ResourcesList);
	
	var _Resource = __webpack_require__("./src/members/Main/__shared__/components/ResourcesList/Resource/index.js");
	
	var _Resource2 = _interopRequireDefault(_Resource);
	
	var _ChatState = __webpack_require__("./src/members/Main/Mail/MailThreadsList/ChatInfo/ChatState/index.js");
	
	var _ChatState2 = _interopRequireDefault(_ChatState);
	
	var _ChatInfoScheduledSession = __webpack_require__("./src/members/Main/Mail/MailThreadsList/ChatInfo/ChatInfoScheduledSession/index.js");
	
	var _ChatInfoScheduledSession2 = _interopRequireDefault(_ChatInfoScheduledSession);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	__webpack_require__("./src/members/Main/Mail/MailThreadsList/ChatInfo/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatInfo = function (_Component) {
	  _inherits(ChatInfo, _Component);
	
	  function ChatInfo() {
	    _classCallCheck(this, ChatInfo);
	
	    return _possibleConstructorReturn(this, (ChatInfo.__proto__ || Object.getPrototypeOf(ChatInfo)).apply(this, arguments));
	  }
	
	  _createClass(ChatInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onDidMount();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var scheduledChatSessionStartDate = this.props.scheduledChatSessionStartDate && (0, _moment2.default)(this.props.scheduledChatSessionStartDate);
	      var className = (0, _classnames2.default)('ChatInfo', {
	        'is-centered': this.props.isCentered
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-full' },
	          _react2.default.createElement(_ChatInfoScheduledSession2.default, { scheduledChatSessionStartDate: scheduledChatSessionStartDate }),
	          _react2.default.createElement(_ChatState2.default, { scheduledChatSessionStartDate: scheduledChatSessionStartDate }),
	          function () {
	            if (_this2.props.shouldShowLatestChatResources) {
	              return _react2.default.createElement(
	                _ResourcesList2.default,
	                null,
	                _this2.props.latestChatResources.map(function (chatResource) {
	                  var key = chatResource.sentAt + '_' + chatResource.data.url;
	
	                  return _react2.default.createElement(_Resource2.default, {
	                    key: key,
	                    title: chatResource.metadata.title,
	                    authorName: chatResource.sender,
	                    isWebsite: true,
	                    url: chatResource.data.url
	                  });
	                })
	              );
	            }
	          }()
	        )
	      );
	    }
	  }]);
	
	  return ChatInfo;
	}(_react.Component);
	
	ChatInfo.propTypes = {
	  shouldShowLatestChatResources: _react.PropTypes.bool,
	  latestChatResources: _react.PropTypes.array,
	  scheduledChatSessionStartDate: _react.PropTypes.string,
	  onDidMount: _react.PropTypes.func,
	  isCentered: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var latestChatResources = (0, _selectors.getChatResources)(state, { page: 1, limit: 3 });
	
	  return {
	    scheduledChatSessionStartDate: (0, _selectors.getFirstChatScheduledSessionStartDate)(state),
	    shouldShowLatestChatResources: latestChatResources.length > 0,
	    latestChatResources: latestChatResources
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onDidMount: function onDidMount() {
	      dispatch(actions.chatResourcesFetch());
	      dispatch(actions.chatScheduleFetch());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatInfo);

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/MailThread/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactNl2br = __webpack_require__("./node_modules/react-nl2br/index.js");
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	var _reactEmojione = __webpack_require__("./node_modules/react-emojione/lib/react-emojione.js");
	
	var _Reply = __webpack_require__("./src/members/Main/__shared__/components/RepliesList/Reply/index.js");
	
	var _Reply2 = _interopRequireDefault(_Reply);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MailThread = function MailThread(props) {
	  var mailThread = props.mailThread;
	
	
	  return _react2.default.createElement(
	    _Reply2.default,
	    { key: mailThread.id,
	      isUnread: !mailThread.latestMessage.read,
	      since: (0, _moment2.default)(mailThread.latestMessage.createdAt).fromNow(),
	      avatarLetter: mailThread.participant[0],
	      avatarImageUrl: mailThread.avatar.url,
	      authorName: mailThread.participant,
	      to: '/messages/threads/' + mailThread.id },
	    (0, _reactNl2br2.default)((0, _reactEmojione.emojify)(mailThread.latestMessage.text, { output: 'unicode' }))
	  );
	};
	
	MailThread.propTypes = {
	  mailThread: _entities.MailThreadShape
	};
	
	exports.default = MailThread;

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/MailThreadsListHeader/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__("./src/members/Main/Mail/MailThreadsList/MailThreadsListHeader/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MailThreadsListHeader = function MailThreadsListHeader() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'MailThreadsListHeader' },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper-full' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        "Mail"
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { isSmall: true, hasIcon: true, isYellow: true, iconType: 'message', to: '/messages/new' },
	        "Message the team"
	      )
	    )
	  );
	};
	
	exports.default = MailThreadsListHeader;

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/MailThreadsListPageSelector/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageSelector = __webpack_require__("./src/members/Main/__shared__/components/PageSelector/index.js");
	
	var _PageSelector2 = _interopRequireDefault(_PageSelector);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MailThreadsListPageSelector = function MailThreadsListPageSelector(props) {
	  return _react2.default.createElement(_PageSelector2.default, props);
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return (0, _selectors.getMailPaging)(state, 'mailThreads');
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onPrevClick: function onPrevClick(currentPage) {
	      dispatch(actions.mailThreadsFetch(currentPage - 1));
	    },
	    onNextClick: function onNextClick(currentPage) {
	      dispatch(actions.mailThreadsFetch(currentPage + 1));
	    },
	    onPossiblePageUpdate: function onPossiblePageUpdate(newPossiblePage) {
	      dispatch(actions.mailThreadsUpdatePossiblePage(newPossiblePage));
	    },
	    onPageUpdate: function onPageUpdate(newPage, pagesCount) {
	      if (newPage >= 1 && newPage <= pagesCount) {
	        dispatch(actions.mailThreadsFetch(newPage));
	      }
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MailThreadsListPageSelector);

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailThreadsList = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	__webpack_require__("./src/members/Main/Mail/MailThreadsList/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatInfo = void 0;
	ChatInfo = __webpack_require__("./src/members/Main/Mail/MailThreadsList/ChatInfo/index.js").default;
	
	var RepliesList = void 0,
	    RepliesListLoading = void 0,
	    RepliesListContentMain = void 0,
	    RepliesListContentSticky = void 0,
	    MailThreadsListHeader = void 0,
	    MailThreadsListPageSelector = void 0,
	    MailThread = void 0;
	RepliesList = __webpack_require__("./src/members/Main/__shared__/components/RepliesList/index.js").default;
	RepliesListLoading = __webpack_require__("./src/members/Main/__shared__/components/RepliesListLoading/index.js").default;
	RepliesListContentMain = __webpack_require__("./src/members/Main/__shared__/components/RepliesList/RepliesListContentMain/index.js").default;
	RepliesListContentSticky = __webpack_require__("./src/members/Main/__shared__/components/RepliesList/RepliesListContentSticky/index.js").default;
	MailThreadsListHeader = __webpack_require__("./src/members/Main/Mail/MailThreadsList/MailThreadsListHeader/index.js").default;
	MailThreadsListPageSelector = __webpack_require__("./src/members/Main/Mail/MailThreadsList/MailThreadsListPageSelector/index.js").default;
	MailThread = __webpack_require__("./src/members/Main/Mail/MailThreadsList/MailThread/index.js").default;
	
	var MailThreadsList = exports.MailThreadsList = function (_Component) {
	  _inherits(MailThreadsList, _Component);
	
	  function MailThreadsList() {
	    _classCallCheck(this, MailThreadsList);
	
	    return _possibleConstructorReturn(this, (MailThreadsList.__proto__ || Object.getPrototypeOf(MailThreadsList)).apply(this, arguments));
	  }
	
	  _createClass(MailThreadsList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var isMailEnabled = RepliesList !== undefined;
	      return _react2.default.createElement(
	        'div',
	        { className: 'FlexRow' },
	        ChatInfo && _react2.default.createElement(ChatInfo, { isCentered: !isMailEnabled }),
	        RepliesList && _react2.default.createElement(
	          RepliesList,
	          null,
	          _react2.default.createElement(
	            RepliesListContentMain,
	            null,
	            _react2.default.createElement(MailThreadsListHeader, null),
	            function () {
	              if (_this2.props.mailThreads.length > 0) {
	                return _react2.default.createElement(
	                  'ul',
	                  null,
	                  _this2.props.mailThreads.map(function (mailThread) {
	                    return _react2.default.createElement(MailThread, { key: mailThread.id, mailThread: mailThread });
	                  })
	                );
	              } else if (_this2.props.isFetching) {
	                return _react2.default.createElement(RepliesListLoading, null);
	              }
	            }()
	          ),
	          function () {
	            if (_this2.props.pagesCount > 1) {
	              return _react2.default.createElement(
	                RepliesListContentSticky,
	                null,
	                _react2.default.createElement(MailThreadsListPageSelector, null)
	              );
	            }
	          }()
	        )
	      );
	    }
	  }]);
	
	  return MailThreadsList;
	}(_react.Component);
	
	MailThreadsList.propTypes = {
	  mailThreads: _react.PropTypes.arrayOf(_entities.MailThreadShape),
	  isFetching: _react.PropTypes.bool,
	  pagesCount: _react.PropTypes.number,
	  onFetchCurrentPage: _react.PropTypes.func,
	  lastRefresh: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  var _getMailPaging = (0, _selectors.getMailPaging)(state, 'mailThreads'),
	      page = _getMailPaging.page,
	      isFetching = _getMailPaging.isFetching,
	      pagesCount = _getMailPaging.pagesCount;
	
	  return {
	    mailThreads: (0, _selectors.getMailThreads)(state, { page: page }),
	    lastRefresh: (0, _selectors.getTimeLastRefresh)(state),
	    isFetching: isFetching,
	    pagesCount: pagesCount
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MailThreadsList);

/***/ },

/***/ "./src/members/Main/Mail/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/Mail/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Mail = function (_Component) {
	  _inherits(Mail, _Component);
	
	  function Mail() {
	    _classCallCheck(this, Mail);
	
	    return _possibleConstructorReturn(this, (Mail.__proto__ || Object.getPrototypeOf(Mail)).apply(this, arguments));
	  }
	
	  _createClass(Mail, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'section',
	        { className: 'content-wrapper' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Mail;
	}(_react.Component);
	
	Mail.propTypes = {
	  children: _react.PropTypes.element
	};
	
	exports.default = Mail;

/***/ },

/***/ "./src/members/Main/MainFooter/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__("./src/__shared__/styles/MainFooter.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainFooter = function MainFooter() {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'MainFooter is-inside-app' },
	    _react2.default.createElement(
	      'div',
	      { className: 'footer-menu' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper-full' },
	        _react2.default.createElement(
	          'nav',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-column' },
	            _react2.default.createElement(
	              'a',
	              { className: 'Link', target: '_blank', href: ("http://dev.kooth.com") + '/team.html' },
	              "Meet the Team"
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-column' },
	            _react2.default.createElement(
	              'a',
	              { className: 'Link', target: '_blank', href: ("http://dev.kooth.com") + '/privacy.html' },
	              "Privacy and Safety"
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-column' },
	            _react2.default.createElement(
	              'a',
	              { className: 'Link', target: '_blank', href: ("http://dev.kooth.com") + '/confidentiality.html' },
	              "Confidentiality"
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-column' },
	            _react2.default.createElement(
	              'a',
	              { className: 'Link', target: '_blank', href: ("http://dev.kooth.com") + '/terms.html' },
	              "Terms of Use"
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-column' },
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/feedback' },
	              "Send Feedback"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'copyright-info' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper-full' },
	        '\xA9 ',
	        _react2.default.createElement(
	          'a',
	          { className: 'Link', target: '_blank', href: "http://www.xenzone.com" },
	          "Xenzone"
	        ),
	        ' ',
	        new Date().getFullYear()
	      )
	    )
	  );
	};
	
	exports.default = MainFooter;

/***/ },

/***/ "./src/members/Main/MainNavigation/MainNavigationDropdownHeader/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/MainNavigation/MainNavigationDropdownHeader/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainNavigationDropdownHeader = function MainNavigationDropdownHeader(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'MainNavigationDropdownHeader' },
	    _react2.default.createElement(
	      'div',
	      { className: 'avatar' },
	      _react2.default.createElement(_UserAvatar2.default, { letter: props.userName[0], imageUrl: props.avatar.url })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'info' },
	      _react2.default.createElement(
	        'div',
	        { className: 'username' },
	        props.userName
	      ),
	      _react2.default.createElement(
	        _Link2.default,
	        { to: '/settings' },
	        "Change settings"
	      )
	    )
	  );
	};
	
	MainNavigationDropdownHeader.propTypes = {
	  userName: _react.PropTypes.string,
	  avatar: _entities.AvatarShape
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return (0, _selectors.getUserProfile)(state);
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainNavigationDropdownHeader);

/***/ },

/***/ "./src/members/Main/MainNavigation/MainNavigationItem/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSimpleDropdown = __webpack_require__("./node_modules/react-simple-dropdown/lib/components/Dropdown.js");
	
	var _reactSimpleDropdown2 = _interopRequireDefault(_reactSimpleDropdown);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__("./src/members/Main/MainNavigation/MainNavigationItem/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MainNavigationItem = function MainNavigationItem(props) {
	  var _props$to = props.to,
	      to = _props$to === undefined ? "_" : _props$to,
	      _props$hideForTablet = props.hideForTablet,
	      hideForTablet = _props$hideForTablet === undefined ? false : _props$hideForTablet,
	      _props$showForTablet = props.showForTablet,
	      showForTablet = _props$showForTablet === undefined ? false : _props$showForTablet,
	      type = props.type,
	      iconUrl = props.iconUrl,
	      dropdownRef = props.dropdownRef,
	      isChatEnabled = props.isChatEnabled,
	      isOnline = props.isOnline,
	      otherProps = _objectWithoutProperties(props, ['to', 'hideForTablet', 'showForTablet', 'type', 'iconUrl', 'dropdownRef', 'isChatEnabled', 'isOnline']);
	
	  var className = (0, _classnames2.default)('MainNavigationItem', type, {
	    'hide-for-tablet': hideForTablet,
	    'show-for-tablet': showForTablet,
	    'is-chat-enabled': isChatEnabled,
	    'is-online': isOnline
	  });
	
	  var trigger = _react2.default.createElement(
	    _Link2.default,
	    _extends({}, otherProps, { to: to, activeClassName: 'is-active' }),
	    _react2.default.createElement('img', { src: iconUrl })
	  );
	
	  return _react2.default.createElement(
	    'li',
	    { className: className },
	    function () {
	      if (props.children) {
	        return _react2.default.createElement(
	          _reactSimpleDropdown2.default,
	          { ref: dropdownRef, className: 'show-for-tablet' },
	          _react2.default.createElement(
	            _reactSimpleDropdown.DropdownTrigger,
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'dropdown-trigger-text' },
	              _react2.default.createElement('img', { src: iconUrl })
	            )
	          ),
	          _react2.default.createElement(
	            _reactSimpleDropdown.DropdownContent,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'dropdown-content-inner' },
	              props.children
	            )
	          )
	        );
	      } else {
	        return trigger;
	      }
	    }()
	  );
	};
	
	MainNavigationItem.propTypes = {
	  type: _react.PropTypes.string,
	  iconUrl: _react.PropTypes.string,
	  dropdownRef: _react.PropTypes.func,
	  hideForTablet: _react.PropTypes.bool,
	  to: _react.PropTypes.string,
	  showForTablet: _react.PropTypes.bool,
	  isOnline: _react.PropTypes.bool,
	  isChatEnabled: _react.PropTypes.bool,
	  children: _react.PropTypes.element
	};
	
	exports.default = MainNavigationItem;

/***/ },

/***/ "./src/members/Main/MainNavigation/MainNavigationSearchBar/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SearchBar = __webpack_require__("./src/members/Main/__shared__/containers/SearchBar/index.js");
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	__webpack_require__("./src/members/Main/MainNavigation/MainNavigationSearchBar/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainNavigationSearchBar = function MainNavigationSearchBar(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'MainNavigationSearchBar' },
	    _react2.default.createElement(_SearchBar2.default, { onEscape: props.onClose }),
	    _react2.default.createElement('a', { className: 'icon-search-close', onClick: props.onClose })
	  );
	};
	
	MainNavigationSearchBar.propTypes = {
	  onClose: _react.PropTypes.func
	};
	
	exports.default = MainNavigationSearchBar;

/***/ },

/***/ "./src/members/Main/MainNavigation/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainNavigation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__("./node_modules/react-addons-css-transition-group/index.js");
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reactSimpleDropdown = __webpack_require__("./node_modules/react-simple-dropdown/lib/components/Dropdown.js");
	
	var _reactSimpleDropdown2 = _interopRequireDefault(_reactSimpleDropdown);
	
	var _reactCookieBanner = __webpack_require__("./node_modules/react-cookie-banner/lib/index.js");
	
	var _reactCookieBanner2 = _interopRequireDefault(_reactCookieBanner);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _MainNavigationDropdownHeader = __webpack_require__("./src/members/Main/MainNavigation/MainNavigationDropdownHeader/index.js");
	
	var _MainNavigationDropdownHeader2 = _interopRequireDefault(_MainNavigationDropdownHeader);
	
	var _MainNavigationItem = __webpack_require__("./src/members/Main/MainNavigation/MainNavigationItem/index.js");
	
	var _MainNavigationItem2 = _interopRequireDefault(_MainNavigationItem);
	
	var _MainNavigationSearchBar = __webpack_require__("./src/members/Main/MainNavigation/MainNavigationSearchBar/index.js");
	
	var _MainNavigationSearchBar2 = _interopRequireDefault(_MainNavigationSearchBar);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/MainNavigation/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainNavigation = exports.MainNavigation = function (_Component) {
	  _inherits(MainNavigation, _Component);
	
	  function MainNavigation(props) {
	    _classCallCheck(this, MainNavigation);
	
	    var _this = _possibleConstructorReturn(this, (MainNavigation.__proto__ || Object.getPrototypeOf(MainNavigation)).call(this, props));
	
	    _this.handleSearchItemClick = _this.handleSearchItemClick.bind(_this);
	    _this.handleSearchBarClose = _this.handleSearchBarClose.bind(_this);
	    _this.handleMoreOnTabletClick = _this.handleMoreOnTabletClick.bind(_this);
	    _this.handleLogout = _this.handleLogout.bind(_this);
	    return _this;
	  }
	
	  _createClass(MainNavigation, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.location !== this.props.location) {
	        this.dropdown.hide();
	        this.moreDropdown.hide();
	      }
	    }
	  }, {
	    key: 'handleSearchItemClick',
	    value: function handleSearchItemClick(event) {
	      event.preventDefault();
	      this.props.onSearchBarOpen();
	    }
	  }, {
	    key: 'handleSearchBarClose',
	    value: function handleSearchBarClose() {
	      this.props.onSearchBarClose();
	    }
	  }, {
	    key: 'handleMoreOnTabletClick',
	    value: function handleMoreOnTabletClick(event) {
	      event.preventDefault();
	    }
	  }, {
	    key: 'handleLogout',
	    value: function handleLogout() {
	      this.props.onLogout();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var searchBar = null;
	
	      if (this.props.searchBarVisible) {
	        searchBar = _react2.default.createElement(_MainNavigationSearchBar2.default, { onClose: this.handleSearchBarClose });
	      }
	
	      return _react2.default.createElement(
	        'header',
	        null,
	        _react2.default.createElement(
	          'nav',
	          { className: 'MainNavigation' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper-full' },
	            _react2.default.createElement(
	              'div',
	              { className: 'user-dropdown show-for-tablet' },
	              _react2.default.createElement(
	                _reactSimpleDropdown2.default,
	                { className: 'show-for-tablet', ref: function ref(c) {
	                    return _this2.dropdown = c;
	                  } },
	                _react2.default.createElement(
	                  _reactSimpleDropdown.DropdownTrigger,
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'dropdown-trigger-text' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'username' },
	                      this.props.userName
	                    )
	                  ),
	                  _react2.default.createElement('span', { className: 'icon-nav-arrow-down' })
	                ),
	                _react2.default.createElement(
	                  _reactSimpleDropdown.DropdownContent,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'dropdown-content-inner' },
	                    _react2.default.createElement(_MainNavigationDropdownHeader2.default, null),
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'user-menu' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { className: 'Link is-half-opaque', onClick: this.handleLogout },
	                          "Logout"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(_MainNavigationItem2.default, { onlyActiveOnIndex: true, to: '/', type: 'home', iconUrl: "https://cdn.kooth.com/logos/kooth.svg", showForTablet: true }),
	              _react2.default.createElement(_MainNavigationItem2.default, { onlyActiveOnIndex: true, to: '/', type: 'home', iconUrl: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/menu-icon-home.svg", hideForTablet: true }),
	              ((true) === true || (true) === true) && _react2.default.createElement(_MainNavigationItem2.default, { to: '/messages', type: 'messages', iconUrl: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/menu-icon-messages.svg", isOnline: this.props.isChatOnline, isChatEnabled: (true) === true }),
	              (true) === true && _react2.default.createElement(_MainNavigationItem2.default, { to: '/magazine', type: 'magazine', iconUrl: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/menu-icon-magazine.svg" }),
	              (true) === true && _react2.default.createElement(_MainNavigationItem2.default, { to: '/forum', type: 'forum', iconUrl: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/menu-icon-forum.svg" }),
	              _react2.default.createElement(_MainNavigationItem2.default, { onClick: this.handleSearchItemClick, type: 'search', iconUrl: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/menu-icon-search.svg", showForTablet: true }),
	              _react2.default.createElement(_MainNavigationItem2.default, { to: '/more', type: 'more', iconUrl: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/menu-icon-more.svg", hideForTablet: true }),
	              _react2.default.createElement(
	                _MainNavigationItem2.default,
	                { onClick: this.handleMoreOnTabletClick, dropdownRef: function dropdownRef(c) {
	                    return _this2.moreDropdown = c;
	                  }, type: 'more', iconUrl: "http://kooth-cdn.s3-website-eu-west-1.amazonaws.com/icons/menu-icon-more.svg", showForTablet: true },
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'user-menu' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _Link2.default,
	                      { to: '/goals' },
	                      "Goals"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _Link2.default,
	                      { to: '/journal' },
	                      "Journal"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _Link2.default,
	                      { to: '/links' },
	                      "Links"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _Link2.default,
	                      { to: '/interests' },
	                      "Interests"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'Link', target: '_blank', href: ("http://dev.kooth.com") + '/team.html' },
	                      "Meet the Team"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _Link2.default,
	                      { to: '/feedback' },
	                      "Feedback"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactAddonsCssTransitionGroup2.default,
	              { transitionName: 'search-bar-transition', transitionEnterTimeout: 200, transitionLeaveTimeout: 200 },
	              searchBar
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactCookieBanner2.default,
	          {
	            className: 'privacy',
	            dismissOnScroll: false,
	            cookie: 'user-has-accepted-our-apology'
	          },
	          function (onAccept) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'react-cookie-banner privacy' },
	              _react2.default.createElement(
	                'p',
	                { className: 'cookie-message' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'We\'ve recently been experiencing some technical issues which have affected the Kooth service. We\'re really sorry if this has meant you\'ve been unable to use Kooth. We\'ve been working hard overnight and the service is back to normal today.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Please bear with us while we catch up on your messages and get all your posts and goals moderated.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'From the Kooth team'
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'button-close', onClick: onAccept },
	                'X'
	              )
	            );
	          }
	        )
	      );
	    }
	  }]);
	
	  return MainNavigation;
	}(_react.Component);
	
	MainNavigation.propTypes = {
	  location: _react.PropTypes.string,
	  onSearchBarOpen: _react.PropTypes.func,
	  onSearchBarClose: _react.PropTypes.func,
	  searchBarVisible: _react.PropTypes.bool,
	  isChatOnline: _react.PropTypes.bool,
	  userName: _react.PropTypes.string,
	  onLogout: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var chatQueueRejection = (0, _selectors.getChatQueueRejection)(state);
	
	  return {
	    searchBarVisible: (0, _selectors.getSearchBar)(state).visible,
	    isChatOnline: (0, _selectors.getChatState)(state).stringValue !== 'OFFLINE' && !chatQueueRejection.isRejected,
	    userName: (0, _selectors.getUserProfile)(state).userName
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onSearchBarOpen: function onSearchBarOpen() {
	      dispatch(actions.searchShow());
	    },
	    onSearchBarClose: function onSearchBarClose() {
	      dispatch(actions.searchHide());
	    },
	    onLogout: function onLogout() {
	      dispatch(actions.authLogout());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainNavigation);

/***/ },

/***/ "./src/members/Main/More/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.More = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _SearchBar = __webpack_require__("./src/members/Main/__shared__/containers/SearchBar/index.js");
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _MainNavigationDropdownHeader = __webpack_require__("./src/members/Main/MainNavigation/MainNavigationDropdownHeader/index.js");
	
	var _MainNavigationDropdownHeader2 = _interopRequireDefault(_MainNavigationDropdownHeader);
	
	__webpack_require__("./src/members/Main/More/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var More = exports.More = function (_Component) {
	  _inherits(More, _Component);
	
	  function More() {
	    _classCallCheck(this, More);
	
	    var _this = _possibleConstructorReturn(this, (More.__proto__ || Object.getPrototypeOf(More)).call(this));
	
	    _this.handleLogoutClick = _this.handleLogoutClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(More, [{
	    key: 'handleLogoutClick',
	    value: function handleLogoutClick(event) {
	      event.preventDefault();
	      this.props.onLogout();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'section',
	        { className: 'content-wrapper has-background-medium' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-collapsed' },
	          _react2.default.createElement(
	            'div',
	            { className: 'MoreSearchBar' },
	            _react2.default.createElement(_SearchBar2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'user-menu-wrapper' },
	            _react2.default.createElement(_MainNavigationDropdownHeader2.default, null),
	            _react2.default.createElement(
	              'ul',
	              { className: 'user-menu has-border-on-last' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _Link2.default,
	                  { to: '/goals' },
	                  "Goals"
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _Link2.default,
	                  { to: '/journal' },
	                  "Journal"
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _Link2.default,
	                  { to: '/links' },
	                  "Links"
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _Link2.default,
	                  { to: '/interests' },
	                  "Interests"
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { className: 'Link', target: '_blank', href: ("http://dev.kooth.com") + '/team.html' },
	                  "Meet the Team"
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _Link2.default,
	                  { to: '/feedback' },
	                  "Feedback"
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { className: 'Link is-half-opaque', onClick: this.handleLogoutClick },
	                  "Logout"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return More;
	}(_react.Component);
	
	More.propTypes = {
	  onLogout: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onLogout: function onLogout() {
	      dispatch(actions.authLogout());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(More);

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/ReferralFormCheckboxGroup/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__("./node_modules/redux-form/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferralFormCheckboxGroup = function ReferralFormCheckboxGroup(props) {
	  var input = props.input,
	      name = props.name,
	      label = props.label,
	      requiredLabel = props.requiredLabel,
	      isRequired = props.isRequired,
	      options = props.options,
	      _props$meta = props.meta,
	      touched = _props$meta.touched,
	      dirty = _props$meta.dirty,
	      error = _props$meta.error;
	
	  var hasError = (dirty || touched) && error;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      null,
	      label,
	      isRequired && _react2.default.createElement(
	        'span',
	        { className: 'required' },
	        ' * (' + requiredLabel + ')'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'small-fields small-checkboxes' },
	      options.map(function (o) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'option-small', key: o.name },
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox-outer' },
	            _react2.default.createElement(_reduxForm.Field, {
	              className: hasError ? 'is-invalid-input' : '',
	              name: name + '.' + o.name,
	              id: '' + o.name,
	              checked: input.value[o.name],
	              component: 'input',
	              type: 'checkbox'
	            }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: '' + o.name },
	              o.title
	            )
	          )
	        );
	      })
	    ),
	    hasError && _react2.default.createElement(
	      'span',
	      { className: 'form-error is-visible' },
	      error
	    )
	  );
	};
	
	ReferralFormCheckboxGroup.propTypes = {
	  input: _react.PropTypes.object,
	  name: _react.PropTypes.string,
	  label: _react.PropTypes.string,
	  isRequired: _react.PropTypes.bool,
	  requiredLabel: _react.PropTypes.string,
	  options: _react.PropTypes.array,
	  meta: _react.PropTypes.object
	};
	
	exports.default = ReferralFormCheckboxGroup;

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/ReferralFormDatepicker/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateInput = __webpack_require__("./src/members/Main/__shared__/components/DateInput/index.js");
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferralFormDatepicker = function ReferralFormDatepicker(props) {
	  var input = props.input,
	      label = props.label,
	      isRequired = props.isRequired,
	      dateFormat = props.dateFormat,
	      _props$meta = props.meta,
	      touched = _props$meta.touched,
	      error = _props$meta.error;
	
	  var hasError = touched && error;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      { htmlFor: '' + input.name },
	      label,
	      isRequired && _react2.default.createElement(
	        'span',
	        { className: 'required' },
	        ' *'
	      )
	    ),
	    _react2.default.createElement(_DateInput2.default, {
	      input: input,
	      format: dateFormat,
	      className: hasError ? 'is-invalid-input' : ''
	    }),
	    hasError && _react2.default.createElement(
	      'span',
	      { className: 'form-error is-visible' },
	      error
	    )
	  );
	};
	
	ReferralFormDatepicker.propTypes = {
	  input: _react.PropTypes.object,
	  label: _react.PropTypes.string,
	  dateFormat: _react.PropTypes.string,
	  isRequired: _react.PropTypes.bool,
	  meta: _react.PropTypes.object
	};
	
	exports.default = ReferralFormDatepicker;

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/ReferralFormField/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferralFormField = function ReferralFormField(props) {
	  var input = props.input,
	      label = props.label,
	      type = props.type,
	      isRequired = props.isRequired,
	      _props$meta = props.meta,
	      touched = _props$meta.touched,
	      error = _props$meta.error;
	
	  var hasError = touched && error;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      { htmlFor: '' + input.name },
	      label,
	      isRequired && _react2.default.createElement(
	        'span',
	        { className: 'required' },
	        ' *'
	      )
	    ),
	    _react2.default.createElement('input', _extends({}, input, {
	      id: '' + input.name,
	      className: hasError ? 'is-invalid-input' : '',
	      type: type
	    })),
	    hasError && _react2.default.createElement(
	      'span',
	      { className: 'form-error is-visible' },
	      error
	    )
	  );
	};
	
	ReferralFormField.propTypes = {
	  input: _react.PropTypes.object,
	  label: _react.PropTypes.string,
	  type: _react.PropTypes.string,
	  isRequired: _react.PropTypes.bool,
	  meta: _react.PropTypes.object
	};
	
	exports.default = ReferralFormField;

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/ReferralFormProviderList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/Referral/ReferralForm/ReferralFormProviderList/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferralFormProviderList = function ReferralFormProviderList(props) {
	  var name = props.name,
	      logo = props.logo,
	      description = props.description;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ReferralFormProviderList' },
	    logo && _react2.default.createElement(
	      'div',
	      { className: 'service-logo' },
	      _react2.default.createElement('img', { src: logo })
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      name
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      description
	    )
	  );
	};
	
	ReferralFormProviderList.propTypes = {
	  name: _react.PropTypes.string,
	  logo: _react.PropTypes.string,
	  description: _react.PropTypes.string
	};
	
	exports.default = ReferralFormProviderList;

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/ReferralFormRadioGroup/index.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferralFormRadioGroup = function ReferralFormRadioGroup(props) {
	  var input = props.input,
	      name = props.name,
	      label = props.label,
	      isRequired = props.isRequired,
	      options = props.options,
	      _props$meta = props.meta,
	      touched = _props$meta.touched,
	      error = _props$meta.error;
	
	  var hasError = touched && error;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "label",
	      null,
	      label,
	      isRequired && _react2.default.createElement(
	        "span",
	        { className: "required" },
	        " *"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "small-fields small-radio-buttons" },
	      options.map(function (o) {
	        return _react2.default.createElement(
	          "div",
	          { className: "option-small", key: o.value },
	          _react2.default.createElement("input", _extends({}, input, {
	            type: "radio",
	            className: hasError ? 'is-invalid-input' : '',
	            value: o.value,
	            checked: o.value === input.value,
	            id: name + "-" + o.value
	          })),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: name + "-" + o.value },
	            o.title
	          )
	        );
	      })
	    ),
	    hasError && _react2.default.createElement(
	      "span",
	      { className: "form-error is-visible" },
	      error
	    )
	  );
	};
	
	ReferralFormRadioGroup.propTypes = {
	  input: _react.PropTypes.object,
	  name: _react.PropTypes.string,
	  label: _react.PropTypes.string,
	  isRequired: _react.PropTypes.bool,
	  options: _react.PropTypes.array,
	  meta: _react.PropTypes.object
	};
	
	exports.default = ReferralFormRadioGroup;

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/ReferralFormSelect/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferralFormSelect = function ReferralFormSelect(props) {
	  var input = props.input,
	      label = props.label,
	      isRequired = props.isRequired,
	      entities = props.entities,
	      entityKey = props.entityKey,
	      _props$meta = props.meta,
	      touched = _props$meta.touched,
	      error = _props$meta.error;
	
	  var hasError = touched && error;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      { htmlFor: '' + input.name },
	      label,
	      isRequired && _react2.default.createElement(
	        'span',
	        { className: 'required' },
	        ' *'
	      )
	    ),
	    _react2.default.createElement(
	      'select',
	      _extends({}, input, {
	        className: hasError ? 'is-invalid-input' : '',
	        id: '' + input.name
	      }),
	      _react2.default.createElement('option', { disabled: true, value: true }),
	      entities.map(function (item) {
	        return _react2.default.createElement(
	          'option',
	          { value: item.id, key: item.id },
	          item[entityKey]
	        );
	      })
	    ),
	    hasError && _react2.default.createElement(
	      'span',
	      { className: 'form-error is-visible' },
	      error
	    )
	  );
	};
	
	ReferralFormSelect.propTypes = {
	  input: _react.PropTypes.object,
	  meta: _react.PropTypes.object,
	  entities: _react.PropTypes.array,
	  label: _react.PropTypes.string,
	  isRequired: _react.PropTypes.bool,
	  entityKey: _react.PropTypes.string
	};
	
	exports.default = ReferralFormSelect;

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/ReferralFormTextarea/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferralFormTextarea = function ReferralFormTextarea(props) {
	  var input = props.input,
	      label = props.label,
	      isRequired = props.isRequired,
	      _props$meta = props.meta,
	      touched = _props$meta.touched,
	      error = _props$meta.error;
	
	  var hasError = touched && error;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      { htmlFor: '' + input.name },
	      label,
	      isRequired && _react2.default.createElement(
	        'span',
	        { className: 'required' },
	        ' *'
	      )
	    ),
	    _react2.default.createElement('textarea', _extends({}, input, {
	      className: hasError ? 'is-invalid-input' : '',
	      id: '' + input.name
	    })),
	    hasError && _react2.default.createElement(
	      'span',
	      { className: 'form-error is-visible' },
	      error
	    )
	  );
	};
	
	ReferralFormTextarea.propTypes = {
	  input: _react.PropTypes.object,
	  label: _react.PropTypes.string,
	  isRequired: _react.PropTypes.bool,
	  meta: _react.PropTypes.object
	};
	
	exports.default = ReferralFormTextarea;

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/asyncValidate.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function (values, dispatch, props, currentField) {
	  if (!currentField || values[currentField] === '') return Promise.resolve();
	
	  return new Promise(function (resolve, reject) {
	    dispatch(actions.f2fFieldValidate(currentField, values[currentField], resolve, reject));
	  });
	};

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reduxForm = __webpack_require__("./node_modules/redux-form/lib/index.js");
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _InfoBar = __webpack_require__("./src/members/Main/__shared__/components/InfoBar/index.js");
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	var _ReferralFormProviderList = __webpack_require__("./src/members/Main/Referral/ReferralForm/ReferralFormProviderList/index.js");
	
	var _ReferralFormProviderList2 = _interopRequireDefault(_ReferralFormProviderList);
	
	var _ReferralFormField = __webpack_require__("./src/members/Main/Referral/ReferralForm/ReferralFormField/index.js");
	
	var _ReferralFormField2 = _interopRequireDefault(_ReferralFormField);
	
	var _ReferralFormTextarea = __webpack_require__("./src/members/Main/Referral/ReferralForm/ReferralFormTextarea/index.js");
	
	var _ReferralFormTextarea2 = _interopRequireDefault(_ReferralFormTextarea);
	
	var _ReferralFormSelect = __webpack_require__("./src/members/Main/Referral/ReferralForm/ReferralFormSelect/index.js");
	
	var _ReferralFormSelect2 = _interopRequireDefault(_ReferralFormSelect);
	
	var _ReferralFormRadioGroup = __webpack_require__("./src/members/Main/Referral/ReferralForm/ReferralFormRadioGroup/index.js");
	
	var _ReferralFormRadioGroup2 = _interopRequireDefault(_ReferralFormRadioGroup);
	
	var _ReferralFormCheckboxGroup = __webpack_require__("./src/members/Main/Referral/ReferralForm/ReferralFormCheckboxGroup/index.js");
	
	var _ReferralFormCheckboxGroup2 = _interopRequireDefault(_ReferralFormCheckboxGroup);
	
	var _ReferralFormDatepicker = __webpack_require__("./src/members/Main/Referral/ReferralForm/ReferralFormDatepicker/index.js");
	
	var _ReferralFormDatepicker2 = _interopRequireDefault(_ReferralFormDatepicker);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/Referral/ReferralForm/style.scss");
	
	var _validate = __webpack_require__("./src/members/Main/Referral/ReferralForm/validate.js");
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _asyncValidate = __webpack_require__("./src/members/Main/Referral/ReferralForm/asyncValidate.js");
	
	var _asyncValidate2 = _interopRequireDefault(_asyncValidate);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferralForm = function (_Component) {
	  _inherits(ReferralForm, _Component);
	
	  function ReferralForm() {
	    _classCallCheck(this, ReferralForm);
	
	    var _this = _possibleConstructorReturn(this, (ReferralForm.__proto__ || Object.getPrototypeOf(ReferralForm)).call(this));
	
	    _this.handleInfoBarClose = _this.handleInfoBarClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReferralForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onDidMount) {
	        this.props.onDidMount();
	      }
	    }
	  }, {
	    key: 'handleInfoBarClose',
	    value: function handleInfoBarClose() {
	      if (this.props.onInfoBarClose) {
	        this.props.onInfoBarClose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ReferralForm' },
	        this.props.isSuccessInfoBarVisible && _react2.default.createElement(_InfoBar2.default, { onClose: this.handleInfoBarClose, type: 'primary', message: this.props.successInfoBarMessage }),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.props.handleSubmit },
	          this.props.provider && _react2.default.createElement(_ReferralFormProviderList2.default, this.props.provider),
	          _react2.default.createElement(
	            'h3',
	            null,
	            "About you"
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'small-fields full-small-down' },
	              _react2.default.createElement(
	                'div',
	                { className: 'option-small' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'firstName',
	                  label: "First Name",
	                  type: 'text',
	                  component: _ReferralFormField2.default,
	                  isRequired: true
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'option-small' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'lastName',
	                  label: "Last Name",
	                  type: 'text',
	                  component: _ReferralFormField2.default,
	                  isRequired: true
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'small-fields full-small-down' },
	              _react2.default.createElement(
	                'div',
	                { className: 'option-small' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'emailAddress',
	                  label: "Email Address",
	                  type: 'email',
	                  component: _ReferralFormField2.default,
	                  isRequired: true
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'option-small' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'emailAddressConfirm',
	                  label: "Confirm Email",
	                  type: 'email',
	                  component: _ReferralFormField2.default,
	                  isRequired: true
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'telephone',
	              label: "Telephone",
	              type: 'tel',
	              component: _ReferralFormField2.default
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'address',
	              label: "First Line of Address",
	              type: 'text',
	              component: _ReferralFormField2.default
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'small-fields full-small-down' },
	              _react2.default.createElement(
	                'div',
	                { className: 'option-small' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'townCity',
	                  label: "Location/Town",
	                  component: _ReferralFormSelect2.default,
	                  normalize: function normalize(value) {
	                    return parseInt(value, 10);
	                  },
	                  isRequired: true,
	                  entities: this.props.locations,
	                  entityKey: 'location'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'option-small' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'postcode',
	                  label: "Postcode",
	                  type: 'text',
	                  isRequired: true,
	                  component: _ReferralFormField2.default
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'small-fields full-small-down' },
	              _react2.default.createElement(
	                'div',
	                { className: 'option-small' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'dob',
	                  label: "Date of Birth",
	                  type: 'date',
	                  isRequired: true,
	                  component: _ReferralFormDatepicker2.default,
	                  dateFormat: 'YYYY-MM-DD',
	                  normalize: function normalize(value) {
	                    return (0, _moment2.default)(value).format('YYYY-MM-DD');
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'option-small' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'preferredLanguage',
	                  label: "Preferred Language",
	                  component: _ReferralFormSelect2.default,
	                  normalize: function normalize(value) {
	                    return parseInt(value, 10);
	                  },
	                  isRequired: true,
	                  entities: this.props.languages,
	                  entityKey: 'language'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            "More about you"
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'school',
	              label: "School/College",
	              component: _ReferralFormSelect2.default,
	              normalize: function normalize(value) {
	                return parseInt(value, 10);
	              },
	              isRequired: true,
	              entities: this.props.schools,
	              entityKey: 'school'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'contactBy',
	              label: "Can we contact you",
	              isRequired: true,
	              requiredLabel: "choose at least one",
	              component: _ReferralFormCheckboxGroup2.default,
	              options: [{ title: "by phone", name: "phone" }, { title: "by email", name: "email" }, { title: "by letter (school/college)", name: "letterSchool" }, { title: "by text", name: "sms" }, { title: "by letter (home)", name: "letterHome" }]
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'childProtection',
	              label: "Are you under any form of child protection?",
	              component: _ReferralFormRadioGroup2.default,
	              isRequired: true,
	              options: [{ title: "Yes", value: "Y" }, { title: "No", value: "N" }, { title: "Don't know", value: "U" }]
	            })
	          ),
	          this.props.childProtectionMoreVisible && _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'childProtectionMore',
	              label: "If you answered yes above please provide more details.",
	              component: _ReferralFormTextarea2.default
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'additionalNeeds',
	              label: "Do you have any additional needs?",
	              component: _ReferralFormRadioGroup2.default,
	              isRequired: true,
	              options: [{ title: "Yes", value: "Y" }, { title: "No", value: "N" }, { title: "Don't know", value: "U" }]
	            })
	          ),
	          this.props.additionalNeedsMoreVisible && _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'additionalNeedsMore',
	              label: "If you answered yes above please provide more details.",
	              component: _ReferralFormTextarea2.default
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'legalProceedings',
	              label: "Are you involved in legal proceedings?",
	              component: _ReferralFormRadioGroup2.default,
	              isRequired: true,
	              options: [{ title: "Yes", value: "Y" }, { title: "No", value: "N" }, { title: "Don't know", value: "U" }]
	            })
	          ),
	          this.props.legalProceedingsMoreVisible && _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'legalProceedingsMore',
	              label: "If you answered yes above please provide more details.",
	              component: _ReferralFormTextarea2.default
	            })
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            "Doctor's details"
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'gpName',
	              label: "GP Name",
	              type: 'text',
	              component: _ReferralFormField2.default
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'gpAddress',
	              label: "GP Address",
	              type: 'text',
	              component: _ReferralFormField2.default
	            })
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            "About the counselling"
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'preferredLocation',
	              label: "Preferred location for counselling",
	              component: _ReferralFormSelect2.default,
	              normalize: function normalize(value) {
	                return parseInt(value, 10);
	              },
	              isRequired: true,
	              entities: this.props.schools,
	              entityKey: 'school'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'preferredGender',
	              component: _ReferralFormSelect2.default,
	              label: 'Preferred gender of counsellor\n(we try to accommodate this but no guarantees)',
	              entities: [{ id: "U", gender: "No preference" }, { id: "M", gender: "Male" }, { id: "F", gender: "Female" }],
	              entityKey: 'gender'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'referralReason',
	              label: "Reasons for referral",
	              component: _ReferralFormTextarea2.default
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'help-text' },
	              "Please say why you want face to face counselling"
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'otherWorkers',
	              label: "Any other workers involved with you or your family?",
	              component: _ReferralFormTextarea2.default
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'help-text' },
	              "Please provide name, role, contact info"
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'contactWorkers',
	              label: "Is it OK to contact these other workers?",
	              component: _ReferralFormRadioGroup2.default,
	              format: function format(value) {
	                if (value === true) return 'true';
	                if (value === false) return 'false';
	                return value;
	              },
	              normalize: function normalize(value) {
	                if (value === 'true') return true;
	                if (value === 'false') return false;
	                return value;
	              },
	              options: [{ title: "Yes", value: 'true' }, { title: "No", value: 'false' }]
	            })
	          ),
	          !!this.props.error && _react2.default.createElement(
	            'div',
	            { className: 'form-wrapper-error-be alert callout' },
	            _react2.default.createElement(
	              'p',
	              null,
	              this.props.error
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              isYellow: true,
	              hasIcon: this.props.submitting,
	              isDisabled: this.props.submitting,
	              iconType: 'preloader-dark',
	              onClick: this.props.handleSubmit
	            },
	            "Submit"
	          ),
	          _react2.default.createElement('input', { type: 'submit', hidden: true })
	        )
	      );
	    }
	  }]);
	
	  return ReferralForm;
	}(_react.Component);
	
	ReferralForm.propTypes = {
	  invalid: _react.PropTypes.bool,
	  submitting: _react.PropTypes.bool,
	  error: _react.PropTypes.string,
	  handleSubmit: _react.PropTypes.func,
	  onDidMount: _react.PropTypes.func,
	  onSubmit: _react.PropTypes.func,
	  locations: _react.PropTypes.arrayOf(_entities.ReferralLocationShape),
	  schools: _react.PropTypes.arrayOf(_entities.ReferralSchoolShape),
	  languages: _react.PropTypes.arrayOf(_entities.ReferralLanguageShape),
	  provider: _entities.ReferralProvider,
	  childProtectionMoreVisible: _react.PropTypes.bool,
	  additionalNeedsMoreVisible: _react.PropTypes.bool,
	  legalProceedingsMoreVisible: _react.PropTypes.bool,
	  isSuccessInfoBarVisible: _react.PropTypes.bool,
	  successInfoBarMessage: _react.PropTypes.string,
	  onInfoBarClose: _react.PropTypes.func
	};
	
	var selector = (0, _reduxForm.formValueSelector)('referral');
	var mapStateToProps = function mapStateToProps(state) {
	  var childProtectionMoreVisible = selector(state, 'childProtection') === "Y";
	  var additionalNeedsMoreVisible = selector(state, 'additionalNeeds') === "Y";
	  var legalProceedingsMoreVisible = selector(state, 'legalProceedings') === "Y";
	
	  // currently there is only one provider per area
	  var provider = (0, _selectors.getF2F)(state).services[0];
	
	  var successState = (0, _selectors.getInfoState)(state, 'success');
	  var isSuccessInfoBarVisible = successState.visible;
	  var successInfoBarMessage = successState.message;
	
	  var initialValues = {
	    referee: (0, _selectors.getUserProfile)(state).id,
	    f2fProvider: provider.id,
	    contactBy: {
	      email: false,
	      sms: false,
	      phone: false,
	      letterHome: false,
	      letterSchool: false
	    },
	    preferredGender: 'U'
	  };
	
	  return _extends({
	    initialValues: initialValues,
	    provider: provider
	  }, (0, _selectors.getF2F)(state), {
	    childProtectionMoreVisible: childProtectionMoreVisible,
	    additionalNeedsMoreVisible: additionalNeedsMoreVisible,
	    legalProceedingsMoreVisible: legalProceedingsMoreVisible,
	    isSuccessInfoBarVisible: isSuccessInfoBarVisible,
	    successInfoBarMessage: successInfoBarMessage
	  });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onDidMount: function onDidMount() {
	      dispatch(actions.f2fStatusFetch());
	      dispatch(actions.f2fLanguagesFetch());
	      dispatch(actions.f2fLocationsFetch());
	      dispatch(actions.f2fSchoolsFetch());
	    },
	    onInfoBarClose: function onInfoBarClose() {
	      dispatch(actions.infoClose('success'));
	    },
	    onSubmit: function onSubmit(data) {
	      return new Promise(function (resolve, reject) {
	        dispatch(actions.f2fReferralCreate(data, resolve, reject, "Successfully signed up for a face to face chat session!"));
	      });
	    }
	  };
	};
	
	ReferralForm = (0, _reduxForm.reduxForm)({ //eslint-disable-line no-class-assign
	  form: 'referral',
	  validate: _validate2.default,
	  asyncValidate: _asyncValidate2.default,
	  asyncBlurFields: ['telephone', 'dob', 'postcode']
	})(ReferralForm);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReferralForm);

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/validate.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EMAIL_REGEX = new RegExp(("^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$"));
	
	exports.default = function (values) {
	  var errors = {};
	
	  if (!values.firstName) {
	    errors.firstName = "This is a required field.";
	  }
	
	  if (!values.lastName) {
	    errors.lastName = "This is a required field.";
	  }
	
	  if (!EMAIL_REGEX.test(values.emailAddress)) {
	    errors.emailAddress = "This should be a valid email address.";
	  }
	
	  if (values.emailAddressConfirm !== values.emailAddress) {
	    errors.emailAddressConfirm = "The confirm email should match the email.";
	  }
	
	  if (!values.preferredLocation) {
	    errors.preferredLocation = true;
	  }
	
	  if (!values.postcode) {
	    errors.postcode = "This is a required field.";
	  }
	
	  if (!values.dob) {
	    errors.dob = "This is a required field.";
	  }
	
	  if (!values.childProtection) {
	    errors.childProtection = true;
	  }
	
	  if (!values.additionalNeeds) {
	    errors.additionalNeeds = true;
	  }
	
	  if (!values.legalProceedings) {
	    errors.legalProceedings = true;
	  }
	
	  if (!values.school) {
	    errors.school = true;
	  }
	
	  if (!values.preferredLanguage) {
	    errors.preferredLanguage = true;
	  }
	
	  if (!values.townCity) {
	    errors.townCity = "This is a required field.";
	  }
	
	  if (!values.school) {
	    errors.school = "This is a required field.";
	  }
	
	  if (!values.preferredLanguage) {
	    errors.preferredLanguage = "This is a required field.";
	  }
	
	  if (!values.childProtection) {
	    errors.childProtection = "This is a required field.";
	  }
	
	  if (!values.additionalNeeds) {
	    errors.additionalNeeds = "This is a required field.";
	  }
	
	  if (!values.legalProceedings) {
	    errors.legalProceedings = "This is a required field.";
	  }
	
	  if (values.contactBy && Object.values(values.contactBy).every(function (value) {
	    return value === false;
	  })) {
	    errors.contactBy = "At least one should be chosen.";
	  }
	
	  return errors;
	};

/***/ },

/***/ "./src/members/Main/Referral/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _ReferralForm = __webpack_require__("./src/members/Main/Referral/ReferralForm/index.js");
	
	var _ReferralForm2 = _interopRequireDefault(_ReferralForm);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _NoEntries = __webpack_require__("./src/members/Main/__shared__/components/NoEntries/index.js");
	
	var _NoEntries2 = _interopRequireDefault(_NoEntries);
	
	var _NoEntriesDetail = __webpack_require__("./src/members/Main/__shared__/components/NoEntries/NoEntriesDetail/index.js");
	
	var _NoEntriesDetail2 = _interopRequireDefault(_NoEntriesDetail);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable react/no-danger*/
	
	
	var Referral = function (_Component) {
	  _inherits(Referral, _Component);
	
	  function Referral() {
	    _classCallCheck(this, Referral);
	
	    return _possibleConstructorReturn(this, (Referral.__proto__ || Object.getPrototypeOf(Referral)).apply(this, arguments));
	  }
	
	  _createClass(Referral, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onDidMount) {
	        this.props.onDidMount();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'content-wrapper has-background-medium' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            "Sign up for a face to face chat session"
	          ),
	          function () {
	            if (_this2.props.isF2FAvailable) {
	              return _react2.default.createElement(_ReferralForm2.default, null);
	            } else if (_this2.props.isFetching) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'while-loading' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  "Loading..."
	                )
	              );
	            } else if (!_this2.props.isF2FAvailable) {
	              var link = "incrisis.html";
	              return _react2.default.createElement(
	                _NoEntries2.default,
	                { title: "Signing up for face to face chat sessions is not available." },
	                _react2.default.createElement(
	                  _NoEntriesDetail2.default,
	                  null,
	                  "We're sorry, at the moment it is not possible to sign up for a face to face chat session in your area."
	                ),
	                _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: 'In crisis? Then click <a class=\'Link\' href=' + link + ' target=\'_blank\'>here</a> for some services that can help you.' } })
	              );
	            }
	          }()
	        )
	      );
	    }
	  }]);
	
	  return Referral;
	}(_react.Component);
	
	Referral.propTypes = {
	  onDidMount: _react.PropTypes.func,
	  isF2FAvailable: _react.PropTypes.bool,
	  isFetching: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isF2FAvailable: (0, _selectors.getF2F)(state).isAvailable,
	    isFetching: (0, _selectors.getF2F)(state).isFetching
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onDidMount: function onDidMount() {
	      dispatch(actions.f2fStatusFetch());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Referral);

/***/ },

/***/ "./src/members/Main/Search/SearchComment/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	__webpack_require__("./src/members/Main/Search/SearchComment/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchComment = function SearchComment(props) {
	  var comment = props.comment;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'SearchComment' },
	    _react2.default.createElement(
	      'div',
	      { className: 'meta has-avatar' },
	      _react2.default.createElement(_UserAvatar2.default, { letter: comment.author.userName[0], imageUrl: comment.author.avatar.url }),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          comment.author.userName
	        ),
	        ' ',
	        "commented in",
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          _react2.default.createElement(
	            _Link2.default,
	            { to: props.originUrl },
	            props.originTitle
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'time' },
	        (0, _moment2.default)(comment.createdAt).fromNow()
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'text-wrapper' },
	      _react2.default.createElement(
	        'p',
	        null,
	        comment.text
	      )
	    ),
	    _react2.default.createElement(
	      _Link2.default,
	      { to: props.commentUrl },
	      "View discussion"
	    )
	  );
	};
	
	SearchComment.propTypes = {
	  comment: _entities.CommentShape,
	  originUrl: _react.PropTypes.string,
	  originTitle: _react.PropTypes.string,
	  commentUrl: _react.PropTypes.string
	};
	
	exports.default = SearchComment;

/***/ },

/***/ "./src/members/Main/Search/SearchPageSelector/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchPageSelector = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _PageSelector = __webpack_require__("./src/members/Main/__shared__/components/PageSelector/index.js");
	
	var _PageSelector2 = _interopRequireDefault(_PageSelector);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SearchPageSelector = function SearchPageSelector(props) {
	  var query = props.query,
	      queryString = props.queryString,
	      otherProps = _objectWithoutProperties(props, ['query', 'queryString']); //eslint-disable-line no-unused-vars
	
	
	  return _react2.default.createElement(_PageSelector2.default, otherProps);
	};
	
	exports.SearchPageSelector = SearchPageSelector;
	var mapStateToProps = function mapStateToProps(state, props) {
	  var queryString = props.queryString;
	
	  return (0, _selectors.getSearchPaging)(state, 'results', { queryString: queryString });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onPrevClick: function onPrevClick(currentPage) {
	      dispatch(actions.searchItemsFetch(currentPage - 1, props.query, props.queryString));
	    },
	    onNextClick: function onNextClick(currentPage) {
	      dispatch(actions.searchItemsFetch(currentPage + 1, props.query, props.queryString));
	    },
	    onPossiblePageUpdate: function onPossiblePageUpdate(newPossiblePage) {
	      dispatch(actions.searchUpdatePossiblePage(newPossiblePage, props.queryString));
	    },
	    onPageUpdate: function onPageUpdate(newPage, pagesCount) {
	      if (newPage >= 1 && newPage <= pagesCount) {
	        dispatch(actions.searchItemsFetch(newPage, props.query, props.queryString));
	      }
	    }
	  };
	};
	
	SearchPageSelector.propTypes = {
	  query: _react.PropTypes.object,
	  queryString: _react.PropTypes.string
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchPageSelector);

/***/ },

/***/ "./src/members/Main/Search/SearchTabNavigation/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _SubNavigation = __webpack_require__("./src/members/Main/__shared__/components/SubNavigation/index.js");
	
	var _SubNavigation2 = _interopRequireDefault(_SubNavigation);
	
	var _SubNavigationItem = __webpack_require__("./src/members/Main/__shared__/components/SubNavigation/SubNavigationItem/index.js");
	
	var _SubNavigationItem2 = _interopRequireDefault(_SubNavigationItem);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchTabNavigation = function (_Component) {
	  _inherits(SearchTabNavigation, _Component);
	
	  function SearchTabNavigation() {
	    _classCallCheck(this, SearchTabNavigation);
	
	    var _this = _possibleConstructorReturn(this, (SearchTabNavigation.__proto__ || Object.getPrototypeOf(SearchTabNavigation)).call(this));
	
	    _this.handleTabChange = _this.handleTabChange.bind(_this);
	    _this.renderSubNavigationItem = _this.renderSubNavigationItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchTabNavigation, [{
	    key: 'handleTabChange',
	    value: function handleTabChange(e, tab) {
	      e.preventDefault();
	      this.props.onTabChange(tab);
	    }
	  }, {
	    key: 'renderSubNavigationItem',
	    value: function renderSubNavigationItem(_ref) {
	      var _this2 = this;
	
	      var category = _ref.category,
	          title = _ref.title,
	          totalCount = _ref.totalCount;
	      var selectedTab = this.props.selectedTab;
	
	      return _react2.default.createElement(
	        _SubNavigationItem2.default,
	        {
	          isForSearch: true,
	          key: category,
	          isActive: selectedTab === category,
	          onClick: function onClick(e) {
	            return _this2.handleTabChange(e, category);
	          }
	        },
	        title,
	        ' (',
	        totalCount,
	        ')'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          magazineTotalCount = _props.magazineTotalCount,
	          forumTotalCount = _props.forumTotalCount;
	
	      var hasItems = magazineTotalCount > 0 || forumTotalCount > 0;
	
	      var subNavItems = [{ category: 'magazine', title: "Magazine", totalCount: magazineTotalCount }, { category: 'forum', title: "Forum", totalCount: forumTotalCount }];
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        hasItems && _react2.default.createElement(
	          _SubNavigation2.default,
	          null,
	          subNavItems.filter(function (subNavItem) {
	            return subNavItem.totalCount > 0;
	          }).map(function (subNavItem) {
	            return _this3.renderSubNavigationItem(subNavItem);
	          })
	        )
	      );
	    }
	  }]);
	
	  return SearchTabNavigation;
	}(_react.Component);
	
	SearchTabNavigation.propTypes = {
	  magazineTotalCount: _react.PropTypes.number,
	  forumTotalCount: _react.PropTypes.number,
	  isFetching: _react.PropTypes.bool,
	  selectedTab: _react.PropTypes.string,
	  onTabChange: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var _getSearchTabs = (0, _selectors.getSearchTabs)(state),
	      selectedTab = _getSearchTabs.selectedTab,
	      isFetching = _getSearchTabs.isFetching;
	
	  var query = { term: props.term, category: selectedTab };
	
	  var _getSearchTotalCounts = (0, _selectors.getSearchTotalCounts)(state, 'results', props.term),
	      magazineTotalCount = _getSearchTotalCounts.magazineTotalCount,
	      forumTotalCount = _getSearchTotalCounts.forumTotalCount;
	
	  return {
	    selectedTab: selectedTab,
	    isFetching: isFetching,
	    query: query,
	    magazineTotalCount: magazineTotalCount,
	    forumTotalCount: forumTotalCount
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onTabChange: function onTabChange(tab) {
	      dispatch(actions.searchChangeTab(tab));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchTabNavigation);

/***/ },

/***/ "./src/members/Main/Search/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _EmptyArticle = __webpack_require__("./src/members/Main/__shared__/components/EmptyArticle/index.js");
	
	var _EmptyArticle2 = _interopRequireDefault(_EmptyArticle);
	
	var _MagazineArticle = __webpack_require__("./src/members/Main/__shared__/containers/MagazineArticle/index.js");
	
	var _MagazineArticle2 = _interopRequireDefault(_MagazineArticle);
	
	var _ForumThread = __webpack_require__("./src/members/Main/__shared__/containers/ForumThreadsList/ForumThread/index.js");
	
	var _ForumThread2 = _interopRequireDefault(_ForumThread);
	
	var _NoEntries = __webpack_require__("./src/members/Main/__shared__/components/NoEntries/index.js");
	
	var _NoEntries2 = _interopRequireDefault(_NoEntries);
	
	var _NoEntriesDetail = __webpack_require__("./src/members/Main/__shared__/components/NoEntries/NoEntriesDetail/index.js");
	
	var _NoEntriesDetail2 = _interopRequireDefault(_NoEntriesDetail);
	
	var _SearchPageSelector = __webpack_require__("./src/members/Main/Search/SearchPageSelector/index.js");
	
	var _SearchPageSelector2 = _interopRequireDefault(_SearchPageSelector);
	
	var _SearchTabNavigation = __webpack_require__("./src/members/Main/Search/SearchTabNavigation/index.js");
	
	var _SearchTabNavigation2 = _interopRequireDefault(_SearchTabNavigation);
	
	var _SearchComment = __webpack_require__("./src/members/Main/Search/SearchComment/index.js");
	
	var _SearchComment2 = _interopRequireDefault(_SearchComment);
	
	var _PropTypes = __webpack_require__("./node_modules/react-router/lib/PropTypes.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	var _commentsResourceTypes = __webpack_require__("./src/members/__shared__/commentsResourceTypes.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search() {
	    _classCallCheck(this, Search);
	
	    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
	  }
	
	  _createClass(Search, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onSearchItemsFetch(this.props.query);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.location.search !== this.props.location.search) {
	        this.props.onSearchItemsFetch(this.props.query);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onWillUnmount) {
	        this.props.onWillUnmount();
	      }
	    }
	  }, {
	    key: 'renderEmptyArticles',
	    value: function renderEmptyArticles() {
	      return [_react2.default.createElement(_EmptyArticle2.default, { key: 'loader1', isDarker: true }), _react2.default.createElement(_EmptyArticle2.default, { key: 'loader2', isDarker: true }), _react2.default.createElement(_EmptyArticle2.default, { key: 'loader3', isDarker: true })];
	    }
	  }, {
	    key: 'renderNoSearchResults',
	    value: function renderNoSearchResults() {
	      return _react2.default.createElement(
	        _NoEntries2.default,
	        { title: "No results were found." },
	        _react2.default.createElement(
	          _NoEntriesDetail2.default,
	          null,
	          "Please try a different search."
	        )
	      );
	    }
	  }, {
	    key: 'renderSearchResult',
	    value: function renderSearchResult(searchResult) {
	      var article = searchResult.article,
	          comment = searchResult.comment,
	          forumThread = searchResult.forumThread;
	
	
	      if (article) return this.renderMagazineArticle(article);
	      if (comment) return this.renderComment(comment);
	      if (forumThread) return this.renderForumThread(forumThread);
	    }
	  }, {
	    key: 'renderMagazineArticle',
	    value: function renderMagazineArticle(magazineArticle) {
	      return _react2.default.createElement(_MagazineArticle2.default, {
	        key: magazineArticle.id,
	        magazineArticle: magazineArticle,
	        imageUrl: magazineArticle.thumbnail.main.lowRes,
	        inFeed: true,
	        shouldOpenProfileFromImage: true
	      });
	    }
	  }, {
	    key: 'renderComment',
	    value: function renderComment(comment) {
	      var id = comment.id,
	          resourceType = comment.resourceType,
	          origin = comment.origin,
	          parentComment = comment.parentComment;
	
	      var originUrl = '';
	      var commentUrl = '';
	      var commentsPage = (0, _api.offsetToPageParams)(origin.offset, (10)).page;
	
	      if ((0, _commentsResourceTypes.findCommentsOwnerType)(resourceType) === 'article') originUrl = '/magazine/articles/' + origin.id;
	      if ((0, _commentsResourceTypes.findCommentsOwnerType)(resourceType) === 'forumThread') originUrl = '/forum/threads/' + origin.id;
	
	      if ((0, _commentsResourceTypes.isRootComment)(resourceType)) commentUrl = originUrl + '/comments/' + commentsPage + '/' + id;
	      if (parentComment && (0, _commentsResourceTypes.isCommentReply)(resourceType)) {
	        var nestedCommentsPage = (0, _api.offsetToPageParams)(parentComment.offset, (3)).page;
	        commentUrl = originUrl + '/comments/' + commentsPage + '/' + parentComment.id + '/' + nestedCommentsPage + '/' + id;
	      }
	
	      return _react2.default.createElement(_SearchComment2.default, {
	        key: comment.id,
	        comment: comment,
	        originUrl: originUrl,
	        originTitle: origin.title,
	        commentUrl: commentUrl
	      });
	    }
	  }, {
	    key: 'renderForumThread',
	    value: function renderForumThread(forumThread) {
	      return _react2.default.createElement(_ForumThread2.default, { isInline: true, forumThread: forumThread, key: forumThread.id });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'content-wrapper has-background' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-collapsed is-padded-vertical' },
	          _react2.default.createElement(
	            'div',
	            { className: 'feed-layout' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrapper-small is-collapsed' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'title' },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'head' },
	                      "Search results for:"
	                    ),
	                    ' ',
	                    this.props.query.term
	                  )
	                ),
	                _react2.default.createElement(_SearchTabNavigation2.default, { term: this.props.query.term }),
	                function () {
	                  if (_this2.props.isFetching) {
	                    return _this2.renderEmptyArticles();
	                  } else if (_this2.props.searchResults.length > 0) {
	                    return _this2.props.searchResults.map(function (searchResult) {
	                      return _this2.renderSearchResult(searchResult);
	                    });
	                  } else if (_this2.props.totalCount === 0) {
	                    return _this2.renderNoSearchResults();
	                  }
	                }()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pagination-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrapper-xlarge' },
	              this.props.pagesCount > 1 && _react2.default.createElement(_SearchPageSelector2.default, { query: this.props.query, queryString: this.props.queryString })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	Search.propTypes = {
	  location: _PropTypes.locationShape,
	  query: _react.PropTypes.shape({
	    term: _react.PropTypes.string,
	    category: _react.PropTypes.string
	  }),
	  queryString: _react.PropTypes.string,
	  searchResults: _react.PropTypes.arrayOf(_entities.SearchItemShape),
	  isFetching: _react.PropTypes.bool,
	  pagesCount: _react.PropTypes.number,
	  totalCount: _react.PropTypes.number,
	  selectedTab: _react.PropTypes.string,
	  onSearchItemsFetch: _react.PropTypes.func,
	  onWillUnmount: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var term = props.location.query.term;
	
	  var _getSearchTabs = (0, _selectors.getSearchTabs)(state),
	      selectedTab = _getSearchTabs.selectedTab,
	      isFetching = _getSearchTabs.isFetching;
	
	  var query = { term: term, category: selectedTab };
	  var queryString = JSON.stringify(query);
	
	  var _getSearchPaging = (0, _selectors.getSearchPaging)(state, 'results', { queryString: queryString }),
	      page = _getSearchPaging.page,
	      pagesCount = _getSearchPaging.pagesCount,
	      totalCount = _getSearchPaging.totalCount;
	
	  var searchResults = (0, _selectors.getSearchResults)(state, { page: page, queryString: queryString });
	
	  return {
	    selectedTab: selectedTab,
	    searchResults: searchResults,
	    isFetching: isFetching,
	    query: query,
	    queryString: queryString,
	    pagesCount: pagesCount,
	    totalCount: totalCount
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onSearchItemsFetch: function onSearchItemsFetch(query) {
	      var magazineQuery = _extends({}, query, { category: 'magazine' });
	      var forumQuery = _extends({}, query, { category: 'forum' });
	
	      dispatch(actions.searchItemsFetch(1, magazineQuery, JSON.stringify(magazineQuery)));
	      dispatch(actions.searchItemsFetch(1, forumQuery, JSON.stringify(forumQuery)));
	    },
	    onWillUnmount: function onWillUnmount() {
	      dispatch(actions.searchHide());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search);

/***/ },

/***/ "./src/members/Main/UserGoals/UserGoalsAddGoal/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/UserGoals/UserGoalsAddGoal/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserGoals = function (_Component) {
	  _inherits(UserGoals, _Component);
	
	  function UserGoals() {
	    _classCallCheck(this, UserGoals);
	
	    var _this = _possibleConstructorReturn(this, (UserGoals.__proto__ || Object.getPrototypeOf(UserGoals)).call(this));
	
	    _this.handleGoalAddingUpdate = _this.handleGoalAddingUpdate.bind(_this);
	    _this.handleGoalAddingShow = _this.handleGoalAddingShow.bind(_this);
	    _this.handleGoalAddingHide = _this.handleGoalAddingHide.bind(_this);
	    _this.handleGoalCreate = _this.handleGoalCreate.bind(_this);
	    _this.handleInputKeyPress = _this.handleInputKeyPress.bind(_this);
	    _this.renderInput = _this.renderInput.bind(_this);
	    _this.renderAddingButton = _this.renderAddingButton.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserGoals, [{
	    key: 'handleGoalAddingShow',
	    value: function handleGoalAddingShow(e) {
	      e.preventDefault();
	      this.props.onGoalAddingShow();
	    }
	  }, {
	    key: 'handleGoalAddingHide',
	    value: function handleGoalAddingHide(e) {
	      e.preventDefault();
	      this.props.onGoalAddingHide();
	    }
	  }, {
	    key: 'handleGoalCreate',
	    value: function handleGoalCreate(e) {
	      e.preventDefault();
	
	      if (this.props.goalText) {
	        this.props.onGoalCreate(this.props.goalText);
	      }
	    }
	  }, {
	    key: 'handleGoalAddingUpdate',
	    value: function handleGoalAddingUpdate(e) {
	      this.props.onGoalAddingUpdate(e.target.value);
	    }
	  }, {
	    key: 'handleInputKeyPress',
	    value: function handleInputKeyPress(e) {
	      if (e.charCode === 13) {
	        this.handleGoalCreate(e);
	      }
	    }
	  }, {
	    key: 'renderAddingButton',
	    value: function renderAddingButton() {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          isSmall: true,
	          isYellow: true,
	          onClick: this.handleGoalAddingShow
	        },
	        "Add a new goal"
	      );
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'add-goal' },
	        _react2.default.createElement(
	          'label',
	          null,
	          "Enter your goal below"
	        ),
	        _react2.default.createElement('input', {
	          autoFocus: true,
	          type: 'text',
	          value: this.props.goalText,
	          onChange: this.handleGoalAddingUpdate,
	          onKeyPress: this.handleInputKeyPress
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-buttons' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              isYellow: true,
	              isDisabled: !this.props.goalText.length,
	              onClick: this.handleGoalCreate
	            },
	            "Save"
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'cancel-link' },
	            _react2.default.createElement(
	              'span',
	              { className: 'separator' },
	              "or"
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '_', onClick: this.handleGoalAddingHide },
	              "Cancel"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'UserGoalsAddGoal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'head' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper-small is-padded-top' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              "Goals"
	            ),
	            !this.props.isInputVisible && this.renderAddingButton()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-collapsed' },
	          this.props.isInputVisible && this.renderInput()
	        )
	      );
	    }
	  }]);
	
	  return UserGoals;
	}(_react.Component);
	
	UserGoals.propTypes = {
	  isInputVisible: _react.PropTypes.bool,
	  goalText: _react.PropTypes.string,
	  onGoalAddingShow: _react.PropTypes.func,
	  onGoalAddingHide: _react.PropTypes.func,
	  onGoalCreate: _react.PropTypes.func,
	  onGoalAddingUpdate: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return (0, _selectors.getGoalAdding)(state);
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onGoalAddingShow: function onGoalAddingShow() {
	      dispatch(actions.goalAddingShow());
	    },
	    onGoalAddingHide: function onGoalAddingHide() {
	      dispatch(actions.goalAddingHide());
	    },
	    onGoalCreate: function onGoalCreate(goal) {
	      dispatch(actions.goalCreate(goal, ("USER_GOALS"), "Thanks", "Your goal has to be quickly double-checked by us before it's added. But don't worry. We will let you know when it's approved :)"));
	    },
	    onGoalAddingUpdate: function onGoalAddingUpdate(value) {
	      dispatch(actions.goalAddingUpdate(value));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserGoals);

/***/ },

/***/ "./src/members/Main/UserGoals/UserGoalsLoading/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Goal = __webpack_require__("./src/members/Main/__shared__/containers/Goals/Goal/index.js");
	
	var _Goal2 = _interopRequireDefault(_Goal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserGoalsLoading = function UserGoalsLoading() {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Goals' },
	    _react2.default.createElement(
	      'table',
	      null,
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(_Goal2.default, { key: 'loader1', isEmpty: true }),
	        _react2.default.createElement(_Goal2.default, { key: 'loader2', isEmpty: true }),
	        _react2.default.createElement(_Goal2.default, { key: 'loader3', isEmpty: true })
	      )
	    )
	  );
	};
	
	exports.default = UserGoalsLoading;

/***/ },

/***/ "./src/members/Main/UserGoals/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _Goals = __webpack_require__("./src/members/Main/__shared__/containers/Goals/index.js");
	
	var _Goals2 = _interopRequireDefault(_Goals);
	
	var _InfoBar = __webpack_require__("./src/members/Main/__shared__/components/InfoBar/index.js");
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	var _NoEntries = __webpack_require__("./src/members/Main/__shared__/components/NoEntries/index.js");
	
	var _NoEntries2 = _interopRequireDefault(_NoEntries);
	
	var _NoEntriesDetail = __webpack_require__("./src/members/Main/__shared__/components/NoEntries/NoEntriesDetail/index.js");
	
	var _NoEntriesDetail2 = _interopRequireDefault(_NoEntriesDetail);
	
	var _UserGoalsLoading = __webpack_require__("./src/members/Main/UserGoals/UserGoalsLoading/index.js");
	
	var _UserGoalsLoading2 = _interopRequireDefault(_UserGoalsLoading);
	
	var _UserGoalsAddGoal = __webpack_require__("./src/members/Main/UserGoals/UserGoalsAddGoal/index.js");
	
	var _UserGoalsAddGoal2 = _interopRequireDefault(_UserGoalsAddGoal);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/UserGoals/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserGoals = function (_Component) {
	  _inherits(UserGoals, _Component);
	
	  function UserGoals() {
	    _classCallCheck(this, UserGoals);
	
	    return _possibleConstructorReturn(this, (UserGoals.__proto__ || Object.getPrototypeOf(UserGoals)).apply(this, arguments));
	  }
	
	  _createClass(UserGoals, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onDidMount();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'UserGoals content-wrapper has-background' },
	        this.props.isSuccessInfoBarVisible && _react2.default.createElement(_InfoBar2.default, { isStatic: true, type: 'primary', title: this.props.successInfoBarTitle, message: this.props.successInfoBarMessage }),
	        _react2.default.createElement(_UserGoalsAddGoal2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper-small is-collapsed' },
	            function () {
	              if (_this2.props.goals.length > 0) {
	                return _react2.default.createElement(_Goals2.default, { goals: _this2.props.goals, source: ("USER_GOALS") });
	              } else if (_this2.props.isFetching) {
	                return _react2.default.createElement(_UserGoalsLoading2.default, null);
	              } else {
	                return _react2.default.createElement(
	                  _NoEntries2.default,
	                  { title: "You have no goals yet." },
	                  _react2.default.createElement(
	                    _NoEntriesDetail2.default,
	                    null,
	                    "This area will hold your goals. A goal is used to track your progress and may be assigned to you by a counsellor."
	                  ),
	                  _react2.default.createElement(
	                    _NoEntriesDetail2.default,
	                    null,
	                    "You can also create your own goals. Go on and try it - create your first goal by clicking on the button above."
	                  )
	                );
	              }
	            }()
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserGoals;
	}(_react.Component);
	
	UserGoals.propTypes = {
	  goals: _react.PropTypes.arrayOf(_entities.GoalShape),
	  isFetching: _react.PropTypes.bool,
	  onDidMount: _react.PropTypes.func,
	  isSuccessInfoBarVisible: _react.PropTypes.bool,
	  successInfoBarMessage: _react.PropTypes.string,
	  successInfoBarTitle: _react.PropTypes.string
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var successState = (0, _selectors.getInfoState)(state, 'success');
	  var isSuccessInfoBarVisible = successState.visible;
	  var successInfoBarMessage = successState.message;
	  var successInfoBarTitle = successState.title;
	
	  return {
	    isSuccessInfoBarVisible: isSuccessInfoBarVisible,
	    successInfoBarMessage: successInfoBarMessage,
	    successInfoBarTitle: successInfoBarTitle,
	    goals: (0, _selectors.getGoals)(state),
	    isFetching: (0, _selectors.getGoalsFetching)(state).isFetching
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onDidMount: function onDidMount() {
	      dispatch(actions.goalsFetch({
	        offset: 0,
	        limit: (200)
	      }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserGoals);

/***/ },

/***/ "./src/members/Main/UserSettings/UserSettingsAvatarHeader/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/UserSettings/UserSettingsAvatarHeader/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSettingsAvatarHeader = function (_Component) {
	  _inherits(UserSettingsAvatarHeader, _Component);
	
	  function UserSettingsAvatarHeader() {
	    _classCallCheck(this, UserSettingsAvatarHeader);
	
	    return _possibleConstructorReturn(this, (UserSettingsAvatarHeader.__proto__ || Object.getPrototypeOf(UserSettingsAvatarHeader)).apply(this, arguments));
	  }
	
	  _createClass(UserSettingsAvatarHeader, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'UserSettingsAvatarHeader' },
	        _react2.default.createElement(
	          'div',
	          { className: 'avatar' },
	          _react2.default.createElement(_UserAvatar2.default, { size: 'large', letter: this.props.userName[0], imageUrl: this.props.avatar.url })
	        ),
	        (true) === true && _react2.default.createElement(
	          _Link2.default,
	          { to: '/settings/avatar' },
	          "Change Avatar"
	        )
	      );
	    }
	  }]);
	
	  return UserSettingsAvatarHeader;
	}(_react.Component);
	
	UserSettingsAvatarHeader.propTypes = {
	  avatar: _entities.AvatarShape,
	  userName: _react.PropTypes.string
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return (0, _selectors.getUserProfile)(state);
	};
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserSettingsAvatarHeader);

/***/ },

/***/ "./src/members/Main/UserSettings/UserSettingsChangeAvatar/UserSettingsAvatar/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSettingsAvatar = function (_Component) {
	  _inherits(UserSettingsAvatar, _Component);
	
	  function UserSettingsAvatar() {
	    _classCallCheck(this, UserSettingsAvatar);
	
	    var _this = _possibleConstructorReturn(this, (UserSettingsAvatar.__proto__ || Object.getPrototypeOf(UserSettingsAvatar)).call(this));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserSettingsAvatar, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      this.props.onClick(this.props.avatar.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)("option", {
	        'is-selected': this.props.isSelected
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, onClick: this.handleClick },
	        _react2.default.createElement(_UserAvatar2.default, { size: 'large', imageUrl: this.props.avatar.url })
	      );
	    }
	  }]);
	
	  return UserSettingsAvatar;
	}(_react.Component);
	
	UserSettingsAvatar.propTypes = {
	  avatar: _entities.AvatarShape,
	  isSelected: _react.PropTypes.bool,
	  onClick: _react.PropTypes.func
	};
	
	exports.default = UserSettingsAvatar;

/***/ },

/***/ "./src/members/Main/UserSettings/UserSettingsChangeAvatar/UserSettingsAvatarsListLoading/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserSettingsAvatarsListLoading = function UserSettingsAvatarsListLoading() {
	  var loadingAvatarsIndexes = Array.from(Array((24)).keys());
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    loadingAvatarsIndexes.map(function (index) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'option', key: index },
	        _react2.default.createElement(_UserAvatar2.default, { size: 'large', isEmpty: true })
	      );
	    })
	  );
	};
	
	exports.default = UserSettingsAvatarsListLoading;

/***/ },

/***/ "./src/members/Main/UserSettings/UserSettingsChangeAvatar/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _UserSettingsAvatar = __webpack_require__("./src/members/Main/UserSettings/UserSettingsChangeAvatar/UserSettingsAvatar/index.js");
	
	var _UserSettingsAvatar2 = _interopRequireDefault(_UserSettingsAvatar);
	
	var _UserSettingsAvatarsListLoading = __webpack_require__("./src/members/Main/UserSettings/UserSettingsChangeAvatar/UserSettingsAvatarsListLoading/index.js");
	
	var _UserSettingsAvatarsListLoading2 = _interopRequireDefault(_UserSettingsAvatarsListLoading);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/UserSettings/UserSettingsChangeAvatar/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSettingsChangeAvatar = function (_Component) {
	  _inherits(UserSettingsChangeAvatar, _Component);
	
	  function UserSettingsChangeAvatar() {
	    _classCallCheck(this, UserSettingsChangeAvatar);
	
	    var _this = _possibleConstructorReturn(this, (UserSettingsChangeAvatar.__proto__ || Object.getPrototypeOf(UserSettingsChangeAvatar)).call(this));
	
	    _this.handleAvatarClick = _this.handleAvatarClick.bind(_this);
	    _this.handleChangeAvatar = _this.handleChangeAvatar.bind(_this);
	    _this.handleFetchMoreAvatars = _this.handleFetchMoreAvatars.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserSettingsChangeAvatar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onFetchAvatars();
	      this.props.onChangeSelectedAvatar(this.props.currentUserAvatarId);
	    }
	  }, {
	    key: 'handleAvatarClick',
	    value: function handleAvatarClick(avatarId) {
	      this.props.onChangeSelectedAvatar(avatarId);
	    }
	  }, {
	    key: 'handleChangeAvatar',
	    value: function handleChangeAvatar(e) {
	      e.preventDefault();
	
	      var avatarId = this.props.selectedAvatarId;
	      var url = this.props.userAvatars.find(function (avatar) {
	        return avatar.id === avatarId;
	      }).url;
	
	      this.props.onChangeAvatar(avatarId, url);
	    }
	  }, {
	    key: 'handleFetchMoreAvatars',
	    value: function handleFetchMoreAvatars(e) {
	      e.preventDefault();
	      this.props.onFetchAvatars();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'content-wrapper has-background-medium' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-padded-top' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            "Select an Avatar"
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'UserSettingsChangeAvatar' },
	            function () {
	              if (_this2.props.userAvatars.length > 0) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'avatar-list' },
	                  _this2.props.userAvatars.map(function (avatar) {
	                    return _react2.default.createElement(_UserSettingsAvatar2.default, {
	                      key: avatar.id,
	                      isSelected: avatar.id === _this2.props.selectedAvatarId,
	                      onClick: _this2.handleAvatarClick,
	                      avatar: avatar
	                    });
	                  })
	                );
	              } else if (_this2.props.isFetching) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'avatar-list' },
	                  _react2.default.createElement(_UserSettingsAvatarsListLoading2.default, null),
	                  ';'
	                );
	              }
	            }(),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-buttons' },
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  isYellow: true,
	                  iconType: 'preloader-dark',
	                  hasIcon: this.props.isSubmitting,
	                  isDisabled: this.props.isFetching || this.props.isSubmitting,
	                  onClick: this.handleChangeAvatar
	                },
	                "Select"
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  isYellow: true,
	                  iconType: 'preloader-dark',
	                  hasIcon: this.props.isFetching,
	                  isDisabled: this.props.isFetching,
	                  onClick: this.handleFetchMoreAvatars
	                },
	                "Load more"
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'cancel-link' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'separator' },
	                  "or"
	                ),
	                _react2.default.createElement(
	                  _Link2.default,
	                  { to: '/settings' },
	                  "Cancel"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserSettingsChangeAvatar;
	}(_react.Component);
	
	UserSettingsChangeAvatar.propTypes = {
	  userAvatars: _react.PropTypes.arrayOf(_entities.AvatarShape),
	  isFetching: _react.PropTypes.bool,
	  isSubmitting: _react.PropTypes.bool,
	  selectedAvatarId: _react.PropTypes.number,
	  currentUserAvatarId: _react.PropTypes.number,
	  onFetchAvatars: _react.PropTypes.func,
	  onChangeSelectedAvatar: _react.PropTypes.func,
	  onChangeAvatar: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _getUserAvatarSelecti = (0, _selectors.getUserAvatarSelection)(state),
	      isFetching = _getUserAvatarSelecti.isFetching,
	      isSubmitting = _getUserAvatarSelecti.isSubmitting,
	      selectedAvatarId = _getUserAvatarSelecti.selectedAvatarId;
	
	  var currentUserAvatarId = (0, _selectors.getUserProfile)(state).avatar.id;
	
	  return {
	    userAvatars: (0, _selectors.getUserAvatars)(state),
	    currentUserAvatarId: currentUserAvatarId,
	    isFetching: isFetching,
	    isSubmitting: isSubmitting,
	    selectedAvatarId: selectedAvatarId
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onFetchAvatars: function onFetchAvatars() {
	      dispatch(actions.userAvatarsFetch());
	    },
	    onChangeSelectedAvatar: function onChangeSelectedAvatar(avatarId) {
	      dispatch(actions.userAvatarsChangeActive(avatarId));
	    },
	    onChangeAvatar: function onChangeAvatar(avatarId, avatarUrl) {
	      dispatch(actions.userUpdate({ avatar: avatarId }, true, avatarUrl));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserSettingsChangeAvatar);

/***/ },

/***/ "./src/members/Main/UserSettings/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reduxForm = __webpack_require__("./node_modules/redux-form/lib/index.js");
	
	var _UserSettingsAvatarHeader = __webpack_require__("./src/members/Main/UserSettings/UserSettingsAvatarHeader/index.js");
	
	var _UserSettingsAvatarHeader2 = _interopRequireDefault(_UserSettingsAvatarHeader);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _InfoBar = __webpack_require__("./src/members/Main/__shared__/components/InfoBar/index.js");
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/UserSettings/style.scss");
	
	var _validate = __webpack_require__("./src/members/Main/UserSettings/validate.js");
	
	var _validate2 = _interopRequireDefault(_validate);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSettings = function (_Component) {
	  _inherits(UserSettings, _Component);
	
	  function UserSettings() {
	    _classCallCheck(this, UserSettings);
	
	    var _this = _possibleConstructorReturn(this, (UserSettings.__proto__ || Object.getPrototypeOf(UserSettings)).call(this));
	
	    _this.handleInfoBarClose = _this.handleInfoBarClose.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserSettings, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onWillUnmount();
	    }
	  }, {
	    key: 'renderField',
	    value: function renderField(_ref) {
	      var input = _ref.input,
	          label = _ref.label,
	          type = _ref.type,
	          _ref$meta = _ref.meta,
	          touched = _ref$meta.touched,
	          error = _ref$meta.error;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-field-wrapper' },
	        _react2.default.createElement('input', _extends({}, input, { className: touched && error ? 'is-invalid-input' : '', placeholder: label, type: type })),
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'form-error is-visible' },
	          error
	        )
	      );
	    }
	  }, {
	    key: 'handleInfoBarClose',
	    value: function handleInfoBarClose() {
	      if (this.props.onInfoBarClose) {
	        this.props.onInfoBarClose();
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      if (this.props.invalid || this.props.isPasswordUpdating) return;
	      this.props.handleSubmit();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'section',
	        { className: 'UserSettings content-wrapper has-background-medium' },
	        this.props.isSuccessInfoBarVisible && _react2.default.createElement(_InfoBar2.default, { isStatic: true, onClose: this.handleInfoBarClose, type: 'primary', message: this.props.successInfoBarMessage }),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper-small is-padded-top' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            "User Settings"
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'user-form' },
	            _react2.default.createElement(_UserSettingsAvatarHeader2.default, null),
	            _react2.default.createElement(
	              'div',
	              { className: 'user-change-password' },
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.handleSubmit },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  "Change password"
	                ),
	                _react2.default.createElement(_reduxForm.Field, { name: 'oldPassword', label: "Old Password", component: this.renderField, type: 'password' }),
	                _react2.default.createElement(_reduxForm.Field, { name: 'newPassword', label: "New Password", component: this.renderField, type: 'password' }),
	                _react2.default.createElement(_reduxForm.Field, { name: 'newPasswordRepeat', label: "Confirm New Password", component: this.renderField, type: 'password' }),
	                !!this.props.serverPasswordError && _react2.default.createElement(
	                  'div',
	                  { className: 'form-wrapper-error-be alert callout' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    this.props.serverPasswordError
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-field-wrapper' },
	                  _react2.default.createElement(
	                    _Button2.default,
	                    {
	                      isYellow: true,
	                      iconType: 'preloader-dark',
	                      hasIcon: this.props.isPasswordUpdating,
	                      isDisabled: this.props.invalid || this.props.isPasswordUpdating,
	                      onClick: this.handleSubmit
	                    },
	                    "Update Password"
	                  ),
	                  _react2.default.createElement('input', { type: 'submit', hidden: true, disabled: this.props.invalid || this.props.isPasswordUpdating })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserSettings;
	}(_react.Component);
	
	UserSettings.propTypes = {
	  isSuccessInfoBarVisible: _react.PropTypes.bool,
	  invalid: _react.PropTypes.bool,
	  successInfoBarMessage: _react.PropTypes.string,
	  onInfoBarClose: _react.PropTypes.func,
	  serverPasswordError: _react.PropTypes.string,
	  isPasswordUpdating: _react.PropTypes.bool,
	  handleSubmit: _react.PropTypes.func,
	  onWillUnmount: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var successState = (0, _selectors.getInfoState)(state, 'success');
	  var isSuccessInfoBarVisible = successState.visible;
	  var successInfoBarMessage = successState.message;
	
	  return _extends({
	    isSuccessInfoBarVisible: isSuccessInfoBarVisible,
	    successInfoBarMessage: successInfoBarMessage
	  }, (0, _selectors.getUserPasswordUpdate)(state));
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onWillUnmount: function onWillUnmount() {
	      dispatch(actions.userUpdateReset());
	    },
	    onInfoBarClose: function onInfoBarClose() {
	      dispatch(actions.infoClose('success'));
	    },
	    onSubmit: function onSubmit(passwordData) {
	      var existingPassword = passwordData.oldPassword,
	          passWord = passwordData.newPassword;
	
	      dispatch(actions.userUpdate({ existingPassword: existingPassword, passWord: passWord }, false, null, "Password updated successfully."));
	    }
	  };
	};
	
	UserSettings = (0, _reduxForm.reduxForm)({ //eslint-disable-line no-class-assign
	  form: 'userSettings',
	  validate: _validate2.default
	})(UserSettings);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserSettings);

/***/ },

/***/ "./src/members/Main/UserSettings/validate.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PASSWORD_REGEX = new RegExp(("(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])^([a-zA-Z0-9]{8,})$"));
	
	exports.default = function (values) {
	  var errors = {};
	
	  if (!PASSWORD_REGEX.test(values.oldPassword)) {
	    errors.oldPassword = "The password should have at least 8 characters, one upper case, one lower case and one number.";
	  }
	
	  if (!PASSWORD_REGEX.test(values.newPassword)) {
	    errors.newPassword = "The password should have at least 8 characters, one upper case, one lower case and one number.";
	  }
	
	  if (values.newPasswordRepeat !== values.newPassword) {
	    errors.newPasswordRepeat = "The confirm password should match the password.";
	  }
	
	  return errors;
	};

/***/ },

/***/ "./src/members/Main/__shared__/components/Accordion/AccordionCheckbox/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/Accordion/AccordionCheckbox/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccordionCheckbox = function AccordionCheckbox(props) {
	  function handleCheckboxChange() {
	
	    if (props.onClick) {
	      props.onClick({
	        id: props.id,
	        isChecked: props.isChecked
	      });
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'AccordionCheckbox' },
	    _react2.default.createElement(
	      'div',
	      { className: 'checkbox-wrap' },
	      _react2.default.createElement('input', {
	        id: 'accordion-checkbox-' + props.id,
	        name: 'accordion-checkbox-' + props.id,
	        type: 'checkbox',
	        checked: props.isChecked,
	        onChange: handleCheckboxChange
	      }),
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'accordion-checkbox-' + props.id },
	        props.title
	      )
	    )
	  );
	};
	
	AccordionCheckbox.propTypes = {
	  id: _react.PropTypes.number,
	  title: _react.PropTypes.string,
	  isChecked: _react.PropTypes.bool,
	  onClick: _react.PropTypes.func
	};
	
	exports.default = AccordionCheckbox;

/***/ },

/***/ "./src/members/Main/__shared__/components/Accordion/AccordionItem/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/components/Accordion/AccordionItem/style.scss");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccordionItem = function (_Component) {
	  _inherits(AccordionItem, _Component);
	
	  function AccordionItem() {
	    _classCallCheck(this, AccordionItem);
	
	    var _this = _possibleConstructorReturn(this, (AccordionItem.__proto__ || Object.getPrototypeOf(AccordionItem)).call(this));
	
	    _this.handleLinkClick = _this.handleLinkClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(AccordionItem, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.onItemOpen && this.props.isExpanded && !prevProps.isExpanded) {
	        this.props.onItemOpen(this.refs.accordionItem.offsetTop);
	      }
	    }
	  }, {
	    key: 'handleLinkClick',
	    value: function handleLinkClick(event) {
	      if (this.props.url) {
	        return;
	      }
	
	      event.preventDefault();
	
	      if (this.props.onClick) {
	        this.props.onClick();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var className = (0, _classnames2.default)('AccordionItem', {
	        'is-group': this.props.isGroup,
	        'is-expanded': this.props.isExpanded,
	        'is-empty': this.props.isEmpty,
	        'is-for-forum': this.props.isForForum,
	        'is-for-magazine': this.props.isForMagazine
	      });
	
	      var _props$url = this.props.url,
	          url = _props$url === undefined ? '_' : _props$url;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, ref: 'accordionItem' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            this.props.title
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'article-count' },
	            this.props.countInfo
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'icon' },
	            _react2.default.createElement('img', { src: this.props.imageUrl })
	          ),
	          _react2.default.createElement('span', { className: 'arrow' }),
	          _react2.default.createElement(
	            _Link2.default,
	            { to: url, onClick: this.handleLinkClick },
	            '\xA0'
	          )
	        ),
	        function () {
	          if (_react2.default.Children.count(_this2.props.children) > 0) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'topics-list' },
	              _this2.props.children
	            );
	          }
	        }()
	      );
	    }
	  }]);
	
	  return AccordionItem;
	}(_react.Component);
	
	AccordionItem.propTypes = {
	  title: _react.PropTypes.string,
	  countInfo: _react.PropTypes.string,
	  url: _react.PropTypes.string,
	  imageUrl: _react.PropTypes.string,
	  children: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  isGroup: _react.PropTypes.bool,
	  isExpanded: _react.PropTypes.bool,
	  isEmpty: _react.PropTypes.bool,
	  isForForum: _react.PropTypes.bool,
	  isForMagazine: _react.PropTypes.bool,
	  onItemOpen: _react.PropTypes.func,
	  onClick: _react.PropTypes.func
	};
	
	exports.default = AccordionItem;

/***/ },

/***/ "./src/members/Main/__shared__/components/Accordion/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/Accordion/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Accordion = function Accordion(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Accordion' },
	    props.children
	  );
	};
	
	Accordion.propTypes = {
	  children: _react.PropTypes.arrayOf(_react.PropTypes.element)
	};
	
	exports.default = Accordion;

/***/ },

/***/ "./src/members/Main/__shared__/components/ArticleOuter/Article/ArticleImage/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/ArticleOuter/Article/ArticleImage/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleImage = function ArticleImage(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ArticleImage' },
	    _react2.default.createElement('img', { src: props.url }),
	    ';'
	  );
	};
	
	ArticleImage.propTypes = {
	  url: _react.PropTypes.string
	};
	
	exports.default = ArticleImage;

/***/ },

/***/ "./src/members/Main/__shared__/components/ArticleOuter/Article/ArticlePreview/ArticleMeta/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	__webpack_require__("./src/members/Main/__shared__/components/ArticleOuter/Article/ArticlePreview/ArticleMeta/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleMeta = function (_Component) {
	  _inherits(ArticleMeta, _Component);
	
	  function ArticleMeta() {
	    _classCallCheck(this, ArticleMeta);
	
	    return _possibleConstructorReturn(this, (ArticleMeta.__proto__ || Object.getPrototypeOf(ArticleMeta)).apply(this, arguments));
	  }
	
	  _createClass(ArticleMeta, [{
	    key: 'renderCategories',
	    value: function renderCategories(categories) {
	      return categories.map(function (category, index) {
	        return _react2.default.createElement(
	          'span',
	          { key: category.name },
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { to: category.url },
	              category.name
	            )
	          ),
	          index < categories.length - 1 ? ', ' : ''
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'article-meta' },
	        _react2.default.createElement(
	          'div',
	          { className: 'avatar' },
	          _react2.default.createElement(_UserAvatar2.default, { imageUrl: this.props.authorAvatarUrl, letter: this.props.authorName[0] })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'meta' },
	          _react2.default.createElement(
	            'span',
	            { className: 'author' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              this.props.authorName
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ' ',
	              "in",
	              ' ',
	              this.renderCategories(this.props.categories),
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'time' },
	            this.props.createdAt
	          ),
	          this.props.showsComments && _react2.default.createElement(
	            'span',
	            { className: 'comment-count' },
	            _react2.default.createElement(
	              _Link2.default,
	              { to: this.props.articleUrl + '#comments' },
	              this.props.commentsInfo
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ArticleMeta;
	}(_react.Component);
	
	ArticleMeta.propTypes = {
	  authorAvatarUrl: _react.PropTypes.string,
	  authorName: _react.PropTypes.string,
	  categories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    name: _react.PropTypes.string,
	    url: _react.PropTypes.string
	  })),
	  commentsInfo: _react.PropTypes.string,
	  createdAt: _react.PropTypes.string,
	  showsComments: _react.PropTypes.bool,
	  articleUrl: _react.PropTypes.string
	};
	
	exports.default = ArticleMeta;

/***/ },

/***/ "./src/members/Main/__shared__/components/ArticleOuter/Article/ArticlePreview/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ArticleMeta = __webpack_require__("./src/members/Main/__shared__/components/ArticleOuter/Article/ArticlePreview/ArticleMeta/index.js");
	
	var _ArticleMeta2 = _interopRequireDefault(_ArticleMeta);
	
	__webpack_require__("./src/members/Main/__shared__/components/ArticleOuter/Article/ArticlePreview/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArticlePreview = function ArticlePreview(props) {
	  var title = props.title,
	      otherProps = _objectWithoutProperties(props, ['title']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ArticlePreview' },
	    _react2.default.createElement(
	      'h4',
	      null,
	      title
	    ),
	    _react2.default.createElement(_ArticleMeta2.default, otherProps),
	    props.children
	  );
	};
	
	ArticlePreview.propTypes = {
	  children: _react.PropTypes.element,
	  title: _react.PropTypes.string,
	  articleUrl: _react.PropTypes.string
	};
	
	exports.default = ArticlePreview;

/***/ },

/***/ "./src/members/Main/__shared__/components/ArticleOuter/Article/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ArticlePreview = __webpack_require__("./src/members/Main/__shared__/components/ArticleOuter/Article/ArticlePreview/index.js");
	
	var _ArticlePreview2 = _interopRequireDefault(_ArticlePreview);
	
	var _ArticleImage = __webpack_require__("./src/members/Main/__shared__/components/ArticleOuter/Article/ArticleImage/index.js");
	
	var _ArticleImage2 = _interopRequireDefault(_ArticleImage);
	
	__webpack_require__("./src/members/Main/__shared__/components/ArticleOuter/Article/style.scss");
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Article = function Article(props) {
	  var className = (0, _classnames2.default)('Article', { 'is-featured': props.isFeatured, 'in-feed': props.inFeed });
	
	  var imageUrl = props.imageUrl,
	      largeImageUrl = props.largeImageUrl,
	      excerpt = props.excerpt,
	      _props$showsReadMoreA = props.showsReadMoreAndComments,
	      showsReadMoreAndComments = _props$showsReadMoreA === undefined ? true : _props$showsReadMoreA,
	      isTitleOnTop = props.isTitleOnTop,
	      otherProps = _objectWithoutProperties(props, ['imageUrl', 'largeImageUrl', 'excerpt', 'showsReadMoreAndComments', 'isTitleOnTop']);
	
	  var image = _react2.default.createElement(_ArticleImage2.default, { minWidthForLargeImage: 768, url: imageUrl, largeUrl: largeImageUrl });
	  var imageOrLink = props.shouldOpenProfileFromImage ? _react2.default.createElement(
	    _Link2.default,
	    { to: props.articleUrl },
	    image
	  ) : image;
	
	  var preview = _react2.default.createElement(
	    _ArticlePreview2.default,
	    _extends({}, otherProps, { showsComments: showsReadMoreAndComments }),
	    function () {
	      if (!isTitleOnTop) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            { className: 'excerpt' },
	            excerpt
	          ),
	          showsReadMoreAndComments && _react2.default.createElement(
	            _Button2.default,
	            { isSmall: true, isYellow: true, to: props.articleUrl },
	            "Read more"
	          )
	        );
	      }
	    }()
	  );
	
	  if (isTitleOnTop) {
	    return _react2.default.createElement(
	      'div',
	      { className: className },
	      preview,
	      imageOrLink
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    imageOrLink,
	    preview
	  );
	};
	
	Article.propTypes = {
	  isFeatured: _react.PropTypes.bool,
	  inFeed: _react.PropTypes.bool,
	  excerpt: _react.PropTypes.string,
	  imageUrl: _react.PropTypes.string,
	  largeImageUrl: _react.PropTypes.string,
	  articleUrl: _react.PropTypes.string,
	  isTitleOnTop: _react.PropTypes.bool,
	  showsReadMoreAndComments: _react.PropTypes.bool,
	  shouldOpenProfileFromImage: _react.PropTypes.bool
	};
	
	exports.default = Article;

/***/ },

/***/ "./src/members/Main/__shared__/components/ArticleOuter/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/ArticleOuter/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleOuter = function ArticleOuter(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'ArticleOuter' },
	    props.children
	  );
	};
	
	ArticleOuter.propTypes = {
	  children: _react.PropTypes.element
	};
	
	exports.default = ArticleOuter;

/***/ },

/***/ "./src/members/Main/__shared__/components/Button/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__("./src/__shared__/styles/Button.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Button = function Button(props) {
	  var isDisabled = props.isDisabled,
	      isXSmall = props.isXSmall,
	      isSmall = props.isSmall,
	      isBlue = props.isBlue,
	      isGreen = props.isGreen,
	      isYellow = props.isYellow,
	      hasIcon = props.hasIcon,
	      iconType = props.iconType,
	      hasIconAnimated = props.hasIconAnimated,
	      _props$to = props.to,
	      to = _props$to === undefined ? "_" : _props$to,
	      otherProps = _objectWithoutProperties(props, ['isDisabled', 'isXSmall', 'isSmall', 'isBlue', 'isGreen', 'isYellow', 'hasIcon', 'iconType', 'hasIconAnimated', 'to']);
	
	  var className = (0, _classnames3.default)('Button', _defineProperty({
	    'is-disabled': isDisabled,
	    'is-x-small': isXSmall,
	    'is-small': isSmall,
	    'is-blue': isBlue,
	    'is-green': isGreen,
	    'is-yellow': isYellow,
	    'has-icon': hasIcon
	  }, 'is-animated', !!hasIconAnimated));
	  var icon = null;
	
	  if (hasIcon) {
	    var iconClassName = (0, _classnames3.default)('icon', 'icon-' + iconType);
	    icon = _react2.default.createElement('span', { className: iconClassName });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    icon,
	    _react2.default.createElement(_Link2.default, _extends({}, otherProps, { to: to }))
	  );
	};
	
	Button.propTypes = {
	  isDisabled: _react.PropTypes.bool,
	  isXSmall: _react.PropTypes.bool,
	  isSmall: _react.PropTypes.bool,
	  isBlue: _react.PropTypes.bool,
	  isGreen: _react.PropTypes.bool,
	  isYellow: _react.PropTypes.bool,
	  hasIcon: _react.PropTypes.bool,
	  iconType: _react.PropTypes.string,
	  hasIconAnimated: _react.PropTypes.bool,
	  to: _react.PropTypes.string
	};
	
	exports.default = Button;

/***/ },

/***/ "./src/members/Main/__shared__/components/CommentsList/Comment/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/components/CommentsList/Comment/style.scss");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Comment = function (_Component) {
	  _inherits(Comment, _Component);
	
	  function Comment() {
	    _classCallCheck(this, Comment);
	
	    var _this = _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).call(this));
	
	    _this.handleMarkAsUsefulClick = _this.handleMarkAsUsefulClick.bind(_this);
	    _this.handleUnmarkAsUsefulClick = _this.handleUnmarkAsUsefulClick.bind(_this);
	    _this.handleReplyClick = _this.handleReplyClick.bind(_this);
	    _this.handleRepliesClick = _this.handleRepliesClick.bind(_this);
	    _this.handleHideRepliesClick = _this.handleHideRepliesClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Comment, [{
	    key: 'handleMarkAsUsefulClick',
	    value: function handleMarkAsUsefulClick(event) {
	      event.preventDefault();
	      this.props.onMarkAsUseful && this.props.onMarkAsUseful(this.props.commentId);
	    }
	  }, {
	    key: 'handleUnmarkAsUsefulClick',
	    value: function handleUnmarkAsUsefulClick(event) {
	      event.preventDefault();
	      this.props.onUnmarkAsUseful && this.props.onUnmarkAsUseful(this.props.commentId);
	    }
	  }, {
	    key: 'handleReplyClick',
	    value: function handleReplyClick(event) {
	      event.preventDefault();
	      this.props.onReply && this.props.onReply(this.props.commentId);
	    }
	  }, {
	    key: 'handleRepliesClick',
	    value: function handleRepliesClick(event) {
	      event.preventDefault();
	      this.props.onViewReplies && this.props.onViewReplies(this.props.commentId);
	    }
	  }, {
	    key: 'handleHideRepliesClick',
	    value: function handleHideRepliesClick(event) {
	      event.preventDefault();
	      this.props.onHideReplies && this.props.onHideReplies(this.props.commentId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var childrenCount = _react2.default.Children.count(this.props.children);
	
	      var className = (0, _classnames2.default)('Comment', {
	        'is-expanded': childrenCount > 0,
	        'is-empty': this.props.isEmpty,
	        'is-highlighted': this.props.isHighlighted,
	        'is-root': this.props.isRoot
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'head' },
	          _react2.default.createElement(
	            'div',
	            { className: 'author' },
	            _react2.default.createElement(
	              'div',
	              { className: 'avatar' },
	              _react2.default.createElement(_UserAvatar2.default, { imageUrl: this.props.authorAvatar })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'name' },
	              this.props.authorName
	            )
	          ),
	          this.props.isPinned && _react2.default.createElement(
	            'div',
	            { className: 'pinned-label float-right' },
	            "Pinned"
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'time float-right' },
	            this.props.since
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text' },
	          _react2.default.createElement(
	            'p',
	            null,
	            this.props.text
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'buttons' },
	          function () {
	            if (_this2.props.canBeMarkedAsUseful) {
	              if (_this2.props.isMarkedAsUseful) {
	                return _react2.default.createElement(
	                  _Link2.default,
	                  { onClick: _this2.handleUnmarkAsUsefulClick },
	                  "Unmark as useful"
	                );
	              }
	
	              return _react2.default.createElement(
	                _Link2.default,
	                { onClick: _this2.handleMarkAsUsefulClick },
	                "Mark as useful"
	              );
	            }
	          }(),
	          this.props.canBeRepliedTo && _react2.default.createElement(
	            _Link2.default,
	            { onClick: this.handleReplyClick },
	            "Reply"
	          ),
	          function () {
	            if (childrenCount > 0) {
	              return _react2.default.createElement(
	                'span',
	                { onClick: _this2.handleHideRepliesClick, className: 'replies-count float-right clickable' },
	                "Hide replies"
	              );
	            } else if (_this2.props.canBeRepliedTo) {
	              var _className = (0, _classnames2.default)('replies-count', 'float-right', { 'clickable': _this2.props.canViewReplies });
	              return _react2.default.createElement(
	                'span',
	                { onClick: _this2.handleRepliesClick, className: _className },
	                _this2.props.repliesInfo
	              );
	            }
	          }()
	        ),
	        function () {
	          if (childrenCount > 0) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'replies' },
	              _this2.props.children
	            );
	          }
	        }()
	      );
	    }
	  }]);
	
	  return Comment;
	}(_react.Component);
	
	Comment.propTypes = {
	  commentId: _react.PropTypes.number,
	  children: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  text: _react.PropTypes.array,
	  isPinned: _react.PropTypes.bool,
	  authorName: _react.PropTypes.string,
	  authorAvatar: _react.PropTypes.string,
	  since: _react.PropTypes.string,
	  isMarkedAsUseful: _react.PropTypes.bool,
	  isRoot: _react.PropTypes.bool,
	  canBeRepliedTo: _react.PropTypes.bool,
	  canViewReplies: _react.PropTypes.bool,
	  repliesInfo: _react.PropTypes.string,
	  isEmpty: _react.PropTypes.bool,
	  canBeMarkedAsUseful: _react.PropTypes.bool,
	  isHighlighted: _react.PropTypes.bool,
	  onMarkAsUseful: _react.PropTypes.func,
	  onUnmarkAsUseful: _react.PropTypes.func,
	  onReply: _react.PropTypes.func,
	  onCancelReply: _react.PropTypes.func,
	  onViewReplies: _react.PropTypes.func,
	  textEditorRenderer: _react.PropTypes.func,
	  onHideReplies: _react.PropTypes.func
	};
	
	exports.default = Comment;

/***/ },

/***/ "./src/members/Main/__shared__/components/CommentsList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/components/CommentsList/style.scss");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommentsList = function CommentsList(props) {
	
	  function handleFollow(event) {
	    event.preventDefault();
	    props.onFollow && props.onFollow();
	  }
	
	  function handleUnfollow(event) {
	    event.preventDefault();
	    props.onFollow && props.onUnfollow();
	  }
	
	  function handleSortOptionChange(event) {
	    props.onSortOptionChange && props.onSortOptionChange(event.target.value);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'CommentsList' },
	    _react2.default.createElement(
	      'div',
	      { className: 'filter' },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('float-left', { hide: !props.allowsSorting }) },
	        _react2.default.createElement(
	          'form',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'sortOptions' },
	            "SORT BY"
	          ),
	          _react2.default.createElement(
	            'select',
	            { name: 'sortOptions', value: props.selectedSortOption, onChange: handleSortOptionChange },
	            props.sortOptionsPairs && props.sortOptionsPairs.map(function (pair) {
	              return _react2.default.createElement(
	                'option',
	                { key: pair.value, value: pair.value },
	                pair.title
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'float-right' },
	        function () {
	          if (props.isFollowed) {
	            return _react2.default.createElement(
	              _Link2.default,
	              { onClick: handleUnfollow, to: '_' },
	              "Unfollow Replies"
	            );
	          }
	
	          return _react2.default.createElement(
	            _Link2.default,
	            { onClick: handleFollow, to: '_' },
	            "Follow Replies"
	          );
	        }()
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'list' },
	      props.children
	    )
	  );
	};
	
	CommentsList.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)]),
	  allowsSorting: _react.PropTypes.bool,
	  sortOptionsPairs: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    value: _react.PropTypes.any,
	    title: _react.PropTypes.string
	  })),
	  selectedSortOption: _react.PropTypes.string,
	  isFollowed: _react.PropTypes.bool,
	  onSortOptionChange: _react.PropTypes.func,
	  onFollow: _react.PropTypes.func,
	  onUnfollow: _react.PropTypes.func
	};
	
	exports.default = CommentsList;

/***/ },

/***/ "./src/members/Main/__shared__/components/Contribute/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TextEditor = __webpack_require__("./src/members/Main/__shared__/components/TextEditor/index.js");
	
	var _TextEditor2 = _interopRequireDefault(_TextEditor);
	
	var _InfoBar = __webpack_require__("./src/members/Main/__shared__/components/InfoBar/index.js");
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	__webpack_require__("./src/members/Main/__shared__/components/Contribute/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contribute = function (_Component) {
	  _inherits(Contribute, _Component);
	
	  function Contribute() {
	    _classCallCheck(this, Contribute);
	
	    var _this = _possibleConstructorReturn(this, (Contribute.__proto__ || Object.getPrototypeOf(Contribute)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleSubjectUpdate = _this.handleSubjectUpdate.bind(_this);
	    _this.handleInfoBarClose = _this.handleInfoBarClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(Contribute, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onDidMount) {
	        this.props.onDidMount();
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(text) {
	      var subject = this.props.subject;
	      this.props.onSubmit(subject, text);
	    }
	  }, {
	    key: 'handleSubjectUpdate',
	    value: function handleSubjectUpdate(e) {
	      var subject = e.target.value;
	      this.props.onSubjectUpdate(subject);
	    }
	  }, {
	    key: 'handleInfoBarClose',
	    value: function handleInfoBarClose() {
	      if (this.props.onInfoBarClose) {
	        this.props.onInfoBarClose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          isNarrow = _props.isNarrow,
	          hasBackgroundWhite = _props.hasBackgroundWhite,
	          otherProps = _objectWithoutProperties(_props, ['title', 'isNarrow', 'hasBackgroundWhite']);
	
	      var wrapperClassName = (0, _classnames2.default)('is-padded-top', {
	        'wrapper-narrow': isNarrow,
	        'wrapper-small': !isNarrow,
	        'has-background-white': hasBackgroundWhite
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Contribute' },
	        this.props.isSuccessInfoBarVisible && _react2.default.createElement(_InfoBar2.default, { onClose: this.handleInfoBarClose, isStatic: true, type: 'primary', title: this.props.successInfoBarTitle, message: this.props.successInfoBarMessage }),
	        _react2.default.createElement(
	          'div',
	          { className: wrapperClassName },
	          _react2.default.createElement(
	            'div',
	            { className: 'contribute-form' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-inner' },
	              _react2.default.createElement(
	                'label',
	                null,
	                "Subject"
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                placeholder: "Write the subject of your discussion.",
	                value: this.props.subject,
	                onChange: this.handleSubjectUpdate
	              }),
	              _react2.default.createElement(_TextEditor2.default, _extends({}, otherProps, {
	                onSubmit: this.handleSubmit,
	                maxChars: (10000),
	                contentTitle: "Content",
	                placeholder: "Please write your message here then press the submit button."
	              }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Contribute;
	}(_react.Component);
	
	Contribute.propTypes = {
	  subject: _react.PropTypes.string,
	  isSuccessInfoBarVisible: _react.PropTypes.bool,
	  successInfoBarMessage: _react.PropTypes.string,
	  successInfoBarTitle: _react.PropTypes.string,
	  title: _react.PropTypes.string,
	  isNarrow: _react.PropTypes.bool,
	  hasBackgroundWhite: _react.PropTypes.bool,
	  onSubjectUpdate: _react.PropTypes.func,
	  onSubmit: _react.PropTypes.func,
	  onDidMount: _react.PropTypes.func,
	  onInfoBarClose: _react.PropTypes.func
	};
	
	exports.default = Contribute;

/***/ },

/***/ "./src/members/Main/__shared__/components/DateInput/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPikadayComponent = __webpack_require__("./node_modules/react-pikaday-component/index.js");
	
	var _reactPikadayComponent2 = _interopRequireDefault(_reactPikadayComponent);
	
	var _bowser = __webpack_require__("./node_modules/bowser/src/bowser.js");
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var _modernizr = __webpack_require__("./src/.modernizrrc");
	
	var _modernizr2 = _interopRequireDefault(_modernizr);
	
	__webpack_require__("./src/members/Main/__shared__/components/DateInput/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DateInput = function DateInput(props) {
	  var input = props.input,
	      className = props.className,
	      format = props.format;
	
	  // only render date input if it is supported and the user is on a mobile or tablet device
	
	  var shouldRenderDateInput = _modernizr2.default.inputtypes.date && (_bowser2.default.mobile || _bowser2.default.tablet);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'DateInput' },
	    shouldRenderDateInput ? _react2.default.createElement('input', _extends({}, input, {
	      className: className,
	      type: 'date',
	      id: '' + input.name
	    })) : _react2.default.createElement(_reactPikadayComponent2.default, _extends({}, input, {
	      className: className,
	      value: new Date(input.value),
	      format: format,
	      yearRange: [new Date().getFullYear() - 30, new Date().getFullYear()],
	      maxDate: new Date(),
	      id: '' + input.name
	    }))
	  );
	};
	
	DateInput.propTypes = {
	  input: _react.PropTypes.object,
	  format: _react.PropTypes.string,
	  className: _react.PropTypes.string
	};
	
	exports.default = DateInput;

/***/ },

/***/ "./src/members/Main/__shared__/components/DetailLabel/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/DetailLabel/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailLabel = function DetailLabel(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'DetailLabel' },
	    props.children
	  );
	};
	
	DetailLabel.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.arrayOf(_react.PropTypes.node)])
	};
	
	exports.default = DetailLabel;

/***/ },

/***/ "./src/members/Main/__shared__/components/Emojis/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactEmojione = __webpack_require__("./node_modules/react-emojione/lib/react-emojione.js");
	
	var _emojiShortnames = __webpack_require__("./node_modules/emoji-shortnames/index.js");
	
	var _emojiShortnames2 = _interopRequireDefault(_emojiShortnames);
	
	__webpack_require__("./src/members/Main/__shared__/components/Emojis/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Emojis = function Emojis(props) {
	  var className = (0, _classnames2.default)('Emojis', {
	    'is-under-textarea': props.isUnderTextArea,
	    'is-visible': props.isVisible
	  });
	
	  function handleEmojiClick(event) {
	    var shortName = event.target.getAttribute('label');
	    props.onEmojiSelected(shortName);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: 'emoji-list' },
	      _emojiShortnames2.default.people.slice(0, 50).map(function (shortName) {
	        return _react2.default.createElement(
	          'span',
	          { key: shortName, label: shortName, onClick: handleEmojiClick, className: 'icon' },
	          (0, _reactEmojione.emojify)(shortName, { output: 'unicode' })
	        );
	      })
	    )
	  );
	};
	
	Emojis.propTypes = {
	  isUnderTextArea: _react.PropTypes.bool,
	  isVisible: _react.PropTypes.bool,
	  onEmojiSelected: _react.PropTypes.func
	};
	
	exports.default = Emojis;

/***/ },

/***/ "./src/members/Main/__shared__/components/EmptyArticle/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/components/EmptyArticle/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyArticle = function EmptyArticle(props) {
	  var className = (0, _classnames2.default)('article-empty', {
	    'is-featured': props.isFeatured,
	    'is-darker': props.isDarker
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement('div', { className: 'image' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'inner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'preview' },
	        _react2.default.createElement('div', { className: 'text' })
	      )
	    )
	  );
	};
	
	EmptyArticle.propTypes = {
	  isFeatured: _react.PropTypes.bool,
	  isDarker: _react.PropTypes.bool
	};
	
	exports.default = EmptyArticle;

/***/ },

/***/ "./src/members/Main/__shared__/components/InfoBar/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames3 = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__("./src/members/Main/__shared__/components/InfoBar/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InfoBar = function InfoBar(props) {
	  var isStatic = props.isStatic,
	      onClose = props.onClose,
	      type = props.type;
	
	
	  var className = (0, _classnames4.default)('InfoBar', {
	    'is-static': isStatic
	  });
	
	  var classNameCallout = (0, _classnames4.default)('callout', _defineProperty({}, '' + type, !!type));
	
	  var classNameClose = (0, _classnames4.default)('search-close', _defineProperty({}, 'is-hidden', !onClose));
	
	  var handleLinkClick = function handleLinkClick(event) {
	    event.preventDefault();
	    props.onClose();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: classNameCallout },
	      _react2.default.createElement(
	        _Link2.default,
	        { to: '/', iconName: classNameClose, onClick: handleLinkClick },
	        'Close'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper-small' },
	        props.title && _react2.default.createElement(
	          'h4',
	          null,
	          props.title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          props.message
	        )
	      )
	    )
	  );
	};
	
	InfoBar.propTypes = {
	  isStatic: _react.PropTypes.bool,
	  type: _react.PropTypes.string,
	  title: _react.PropTypes.string,
	  message: _react.PropTypes.string,
	  onClose: _react.PropTypes.func
	};
	
	exports.default = InfoBar;

/***/ },

/***/ "./src/members/Main/__shared__/components/Link/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	__webpack_require__("./src/__shared__/styles/Link.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ReduxLink = function ReduxLink(props) {
	  var _classnames;
	
	  var iconName = props.iconName,
	      _props$to = props.to,
	      to = _props$to === undefined ? '_' : _props$to,
	      isDisabled = props.isDisabled,
	      isActive = props.isActive,
	      path = props.path,
	      otherProps = _objectWithoutProperties(props, ['iconName', 'to', 'isDisabled', 'isActive', 'path']); //eslint-disable-line no-unused-vars
	
	  var className = (0, _classnames3.default)('Link', (_classnames = {
	    'link-icon': !!iconName,
	    'is-disabled': isDisabled
	  }, _defineProperty(_classnames, 'icon-' + iconName, !!iconName), _defineProperty(_classnames, otherProps.activeClassName, isActive), _classnames));
	
	  return _react2.default.createElement(_reactRouter.Link, _extends({ to: to }, otherProps, { className: className }));
	};
	
	ReduxLink.propTypes = {
	  iconName: _react.PropTypes.string,
	  path: _react.PropTypes.string,
	  isDisabled: _react.PropTypes.bool,
	  isActive: _react.PropTypes.bool,
	  to: _react.PropTypes.string
	};
	
	exports.default = (0, _reactRedux.connect)(function (state, ownProps) {
	  var prevLocation = state.routing.locationBeforeTransitions;
	
	  return _extends({}, ownProps, {
	    path: prevLocation ? prevLocation.pathname : ''
	  });
	}, function () {
	  return {};
	})(ReduxLink);

/***/ },

/***/ "./src/members/Main/__shared__/components/NoEntries/NoEntriesDetail/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoEntriesDetail = function NoEntriesDetail(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'p',
	    null,
	    children
	  );
	};
	
	NoEntriesDetail.propTypes = {
	  text: _react.PropTypes.string,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.arrayOf(_react.PropTypes.node)])
	};
	
	exports.default = NoEntriesDetail;

/***/ },

/***/ "./src/members/Main/__shared__/components/NoEntries/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/NoEntries/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoEntries = function NoEntries(_ref) {
	  var title = _ref.title,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'NoEntries' },
	    _react2.default.createElement(
	      'h4',
	      null,
	      title
	    ),
	    children
	  );
	};
	
	NoEntries.propTypes = {
	  title: _react.PropTypes.string,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.element), _react.PropTypes.element])
	};
	
	exports.default = NoEntries;

/***/ },

/***/ "./src/members/Main/__shared__/components/NotFound/index.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFound = function NotFound() {
	  return _react2.default.createElement(
	    "section",
	    { className: "content-wrapper is-404" },
	    _react2.default.createElement(
	      "div",
	      { className: "error-graphic" },
	      _react2.default.createElement(
	        "div",
	        { className: "wrapper-narrow" },
	        _react2.default.createElement("img", { src: "https://cdn.kooth.com/home/404.svg", alt: "404 icon" }),
	        _react2.default.createElement(
	          "h1",
	          null,
	          "The page you are looking for does not exist."
	        )
	      )
	    )
	  );
	};
	
	exports.default = NotFound;

/***/ },

/***/ "./src/members/Main/__shared__/components/PageSelector/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PageSelector = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/components/PageSelector/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageSelector = exports.PageSelector = function (_Component) {
	  _inherits(PageSelector, _Component);
	
	  function PageSelector(props) {
	    _classCallCheck(this, PageSelector);
	
	    var _this = _possibleConstructorReturn(this, (PageSelector.__proto__ || Object.getPrototypeOf(PageSelector)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handle = _this.handleInputChange.bind(_this);
	    _this.handlePrevClick = _this.handlePrevClick.bind(_this);
	    _this.handleNextClick = _this.handleNextClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(PageSelector, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      event.preventDefault();
	      this.props.onPageUpdate(Number(this.refs.input.value), this.props.pagesCount);
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(event) {
	      this.props.onPossiblePageUpdate(Number(event.target.value));
	    }
	  }, {
	    key: 'handlePrevClick',
	    value: function handlePrevClick() {
	      this.props.onPrevClick(this.props.possiblePage);
	    }
	  }, {
	    key: 'handleNextClick',
	    value: function handleNextClick() {
	      this.props.onNextClick(this.props.possiblePage);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prevClassName = (0, _classnames2.default)({
	        'prev': true,
	        'is-inactive': !this.props.isPrevActive
	      });
	
	      var nextClassName = (0, _classnames2.default)({
	        'next': true,
	        'is-inactive': !this.props.isNextActive
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'PageSelector' },
	        _react2.default.createElement(
	          'a',
	          { className: prevClassName, onClick: this.handlePrevClick },
	          "Prev"
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'numbers' },
	          _react2.default.createElement(
	            'span',
	            { className: 'current' },
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.handleSubmit },
	              _react2.default.createElement('input', { type: 'number', ref: 'input', value: this.props.possiblePage || "", onChange: this.handleInputChange })
	            )
	          ),
	          "of",
	          ' ',
	          this.props.pagesCount
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: nextClassName, onClick: this.handleNextClick },
	          "Next"
	        )
	      );
	    }
	  }]);
	
	  return PageSelector;
	}(_react.Component);
	
	PageSelector.propTypes = {
	  isPrevActive: _react.PropTypes.bool,
	  isNextActive: _react.PropTypes.bool,
	  possiblePage: _react.PropTypes.number,
	  pagesCount: _react.PropTypes.number,
	  onNextClick: _react.PropTypes.func,
	  onPrevClick: _react.PropTypes.func,
	  onPossiblePageUpdate: _react.PropTypes.func,
	  onPageUpdate: _react.PropTypes.func
	};
	
	exports.default = PageSelector;

/***/ },

/***/ "./src/members/Main/__shared__/components/Questionnaire/QuestionnaireQuestion/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/Questionnaire/QuestionnaireQuestion/style.scss");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuestionnaireQuestion = function (_React$Component) {
	  _inherits(QuestionnaireQuestion, _React$Component);
	
	  function QuestionnaireQuestion() {
	    var _ref;
	
	    _classCallCheck(this, QuestionnaireQuestion);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = QuestionnaireQuestion.__proto__ || Object.getPrototypeOf(QuestionnaireQuestion)).call.apply(_ref, [this].concat(args)));
	
	    var props = args[0];
	
	    _this.state = {
	      answers: props.question && props.question.answer !== null ? props.question.answer : [],
	      values: props.question && props.question.value !== null ? props.question.value : []
	    };
	
	    _this.isOptionChecked = _this.isOptionChecked.bind(_this);
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(QuestionnaireQuestion, [{
	    key: 'isOptionChecked',
	    value: function isOptionChecked(option) {
	      var question = this.props.question;
	      var answers = this.state.answers;
	
	
	      if (question.type === 'checkbox') {
	        return Boolean(answers.filter(function (id) {
	          return id === option.id;
	        }).length);
	      }
	
	      return question.answer === option.id;
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(answerId, answerValue, event) {
	      var question = this.props.question;
	      var _state = this.state,
	          answers = _state.answers,
	          values = _state.values;
	
	
	      if (question.type === 'checkbox') {
	        if (!answers.includes(answerId) && (!question.hasOwnProperty('maxNoOfAnswers') || question.maxNoOfAnswers > answers.length)) {
	          answers.push(answerId);
	          values.push(answerValue);
	        } else if (answers.includes(answerId)) {
	          answers.splice(answers.indexOf(answerId), 1);
	          values.splice(values.indexOf(answerValue), 1);
	        }
	
	        this.setState({ answers: answers, values: values }); // eslint-disable-line react/no-set-state
	      }
	
	      var answer = question.type === 'checkbox' ? answers : answerId;
	      var value = void 0;
	
	      if (question.type === 'checkbox') value = values;else if (question.type === 'text') value = event.target.value;else value = answerValue;
	
	      this.props.onAnswer(question, answer, value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          question = _props.question,
	          title = _props.title,
	          description = _props.description,
	          tip = _props.tip;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'QuestionnaireQuestion' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          function () {
	            if (question) {
	              var name = question.id;
	
	              return _react2.default.createElement(
	                'form',
	                null,
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  question.text
	                ),
	                question.options.map(function (option) {
	                  var key = name + '_' + option.id;
	
	                  return _react2.default.createElement(
	                    'div',
	                    { key: key, className: 'form-field radio' },
	                    question.type === 'text' ? _react2.default.createElement(
	                      'textarea',
	                      {
	                        name: name,
	                        onChange: function onChange(event) {
	                          return _this2.handleInputChange(option.id, option.value, event);
	                        }
	                      },
	                      question.value
	                    ) : _react2.default.createElement('input', {
	                      name: name,
	                      type: question.type,
	                      checked: _this2.isOptionChecked(option),
	                      onChange: function onChange(event) {
	                        return _this2.handleInputChange(option.id, option.value, event);
	                      }
	                    }),
	                    question.type !== 'text' && _react2.default.createElement(
	                      'label',
	                      {
	                        htmlFor: name,
	                        onClick: function onClick(event) {
	                          return _this2.handleInputChange(option.id, option.value, event);
	                        }
	                      },
	                      option.text
	                    )
	                  );
	                })
	              );
	            } else {
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  title
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  description
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'instruction' },
	                  _react2.default.createElement('span', { className: 'icon-gesture-swipe' }),
	                  ' ',
	                  tip
	                )
	              );
	            }
	          }()
	        )
	      );
	    }
	  }]);
	
	  return QuestionnaireQuestion;
	}(_react2.default.Component);
	
	QuestionnaireQuestion.propTypes = {
	  title: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  tip: _react.PropTypes.string,
	  question: _entities.QuestionShape,
	  onAnswer: _react.PropTypes.func
	};
	
	exports.default = QuestionnaireQuestion;

/***/ },

/***/ "./src/members/Main/__shared__/components/Questionnaire/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactSwipr = __webpack_require__("./node_modules/react-swipr/lib/ReactSwipr.js");
	
	var _reactSwipr2 = _interopRequireDefault(_reactSwipr);
	
	var _QuestionnaireQuestion = __webpack_require__("./src/members/Main/__shared__/components/Questionnaire/QuestionnaireQuestion/index.js");
	
	var _QuestionnaireQuestion2 = _interopRequireDefault(_QuestionnaireQuestion);
	
	var _DetailLabel = __webpack_require__("./src/members/Main/__shared__/components/DetailLabel/index.js");
	
	var _DetailLabel2 = _interopRequireDefault(_DetailLabel);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	__webpack_require__("./src/members/Main/__shared__/components/Questionnaire/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lastId = 0;
	
	var Questionnaire = function (_Component) {
	  _inherits(Questionnaire, _Component);
	
	  function Questionnaire() {
	    var _ref;
	
	    _classCallCheck(this, Questionnaire);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = Questionnaire.__proto__ || Object.getPrototypeOf(Questionnaire)).call.apply(_ref, [this].concat(args)));
	
	    _this.handleAnswer = _this.handleAnswer.bind(_this);
	    return _this;
	  }
	
	  _createClass(Questionnaire, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.id = this.generateNewId();
	    }
	
	    // Swipr elementIds need to be unique
	
	  }, {
	    key: 'generateNewId',
	    value: function generateNewId() {
	      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
	
	      lastId += 1;
	      return prefix + '-' + lastId;
	    }
	  }, {
	    key: 'handleAnswer',
	    value: function handleAnswer(question, answerId, answerValue) {
	      this.props.onQuestionAnswer(this.props.questionnaire, question, answerId, answerValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Questionnaire' },
	        _react2.default.createElement(
	          'div',
	          { className: 'the-carousel' },
	          _react2.default.createElement(
	            _reactSwipr2.default,
	            { elementId: this.props.questionnaire.id + '-' + this.id },
	            _react2.default.createElement(_QuestionnaireQuestion2.default, {
	              title: this.props.questionnaire.summary,
	              description: this.props.questionnaire.description,
	              tip: "Swipe left when you’re ready"
	            }),
	            this.props.questionnaire.questions.map(function (question) {
	              return _react2.default.createElement(_QuestionnaireQuestion2.default, {
	                key: question.id,
	                question: question,
	                onAnswer: _this2.handleAnswer
	              });
	            })
	          ),
	          !this.props.metaHidden && _react2.default.createElement(
	            'div',
	            { className: 'meta' },
	            _react2.default.createElement(
	              _DetailLabel2.default,
	              null,
	              (0, _moment2.default)(this.props.lastUpdated).fromNow()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Questionnaire;
	}(_react.Component);
	
	Questionnaire.propTypes = {
	  questionnaire: _entities.QuestionnaireShape,
	  onQuestionAnswer: _react.PropTypes.func,
	  lastRefresh: _react.PropTypes.object,
	  lastUpdated: _react.PropTypes.object,
	  metaHidden: _react.PropTypes.bool
	};
	
	exports.default = Questionnaire;

/***/ },

/***/ "./src/members/Main/__shared__/components/RepliesList/RepliesListContentMain/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/RepliesList/RepliesListContentMain/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RepliesListContentMain = function RepliesListContentMain(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'RepliesListContentMain' },
	    props.children
	  );
	};
	
	RepliesListContentMain.propTypes = {
	  children: _react.PropTypes.arrayOf(_react.PropTypes.node)
	};
	
	exports.default = RepliesListContentMain;

/***/ },

/***/ "./src/members/Main/__shared__/components/RepliesList/RepliesListContentSticky/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/RepliesList/RepliesListContentSticky/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RepliesListContentSticky = function RepliesListContentSticky(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'RepliesListContentSticky' },
	    props.children
	  );
	};
	
	RepliesListContentSticky.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.node)])
	};
	
	exports.default = RepliesListContentSticky;

/***/ },

/***/ "./src/members/Main/__shared__/components/RepliesList/Reply/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactVisibilitySensor = __webpack_require__("./node_modules/react-visibility-sensor/visibility-sensor.js");
	
	var _reactVisibilitySensor2 = _interopRequireDefault(_reactVisibilitySensor);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__("./src/members/Main/__shared__/components/RepliesList/Reply/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Reply = function (_Component) {
	  _inherits(Reply, _Component);
	
	  function Reply() {
	    _classCallCheck(this, Reply);
	
	    var _this = _possibleConstructorReturn(this, (Reply.__proto__ || Object.getPrototypeOf(Reply)).call(this));
	
	    _this.handleVisibilityChange = _this.handleVisibilityChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Reply, [{
	    key: 'handleVisibilityChange',
	    value: function handleVisibilityChange(isVisible) {
	      if (isVisible && this.props.onDidBecomeVisible) {
	        this.props.onDidBecomeVisible();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$animateHover = this.props.animateHover,
	          animateHover = _props$animateHover === undefined ? true : _props$animateHover;
	
	
	      var className = (0, _classnames2.default)({
	        'Reply': true,
	        'is-unread': this.props.isUnread,
	        'is-empty': this.props.isEmpty,
	        'animate-hover': animateHover
	      });
	
	      return _react2.default.createElement(
	        'li',
	        { className: className },
	        _react2.default.createElement(_reactVisibilitySensor2.default, { onChange: this.handleVisibilityChange }),
	        _react2.default.createElement(
	          'div',
	          { className: 'date' },
	          this.props.since
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'avatar' },
	          _react2.default.createElement(_UserAvatar2.default, { letter: this.props.avatarLetter, imageUrl: this.props.avatarImageUrl })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'author' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            this.props.authorName
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'snippet' },
	          _react2.default.createElement(
	            'p',
	            null,
	            this.props.children
	          )
	        ),
	        function () {
	          if (_this2.props.to) {
	            return _react2.default.createElement(
	              _Link2.default,
	              { to: _this2.props.to },
	              '\xA0'
	            );
	          }
	        }()
	      );
	    }
	  }]);
	
	  return Reply;
	}(_react.Component);
	
	Reply.propTypes = {
	  isUnread: _react.PropTypes.bool,
	  since: _react.PropTypes.string,
	  avatarLetter: _react.PropTypes.string,
	  avatarImageUrl: _react.PropTypes.string,
	  authorName: _react.PropTypes.string,
	  to: _react.PropTypes.string,
	  children: _react.PropTypes.node,
	  animateHover: _react.PropTypes.bool,
	  onDidBecomeVisible: _react.PropTypes.func,
	  isEmpty: _react.PropTypes.bool
	};
	
	exports.default = Reply;

/***/ },

/***/ "./src/members/Main/__shared__/components/RepliesList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RepliesList = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/RepliesList/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RepliesList = exports.RepliesList = function (_Component) {
	  _inherits(RepliesList, _Component);
	
	  function RepliesList() {
	    _classCallCheck(this, RepliesList);
	
	    return _possibleConstructorReturn(this, (RepliesList.__proto__ || Object.getPrototypeOf(RepliesList)).apply(this, arguments));
	  }
	
	  _createClass(RepliesList, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'RepliesList' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return RepliesList;
	}(_react.Component);
	
	RepliesList.propTypes = {
	  children: _react.PropTypes.arrayOf(_react.PropTypes.node)
	};
	
	exports.default = RepliesList;

/***/ },

/***/ "./src/members/Main/__shared__/components/RepliesListLoading/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Reply = __webpack_require__("./src/members/Main/__shared__/components/RepliesList/Reply/index.js");
	
	var _Reply2 = _interopRequireDefault(_Reply);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RepliesListLoading = function RepliesListLoading() {
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Reply2.default, { isEmpty: true }),
	    _react2.default.createElement(_Reply2.default, { isEmpty: true }),
	    _react2.default.createElement(_Reply2.default, { isEmpty: true })
	  );
	};
	
	exports.default = RepliesListLoading;

/***/ },

/***/ "./src/members/Main/__shared__/components/ResourcesList/Resource/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/components/ResourcesList/Resource/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resource = function Resource(props) {
	  var className = (0, _classnames2.default)('Resource', {
	    'url': props.isWebsite,
	    'document': props.isDocument,
	    'is-empty': props.isEmpty
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'p',
	      { className: 'date' },
	      props.since
	    ),
	    _react2.default.createElement(
	      'h5',
	      null,
	      props.title
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'author' },
	      props.authorName
	    ),
	    _react2.default.createElement('a', { className: 'Link', href: props.url, target: '_blank' })
	  );
	};
	
	Resource.propTypes = {
	  title: _react.PropTypes.string,
	  authorName: _react.PropTypes.string,
	  isWebsite: _react.PropTypes.bool,
	  isDocument: _react.PropTypes.bool,
	  since: _react.PropTypes.string,
	  url: _react.PropTypes.string,
	  isEmpty: _react.PropTypes.bool
	};
	
	exports.default = Resource;

/***/ },

/***/ "./src/members/Main/__shared__/components/ResourcesList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/components/ResourcesList/style.scss");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourcesList = function ResourcesList(props) {
	  var className = (0, _classnames2.default)('ResourcesList', {
	    'is-inner': props.showsAll
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    function () {
	      if (!props.showsAll) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'head' },
	          _react2.default.createElement(
	            'p',
	            { className: 'link-see-all' },
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/chat-resources' },
	              "View all"
	            )
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            "Chat resources"
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            "Browse documents and links sent by counsellors"
	          )
	        );
	      }
	    }(),
	    _react2.default.createElement(
	      'div',
	      { className: 'list' },
	      props.children
	    )
	  );
	};
	
	ResourcesList.propTypes = {
	  showsAll: _react.PropTypes.bool,
	  children: _react.PropTypes.array
	};
	
	exports.default = ResourcesList;

/***/ },

/***/ "./src/members/Main/__shared__/components/ResourcesListLoading/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Resource = __webpack_require__("./src/members/Main/__shared__/components/ResourcesList/Resource/index.js");
	
	var _Resource2 = _interopRequireDefault(_Resource);
	
	__webpack_require__("./src/members/Main/__shared__/components/ResourcesListLoading/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourcesListLoading = function ResourcesListLoading() {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ResourcesListLoading' },
	    _react2.default.createElement(_Resource2.default, { isEmpty: true }),
	    _react2.default.createElement(_Resource2.default, { isEmpty: true }),
	    _react2.default.createElement(_Resource2.default, { isEmpty: true })
	  );
	};
	
	exports.default = ResourcesListLoading;

/***/ },

/***/ "./src/members/Main/__shared__/components/Sidebar/SidebarGroup/SidebarGroupItem/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _UserAvatar = __webpack_require__("./src/members/Main/__shared__/components/UserAvatar/index.js");
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	__webpack_require__("./src/members/Main/__shared__/components/Sidebar/SidebarGroup/SidebarGroupItem/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarGroupItem = function SidebarGroupItem(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'SidebarGroupItem' },
	    _react2.default.createElement(
	      'div',
	      { className: 'avatar' },
	      _react2.default.createElement(_UserAvatar2.default, { imageUrl: props.authorAvatarUrl, letter: props.authorName[0] })
	    ),
	    _react2.default.createElement(
	      'h5',
	      null,
	      _react2.default.createElement(
	        _Link2.default,
	        { to: props.articleUrl },
	        props.title
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'author' },
	      props.authorName
	    )
	  );
	};
	
	SidebarGroupItem.propTypes = {
	  authorAvatarUrl: _react.PropTypes.string,
	  authorName: _react.PropTypes.string,
	  articleUrl: _react.PropTypes.string,
	  title: _react.PropTypes.string
	};
	
	exports.default = SidebarGroupItem;

/***/ },

/***/ "./src/members/Main/__shared__/components/Sidebar/SidebarGroup/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/Sidebar/SidebarGroup/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarGroup = function SidebarGroup(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'SidebarGroup' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      props.title
	    ),
	    props.children
	  );
	};
	
	SidebarGroup.propTypes = {
	  children: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  title: _react.PropTypes.string
	};
	
	exports.default = SidebarGroup;

/***/ },

/***/ "./src/members/Main/__shared__/components/Sidebar/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/components/Sidebar/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sidebar = function Sidebar(props) {
	  var className = (0, _classnames2.default)('Sidebar', { 'is-wider': props.isWider });
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    props.children
	  );
	};
	
	Sidebar.propTypes = {
	  children: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  isWider: _react.PropTypes.bool
	};
	
	exports.default = Sidebar;

/***/ },

/***/ "./src/members/Main/__shared__/components/SubNavigation/SubNavigationItem/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/components/SubNavigation/SubNavigationItem/style.scss");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SubNavigationItem = function SubNavigationItem(props) {
	  var isForForum = props.isForForum,
	      isForSearch = props.isForSearch,
	      isForMagazine = props.isForMagazine,
	      otherProps = _objectWithoutProperties(props, ['isForForum', 'isForSearch', 'isForMagazine']);
	
	  var className = (0, _classnames2.default)('SubNavigationItem', {
	    'is-for-forum': isForForum,
	    'is-for-search': isForSearch,
	    'is-for-magazine': isForMagazine
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(_Link2.default, _extends({}, otherProps, { activeClassName: 'is-active' }))
	  );
	};
	
	SubNavigationItem.propTypes = {
	  isForForum: _react.PropTypes.bool,
	  isForSearch: _react.PropTypes.bool,
	  isForMagazine: _react.PropTypes.bool
	};
	
	exports.default = SubNavigationItem;

/***/ },

/***/ "./src/members/Main/__shared__/components/SubNavigation/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/components/SubNavigation/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Flickity = __webpack_require__("./node_modules/react-flickity-component/lib/index.js")(_react2.default);
	
	var SubNavigation = function SubNavigation(props) {
	
	  var flickityOptions = {
	    accessibility: false,
	    setGallerySize: false,
	    prevNextButtons: false,
	    pageDots: false,
	    cellSelector: '.SubNavigationItem',
	    percentPosition: false,
	    contain: true // needed to fix desktop behaviour
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'SubNavigation' },
	    _react2.default.createElement(
	      'div',
	      { className: 'slides' },
	      _react2.default.createElement(
	        Flickity,
	        {
	          key: props.children.length,
	          className: 'carousel',
	          elementType: 'span',
	          options: flickityOptions,
	          disableImagesLoaded: false },
	        props.children
	      )
	    )
	  );
	};
	
	SubNavigation.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)])
	};
	
	exports.default = SubNavigation;

/***/ },

/***/ "./src/members/Main/__shared__/components/TextArea/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAutosizeTextarea = __webpack_require__("./node_modules/react-autosize-textarea/index.js");
	
	var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);
	
	__webpack_require__("./src/members/Main/__shared__/components/TextArea/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextArea = function (_Component) {
	  _inherits(TextArea, _Component);
	
	  function TextArea() {
	    _classCallCheck(this, TextArea);
	
	    return _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).apply(this, arguments));
	  }
	
	  _createClass(TextArea, [{
	    key: 'getTextAreaElement',
	    value: function getTextAreaElement() {
	      if (this.props.isAutosized) {
	        return this.refs.textarea.getTextareaDOMNode();
	      }
	
	      return this.refs.textarea;
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.getTextAreaElement().focus();
	    }
	  }, {
	    key: 'getSelectionStart',
	    value: function getSelectionStart() {
	      return this.getTextAreaElement().selectionStart;
	    }
	  }, {
	    key: 'setCaretPosition',
	    value: function setCaretPosition(position) {
	      this.refs.textarea.selectionStart = position;
	      this.refs.textarea.selectionEnd = position;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isExpanded = _props.isExpanded,
	          isAutosized = _props.isAutosized,
	          hasMediumHeight = _props.hasMediumHeight,
	          otherProps = _objectWithoutProperties(_props, ['isExpanded', 'isAutosized', 'hasMediumHeight']);
	
	      var className = (0, _classnames2.default)('TextArea', {
	        'is-expanded': isExpanded,
	        'is-autosized': isAutosized,
	        'has-medium-height': hasMediumHeight
	      });
	
	      return this.props.isAutosized ? _react2.default.createElement(_reactAutosizeTextarea2.default, _extends({ ref: 'textarea', className: className }, otherProps)) : _react2.default.createElement('textarea', _extends({ ref: 'textarea', className: className }, otherProps));
	    }
	  }]);
	
	  return TextArea;
	}(_react.Component);
	
	TextArea.propTypes = {
	  isExpanded: _react.PropTypes.bool,
	  isAutosized: _react.PropTypes.bool,
	  hasMediumHeight: _react.PropTypes.bool
	};
	
	exports.default = TextArea;

/***/ },

/***/ "./src/members/Main/__shared__/components/TextEditor/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactEmojione = __webpack_require__("./node_modules/react-emojione/lib/react-emojione.js");
	
	var _TextArea = __webpack_require__("./src/members/Main/__shared__/components/TextArea/index.js");
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__("./src/members/Main/__shared__/components/TextEditor/style.scss");
	
	var _Emojis = __webpack_require__("./src/members/Main/__shared__/components/Emojis/index.js");
	
	var _Emojis2 = _interopRequireDefault(_Emojis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextEditor = exports.TextEditor = function (_Component) {
	  _inherits(TextEditor, _Component);
	
	  function TextEditor(props) {
	    _classCallCheck(this, TextEditor);
	
	    var _this = _possibleConstructorReturn(this, (TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call(this, props));
	
	    _this.pendingCaretPosition = -1;
	
	    _this.handleTextUpdate = _this.handleTextUpdate.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleOnFocus = _this.handleOnFocus.bind(_this);
	    _this.handleEmojisToggle = _this.handleEmojisToggle.bind(_this);
	    _this.handleEmojiSelected = _this.handleEmojiSelected.bind(_this);
	    _this.handleCancel = _this.handleCancel.bind(_this);
	    return _this;
	  }
	
	  _createClass(TextEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.focusIfNecessary();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.focusIfNecessary();
	
	      if (this.pendingCaretPosition >= 0) {
	        this.refs.textarea.setCaretPosition(this.pendingCaretPosition);
	        this.pendingCaretPosition = -1;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onWillUnmount) {
	        this.props.onWillUnmount();
	      }
	    }
	  }, {
	    key: 'focusIfNecessary',
	    value: function focusIfNecessary() {
	      if (this.props.shouldFocusOnMountAndUpdate) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'handleTextUpdate',
	    value: function handleTextUpdate(event) {
	      this.props.onTextUpdate(event.target.value);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      event.preventDefault();
	
	      if (!this.props.isSubmitDisabled) {
	        this.props.onSubmit(this.props.text);
	      }
	    }
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus() {
	      if (this.props.onFocus) {
	        this.props.onFocus();
	      }
	    }
	  }, {
	    key: 'handleEmojisToggle',
	    value: function handleEmojisToggle(event) {
	      event.preventDefault();
	      this.props.onEmojisToggled(this.props.showsEmojis);
	    }
	  }, {
	    key: 'handleEmojiSelected',
	    value: function handleEmojiSelected(emojiShortName) {
	      this.pendingCaretPosition = this.getTextSelectionStart();
	      this.props.onEmojiSelected(this.props.text, emojiShortName, this.pendingCaretPosition);
	      this.focus();
	    }
	  }, {
	    key: 'handleCancel',
	    value: function handleCancel(event) {
	      event.preventDefault();
	      this.props.onCancel && this.props.onCancel();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.refs.textarea.focus();
	    }
	  }, {
	    key: 'getTextSelectionStart',
	    value: function getTextSelectionStart() {
	      return this.refs.textarea.getSelectionStart();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$allowsCancelin = _props.allowsCanceling,
	          allowsCanceling = _props$allowsCancelin === undefined ? false : _props$allowsCancelin,
	          _props$hasMediumHeigh = _props.hasMediumHeight,
	          hasMediumHeight = _props$hasMediumHeigh === undefined ? false : _props$hasMediumHeigh,
	          _props$contentTitle = _props.contentTitle,
	          contentTitle = _props$contentTitle === undefined ? "Content" : _props$contentTitle;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'TextEditor' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'form',
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            contentTitle
	          ),
	          _react2.default.createElement(_TextArea2.default, { placeholder: this.props.placeholder,
	            ref: 'textarea',
	            isExpanded: this.props.isExpanded,
	            hasMediumHeight: hasMediumHeight,
	            isAutosized: this.props.isAutosized,
	            value: this.props.text,
	            onFocus: this.handleOnFocus,
	            onChange: this.handleTextUpdate }),
	          _react2.default.createElement(_Emojis2.default, { isVisible: this.props.showsEmojis, onEmojiSelected: this.handleEmojiSelected, isUnderTextArea: true }),
	          function () {
	            if (_this2.props.isExpanded) {
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'submit' },
	                  _react2.default.createElement(
	                    _Button2.default,
	                    {
	                      isXSmall: true,
	                      isYellow: true,
	                      onClick: _this2.handleSubmit,
	                      isDisabled: _this2.props.isSubmitDisabled },
	                    _this2.props.isSubmitting ? "Submitting..." : "Submit"
	                  ),
	                  allowsCanceling && _react2.default.createElement(
	                    _Link2.default,
	                    { onClick: _this2.handleCancel },
	                    "Cancel"
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'emoji-trigger' },
	                  _react2.default.createElement(
	                    _Link2.default,
	                    { onClick: _this2.handleEmojisToggle },
	                    (0, _reactEmojione.emojify)(':)', { output: 'unicode' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('character-count', { 'is-exceeded': _this2.props.isCharsLimitExceeded }) },
	                  _react2.default.createElement(
	                    'span',
	                    { className: '' },
	                    _this2.props.text.length
	                  ),
	                  '/',
	                  _this2.props.maxChars
	                )
	              );
	            }
	          }()
	        )
	      );
	    }
	  }]);
	
	  return TextEditor;
	}(_react.Component);
	
	TextEditor.propTypes = {
	  text: _react.PropTypes.string,
	  title: _react.PropTypes.string,
	  contentTitle: _react.PropTypes.string,
	  placeholder: _react.PropTypes.string,
	  isSubmitting: _react.PropTypes.bool,
	  isSubmitDisabled: _react.PropTypes.bool,
	  isCharsLimitExceeded: _react.PropTypes.bool,
	  maxChars: _react.PropTypes.number,
	  onTextUpdate: _react.PropTypes.func,
	  onSubmit: _react.PropTypes.func,
	  isExpanded: _react.PropTypes.bool,
	  shouldFocusOnMountAndUpdate: _react.PropTypes.bool,
	  allowsCanceling: _react.PropTypes.bool,
	  isAutosized: _react.PropTypes.bool,
	  hasMediumHeight: _react.PropTypes.bool,
	  onFocus: _react.PropTypes.func,
	  onWillUnmount: _react.PropTypes.func,
	  showsEmojis: _react.PropTypes.bool,
	  onEmojisToggled: _react.PropTypes.func,
	  onEmojiSelected: _react.PropTypes.func,
	  onCancel: _react.PropTypes.func
	};
	
	exports.default = TextEditor;

/***/ },

/***/ "./src/members/Main/__shared__/components/UserAvatar/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	__webpack_require__("./src/members/Main/__shared__/components/UserAvatar/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var UserAvatar = function UserAvatar(props) {
	  var className = (0, _classnames3.default)(_defineProperty({
	    'user-avatar': true,
	    'is-empty': !!props.isEmpty,
	    'has-image': !!props.imageUrl
	  }, '' + props.size, !!props.size));
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    function () {
	      if (props.imageUrl) {
	        return _react2.default.createElement('img', { src: props.imageUrl });
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          props.letter
	        );
	      }
	    }()
	  );
	};
	
	UserAvatar.propTypes = {
	  imageUrl: _react.PropTypes.string,
	  isEmpty: _react.PropTypes.bool,
	  letter: _react.PropTypes.string,
	  size: _react.PropTypes.string
	};
	
	exports.default = UserAvatar;

/***/ },

/***/ "./src/members/Main/__shared__/containers/ForumThreadsList/ForumThread/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/containers/ForumThreadsList/ForumThread/style.scss");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _Link = __webpack_require__("./src/members/Main/__shared__/components/Link/index.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ForumThread = function ForumThread(props) {
	  var _props$forumThread = props.forumThread,
	      forumThread = _props$forumThread === undefined ? { author: {} } : _props$forumThread;
	
	  var className = (0, _classnames2.default)('ForumThread', {
	    'is-empty': props.isEmpty,
	    'is-live': props.isLive,
	    'is-inline': props.isInline
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: 'discussion-inner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'title-wrapper' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            forumThread.title
	          ),
	          props.isLive && _react2.default.createElement(
	            'span',
	            { className: 'live-label' },
	            "Live"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'author' },
	        forumThread.author.userName
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'time' },
	        props.timeInfo
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'replies' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          forumThread.commentCount
	        ),
	        ' ',
	        "replies"
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'discussion-link' },
	        _react2.default.createElement(_Link2.default, { to: '/forum/threads/' + forumThread.id })
	      )
	    )
	  );
	};
	
	ForumThread.propTypes = {
	  forumThread: _entities.ForumThreadShape,
	  timeInfo: _react.PropTypes.string,
	  isEmpty: _react.PropTypes.bool,
	  isLive: _react.PropTypes.bool,
	  isInline: _react.PropTypes.bool
	};
	
	exports.default = ForumThread;

/***/ },

/***/ "./src/members/Main/__shared__/containers/ForumThreadsList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/members/Main/__shared__/containers/ForumThreadsList/style.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ForumThreadsList = function ForumThreadsList(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ForumThreadsList' },
	    props.title && _react2.default.createElement(
	      'div',
	      { className: 'head' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        props.title
	      )
	    ),
	    props.children
	  );
	};
	
	ForumThreadsList.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.element), _react.PropTypes.element]),
	  title: _react.PropTypes.string
	};
	
	exports.default = ForumThreadsList;

/***/ },

/***/ "./src/members/Main/__shared__/containers/Goals/Goal/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/members/Main/__shared__/containers/Goals/Goal/style.scss");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Goal = function Goal(props) {
	  var isEmpty = props.isEmpty,
	      _props$goal = props.goal,
	      goal = _props$goal === undefined ? {} : _props$goal;
	
	
	  function handleMinusClick() {
	    props.onDecrease(goal);
	  }
	
	  function handlePlusClick() {
	    props.onIncrease(goal);
	  }
	
	  var className = (0, _classnames2.default)('Goal', { 'is-empty': isEmpty });
	
	  return _react2.default.createElement(
	    'tr',
	    { className: className },
	    _react2.default.createElement(
	      'td',
	      null,
	      _react2.default.createElement(
	        'h5',
	        null,
	        goal.goal
	      )
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'score' },
	        _react2.default.createElement(
	          'div',
	          { className: 'number' },
	          goal.score
	        ),
	        _react2.default.createElement('div', { className: 'icon-minus', onClick: handleMinusClick }),
	        _react2.default.createElement('div', { className: 'icon-plus', onClick: handlePlusClick })
	      )
	    )
	  );
	};
	
	Goal.propTypes = {
	  goal: _entities.GoalShape,
	  isEmpty: _react.PropTypes.bool,
	  onIncrease: _react.PropTypes.func,
	  onDecrease: _react.PropTypes.func
	};
	
	exports.default = Goal;

/***/ },

/***/ "./src/members/Main/__shared__/containers/Goals/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	__webpack_require__("./src/members/Main/__shared__/containers/Goals/style.scss");
	
	var _Goal = __webpack_require__("./src/members/Main/__shared__/containers/Goals/Goal/index.js");
	
	var _Goal2 = _interopRequireDefault(_Goal);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Goals = function (_Component) {
	  _inherits(Goals, _Component);
	
	  function Goals() {
	    _classCallCheck(this, Goals);
	
	    return _possibleConstructorReturn(this, (Goals.__proto__ || Object.getPrototypeOf(Goals)).apply(this, arguments));
	  }
	
	  _createClass(Goals, [{
	    key: 'renderGoals',
	    value: function renderGoals() {
	      var _this2 = this;
	
	      return this.props.goals.map(function (goal, i) {
	        return _react2.default.createElement(_Goal2.default, {
	          key: i,
	          goal: goal,
	          onIncrease: _this2.props.onGoalIncrease,
	          onDecrease: _this2.props.onGoalDecrease
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Goals' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                "Your goals"
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                "Score"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            this.renderGoals()
	          )
	        )
	      );
	    }
	  }]);
	
	  return Goals;
	}(_react.Component);
	
	Goals.propTypes = {
	  goals: _react.PropTypes.arrayOf(_entities.GoalShape),
	  source: _react.PropTypes.string,
	  onGoalIncrease: _react.PropTypes.func,
	  onGoalDecrease: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var goalsUpdates = ownProps.goals.map(function (goal) {
	    return goal.updatedAt;
	  });
	  goalsUpdates.sort(function (date1, date2) {
	    return date2 - date1;
	  });
	
	  return {
	    lastUpdated: goalsUpdates[0]
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onGoalDecrease: function onGoalDecrease(goal) {
	      var goalScore = goal.score - 1;
	      if (goalScore >= (0)) {
	        dispatch(actions.goalUpdate(goal.id, goal, {
	          score: goalScore
	        }, props.source));
	      }
	    },
	    onGoalIncrease: function onGoalIncrease(goal) {
	      var goalScore = goal.score + 1;
	      if (goalScore <= (10)) {
	        dispatch(actions.goalUpdate(goal.id, goal, {
	          score: goalScore
	        }, props.source));
	      }
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Goals);

/***/ },

/***/ "./src/members/Main/__shared__/containers/JournalEntryForm/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAutosizeTextarea = __webpack_require__("./node_modules/react-autosize-textarea/index.js");
	
	var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);
	
	var _reactEmojione = __webpack_require__("./node_modules/react-emojione/lib/react-emojione.js");
	
	var _Button = __webpack_require__("./src/members/Main/__shared__/components/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	__webpack_require__("./src/members/Main/__shared__/containers/JournalEntryForm/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JournalEntryForm = function (_Component) {
	  _inherits(JournalEntryForm, _Component);
	
	  function JournalEntryForm() {
	    _classCallCheck(this, JournalEntryForm);
	
	    var _this = _possibleConstructorReturn(this, (JournalEntryForm.__proto__ || Object.getPrototypeOf(JournalEntryForm)).call(this));
	
	    _this.handleEmotionChange = _this.handleEmotionChange.bind(_this);
	    _this.handleReasonChange = _this.handleReasonChange.bind(_this);
	    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(JournalEntryForm, [{
	    key: 'handleReasonChange',
	    value: function handleReasonChange(event) {
	      this.props.onReasonChange(event.target.value);
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(event) {
	      event.preventDefault();
	      var _props = this.props,
	          selectedEmoji = _props.selectedEmoji,
	          reason = _props.reason;
	
	      if (selectedEmoji && reason) {
	        this.props.onEntryCreate(selectedEmoji, reason);
	      }
	    }
	  }, {
	    key: 'handleEmotionChange',
	    value: function handleEmotionChange(emoji) {
	      this.props.onEmotionChange(emoji);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'JournalEntryForm' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          this.props.text
	        ),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleFormSubmit },
	          _react2.default.createElement(
	            'div',
	            { className: 'mood-list' },
	            this.props.emojis.map(function (emoji, i) {
	              var className = (0, _classnames2.default)('mood', {
	                active: _this2.props.selectedEmoji === emoji
	              });
	
	              return _react2.default.createElement(
	                'div',
	                {
	                  className: className,
	                  role: 'button',
	                  key: i,
	                  onClick: function onClick() {
	                    return _this2.handleEmotionChange(emoji);
	                  }
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _reactEmojione.emojify)(emoji, { output: 'unicode' })
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-field-wrapper' },
	            this.props.shouldRenderOnOneLine ? _react2.default.createElement('input', {
	              type: 'text',
	              value: this.props.reason,
	              placeholder: "Share a reason?",
	              onChange: this.handleReasonChange
	            }) : _react2.default.createElement(_reactAutosizeTextarea2.default, {
	              value: this.props.reason,
	              placeholder: "Share a reason?",
	              onChange: this.handleReasonChange
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              isYellow: true,
	              iconType: 'preloader-dark',
	              hasIcon: this.props.isSubmitting,
	              onClick: this.handleFormSubmit,
	              isDisabled: !this.props.reason || !this.props.selectedEmoji || this.props.isSubmitting
	            },
	            "Submit"
	          )
	        )
	      );
	    }
	  }]);
	
	  return JournalEntryForm;
	}(_react.Component);
	
	JournalEntryForm.propTypes = {
	  shouldRenderOnOneLine: _react.PropTypes.bool,
	  title: _react.PropTypes.string,
	  text: _react.PropTypes.string,
	  emojis: _react.PropTypes.arrayOf(_react2.default.PropTypes.string),
	  reason: _react.PropTypes.string,
	  selectedEmoji: _react.PropTypes.string,
	  isSubmitting: _react.PropTypes.bool,
	  onReasonChange: _react.PropTypes.func,
	  onEmotionChange: _react.PropTypes.func,
	  onEntryCreate: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _getJournalCreation = (0, _selectors.getJournalCreation)(state),
	      emoji = _getJournalCreation.emoji,
	      text = _getJournalCreation.text,
	      isSubmitting = _getJournalCreation.isSubmitting;
	
	  return {
	    selectedEmoji: emoji,
	    reason: text,
	    isSubmitting: isSubmitting
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onReasonChange: function onReasonChange(text) {
	      dispatch(actions.journalCreationChange({ text: text }));
	    },
	    onEmotionChange: function onEmotionChange(emoji) {
	      dispatch(actions.journalCreationChange({ emoji: emoji }));
	    },
	    onEntryCreate: function onEntryCreate(emoji, text) {
	      dispatch(actions.journalEntryCreate(emoji, text, "You have succesfully created an entry in your journal!"));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JournalEntryForm);

/***/ },

/***/ "./src/members/Main/__shared__/containers/MagazineArticle/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__("./node_modules/react-addons-shallow-compare/index.js");
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _Article = __webpack_require__("./src/members/Main/__shared__/components/ArticleOuter/Article/index.js");
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _quantity = __webpack_require__("./src/__shared__/quantity.js");
	
	var _quantity2 = _interopRequireDefault(_quantity);
	
	var _bbCodeRemover = __webpack_require__("./src/__shared__/bbCodeRemover.js");
	
	var _bbCodeRemover2 = _interopRequireDefault(_bbCodeRemover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MagazineArticle = function (_Component) {
	  _inherits(MagazineArticle, _Component);
	
	  function MagazineArticle() {
	    _classCallCheck(this, MagazineArticle);
	
	    return _possibleConstructorReturn(this, (MagazineArticle.__proto__ || Object.getPrototypeOf(MagazineArticle)).apply(this, arguments));
	  }
	
	  _createClass(MagazineArticle, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          magazineArticle = _props.magazineArticle,
	          otherProps = _objectWithoutProperties(_props, ['magazineArticle']);
	
	      var summary = magazineArticle.summary;
	
	      var excerpt = summary ? (0, _bbCodeRemover2.default)(summary) : '';
	
	      return _react2.default.createElement(_Article2.default, _extends({
	        excerpt: excerpt,
	        title: magazineArticle.title,
	        date: magazineArticle.createdAt,
	        authorName: magazineArticle.author.userName,
	        authorAvatarUrl: magazineArticle.author.avatar.url,
	        commentsInfo: magazineArticle.commentCount + ' ' + (0, _quantity2.default)(magazineArticle.commentCount, "comment", "comments"),
	        categories: magazineArticle.topics.map(function (_ref) {
	          var id = _ref.id,
	              title = _ref.title;
	          return { url: '/magazine?topic=' + id, name: title };
	        }),
	        createdAt: (0, _moment2.default)(magazineArticle.createdAt).format(("MMMM Do YYYY, h:mm a")),
	        articleUrl: 'magazine/articles/' + magazineArticle.id
	      }, otherProps));
	    }
	  }]);
	
	  return MagazineArticle;
	}(_react.Component);
	
	MagazineArticle.propTypes = {
	  magazineArticle: _entities.MagazineArticleShape
	};
	
	exports.default = MagazineArticle;

/***/ },

/***/ "./src/members/Main/__shared__/containers/MagazineArticlesSidebar/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _Sidebar = __webpack_require__("./src/members/Main/__shared__/components/Sidebar/index.js");
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _SidebarGroup = __webpack_require__("./src/members/Main/__shared__/components/Sidebar/SidebarGroup/index.js");
	
	var _SidebarGroup2 = _interopRequireDefault(_SidebarGroup);
	
	var _SidebarGroupItem = __webpack_require__("./src/members/Main/__shared__/components/Sidebar/SidebarGroup/SidebarGroupItem/index.js");
	
	var _SidebarGroupItem2 = _interopRequireDefault(_SidebarGroupItem);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MagazineArticleSidebar = function (_Component) {
	  _inherits(MagazineArticleSidebar, _Component);
	
	  function MagazineArticleSidebar() {
	    _classCallCheck(this, MagazineArticleSidebar);
	
	    return _possibleConstructorReturn(this, (MagazineArticleSidebar.__proto__ || Object.getPrototypeOf(MagazineArticleSidebar)).apply(this, arguments));
	  }
	
	  _createClass(MagazineArticleSidebar, [{
	    key: 'renderMagazineArticles',
	    value: function renderMagazineArticles(magazineArticles) {
	      return magazineArticles.map(function (magazineArticle) {
	        return _react2.default.createElement(_SidebarGroupItem2.default, {
	          key: magazineArticle.id,
	          title: magazineArticle.title,
	          authorName: magazineArticle.author.userName,
	          authorAvatarUrl: magazineArticle.author.avatar.url,
	          articleUrl: '/magazine/articles/' + magazineArticle.id
	        });
	      });
	    }
	  }, {
	    key: 'renderMagazineArticlesGroups',
	    value: function renderMagazineArticlesGroups(magazineArticlesGroups) {
	      var _this2 = this;
	
	      return magazineArticlesGroups.map(function (magazineArticlesGroup) {
	        var magazineArticles = magazineArticlesGroup.magazineArticles;
	
	
	        return _react2.default.createElement(
	          _SidebarGroup2.default,
	          { key: magazineArticlesGroup.title, title: magazineArticlesGroup.title },
	          _this2.renderMagazineArticles(magazineArticles)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Sidebar2.default,
	        { isWider: this.props.isWider },
	        this.renderMagazineArticlesGroups(this.props.magazineArticlesGroups)
	      );
	    }
	  }]);
	
	  return MagazineArticleSidebar;
	}(_react.Component);
	
	MagazineArticleSidebar.propTypes = {
	  queries: _react.PropTypes.object,
	  selectedQueryString: _react.PropTypes.string,
	  magazineArticlesGroups: _react.PropTypes.array,
	  isWider: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var magazineArticlesGroups = [];
	
	  Object.keys(props.queries).forEach(function (key) {
	    var queryString = JSON.stringify(_extends({}, props.queries[key].query));
	    var title = props.queries[key].title;
	
	    if (queryString !== props.selectedQueryString) {
	      var allMagazineArticles = (0, _selectors.getMagazineArticlesOnSidebar)(state, { page: 1, queryString: queryString });
	      var magazineArticles = allMagazineArticles.slice(0, Math.min(3, allMagazineArticles.length));
	
	      if (magazineArticlesGroups.length < 2 && magazineArticles.length > 0) {
	        magazineArticlesGroups.push({
	          title: title,
	          magazineArticles: magazineArticles
	        });
	      }
	    }
	  });
	
	  return {
	    magazineArticlesGroups: magazineArticlesGroups
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MagazineArticleSidebar);

/***/ },

/***/ "./src/members/Main/__shared__/containers/ResourceCategoriesAccordion/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reactScroll = __webpack_require__("./node_modules/react-scroll/lib/index.js");
	
	var _Accordion = __webpack_require__("./src/members/Main/__shared__/components/Accordion/index.js");
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _AccordionItem = __webpack_require__("./src/members/Main/__shared__/components/Accordion/AccordionItem/index.js");
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _quantity = __webpack_require__("./src/__shared__/quantity.js");
	
	var _quantity2 = _interopRequireDefault(_quantity);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceCategoriesAccordion = function (_Component) {
	  _inherits(ResourceCategoriesAccordion, _Component);
	
	  function ResourceCategoriesAccordion() {
	    _classCallCheck(this, ResourceCategoriesAccordion);
	
	    var _this = _possibleConstructorReturn(this, (ResourceCategoriesAccordion.__proto__ || Object.getPrototypeOf(ResourceCategoriesAccordion)).call(this));
	
	    _this.handleCategoryOpen = _this.handleCategoryOpen.bind(_this);
	    _this.countInfo = _this.countInfo.bind(_this);
	    _this.renderTopics = _this.renderTopics.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(ResourceCategoriesAccordion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onDidMount) {
	        this.props.onDidMount();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onWillUnmount) {
	        this.props.onWillUnmount();
	      }
	    }
	  }, {
	    key: 'handleCategoryOpen',
	    value: function handleCategoryOpen(itemOffset) {
	      var parentOffset = this.props.scrollElementGetter().offsetTop;
	      _reactScroll.animateScroll.scrollTo(itemOffset - parentOffset, { duration: 600 });
	    }
	  }, {
	    key: 'handleCategoryClick',
	    value: function handleCategoryClick(category) {
	      if (this.props.onCategoryClick) {
	        this.props.onCategoryClick(category, this.props.selectedCategory);
	      }
	    }
	  }, {
	    key: 'renderAccordionItemsForLoading',
	    value: function renderAccordionItemsForLoading() {
	      return [_react2.default.createElement(_AccordionItem2.default, { key: 'loader1', isEmpty: true }), _react2.default.createElement(_AccordionItem2.default, { key: 'loader2', isEmpty: true }), _react2.default.createElement(_AccordionItem2.default, { key: 'loader3', isEmpty: true })];
	    }
	  }, {
	    key: 'renderTopics',
	    value: function renderTopics(category, topicsForSelectedCategory) {
	      var _this2 = this;
	
	      if (topicsForSelectedCategory.length > 0) {
	        return topicsForSelectedCategory.map(function (topic) {
	          return _this2.props.renderTopic(topic, _this2.countInfo);
	        });
	      } else {
	        return this.renderAccordionItemsForLoading();
	      }
	    }
	  }, {
	    key: 'countInfo',
	    value: function countInfo(categoryOrTopic) {
	      var resourceCountInfo = categoryOrTopic.resourceCount + ' ' + (0, _quantity2.default)(categoryOrTopic.resourceCount, this.props.resourceNameSingular, this.props.resourceNamePlural);
	      var usersCountInfo = categoryOrTopic.userCount + ' ' + (0, _quantity2.default)(categoryOrTopic.userCount, "user", "users");
	
	      return resourceCountInfo + ' ' + usersCountInfo;
	    }
	  }, {
	    key: 'renderCategories',
	    value: function renderCategories(selectedCategory, topicsForSelectedCategory) {
	      var _this3 = this;
	
	      return this.props.categories.map(function (category) {
	        var shouldRenderTopics = selectedCategory && category.id == selectedCategory.id;
	        var topics = shouldRenderTopics ? _this3.renderTopics(category, topicsForSelectedCategory) : [];
	
	        return _react2.default.createElement(
	          _AccordionItem2.default,
	          {
	            key: category.id,
	            title: category.title,
	            countInfo: _this3.countInfo(category),
	            onClick: function onClick() {
	              return _this3.handleCategoryClick(category);
	            },
	            isGroup: true,
	            onItemOpen: _this3.handleCategoryOpen,
	            imageUrl: category.thumbnail.url,
	            isExpanded: shouldRenderTopics,
	            isForForum: _this3.props.isForForum,
	            isForMagazine: _this3.props.isForMagazine },
	          topics
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        _Accordion2.default,
	        null,
	        function () {
	          if (_this4.props.categories.length == 0) {
	            return _this4.renderAccordionItemsForLoading();
	          }
	
	          return _this4.renderCategories(_this4.props.selectedCategory, _this4.props.topicsForSelectedCategory);
	        }()
	      );
	    }
	  }]);
	
	  return ResourceCategoriesAccordion;
	}(_react.Component);
	
	ResourceCategoriesAccordion.propTypes = {
	  categories: _react.PropTypes.arrayOf(_entities.CategoryShape),
	  selectedCategory: _entities.CategoryShape,
	  topicsForSelectedCategory: _react.PropTypes.arrayOf(_entities.TopicShape),
	  renderTopic: _react.PropTypes.func.isRequired,
	  resourceType: _react.PropTypes.string,
	  resourceNameSingular: _react.PropTypes.string,
	  resourceNamePlural: _react.PropTypes.string,
	  isForForum: _react.PropTypes.bool,
	  isForMagazine: _react.PropTypes.bool,
	  scrollElementGetter: _react.PropTypes.func,
	  onCategoryOpen: _react.PropTypes.func,
	  onCategoryClick: _react.PropTypes.func,
	  onDidMount: _react.PropTypes.func,
	  onWillUnmount: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var selectedCategory = (0, _selectors.getCategorySelected)(state, props.resourceType);
	  var topicsForSelectedCategory = selectedCategory ? (0, _selectors.getTopics)(state, selectedCategory.id) : [];
	
	  return {
	    categories: (0, _selectors.getCategories)(state),
	    selectedCategory: selectedCategory,
	    topicsForSelectedCategory: topicsForSelectedCategory
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onDidMount: function onDidMount() {
	      dispatch(actions.categoriesFetch(props.resourceType));
	    },
	    onWillUnmount: function onWillUnmount() {
	      dispatch(actions.categorySelect(props.resourceType, null));
	    },
	    onCategoryClick: function onCategoryClick(category, selectedCategory) {
	      if (selectedCategory && category.id === selectedCategory.id) {
	        dispatch(actions.categorySelect(props.resourceType, null));
	      } else {
	        dispatch(actions.categorySelect(props.resourceType, category.id));
	        dispatch(actions.topicsFetch(props.resourceType, category.id));
	      }
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceCategoriesAccordion);

/***/ },

/***/ "./src/members/Main/__shared__/containers/ResourceCommentsList/ResourceComment/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__("./node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reactNl2br = __webpack_require__("./node_modules/react-nl2br/index.js");
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	var _reactEmojione = __webpack_require__("./node_modules/react-emojione/lib/react-emojione.js");
	
	var _quantity = __webpack_require__("./src/__shared__/quantity.js");
	
	var _quantity2 = _interopRequireDefault(_quantity);
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _Comment = __webpack_require__("./src/members/Main/__shared__/components/CommentsList/Comment/index.js");
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _ResourceCommentsPageSelector = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCommentsPageSelector/index.js");
	
	var _ResourceCommentsPageSelector2 = _interopRequireDefault(_ResourceCommentsPageSelector);
	
	var _ResourceCommentsTextEditor = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCommentsTextEditor/index.js");
	
	var _ResourceCommentsTextEditor2 = _interopRequireDefault(_ResourceCommentsTextEditor);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceComment = function (_Component) {
	  _inherits(ResourceComment, _Component);
	
	  function ResourceComment() {
	    _classCallCheck(this, ResourceComment);
	
	    var _this = _possibleConstructorReturn(this, (ResourceComment.__proto__ || Object.getPrototypeOf(ResourceComment)).call(this));
	
	    _this.handleMarkAsUseful = _this.handleMarkAsUseful.bind(_this);
	    _this.handleUnmarkAsUseful = _this.handleUnmarkAsUseful.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResourceComment, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      // we only care about this comment, otherwise commentsById prop will make it update on changes in any other comment
	      return this.props.comment != nextProps.comment || this.props.isFetchingReplies != nextProps.isFetchingReplies;
	    }
	  }, {
	    key: 'renderLoadingReplies',
	    value: function renderLoadingReplies() {
	      return [_react2.default.createElement(_Comment2.default, { key: 'loader1', isEmpty: true }), _react2.default.createElement(_Comment2.default, { key: 'loader2', isEmpty: true }), _react2.default.createElement(_Comment2.default, { key: 'loader3', isEmpty: true })];
	    }
	  }, {
	    key: 'handleMarkAsUseful',
	    value: function handleMarkAsUseful(commentId) {
	      this.props.onMarkAsUseful && this.props.onMarkAsUseful(this.props.commentsById[commentId]);
	    }
	  }, {
	    key: 'handleUnmarkAsUseful',
	    value: function handleUnmarkAsUseful(commentId) {
	      this.props.onUnmarkAsUseful && this.props.onUnmarkAsUseful(this.props.commentsById[commentId]);
	    }
	  }, {
	    key: 'renderComment',
	    value: function renderComment(comment, parentCommentId, commentsById, canBeRepliedTo) {
	      var _this2 = this;
	
	      var repliesIds = comment.replies;
	      var replies = null;
	
	      if (repliesIds) {
	        replies = repliesIds.map(function (replyId) {
	          return commentsById[replyId];
	        });
	      }
	
	      var ref = null;
	
	      if (this.props.commentOrReplyRef && this.props.commentOrReplyId === comment.id) {
	        ref = function ref(value) {
	          return _this2.props.commentOrReplyRef(value);
	        };
	      }
	
	      return _react2.default.createElement(
	        _Comment2.default,
	        {
	          isRoot: parentCommentId === null,
	          key: comment.id,
	          isHighlighted: comment.isHighlighted,
	          ref: ref,
	          commentId: comment.id,
	          canBeRepliedTo: canBeRepliedTo,
	          text: (0, _reactNl2br2.default)((0, _reactEmojione.emojify)(comment.text, { output: 'unicode' })),
	          authorName: comment.author.userName,
	          authorAvatar: comment.author.avatar.url,
	          since: (0, _moment2.default)(comment.createdAt).fromNow(),
	          repliesInfo: comment.replyCount + ' ' + (0, _quantity2.default)(comment.replyCount, "reply", "replies"),
	          canViewReplies: comment.replyCount > 0,
	          isMarkedAsUseful: comment.useful,
	          canBeMarkedAsUseful: parentCommentId === null,
	          onViewReplies: this.props.onViewReplies,
	          onHideReplies: this.props.onHideReplies,
	          onReply: this.props.onReply,
	          onCancelReply: this.props.onCancelReply,
	          onMarkAsUseful: this.handleMarkAsUseful,
	          onUnmarkAsUseful: this.handleUnmarkAsUseful },
	        function () {
	          // Replies are not cached by page so we reload them each time.
	          if (_this2.props.isFetchingReplies) {
	            return _this2.renderLoadingReplies();
	          } else if (replies) {
	            return replies.map(function (reply) {
	              return _this2.renderComment(reply, comment.id, commentsById, false);
	            });
	          }
	        }()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          comment = _props.comment,
	          commentsById = _props.commentsById,
	          repliesPagesCount = _props.repliesPagesCount,
	          canBeRepliedTo = _props.canBeRepliedTo;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ResourceComment' },
	        this.renderComment(comment, null, commentsById, canBeRepliedTo),
	        comment.isBeingRepliedTo && _react2.default.createElement(_ResourceCommentsTextEditor2.default, { resourceType: this.props.repliesResourceType, resourceId: comment.id, isExpanded: true, shouldFocusOnMountAndUpdate: true }),
	        repliesPagesCount > 1 && comment.replies && _react2.default.createElement(
	          'div',
	          { className: 'pagination-wrapper-inner' },
	          _react2.default.createElement(_ResourceCommentsPageSelector2.default, {
	            pageSize: (3),
	            resourceType: this.props.repliesResourceType,
	            resourceId: comment.id })
	        )
	      );
	    }
	  }]);
	
	  return ResourceComment;
	}(_react.Component);
	
	ResourceComment.propTypes = {
	  comment: _entities.CommentShape,
	  repliesResourceType: _react.PropTypes.string,
	  commentReplyingId: _react.PropTypes.number,
	  repliesPagesCount: _react.PropTypes.number,
	  commentsById: _react.PropTypes.object,
	  isFetchingReplies: _react.PropTypes.bool,
	  commentOrReplyRef: _react.PropTypes.func,
	  commentOrReplyId: _react.PropTypes.number,
	  canBeRepliedTo: _react.PropTypes.bool,
	  onViewReplies: _react.PropTypes.func,
	  onHideReplies: _react.PropTypes.func,
	  onReply: _react.PropTypes.func,
	  onCancelReply: _react.PropTypes.func,
	  onMarkAsUseful: _react.PropTypes.func,
	  onUnmarkAsUseful: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	
	  return {
	    commentsById: (0, _selectors.getCommentsById)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onViewReplies: function onViewReplies(commentId) {
	      var query = { resourceId: commentId, resourceType: props.repliesResourceType };
	
	      dispatch(actions.commentsFetch(1, (3), query));
	    },
	    onHideReplies: function onHideReplies(commentId) {
	      dispatch(actions.commentUpdate(commentId, null, { replies: null }));
	    },
	    onReply: function onReply(commentId) {
	      dispatch(actions.commentReplyBegin(commentId));
	    },
	    onCancelReply: function onCancelReply() {
	      dispatch(actions.commentReplyCancel());
	    },
	    onMarkAsUseful: function onMarkAsUseful(comment) {
	      dispatch(actions.commentUpdate(comment.id, comment, { useful: true }));
	    },
	    onUnmarkAsUseful: function onUnmarkAsUseful(comment) {
	      dispatch(actions.commentUpdate(comment.id, comment, { useful: false }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceComment);

/***/ },

/***/ "./src/members/Main/__shared__/containers/ResourceCommentsList/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _CommentsList = __webpack_require__("./src/members/Main/__shared__/components/CommentsList/index.js");
	
	var _CommentsList2 = _interopRequireDefault(_CommentsList);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _ResourceComment = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCommentsList/ResourceComment/index.js");
	
	var _ResourceComment2 = _interopRequireDefault(_ResourceComment);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _entities = __webpack_require__("./src/members/Main/__shared__/entities.js");
	
	var _ResourceCommentsPageSelector = __webpack_require__("./src/members/Main/__shared__/containers/ResourceCommentsPageSelector/index.js");
	
	var _ResourceCommentsPageSelector2 = _interopRequireDefault(_ResourceCommentsPageSelector);
	
	var _Comment = __webpack_require__("./src/members/Main/__shared__/components/CommentsList/Comment/index.js");
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	var _InfoBar = __webpack_require__("./src/members/Main/__shared__/components/InfoBar/index.js");
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	__webpack_require__("./src/members/Main/__shared__/containers/ResourceCommentsList/style.scss");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function highlihgtedIdForUrlParams() {
	  var urlParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var commentOrReplyId = null;
	  var commentId = urlParams.commentId,
	      commentsPage = urlParams.commentsPage,
	      repliesPage = urlParams.repliesPage,
	      replyId = urlParams.replyId;
	
	
	  if (commentsPage && commentId) {
	    if (repliesPage && replyId) {
	      commentOrReplyId = Number(replyId);
	    } else {
	      commentOrReplyId = Number(commentId);
	    }
	  }
	
	  return commentOrReplyId;
	}
	
	var ResourceCommentsList = function (_Component) {
	  _inherits(ResourceCommentsList, _Component);
	
	  function ResourceCommentsList() {
	    _classCallCheck(this, ResourceCommentsList);
	
	    return _possibleConstructorReturn(this, (ResourceCommentsList.__proto__ || Object.getPrototypeOf(ResourceCommentsList)).apply(this, arguments));
	  }
	
	  _createClass(ResourceCommentsList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onDidMount && this.props.onDidMount(this.props.sort);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.props.onDidUpdate && this.props.onDidUpdate(prevProps, this.props.sort);
	
	      if (this.commentToScrollTo) {
	        var commentDOMNode = _reactDom2.default.findDOMNode(this.commentToScrollTo);
	        var scrollElementDOMNode = _reactDom2.default.findDOMNode(this.props.scrollElementGetter());
	
	        window.scrollTo(0, commentDOMNode.getBoundingClientRect().top + window.scrollY - scrollElementDOMNode.offsetTop);
	        this.commentToScrollTo = null;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onWillUnmount && this.props.onWillUnmount();
	    }
	  }, {
	    key: 'renderComments',
	    value: function renderComments(comments, repliesResourceType) {
	      var _this2 = this;
	
	      return comments.map(function (comment) {
	        var paging = _this2.props.nestedCommentsPaging[comment.repliesQueryString];
	        var commentOrReplyId = highlihgtedIdForUrlParams(_this2.props.urlParams);
	        var commentOrReplyRef = commentOrReplyId !== null ? function (value) {
	          return _this2.commentToScrollTo = value;
	        } : null;
	
	        return _react2.default.createElement(_ResourceComment2.default, {
	          key: comment.id,
	          commentOrReplyRef: commentOrReplyRef,
	          commentOrReplyId: commentOrReplyId,
	          canBeRepliedTo: _this2.props.canCommentsBeRepliedTo,
	          repliesResourceType: repliesResourceType,
	          repliesPagesCount: paging ? paging.pagesCount : 0,
	          comment: comment,
	          isFetchingReplies: paging && paging.isFetching
	        });
	      });
	    }
	  }, {
	    key: 'renderLoadingComments',
	    value: function renderLoadingComments() {
	      return [_react2.default.createElement(_Comment2.default, { key: 'loader1', isEmpty: true }), _react2.default.createElement(_Comment2.default, { key: 'loader2', isEmpty: true }), _react2.default.createElement(_Comment2.default, { key: 'loader3', isEmpty: true })];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ResourceCommentsList' },
	        this.props.isSuccessInfoBarVisible && _react2.default.createElement(_InfoBar2.default, {
	          type: 'primary',
	          message: this.props.successInfoBarMessage,
	          title: this.props.successInfoBarTitle,
	          onClose: this.props.onInfoBarClose }),
	        _react2.default.createElement(
	          _CommentsList2.default,
	          { sortOptionsPairs: [{ value: 'recent', title: "MOST RECENT" }, { value: 'useful', title: "MOST USEFUL" }],
	            selectedSortOption: this.props.sort,
	            onSortOptionChange: this.props.onSortOptionChange,
	            isFollowed: this.props.isFollowed,
	            allowsSorting: this.props.comments.length > 0,
	            onFollow: this.props.onFollow,
	            onUnfollow: this.props.onUnfollow },
	          function () {
	            if (_this3.props.comments.length > 0) {
	              return _this3.renderComments(_this3.props.comments, _this3.props.repliesResourceType);
	            } else if (_this3.props.isFetching) {
	              return _this3.renderLoadingComments();
	            }
	          }()
	        ),
	        this.props.pagesCount > 1 && _react2.default.createElement(
	          'div',
	          { className: 'pagination-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper-xlarge' },
	            _react2.default.createElement(_ResourceCommentsPageSelector2.default, {
	              pageSize: (10),
	              sort: this.props.sort,
	              resourceType: this.props.resourceType,
	              resourceId: this.props.resourceId })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResourceCommentsList;
	}(_react.Component);
	
	ResourceCommentsList.propTypes = {
	  resourceId: _react.PropTypes.number,
	  resourceType: _react.PropTypes.string,
	  repliesResourceType: _react.PropTypes.string,
	  comments: _react.PropTypes.arrayOf(_entities.CommentShape),
	  nestedCommentsPaging: _react.PropTypes.object,
	  isFetching: _react.PropTypes.bool,
	  sort: _react.PropTypes.string,
	  pagesCount: _react.PropTypes.number,
	  currentPage: _react.PropTypes.number,
	  isSuccessInfoBarVisible: _react.PropTypes.bool,
	  canCommentsBeRepliedTo: _react.PropTypes.bool,
	  isFollowed: _react.PropTypes.bool,
	  successInfoBarMessage: _react.PropTypes.string,
	  successInfoBarTitle: _react.PropTypes.string,
	  urlParams: _react.PropTypes.object,
	  onDidMount: _react.PropTypes.func,
	  onWillUnmount: _react.PropTypes.func,
	  onCommentViewReplies: _react.PropTypes.func,
	  onCommentHideReplies: _react.PropTypes.func,
	  onCommentReply: _react.PropTypes.func,
	  onCommentCancelReply: _react.PropTypes.func,
	  onInfoBarClose: _react.PropTypes.func,
	  onSortOptionChange: _react.PropTypes.func,
	  onDidUpdate: _react.PropTypes.func,
	  onFollow: _react.PropTypes.func,
	  onUnfollow: _react.PropTypes.func,
	  scrollElementGetter: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var sort = (0, _selectors.getCommentsSort)(state);
	  var query = { resourceId: props.resourceId, resourceType: props.resourceType, sort: sort };
	  var queryString = JSON.stringify(query);
	
	  var _getCommentsPaging = (0, _selectors.getCommentsPaging)(state, null, { queryString: queryString }),
	      page = _getCommentsPaging.page,
	      isFetching = _getCommentsPaging.isFetching,
	      pagesCount = _getCommentsPaging.pagesCount;
	
	  var successState = (0, _selectors.getInfoState)(state, 'success');
	
	  return {
	    comments: (0, _selectors.getComments)(state, { queryString: queryString, page: page }),
	    nestedCommentsPaging: (0, _selectors.getNestedCommentsPagingState)(state),
	    sort: sort,
	    isFetching: isFetching,
	    currentPage: page,
	    pagesCount: pagesCount,
	    isSuccessInfoBarVisible: successState.visible,
	    successInfoBarMessage: successState.message,
	    successInfoBarTitle: successState.title
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  var reset = function reset() {
	    dispatch(actions.commentReplyCancel());
	    dispatch(actions.commentReset('firstLevel'));
	    dispatch(actions.commentEmojisHide('firstLevel'));
	    dispatch(actions.commentsResetRepliesRelatedProperties());
	  };
	
	  return {
	    onDidMount: function onDidMount(sort) {
	      var _props$urlParams = props.urlParams,
	          urlParams = _props$urlParams === undefined ? {} : _props$urlParams;
	      var commentsPage = urlParams.commentsPage,
	          commentId = urlParams.commentId,
	          repliesPage = urlParams.repliesPage,
	          replyId = urlParams.replyId;
	
	
	      var query = { resourceId: props.resourceId, resourceType: props.resourceType, sort: sort };
	      dispatch(actions.commentsFetch(Number(commentsPage) || 1, (10), query));
	
	      if (repliesPage && replyId) {
	        var _query = { resourceId: Number(commentId), resourceType: props.repliesResourceType };
	        dispatch(actions.commentsFetch(Number(repliesPage) || 1, (3), _query));
	      }
	
	      var highlightedCommentId = highlihgtedIdForUrlParams(urlParams);
	
	      if (highlightedCommentId !== null) {
	        dispatch(actions.commentUpdate(highlightedCommentId, null, { isHighlighted: true }));
	
	        if (highlightedCommentId !== commentId) {
	          dispatch(actions.commentUpdate(commentId, null, { hasHighlightedReply: true }));
	        }
	      }
	    },
	    onDidUpdate: function onDidUpdate(prevProps, sort) {
	      if (prevProps.resourceId !== props.resourceId) {
	        reset();
	
	        var query = { resourceId: props.resourceId, resourceType: props.resourceType, sort: sort };
	        dispatch(actions.commentsFetch(1, (10), query));
	      }
	    },
	    onSortOptionChange: function onSortOptionChange(sort) {
	      var query = { resourceId: props.resourceId, resourceType: props.resourceType, sort: sort };
	
	      dispatch(actions.commentsFetch(1, (10), query));
	      dispatch(actions.commentsChangeSort(sort));
	    },
	    onWillUnmount: function onWillUnmount() {
	      reset();
	    },
	    onInfoBarClose: function onInfoBarClose() {
	      dispatch(actions.infoClose('success'));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceCommentsList);

/***/ },

/***/ "./src/members/Main/__shared__/containers/ResourceCommentsPageSelector/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResourceCommentsPageSelector = undefined;
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageSelector = __webpack_require__("./src/members/Main/__shared__/components/PageSelector/index.js");
	
	var _PageSelector2 = _interopRequireDefault(_PageSelector);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ResourceCommentsPageSelector = function ResourceCommentsPageSelector(props) {
	  var resourceId = props.resourceId,
	      resourceType = props.resourceType,
	      otherProps = _objectWithoutProperties(props, ['resourceId', 'resourceType']); //eslint-disable-line no-unused-vars
	
	
	  return _react2.default.createElement(_PageSelector2.default, otherProps);
	};
	
	exports.ResourceCommentsPageSelector = ResourceCommentsPageSelector;
	ResourceCommentsPageSelector.propTypes = {
	  resourceId: _react.PropTypes.number,
	  resourceType: _react.PropTypes.string,
	  sort: _react.PropTypes.string,
	  pageSize: _react.PropTypes.number
	};
	
	var queryForProps = function queryForProps(props) {
	  return { resourceId: props.resourceId, resourceType: props.resourceType, sort: props.sort };
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var queryString = JSON.stringify(queryForProps(props));
	  return (0, _selectors.getCommentsPaging)(state, null, { queryString: queryString });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  var query = queryForProps(props);
	
	  return {
	    onPrevClick: function onPrevClick(currentPage) {
	      dispatch(actions.commentsFetch(currentPage - 1, props.pageSize, query));
	    },
	    onNextClick: function onNextClick(currentPage) {
	      dispatch(actions.commentsFetch(currentPage + 1, props.pageSize, query));
	    },
	    onPossiblePageUpdate: function onPossiblePageUpdate(newPossiblePage) {
	      dispatch(actions.commentsUpdatePossiblePage(newPossiblePage, query));
	    },
	    onPageUpdate: function onPageUpdate(newPage, pagesCount) {
	      if (newPage >= 1 && newPage <= pagesCount) {
	        dispatch(actions.commentsFetch(newPage, props.pageSize, query));
	      }
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceCommentsPageSelector);

/***/ },

/***/ "./src/members/Main/__shared__/containers/ResourceCommentsTextEditor/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _TextEditor = __webpack_require__("./src/members/Main/__shared__/components/TextEditor/index.js");
	
	var _TextEditor2 = _interopRequireDefault(_TextEditor);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceCommentsTextEditor = function (_Component) {
	  _inherits(ResourceCommentsTextEditor, _Component);
	
	  function ResourceCommentsTextEditor() {
	    _classCallCheck(this, ResourceCommentsTextEditor);
	
	    return _possibleConstructorReturn(this, (ResourceCommentsTextEditor.__proto__ || Object.getPrototypeOf(ResourceCommentsTextEditor)).apply(this, arguments));
	  }
	
	  _createClass(ResourceCommentsTextEditor, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(_TextEditor2.default, _extends({}, this.props, {
	        ref: 'textEditor',
	        contentTitle: "Your comment",
	        hasMediumHeight: true,
	        allowsCanceling: true,
	        maxChars: (10000),
	        placeholder: "Please write your comment here then press the submit button.",
	        onSubmit: function onSubmit(text) {
	          return _this2.props.onSubmit(text, _this2.props.userName);
	        }
	      }));
	    }
	  }]);
	
	  return ResourceCommentsTextEditor;
	}(_react.Component);
	
	ResourceCommentsTextEditor.propTypes = {
	  resourceType: _react.PropTypes.string,
	  isForNewComments: _react.PropTypes.bool,
	  userName: _react.PropTypes.string,
	  onSubmit: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var level = props.isForNewComments ? 'firstLevel' : 'secondLevel';
	  var textEditing = (0, _selectors.getCommentsTextEditing)(state, level);
	  var userName = (0, _selectors.getUserProfile)(state).userName;
	
	  return _extends({}, textEditing, {
	    isExpanded: textEditing.isExpanded || props.isExpanded,
	    showsEmojis: (0, _selectors.getCommentsEmojis)(state, level).areVisible,
	    userName: userName
	  });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  var level = props.isForNewComments ? 'firstLevel' : 'secondLevel';
	
	  return {
	    onTextUpdate: function onTextUpdate(text) {
	      dispatch(actions.commentUpdateText({ text: text, key: level }));
	    },
	    onSubmit: function onSubmit(text, userName) {
	      dispatch(actions.commentCreate(text, level, props.resourceType, props.resourceId, 'Thanks ' + userName, "Your comment has to be quickly double-checked by us before it’s posted. But don’t worry. We will let you know when it’s approved :)"));
	      dispatch(actions.commentEmojisHide(level));
	    },
	    onFocus: function onFocus() {
	      if (props.isForNewComments) {
	        dispatch(actions.commentExpand(level));
	      }
	    },
	    onCancel: function onCancel() {
	      if (props.isForNewComments) {
	        dispatch(actions.commentReset('firstLevel'));
	      } else {
	        dispatch(actions.commentReplyCancel());
	      }
	
	      dispatch(actions.commentEmojisHide(level));
	    },
	    onEmojisToggled: function onEmojisToggled(showsEmojis) {
	      if (showsEmojis) {
	        dispatch(actions.commentEmojisHide(level));
	      } else {
	        dispatch(actions.commentEmojisShow(level));
	      }
	    },
	    onEmojiSelected: function onEmojiSelected(text, emojiShortName, selectionStart) {
	      dispatch(actions.commentUpdateText({ text: text, emojiShortName: emojiShortName, selectionStart: selectionStart, key: level }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceCommentsTextEditor);

/***/ },

/***/ "./src/members/Main/__shared__/containers/SearchBar/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _bowser = __webpack_require__("./node_modules/bowser/src/bowser.js");
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchBar = function (_Component) {
	  _inherits(SearchBar, _Component);
	
	  function SearchBar(props) {
	    _classCallCheck(this, SearchBar);
	
	    var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchBar, [{
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var value = event.target.value;
	      this.props.onSearchQueryChange(value);
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(event) {
	      if (event.keyCode === 27 && this.props.onEscape) {
	        this.props.onEscape();
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      event.preventDefault();
	      this.props.onSearchInitiate(this.refs.input.value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'SearchBar' },
	        _react2.default.createElement(
	          'form',
	          { action: '.', onSubmit: this.handleSubmit },
	          _react2.default.createElement('input', {
	            type: 'search',
	            ref: 'input',
	            placeholder: "What are you searching for",
	            autoFocus: !_bowser2.default.mobile,
	            value: this.props.query,
	            onChange: this.handleChange,
	            onKeyUp: this.handleKeyUp
	          })
	        )
	      );
	    }
	  }]);
	
	  return SearchBar;
	}(_react.Component);
	
	SearchBar.propTypes = {
	  query: _react.PropTypes.string,
	  onSearchInitiate: _react.PropTypes.func,
	  onSearchQueryChange: _react.PropTypes.func,
	  onEscape: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return _extends({}, (0, _selectors.getSearchBar)(state));
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onSearchInitiate: function onSearchInitiate(term) {
	      dispatch(actions.searchInitiate(term));
	    },
	    onSearchQueryChange: function onSearchQueryChange(query) {
	      dispatch(actions.searchUpdateQuery(query));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchBar);

/***/ },

/***/ "./src/members/Main/__shared__/entities.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ForumThreadShape = exports.LinkShape = exports.SearchItemShape = exports.FeedGoalsShape = exports.FeedJournalShape = exports.FeedButtonShape = exports.FeedItemShape = exports.ReferralProvider = exports.ReferralLanguageShape = exports.ReferralSchoolShape = exports.ReferralLocationShape = exports.JournalEntryShape = exports.JournalEmojiShape = exports.CommentShape = exports.MagazineArticleShape = exports.CategoryShape = exports.CategoryThumbnailShape = exports.TopicShape = exports.AuthorShape = exports.ThumbnailShape = exports.ThumbnailResolutionShape = exports.MailThreadShape = exports.MailThreadMessageShape = exports.ChatItemShape = exports.GoalShape = exports.ChatWebsiteShape = exports.ChatDocumentShape = exports.ChatMessageShape = exports.ChatResourceShape = exports.QuestionnaireShape = exports.QuestionShape = exports.QuestionOptionShape = exports.AvatarShape = exports.DateType = exports.IdType = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var IdType = exports.IdType = _react.PropTypes.any;
	
	var DateType = exports.DateType = _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]);
	
	var AvatarShape = exports.AvatarShape = _react.PropTypes.shape({
	  id: IdType,
	  url: _react.PropTypes.string
	});
	
	var QuestionOptionShape = exports.QuestionOptionShape = _react.PropTypes.shape({
	  text: _react.PropTypes.text,
	  value: _react.PropTypes.node
	});
	
	var QuestionShape = exports.QuestionShape = _react.PropTypes.shape({
	  id: IdType,
	  text: _react.PropTypes.string,
	  answer: _react.PropTypes.node,
	  options: _react.PropTypes.arrayOf(QuestionOptionShape)
	});
	
	var QuestionnaireShape = exports.QuestionnaireShape = _react.PropTypes.shape({
	  id: IdType,
	  summary: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  questions: _react.PropTypes.arrayOf(QuestionShape)
	});
	
	var ChatResourceShape = exports.ChatResourceShape = _react.PropTypes.shape({
	  metadata: _react.PropTypes.shape({
	    title: _react.PropTypes.string
	  }),
	  data: _react.PropTypes.shape({
	    url: _react.PropTypes.string
	  }),
	  sender: _react.PropTypes.string,
	  sentAt: _react.PropTypes.string
	});
	
	var ChatMessageShape = exports.ChatMessageShape = _react.PropTypes.shape({
	  id: IdType,
	  fromCounsellor: _react.PropTypes.bool,
	  createdAt: DateType,
	  text: _react.PropTypes.string
	});
	
	var ChatDocumentShape = exports.ChatDocumentShape = _react.PropTypes.shape({
	  id: IdType,
	  name: _react.PropTypes.string,
	  url: _react.PropTypes.string
	});
	
	var ChatWebsiteShape = exports.ChatWebsiteShape = _react.PropTypes.shape({
	  id: IdType,
	  title: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  url: _react.PropTypes.string,
	  image: _react.PropTypes.string
	});
	
	var GoalShape = exports.GoalShape = _react.PropTypes.shape({
	  id: IdType,
	  goal: _react.PropTypes.string,
	  score: _react.PropTypes.number
	});
	
	var ChatItemShape = exports.ChatItemShape = _react.PropTypes.shape({
	  chatDocuemnt: ChatDocumentShape,
	  chatWebsite: ChatWebsiteShape,
	  chatQuestionnaire: QuestionnaireShape,
	  goals: _react.PropTypes.arrayOf(GoalShape)
	});
	
	var MailThreadMessageShape = exports.MailThreadMessageShape = _react.PropTypes.shape({
	  id: IdType,
	  read: _react.PropTypes.bool,
	  fromCounsellor: _react.PropTypes.fromCounsellor,
	  createdAt: DateType,
	  sender: _react.PropTypes.string,
	  avatar: AvatarShape
	});
	
	var MailThreadShape = exports.MailThreadShape = _react.PropTypes.shape({
	  id: IdType,
	  latestMessage: MailThreadMessageShape,
	  participant: _react.PropTypes.string,
	  avatar: AvatarShape
	});
	
	var ThumbnailResolutionShape = exports.ThumbnailResolutionShape = _react.PropTypes.shape({
	  highRes: _react.PropTypes.string,
	  lowRes: _react.PropTypes.string
	});
	
	var ThumbnailShape = exports.ThumbnailShape = _react.PropTypes.shape({
	  preview: ThumbnailResolutionShape,
	  main: ThumbnailResolutionShape
	});
	
	var AuthorShape = exports.AuthorShape = _react.PropTypes.shape({
	  avatar: _react.PropTypes.shape({
	    url: _react.PropTypes.string,
	    id: IdType
	  }),
	  userName: _react.PropTypes.string
	});
	
	var TopicShape = exports.TopicShape = _react.PropTypes.shape({
	  id: IdType,
	  title: _react.PropTypes.string,
	  resourceCount: _react.PropTypes.number,
	  userCount: _react.PropTypes.number
	});
	
	var CategoryThumbnailShape = exports.CategoryThumbnailShape = _react.PropTypes.shape({
	  url: _react.PropTypes.string
	});
	
	var CategoryShape = exports.CategoryShape = _react.PropTypes.shape({
	  id: IdType,
	  title: _react.PropTypes.string,
	  thumbnail: CategoryThumbnailShape,
	  resourceCount: _react.PropTypes.number,
	  userCount: _react.PropTypes.number
	});
	
	var MagazineArticleShape = exports.MagazineArticleShape = _react.PropTypes.shape({
	  id: IdType,
	  commentCount: _react.PropTypes.number,
	  createdAt: DateType,
	  summary: _react.PropTypes.string,
	  thumbnail: ThumbnailShape,
	  title: _react.PropTypes.string,
	  topics: _react.PropTypes.arrayOf(TopicShape),
	  author: AuthorShape,
	  text: _react.PropTypes.string,
	  favourite: _react.PropTypes.bool
	});
	
	var CommentShape = exports.CommentShape = _react.PropTypes.shape({
	  id: IdType,
	  text: _react.PropTypes.string,
	  useful: _react.PropTypes.bool,
	  resourceId: IdType,
	  resourceType: _react.PropTypes.string,
	  replyCount: _react.PropTypes.number,
	  createdAt: DateType
	});
	
	var JournalEmojiShape = exports.JournalEmojiShape = _react.PropTypes.shape({
	  emoji: _react.PropTypes.string
	});
	
	var JournalEntryShape = exports.JournalEntryShape = _react.PropTypes.shape({
	  id: IdType,
	  emoji: _react.PropTypes.string,
	  text: _react.PropTypes.string,
	  createdAt: DateType
	});
	
	var ReferralLocationShape = exports.ReferralLocationShape = _react.PropTypes.shape({
	  id: IdType,
	  location: _react.PropTypes.string
	});
	
	var ReferralSchoolShape = exports.ReferralSchoolShape = _react.PropTypes.shape({
	  id: IdType,
	  school: _react.PropTypes.string
	});
	
	var ReferralLanguageShape = exports.ReferralLanguageShape = _react.PropTypes.shape({
	  id: IdType,
	  location: _react.PropTypes.string
	});
	
	var ReferralProvider = exports.ReferralProvider = _react.PropTypes.shape({
	  id: IdType,
	  name: _react.PropTypes.string,
	  logo: _react.PropTypes.string,
	  description: _react.PropTypes.string
	});
	
	var FeedItemShape = exports.FeedItemShape = _react.PropTypes.shape({
	  feedChat: FeedButtonShape,
	  feedInterests: FeedButtonShape,
	  feedJournal: FeedJournalShape,
	  feedGoals: FeedGoalsShape,
	  feedQuestionnaire: QuestionnaireShape,
	  magazineArticle: MagazineArticleShape
	});
	
	var FeedButtonShape = exports.FeedButtonShape = _react.PropTypes.shape({
	  id: IdType,
	  title: _react.PropTypes.string,
	  text: _react.PropTypes.string,
	  button: _react.PropTypes.string
	});
	
	var FeedJournalShape = exports.FeedJournalShape = _react.PropTypes.shape({
	  id: IdType,
	  title: _react.PropTypes.string,
	  text: _react.PropTypes.string,
	  emojis: _react.PropTypes.arrayOf(JournalEmojiShape)
	});
	
	var FeedGoalsShape = exports.FeedGoalsShape = _react.PropTypes.shape({
	  id: IdType,
	  title: _react.PropTypes.string,
	  goals: _react.PropTypes.arrayOf(GoalShape)
	});
	
	var SearchItemShape = exports.SearchItemShape = _react.PropTypes.shape({
	  article: MagazineArticleShape,
	  comment: CommentShape
	});
	
	var LinkShape = exports.LinkShape = _react.PropTypes.shape({
	  image: _react.PropTypes.string,
	  url: _react.PropTypes.string,
	  title: _react.PropTypes.string
	});
	
	var ForumThreadShape = exports.ForumThreadShape = _react.PropTypes.shape({
	  id: IdType,
	  title: _react.PropTypes.string,
	  body: _react.PropTypes.string,
	  author: AuthorShape,
	  commentCount: _react.PropTypes.number
	});

/***/ },

/***/ "./src/members/Main/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _MainNavigation = __webpack_require__("./src/members/Main/MainNavigation/index.js");
	
	var _MainNavigation2 = _interopRequireDefault(_MainNavigation);
	
	var _MainFooter = __webpack_require__("./src/members/Main/MainFooter/index.js");
	
	var _MainFooter2 = _interopRequireDefault(_MainFooter);
	
	var _InfoBar = __webpack_require__("./src/members/Main/__shared__/components/InfoBar/index.js");
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-named-as-default
	
	
	var ChatWindow = void 0,
	    ChatBubble = void 0;
	ChatWindow = __webpack_require__("./src/members/Main/ChatWindow/index.js").default;
	ChatBubble = __webpack_require__("./src/members/Main/ChatBubble/index.js").default;
	
	var Main = function (_Component) {
	  _inherits(Main, _Component);
	
	  function Main() {
	    _classCallCheck(this, Main);
	
	    var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this));
	
	    _this.handleChatBubbleClicked = _this.handleChatBubbleClicked.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Main, [{
	    key: 'handleChatBubbleClicked',
	    value: function handleChatBubbleClicked() {
	      this.props.onChatBubbleClicked();
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      this.props.onClick(event.target);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { onClick: this.handleClick },
	        _react2.default.createElement(_MainNavigation2.default, { location: this.props.location.pathname }),
	        this.props.children,
	        ChatWindow && _react2.default.createElement(ChatWindow, null),
	        _react2.default.createElement(_MainFooter2.default, null),
	        this.props.isErrorsInfoBarVisible && _react2.default.createElement(_InfoBar2.default, { type: 'alert', message: this.props.errorsInfoBarMessage, onClose: this.props.onErrorsInfoBarClose }),
	        this.props.isConnectionInfoBarVisible && _react2.default.createElement(_InfoBar2.default, { type: 'alert', message: this.props.connectionInfoBarMessage, onClose: this.props.onConnectionInfoBarClose }),
	        this.props.isChatBubbleVisible && ChatBubble && _react2.default.createElement(ChatBubble, null)
	      );
	    }
	  }]);
	
	  return Main;
	}(_react.Component);
	
	Main.propTypes = {
	  location: _reactRouter.locationShape,
	  children: _react.PropTypes.element,
	  isErrorsInfoBarVisible: _react.PropTypes.bool,
	  isConnectionInfoBarVisible: _react.PropTypes.bool,
	  isChatBubbleVisible: _react.PropTypes.bool,
	  errorsInfoBarMessage: _react.PropTypes.string,
	  connectionInfoBarMessage: _react.PropTypes.string,
	  onErrorsInfoBarClose: _react.PropTypes.func,
	  onConnectionInfoBarClose: _react.PropTypes.func,
	  onChatBubbleClicked: _react.PropTypes.func,
	  onClick: _react.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var errorsState = (0, _selectors.getInfoState)(state, 'errors');
	  var isErrorsInfoBarVisible = errorsState.visible;
	  var errorsInfoBarMessage = errorsState.message;
	
	  var connectionState = (0, _selectors.getInfoState)(state, 'connectionState');
	  var isConnectionInfoBarVisible = connectionState.visible;
	  var connectionInfoBarMessage = connectionState.message;
	
	  var chatState = (0, _selectors.getChatState)(state);
	
	  return {
	    isErrorsInfoBarVisible: isErrorsInfoBarVisible,
	    errorsInfoBarMessage: errorsInfoBarMessage,
	    isConnectionInfoBarVisible: isConnectionInfoBarVisible,
	    connectionInfoBarMessage: connectionInfoBarMessage,
	    isChatBubbleVisible: chatState.isActive
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onErrorsInfoBarClose: function onErrorsInfoBarClose() {
	      dispatch(actions.infoClose('errors'));
	    },
	    onConnectionInfoBarClose: function onConnectionInfoBarClose() {
	      dispatch(actions.infoClose('connectionState'));
	    },
	    onClick: function onClick(target) {
	      var tagName = target.tagName,
	          href = target.href,
	          hostname = target.hostname;
	
	
	      if (tagName === 'A' && hostname !== window.location.hostname) {
	        dispatch(actions.analyticsOutlinkSelected(href));
	      }
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Main);

/***/ },

/***/ "./src/members/__shared__/actions.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/state/mail/actions.js");
	
	Object.keys(_actions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions[key];
	    }
	  });
	});
	
	var _actions2 = __webpack_require__("./src/members/state/chat/actions.js");
	
	Object.keys(_actions2).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions2[key];
	    }
	  });
	});
	
	var _actions3 = __webpack_require__("./src/members/state/auth/actions.js");
	
	Object.keys(_actions3).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions3[key];
	    }
	  });
	});
	
	var _actions4 = __webpack_require__("./src/members/state/search/actions.js");
	
	Object.keys(_actions4).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions4[key];
	    }
	  });
	});
	
	var _actions5 = __webpack_require__("./src/members/state/info/actions.js");
	
	Object.keys(_actions5).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions5[key];
	    }
	  });
	});
	
	var _actions6 = __webpack_require__("./src/members/state/user/actions.js");
	
	Object.keys(_actions6).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions6[key];
	    }
	  });
	});
	
	var _actions7 = __webpack_require__("./src/members/state/lastTimeRefresh/actions.js");
	
	Object.keys(_actions7).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions7[key];
	    }
	  });
	});
	
	var _actions8 = __webpack_require__("./src/members/state/magazine/actions.js");
	
	Object.keys(_actions8).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions8[key];
	    }
	  });
	});
	
	var _actions9 = __webpack_require__("./src/members/state/categories/actions.js");
	
	Object.keys(_actions9).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions9[key];
	    }
	  });
	});
	
	var _actions10 = __webpack_require__("./src/members/state/topics/actions.js");
	
	Object.keys(_actions10).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions10[key];
	    }
	  });
	});
	
	var _actions11 = __webpack_require__("./src/members/state/goals/actions.js");
	
	Object.keys(_actions11).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions11[key];
	    }
	  });
	});
	
	var _actions12 = __webpack_require__("./src/members/state/journal/actions.js");
	
	Object.keys(_actions12).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions12[key];
	    }
	  });
	});
	
	var _actions13 = __webpack_require__("./src/members/state/feedback/actions.js");
	
	Object.keys(_actions13).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions13[key];
	    }
	  });
	});
	
	var _actions14 = __webpack_require__("./src/members/state/comments/actions.js");
	
	Object.keys(_actions14).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions14[key];
	    }
	  });
	});
	
	var _actions15 = __webpack_require__("./src/members/state/feed/actions.js");
	
	Object.keys(_actions15).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions15[key];
	    }
	  });
	});
	
	var _actions16 = __webpack_require__("./src/members/state/f2f/actions.js");
	
	Object.keys(_actions16).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions16[key];
	    }
	  });
	});
	
	var _actions17 = __webpack_require__("./src/members/state/links/actions.js");
	
	Object.keys(_actions17).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions17[key];
	    }
	  });
	});
	
	var _actions18 = __webpack_require__("./src/members/state/forum/actions.js");
	
	Object.keys(_actions18).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions18[key];
	    }
	  });
	});
	
	var _actions19 = __webpack_require__("./src/members/state/analytics/actions.js");
	
	Object.keys(_actions19).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions19[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/commentsResourceTypes.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var OWNER_COLUMN = 0;
	var ROOT_COMMENTS_COLUMN = 1;
	var COMMENT_REPLIES_COLUMN = 2;
	
	var matrix = [['article', 'articles', 'articleComments'], ['forumThread', 'forumThreads', 'forumThreadComments']];
	
	function findAndMap(resourceType, f) {
	  for (var i = 0; i < matrix.length; i++) {
	    var row = matrix[i];
	    var columnIndex = row.indexOf(resourceType);
	
	    if (columnIndex >= 0) {
	      return f(row, columnIndex);
	    }
	  }
	
	  throw new Error('Cannot find resource type ' + resourceType);
	}
	
	var isCommentsOwner = exports.isCommentsOwner = function isCommentsOwner(resourceType) {
	  return findAndMap(resourceType, function (_, columnIndex) {
	    return columnIndex == OWNER_COLUMN;
	  });
	};
	var isComment = exports.isComment = function isComment(resourceType) {
	  return findAndMap(resourceType, function (_, columnIndex) {
	    return columnIndex > OWNER_COLUMN;
	  });
	};
	var isRootComment = exports.isRootComment = function isRootComment(resourceType) {
	  return findAndMap(resourceType, function (_, columnIndex) {
	    return columnIndex == ROOT_COMMENTS_COLUMN;
	  });
	};
	var isCommentReply = exports.isCommentReply = function isCommentReply(resourceType) {
	  return findAndMap(resourceType, function (_, columnIndex) {
	    return columnIndex == COMMENT_REPLIES_COLUMN;
	  });
	};
	var findCommentsOwnerType = exports.findCommentsOwnerType = function findCommentsOwnerType(resourceType) {
	  return findAndMap(resourceType, function (row) {
	    return row[OWNER_COLUMN];
	  });
	};
	var findCommentRepliesType = exports.findCommentRepliesType = function findCommentRepliesType(resourceType) {
	  return findAndMap(resourceType, function (row) {
	    return row[COMMENT_REPLIES_COLUMN];
	  });
	};
	var findRowByCommentsOwnerType = exports.findRowByCommentsOwnerType = function findRowByCommentsOwnerType(commentsOwnerType) {
	  return matrix.find(function (row) {
	    return row[0] === commentsOwnerType;
	  });
	};

/***/ },

/***/ "./src/members/__shared__/forumLiveStatus.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var compareNowWith = function compareNowWith(time) {
	  return Date.now() - time;
	};
	
	var timeFromString = function timeFromString(string) {
	  return new Date(string).getTime();
	};
	
	// Note: the the property 'live' means the forum thread is, will be or has been live at some point
	
	var isLiveNow = exports.isLiveNow = function isLiveNow(forumThread) {
	  return forumThread.live && compareNowWith(timeFromString(forumThread.liveStart)) > 0 && compareNowWith(timeFromString(forumThread.liveEnd)) < 0;
	};
	
	var isSoonToBeLive = exports.isSoonToBeLive = function isSoonToBeLive(forumThread) {
	  return forumThread.live && compareNowWith(timeFromString(forumThread.liveStart)) < 0;
	};
	
	var hasEnded = exports.hasEnded = function hasEnded(forumThread) {
	  return forumThread.live && compareNowWith(timeFromString(forumThread.liveEnd)) >= 0;
	};

/***/ },

/***/ "./src/members/__shared__/forumQueries.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.normalizeForumQuery = normalizeForumQuery;
	exports.getQueryTitle = getQueryTitle;
	var queries = {
	  'Popular': { sort: 'popular' },
	  'Following': { following: 'true' }
	};
	
	function normalizeForumQuery(query) {
	  var normalizedQuery = query;
	
	  if (Object.keys(query).length == 0) {
	    normalizedQuery = queries['Popular'];
	  }
	
	  if (normalizedQuery.topic) {
	    normalizedQuery = _extends({}, normalizedQuery, {
	      sort: 'recent'
	    });
	  }
	
	  return normalizedQuery;
	}
	
	function getQueryTitle(query) {
	  if (query.topic) {
	    return query.title;
	  }
	
	  var queriesTitles = Object.keys(queries);
	
	  for (var i = 0; i < queriesTitles.length; i++) {
	    var queryTitle = queriesTitles[i];
	
	    if (JSON.stringify(normalizeForumQuery(queries[queryTitle])) === JSON.stringify(normalizeForumQuery(query))) {
	      return queryTitle;
	    }
	  }
	
	  return null;
	}
	
	exports.default = queries;

/***/ },

/***/ "./src/members/__shared__/magazineQueries.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.normalizeMagazineQuery = normalizeMagazineQuery;
	var queries = {
	  'New': { query: { sort: 'recent' }, title: "New" },
	  'Popular': { query: { sort: 'popular' }, title: "Popular" },
	  'Local': { query: { local: 'true' }, title: "Local" },
	  'Favourite': { query: { favourite: 'true' }, title: "Favourites" }
	};
	
	function normalizeMagazineQuery(query) {
	  var normalizedQuery = query;
	
	  if (Object.keys(query).length == 0) {
	    normalizedQuery = queries['New'].query;
	  }
	
	  return normalizedQuery;
	}
	
	exports.default = queries;

/***/ },

/***/ "./src/members/__shared__/selectors/auth.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/auth/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/categories.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/categories/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/chat.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/chat/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/comments.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/comments/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/f2f.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/f2f/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/feed.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/feed/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/feedback.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/feedback/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/forum.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/forum/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/goals.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/goals/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mail = __webpack_require__("./src/members/__shared__/selectors/mail.js");
	
	Object.keys(_mail).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mail[key];
	    }
	  });
	});
	
	var _chat = __webpack_require__("./src/members/__shared__/selectors/chat.js");
	
	Object.keys(_chat).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _chat[key];
	    }
	  });
	});
	
	var _user = __webpack_require__("./src/members/__shared__/selectors/user.js");
	
	Object.keys(_user).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _user[key];
	    }
	  });
	});
	
	var _auth = __webpack_require__("./src/members/__shared__/selectors/auth.js");
	
	Object.keys(_auth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _auth[key];
	    }
	  });
	});
	
	var _magazine = __webpack_require__("./src/members/__shared__/selectors/magazine.js");
	
	Object.keys(_magazine).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _magazine[key];
	    }
	  });
	});
	
	var _categories = __webpack_require__("./src/members/__shared__/selectors/categories.js");
	
	Object.keys(_categories).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _categories[key];
	    }
	  });
	});
	
	var _topics = __webpack_require__("./src/members/__shared__/selectors/topics.js");
	
	Object.keys(_topics).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _topics[key];
	    }
	  });
	});
	
	var _goals = __webpack_require__("./src/members/__shared__/selectors/goals.js");
	
	Object.keys(_goals).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _goals[key];
	    }
	  });
	});
	
	var _journal = __webpack_require__("./src/members/__shared__/selectors/journal.js");
	
	Object.keys(_journal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _journal[key];
	    }
	  });
	});
	
	var _feedback = __webpack_require__("./src/members/__shared__/selectors/feedback.js");
	
	Object.keys(_feedback).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _feedback[key];
	    }
	  });
	});
	
	var _comments = __webpack_require__("./src/members/__shared__/selectors/comments.js");
	
	Object.keys(_comments).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _comments[key];
	    }
	  });
	});
	
	var _feed = __webpack_require__("./src/members/__shared__/selectors/feed.js");
	
	Object.keys(_feed).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _feed[key];
	    }
	  });
	});
	
	var _f2f = __webpack_require__("./src/members/__shared__/selectors/f2f.js");
	
	Object.keys(_f2f).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _f2f[key];
	    }
	  });
	});
	
	var _search = __webpack_require__("./src/members/__shared__/selectors/search.js");
	
	Object.keys(_search).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _search[key];
	    }
	  });
	});
	
	var _links = __webpack_require__("./src/members/__shared__/selectors/links.js");
	
	Object.keys(_links).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _links[key];
	    }
	  });
	});
	
	var _forum = __webpack_require__("./src/members/__shared__/selectors/forum.js");
	
	Object.keys(_forum).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _forum[key];
	    }
	  });
	});
	
	var _info = __webpack_require__("./src/members/__shared__/selectors/info.js");
	
	Object.keys(_info).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _info[key];
	    }
	  });
	});
	
	var _lastTimeRefresh = __webpack_require__("./src/members/__shared__/selectors/lastTimeRefresh.js");
	
	Object.keys(_lastTimeRefresh).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _lastTimeRefresh[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/info.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/info/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/journal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/journal/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/lastTimeRefresh.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/lastTimeRefresh/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/links.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/links/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/magazine.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/magazine/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/mail.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/mail/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/search.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/search/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/topics.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/topics/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ "./src/members/__shared__/selectors/user.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__("./src/members/state/user/selectors.js");
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});

/***/ },

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__("./node_modules/babel-polyfill/lib/index.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _history = __webpack_require__("./node_modules/history/lib/index.js");
	
	var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	var _useScroll = __webpack_require__("./node_modules/react-router-scroll/lib/useScroll.js");
	
	var _useScroll2 = _interopRequireDefault(_useScroll);
	
	var _routes = __webpack_require__("./src/members/routes.js");
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__("./src/members/state/store.js");
	
	var _bowser = __webpack_require__("./node_modules/bowser/src/bowser.js");
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	__webpack_require__("./src/members/members.scss");
	
	var _sagas = __webpack_require__("./src/members/state/__shared__/utils/sagas.js");
	
	var _authStore = __webpack_require__("./src/__shared__/authStore.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__("./assets/favicons/favicon.ico");
	
	function run(authData) {
	  var browserHistory = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
	    basename: ("/members.html")
	  });
	
	  var store = (0, _store.configureStore)(browserHistory, authData);
	  var enhancedHistory = (0, _reactRouterRedux.syncHistoryWithStore)(browserHistory, store);
	
	  var app = document.getElementById("app");
	
	  if (_bowser2.default.msie) {
	    app.className += "isBrowserIE";
	  }
	
	  if (_bowser2.default.msedge) {
	    app.className += "isBrowserEdge";
	  }
	
	  (0, _reactDom.render)(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(_reactRouter.Router, { history: enhancedHistory, routes: _routes2.default, render: (0, _reactRouter.applyRouterMiddleware)((0, _useScroll2.default)()) })
	  ), app);
	}
	
	if ((0, _authStore.hasValidToken)()) {
	  run((0, _authStore.getAuthData)());
	} else {
	  (0, _sagas.navigateToWebsite)();
	}

/***/ },

/***/ "./src/members/routes.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");
	
	var _Main = __webpack_require__("./src/members/Main/index.js");
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Mail = __webpack_require__("./src/members/Main/Mail/index.js");
	
	var _Mail2 = _interopRequireDefault(_Mail);
	
	var _MailThreadsList = __webpack_require__("./src/members/Main/Mail/MailThreadsList/index.js");
	
	var _MailThreadsList2 = _interopRequireDefault(_MailThreadsList);
	
	var _More = __webpack_require__("./src/members/Main/More/index.js");
	
	var _More2 = _interopRequireDefault(_More);
	
	var _UserGoals = __webpack_require__("./src/members/Main/UserGoals/index.js");
	
	var _UserGoals2 = _interopRequireDefault(_UserGoals);
	
	var _Links = __webpack_require__("./src/members/Main/Links/index.js");
	
	var _Links2 = _interopRequireDefault(_Links);
	
	var _UserSettings = __webpack_require__("./src/members/Main/UserSettings/index.js");
	
	var _UserSettings2 = _interopRequireDefault(_UserSettings);
	
	var _Interests = __webpack_require__("./src/members/Main/Interests/index.js");
	
	var _Interests2 = _interopRequireDefault(_Interests);
	
	var _Referral = __webpack_require__("./src/members/Main/Referral/index.js");
	
	var _Referral2 = _interopRequireDefault(_Referral);
	
	var _Journal = __webpack_require__("./src/members/Main/Journal/index.js");
	
	var _Journal2 = _interopRequireDefault(_Journal);
	
	var _Feedback = __webpack_require__("./src/members/Main/Feedback/index.js");
	
	var _Feedback2 = _interopRequireDefault(_Feedback);
	
	var _Search = __webpack_require__("./src/members/Main/Search/index.js");
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _NotFound = __webpack_require__("./src/members/Main/__shared__/components/NotFound/index.js");
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Feed = void 0;
	Feed = __webpack_require__("./src/members/Main/Feed/index.js").default;
	
	var MailThreadMessagesList = void 0,
	    MailTeamMessageEditor = void 0;
	MailThreadMessagesList = __webpack_require__("./src/members/Main/Mail/MailThreadMessagesList/index.js").default;
	MailTeamMessageEditor = __webpack_require__("./src/members/Main/Mail/MailTeamMessageEditor/index.js").default;
	
	var ChatResources = void 0;
	ChatResources = __webpack_require__("./src/members/Main/ChatResources/index.js").default;
	
	var UserSettingsChangeAvatar = void 0;
	UserSettingsChangeAvatar = __webpack_require__("./src/members/Main/UserSettings/UserSettingsChangeAvatar/index.js").default;
	
	var Forum = void 0,
	    ForumFilteredThreadsList = void 0,
	    ForumCategories = void 0,
	    ForumThreadProfile = void 0,
	    ForumContribute = void 0;
	Forum = __webpack_require__("./src/members/Main/Forum/index.js").default;
	ForumFilteredThreadsList = __webpack_require__("./src/members/Main/Forum/ForumFilteredThreadsList/index.js").default;
	ForumCategories = __webpack_require__("./src/members/Main/Forum/ForumCategories/index.js").default;
	ForumThreadProfile = __webpack_require__("./src/members/Main/Forum/ForumThreadProfile/index.js").default;
	ForumContribute = __webpack_require__("./src/members/Main/Forum/ForumContribute/index.js").default;
	
	var ForumLiveThreadsList = void 0,
	    ForumLiveThreadLobby = void 0;
	ForumLiveThreadsList = __webpack_require__("./src/members/Main/Forum/ForumLiveThreadsList/index.js").default;
	ForumLiveThreadLobby = __webpack_require__("./src/members/Main/Forum/ForumLiveThreadLobby/index.js").default;
	
	var ForumAskKooth = void 0;
	ForumAskKooth = __webpack_require__("./src/members/Main/Forum/ForumAskKooth/index.js").default;
	
	var Magazine = void 0,
	    MagazineArticleProfile = void 0,
	    MagazineArticlesList = void 0,
	    MagazineCategories = void 0,
	    MagazineContribute = void 0;
	Magazine = __webpack_require__("./src/members/Main/Magazine/index.js").default;
	MagazineArticleProfile = __webpack_require__("./src/members/Main/Magazine/MagazineArticleProfile/index.js").default;
	MagazineArticlesList = __webpack_require__("./src/members/Main/Magazine/MagazineArticlesList/index.js").default;
	MagazineCategories = __webpack_require__("./src/members/Main/Magazine/MagazineCategories/index.js").default;
	MagazineContribute = __webpack_require__("./src/members/Main/Magazine/MagazineContribute/index.js").default;
	
	// If feed is disabled, the magazine should be the homepage
	var isMagazineHomepage = Feed === undefined;
	var isMailOrChatEnabled = ChatResources !== undefined || MailThreadMessagesList !== undefined;
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { path: '/', component: _Main2.default },
	  Feed && _react2.default.createElement(_reactRouter.IndexRoute, { component: Feed }),
	  isMagazineHomepage && _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'magazine' }),
	  Magazine && _react2.default.createElement(
	    _reactRouter.Route,
	    { path: 'magazine', component: Magazine },
	    _react2.default.createElement(_reactRouter.IndexRoute, { component: MagazineArticlesList }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'articles/:id', component: MagazineArticleProfile }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'articles/:id/comments', component: MagazineArticleProfile }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'articles/:id/comments/:commentsPage/:commentId', component: MagazineArticleProfile }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'articles/:id/comments/:commentsPage/:commentId/:repliesPage/:replyId', component: MagazineArticleProfile }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'categories', component: MagazineCategories }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'contribute', component: MagazineContribute })
	  ),
	  isMailOrChatEnabled && _react2.default.createElement(
	    _reactRouter.Route,
	    { path: 'messages', component: _Mail2.default },
	    _react2.default.createElement(_reactRouter.IndexRoute, { component: _MailThreadsList2.default }),
	    MailThreadMessagesList && _react2.default.createElement(_reactRouter.Route, { path: 'threads/:id', component: MailThreadMessagesList }),
	    MailTeamMessageEditor && _react2.default.createElement(_reactRouter.Route, { path: 'new', component: MailTeamMessageEditor })
	  ),
	  ChatResources && _react2.default.createElement(_reactRouter.Route, { path: 'chat-resources', component: ChatResources }),
	  Forum && _react2.default.createElement(
	    _reactRouter.Route,
	    { path: 'forum', component: Forum },
	    _react2.default.createElement(_reactRouter.IndexRoute, { component: ForumFilteredThreadsList }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'threads/:id', component: ForumThreadProfile }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'threads/:id/comments', component: ForumThreadProfile }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'threads/:id/comments/:commentsPage/:commentId', component: ForumThreadProfile }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'threads/:id/comments/:commentsPage/:commentId/:repliesPage/:replyId', component: ForumThreadProfile }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'categories', component: ForumCategories }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'start-discussion', component: ForumContribute }),
	    ForumAskKooth && _react2.default.createElement(_reactRouter.Route, { path: 'ask-kooth', component: ForumAskKooth }),
	    ForumLiveThreadsList && _react2.default.createElement(_reactRouter.Route, { path: 'live', component: ForumLiveThreadsList }),
	    ForumLiveThreadLobby && _react2.default.createElement(_reactRouter.Route, { path: 'lobby/:id', component: ForumLiveThreadLobby })
	  ),
	  _react2.default.createElement(_reactRouter.Route, { path: 'more', component: _More2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'search', component: _Search2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'goals', component: _UserGoals2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'links', component: _Links2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'interests', component: _Interests2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'journal', component: _Journal2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'feedback', component: _Feedback2.default }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: 'settings' },
	    _react2.default.createElement(_reactRouter.IndexRoute, { component: _UserSettings2.default }),
	    UserSettingsChangeAvatar && _react2.default.createElement(_reactRouter.Route, { path: 'avatar', component: UserSettingsChangeAvatar })
	  ),
	  _react2.default.createElement(_reactRouter.Route, { path: 'referral', component: _Referral2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFound2.default })
	);

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/booleanMaker.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var booleanName = _ref.booleanName,
	      trueTypes = _ref.trueTypes,
	      falseTypes = _ref.falseTypes;
	
	  var INITIAL_STATE = _defineProperty({}, booleanName, false);
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    if (trueTypes.indexOf(action.type) >= 0) {
	      return _defineProperty({}, booleanName, true);
	    }
	
	    if (falseTypes.indexOf(action.type) >= 0) {
	      return _defineProperty({}, booleanName, false);
	    }
	
	    return state;
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/byIdMaker.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var fetchSuccessTypes = _ref.fetchSuccessTypes,
	      updateSuccessTypes = _ref.updateSuccessTypes,
	      removeType = _ref.removeType,
	      resetType = _ref.resetType,
	      entityType = _ref.entityType,
	      updateKey = _ref.updateKey;
	
	  var INITIAL_STATE = {};
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    if (fetchSuccessTypes.indexOf(action.type) >= 0) {
	      var entities = action.result.entities[entityType];
	      var newState = _extends({}, state);
	
	      if (entities) {
	        Object.keys(entities).forEach(function (id) {
	          return newState[id] = _extends({}, newState[id], entities[id]);
	        });
	      }
	
	      return newState;
	    }
	
	    if (updateSuccessTypes && updateSuccessTypes.indexOf(action.type) >= 0) {
	      return _extends({}, state, _defineProperty({}, action[updateKey], _extends({}, state[action[updateKey]], action.updates)));
	    }
	
	    switch (action.type) {
	      case removeType:
	        {
	          var omitId = state[action.id],
	              withoutId = _objectWithoutProperties(state, [action.id]); // eslint-disable-line no-unused-vars
	
	
	          return withoutId;
	        }
	
	      case resetType:
	        {
	          return INITIAL_STATE;
	        }
	
	      default:
	        return state;
	    }
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/byKeyMaker.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (key, reducers) {
	  return function (state, action) {
	    var isSingleReducer = typeof reducers === 'function';
	
	    if (state === undefined) {
	      var newState = {};
	
	      if (!isSingleReducer) {
	        var values = Object.keys(reducers);
	
	        values.forEach(function (value) {
	          newState[value] = reducers[value](undefined, action);
	        });
	      }
	
	      return newState;
	    }
	
	    var value = action[key];
	
	    if (value) {
	      var reducer = isSingleReducer ? reducers : reducers[value];
	
	      if (reducer) {
	        return _extends({}, state, _defineProperty({}, value, reducer(state[value], action)));
	      }
	    }
	
	    return state;
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/byPageMaker.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = function (successTypes, resultKey) {
	  var INITIAL_STATE = {};
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    if (successTypes.indexOf(action.type) >= 0) {
	      return _extends({}, state, _defineProperty({}, action.page, [].concat(_toConsumableArray(action.result[resultKey]))));
	    }
	
	    return state;
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/categorySelectionMaker.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (_ref) {
	  var selectType = _ref.selectType,
	      idKey = _ref.idKey;
	
	  var INITIAL_STATE = {
	    selectedCategory: null
	  };
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	      case selectType:
	        return _extends({}, state, {
	          selectedCategory: action[idKey]
	        });
	
	      default:
	        return state;
	    }
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/emojisMaker.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (_ref) {
	  var showType = _ref.showType,
	      closeType = _ref.closeType;
	
	  var INITIAL_STATE = {
	    areVisible: false
	  };
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	      case closeType:
	        return _extends({}, state, {
	          areVisible: false
	        });
	
	      case showType:
	        return _extends({}, state, {
	          areVisible: true
	        });
	
	      default:
	        return state;
	    }
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/infoMaker.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (_ref) {
	  var showType = _ref.showType,
	      closeType = _ref.closeType;
	
	  var INITIAL_STATE = {
	    visible: false,
	    message: null,
	    title: null
	  };
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	      case closeType:
	        return _extends({}, state, {
	          visible: false
	        });
	
	      case showType:
	        return _extends({}, state, {
	          visible: true,
	          message: action.message,
	          title: action.title
	        });
	
	      default:
	        return state;
	    }
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/lastTimeRefreshMaker.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (refreshType) {
	  var INITIAL_STATE = null;
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	      case refreshType:
	        return new Date();
	
	      default:
	        return state;
	    }
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/pagingMaker.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var INITIAL_STATE = exports.INITIAL_STATE = {
	  page: 1,
	  possiblePage: 1,
	  pagesCount: 0,
	  isFetching: false,
	  totalCount: 0
	};
	
	exports.default = function (_ref) {
	  var fetchType = _ref.fetchType,
	      fetchSuccessType = _ref.fetchSuccessType,
	      fetchErrorType = _ref.fetchErrorType,
	      possiblePageUpdateType = _ref.possiblePageUpdateType;
	
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	      case fetchType:
	        {
	          var newPage = action.page || state.page;
	
	          return _extends({}, state, {
	            page: newPage,
	            possiblePage: newPage,
	            isFetching: true
	          });
	        }
	
	      case fetchSuccessType:
	        {
	          return _extends({}, state, {
	            pagesCount: Math.ceil(action.result.meta.count / action.result.meta.limit),
	            totalCount: action.result.meta.count,
	            isFetching: false
	          });
	        }
	
	      case fetchErrorType:
	        {
	          return _extends({}, state, {
	            isFetching: false
	          });
	        }
	
	      case possiblePageUpdateType:
	        {
	          return _extends({}, state, {
	            possiblePage: action.possiblePage
	          });
	        }
	
	      default:
	        {
	          return state;
	        }
	    }
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/subjectMaker.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (_ref) {
	  var updateType = _ref.updateType,
	      resetType = _ref.resetType;
	
	  var INITIAL_STATE = {
	    subject: ''
	  };
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	      case updateType:
	        return _extends({}, state, {
	          subject: action.subject
	        });
	
	      case resetType:
	        return _extends({}, INITIAL_STATE);
	
	      default:
	        return state;
	    }
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/reducersMakers/textEditingMaker.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (_ref) {
	  var submitType = _ref.submitType,
	      submitSuccessType = _ref.submitSuccessType,
	      submitErrorType = _ref.submitErrorType,
	      updateTextType = _ref.updateTextType,
	      expandType = _ref.expandType,
	      resetType = _ref.resetType;
	
	  var INITIAL_STATE = {
	    isSubmitting: false,
	    isExpanded: false,
	    text: ""
	  };
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    if (action.type == submitSuccessType || action.type == submitErrorType) {
	      return _extends({}, state, {
	        isSubmitting: false
	      });
	    }
	
	    switch (action.type) {
	      case submitType:
	        return _extends({}, state, {
	          isSubmitting: true
	        });
	
	      case updateTextType:
	        return _extends({}, state, {
	          text: action.text
	        });
	
	      case expandType:
	        return _extends({}, state, {
	          isExpanded: true
	        });
	
	      case resetType:
	        return _extends({}, INITIAL_STATE);
	
	      default:
	        return state;
	    }
	  };
	};

/***/ },

/***/ "./src/members/state/__shared__/schemas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.searchResultsArraySchema = exports.journalEntriesArraySchema = exports.goalsArraySchema = exports.userAvatarsArraySchema = exports.topicsArraySchema = exports.categoriesArraySchema = exports.commentsArraySchema = exports.forumThreadsArraySchema = exports.magazineArticlesArraySchema = exports.chatResourcesArraySchema = exports.chatQuestionsArraySchema = exports.chatMessagesArraySchema = exports.questionsArraySchema = exports.threadMessagesArraySchema = exports.threadsArraySchema = exports.searchResultSchema = exports.journalEntrySchema = exports.goalSchema = exports.userAvatarSchema = exports.topicSchema = exports.categorySchema = exports.commentSchema = exports.forumThreadSchema = exports.magazineArticleSchema = exports.chatResourceSchema = exports.chatQuestionSchema = exports.chatQuestionnaireSchema = exports.chatMessageSchema = exports.questionSchema = exports.questionnaireSchema = exports.threadSchema = exports.threadMessageSchema = undefined;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var threadMessageSchema = exports.threadMessageSchema = new _normalizr.Schema('threadMessages');
	
	var threadSchema = exports.threadSchema = new _normalizr.Schema('threads');
	
	var questionnaireSchema = exports.questionnaireSchema = new _normalizr.Schema('questionnaires');
	
	var questionSchema = exports.questionSchema = new _normalizr.Schema('questions');
	
	var chatMessageSchema = exports.chatMessageSchema = new _normalizr.Schema('chatMessages');
	
	var chatQuestionnaireSchema = exports.chatQuestionnaireSchema = new _normalizr.Schema('chatQuestionnaires');
	
	var chatQuestionSchema = exports.chatQuestionSchema = new _normalizr.Schema('chatQuestions');
	
	var chatResourceSchema = exports.chatResourceSchema = new _normalizr.Schema('chatResources', {
	  idAttribute: function idAttribute(entity) {
	    return entity.sentAt + '_' + entity.data.url;
	  }
	});
	
	var magazineArticleSchema = exports.magazineArticleSchema = new _normalizr.Schema('magazineArticles');
	
	var forumThreadSchema = exports.forumThreadSchema = new _normalizr.Schema('forumThreads');
	
	var commentSchema = exports.commentSchema = new _normalizr.Schema('comments');
	
	var categorySchema = exports.categorySchema = new _normalizr.Schema('categories');
	
	var topicSchema = exports.topicSchema = new _normalizr.Schema('topics');
	
	var userAvatarSchema = exports.userAvatarSchema = new _normalizr.Schema('userAvatars');
	
	var goalSchema = exports.goalSchema = new _normalizr.Schema('goals');
	
	var journalEntrySchema = exports.journalEntrySchema = new _normalizr.Schema('journalEntries');
	
	var searchResultSchema = exports.searchResultSchema = (0, _normalizr.unionOf)({
	  article: magazineArticleSchema,
	  articles: commentSchema,
	  articleComments: commentSchema,
	  forumThread: forumThreadSchema,
	  forumThreads: commentSchema,
	  forumThreadComments: commentSchema
	}, { schemaAttribute: 'resourceType' });
	
	var threadsArraySchema = exports.threadsArraySchema = (0, _normalizr.arrayOf)(threadSchema);
	
	var threadMessagesArraySchema = exports.threadMessagesArraySchema = (0, _normalizr.arrayOf)(threadMessageSchema);
	
	var questionsArraySchema = exports.questionsArraySchema = (0, _normalizr.arrayOf)(questionSchema);
	
	var chatMessagesArraySchema = exports.chatMessagesArraySchema = (0, _normalizr.arrayOf)(chatMessageSchema);
	
	var chatQuestionsArraySchema = exports.chatQuestionsArraySchema = (0, _normalizr.arrayOf)(chatQuestionSchema);
	
	var chatResourcesArraySchema = exports.chatResourcesArraySchema = (0, _normalizr.arrayOf)(chatResourceSchema);
	
	var magazineArticlesArraySchema = exports.magazineArticlesArraySchema = (0, _normalizr.arrayOf)(magazineArticleSchema);
	
	var forumThreadsArraySchema = exports.forumThreadsArraySchema = (0, _normalizr.arrayOf)(forumThreadSchema);
	
	var commentsArraySchema = exports.commentsArraySchema = (0, _normalizr.arrayOf)(commentSchema);
	
	var categoriesArraySchema = exports.categoriesArraySchema = (0, _normalizr.arrayOf)(categorySchema);
	
	var topicsArraySchema = exports.topicsArraySchema = (0, _normalizr.arrayOf)(topicSchema);
	
	var userAvatarsArraySchema = exports.userAvatarsArraySchema = (0, _normalizr.arrayOf)(userAvatarSchema);
	
	var goalsArraySchema = exports.goalsArraySchema = (0, _normalizr.arrayOf)(goalSchema);
	
	var journalEntriesArraySchema = exports.journalEntriesArraySchema = (0, _normalizr.arrayOf)(journalEntrySchema);
	
	var searchResultsArraySchema = exports.searchResultsArraySchema = (0, _normalizr.arrayOf)(searchResultSchema);
	
	threadSchema.define({
	  latestMessage: threadMessageSchema
	});
	
	chatQuestionnaireSchema.define({
	  questions: chatQuestionsArraySchema
	});
	
	questionnaireSchema.define({
	  questions: questionsArraySchema
	});

/***/ },

/***/ "./src/members/state/__shared__/socket.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CONNECTION_STATE_EVENTS = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*global Primus*/
	/*eslint-disable no-console*/
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CONNECTION_STATE_EVENTS = exports.CONNECTION_STATE_EVENTS = ['open', 'reconnect', 'error', 'reconnect scheduled', 'reconnected', 'reconnect timeout', 'reconnect failed', 'end'];
	
	var Socket = function () {
	  function Socket(accessToken) {
	    _classCallCheck(this, Socket);
	
	    this.primus = Primus.connect(("https://dev-api.kooth.com"));
	    this.primus.on('outgoing::url', function (url) {
	      return url.query = 'accessToken=' + accessToken;
	    });
	    this.requestPromises = {};
	
	    window.req = this.request.bind(this);
	  }
	
	  _createClass(Socket, [{
	    key: 'getEventChannel',
	    value: function getEventChannel() {
	      var _this = this;
	
	      return (0, _reduxSaga.eventChannel)(function (emitter) {
	        _this.primus.on('data', function (data) {
	          console.log('Received a new message from the server', data);
	
	          if (data.inResponseTo) {
	            var _requestPromises$data = _this.requestPromises[data.inResponseTo],
	                resolve = _requestPromises$data.resolve,
	                reject = _requestPromises$data.reject;
	
	
	            if (Math.floor(data.code / 100) == 2) {
	              resolve(data.body);
	            } else {
	              var message = data.code;
	
	              if (data.code === 403) {
	                message = 'You are temporarily denied access to the chat.';
	              }
	
	              reject(new Error(message));
	            }
	
	            delete _this.requestPromises[data.inResponseTo];
	          }
	
	          emitter({ type: 'data', data: data });
	        });
	
	        _this.primus.on('open', function () {
	          var statusMessage = 'Connection is alive and kicking';
	          console.log(statusMessage);
	
	          emitter({ type: 'open', statusMessage: statusMessage });
	        });
	
	        _this.primus.on('error', function (error) {
	          var statusMessage = 'A connection error occured';
	          console.error(statusMessage, error);
	
	          emitter({ type: 'error', error: error, statusMessage: statusMessage });
	        });
	
	        _this.primus.on('reconnect', function () {
	          var statusMessage = 'Reconnection attempt started';
	          console.log(statusMessage);
	          emitter({ type: 'reconnect', statusMessage: statusMessage });
	        });
	
	        _this.primus.on('reconnect scheduled', function (options) {
	          var statusMessage = 'Reconnecting in ' + options.scheduled + ' ms. This is an attempt ' + options.attempt + ' out of ' + options.retries;
	          emitter({ type: 'reconnect scheduled', options: options, statusMessage: statusMessage });
	        });
	
	        _this.primus.on('reconnected', function (options) {
	          var statusMessage = 'It took ' + options.duration + ' ms to reconnect';
	          emitter({ type: 'reconnected', options: options, statusMessage: statusMessage });
	        });
	
	        _this.primus.on('reconnect timeout', function (error) {
	          var statusMessage = 'Timeout expired: ' + error.message;
	          console.log(statusMessage);
	          emitter({ type: 'reconnect timeout', error: error, statusMessage: statusMessage });
	        });
	
	        _this.primus.on('reconnect failed', function (error) {
	          var statusMessage = 'The reconnection failed: ' + error.message;
	          console.log(statusMessage);
	          emitter({ type: 'reconnect failed', error: error, statusMessage: statusMessage });
	        });
	
	        _this.primus.on('end', function () {
	          var statusMessage = 'Connection closed';
	          console.log(statusMessage);
	          emitter({ type: 'end', statusMessage: statusMessage });
	        });
	
	        return function () {
	          emitter = function emitter() {};
	        };
	      });
	    }
	  }, {
	    key: 'request',
	    value: function request(path) {
	      var _this2 = this;
	
	      var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      console.log('request', path, body);
	
	      var id = Math.random().toString();
	      var promise = new Promise(function (resolve, reject) {
	        _this2.requestPromises[id] = { resolve: resolve, reject: reject };
	      });
	
	      this.primus.write({ path: path, body: body, id: id });
	
	      return promise;
	    }
	  }, {
	    key: 'respond',
	    value: function respond(inResponseTo, body) {
	      var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
	
	      console.log('respond', inResponseTo, body);
	      this.primus.write({ inResponseTo: inResponseTo, body: body, code: code });
	    }
	  }, {
	    key: 'refreshToken',
	    value: function refreshToken(accessToken) {
	      this.primus.on('outgoing::url', function (url) {
	        return url.query = 'accessToken=' + accessToken;
	      });
	      return this.request('auth.provide', { accessToken: accessToken });
	    }
	  }, {
	    key: 'chatEnqueue',
	    value: function chatEnqueue() {
	      return this.request('chat.add-to-queue');
	    }
	  }, {
	    key: 'chatEnqueueCancel',
	    value: function chatEnqueueCancel() {
	      return this.request('chat.remove-from-queue');
	    }
	  }, {
	    key: 'chatSendMessage',
	    value: function chatSendMessage(chatMessage) {
	      return this.request('chat.send-message', chatMessage);
	    }
	  }, {
	    key: 'chatStartWritingMessage',
	    value: function chatStartWritingMessage() {
	      return this.request('chat.start-writing-message');
	    }
	  }, {
	    key: 'chatStopWritingMessage',
	    value: function chatStopWritingMessage() {
	      return this.request('chat.stop-writing-message');
	    }
	  }, {
	    key: 'chatQuestionnaireSubmit',
	    value: function chatQuestionnaireSubmit(questionnaire) {
	      return this.request('chat.questionnaire-progress', questionnaire);
	    }
	  }, {
	    key: 'forumThreadWatch',
	    value: function forumThreadWatch(id) {
	      return this.request('forum.watch', { id: id });
	    }
	  }, {
	    key: 'forumThreadUnwatch',
	    value: function forumThreadUnwatch(id) {
	      return this.request('forum.unwatch', { id: id });
	    }
	  }]);
	
	  return Socket;
	}();
	
	exports.default = Socket;

/***/ },

/***/ "./src/members/state/__shared__/utils/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var successActionFrom = exports.successActionFrom = function successActionFrom(action, result) {
	  return _extends({}, action, { result: result,
	    type: action.type + '_SUCCESS'
	  });
	};
	
	var errorActionFrom = exports.errorActionFrom = function errorActionFrom(action, error) {
	  return _extends({}, action, { error: error,
	    errorMessage: error ? error.toString() : "",
	    type: action.type + '_ERROR'
	  });
	};
	
	var actionCausedByURLChangeFrom = exports.actionCausedByURLChangeFrom = function actionCausedByURLChangeFrom(action) {
	  return _extends({}, action, {
	    causedByURLChange: true
	  });
	};
	
	var textEditingUpdateTextMaker = function textEditingUpdateTextMaker(type) {
	  return function (_ref) {
	    var text = _ref.text,
	        emojiShortName = _ref.emojiShortName,
	        selectionStart = _ref.selectionStart,
	        other = _objectWithoutProperties(_ref, ['text', 'emojiShortName', 'selectionStart']);
	
	    if (emojiShortName) {
	      return _extends({
	        type: type,
	        text: text.substring(0, selectionStart) + emojiShortName + text.substring(selectionStart, text.length)
	      }, other);
	    }
	
	    return _extends({ type: type, text: text }, other);
	  };
	};
	exports.textEditingUpdateTextMaker = textEditingUpdateTextMaker;

/***/ },

/***/ "./src/members/state/__shared__/utils/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.offsetToPageParams = exports.pageToOffsetParams = exports.urlEncode = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.callApi = callApi;
	
	__webpack_require__("./node_modules/isomorphic-fetch/fetch-npm-browserify.js");
	
	var _authStore = __webpack_require__("./src/__shared__/authStore.js");
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var urlEncode = exports.urlEncode = function urlEncode(object) {
	  var encodedKeyValuePairs = Object.keys(object).map(function (key) {
	    var value = object[key];
	
	    if (Array.isArray(value)) {
	      var encodedArrayItems = value.map(function (item) {
	        return urlEncode(_defineProperty({}, key, item));
	      });
	      return encodedArrayItems.join('&');
	    }
	
	    return encodeKeyValue(key, value);
	  });
	
	  return encodedKeyValuePairs.join('&');
	};
	
	var encodeKeyValue = function encodeKeyValue(key, value) {
	  return encodeURIComponent(key) + '=' + encodeURIComponent(value);
	};
	
	var pageToOffsetParams = exports.pageToOffsetParams = function pageToOffsetParams(page, pageSize) {
	  return { offset: (page - 1) * pageSize, limit: pageSize };
	};
	var offsetToPageParams = exports.offsetToPageParams = function offsetToPageParams(offset, pageSize) {
	  return { page: Math.floor(offset / pageSize) + 1 };
	};
	
	function callApi(endpoint) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var finalEndpoint = endpoint;
	
	  if (options.query) {
	    finalEndpoint = endpoint + '?' + urlEncode(options.query);
	  }
	
	  var fullUrl = endpoint.indexOf('://') === -1 ? ("https://dev-api.kooth.com") + finalEndpoint : finalEndpoint;
	  var authData = (0, _authStore.getAuthData)();
	
	  var headers = {
	    'Content-Type': 'application/json',
	    'Service': ("Kooth")
	  };
	
	  var finalHeaders = _extends({}, headers);
	
	  if (authData && authData.accessToken) {
	    finalHeaders.Authorization = authData.accessToken;
	  }
	
	  var finalOptions = _extends({}, options, {
	    headers: finalHeaders
	  });
	
	  finalOptions.body = JSON.stringify(options.body);
	
	  return fetch(fullUrl, finalOptions).then(function (response) {
	    if (response.status !== 204) {
	      return response.text().then(function (text) {
	        try {
	          return { json: JSON.parse(text), response: response };
	        } catch (error) {
	          return { text: text, response: response };
	        }
	      });
	    }
	
	    return { text: '', response: response };
	  }).then(function (_ref) {
	    var text = _ref.text,
	        json = _ref.json,
	        response = _ref.response;
	
	    if (!response.ok) {
	      var error = new Error();
	      error.httpResponse = response;
	      error.json = json;
	
	      if (json) {
	        error.message = json.errors.map(function (errorInfo) {
	          return errorInfo.message;
	        }).join('\n');
	      } else {
	        error.message = text;
	      }
	
	      return Promise.reject(error);
	    }
	
	    return json || text;
	  });
	}

/***/ },

/***/ "./src/members/state/__shared__/utils/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.httpRequestSagaMaker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.optimisticUpdateMaker = optimisticUpdateMaker;
	exports.socketRequestWithErrorChecks = socketRequestWithErrorChecks;
	exports.navigateToWebsite = navigateToWebsite;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var _marked2 = [socketRequestWithErrorChecks].map(regeneratorRuntime.mark);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var httpRequestSagaMaker = function httpRequestSagaMaker(successActionFrom, errorActionFrom) {
	  return function (apiMethod) {
	    for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      keys[_key - 1] = arguments[_key];
	    }
	
	    return regeneratorRuntime.mark(function _callee(action) {
	      var type, values, result, finalError;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              type = action.type, values = _objectWithoutProperties(action, ['type']); // eslint-disable-line no-unused-vars
	
	              _context.prev = 1;
	              _context.next = 4;
	              return _effects.call.apply(undefined, [apiMethod].concat(_toConsumableArray(keys.map(function (key) {
	                return values[key];
	              }))));
	
	            case 4:
	              result = _context.sent;
	              _context.next = 7;
	              return (0, _effects.put)(successActionFrom(action, result));
	
	            case 7:
	              _context.next = 14;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	              finalError = Object.assign(_context.t0, action.errorOptions);
	              _context.next = 14;
	              return (0, _effects.put)(errorActionFrom(action, finalError));
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[1, 9]]);
	    });
	  };
	};
	
	exports.httpRequestSagaMaker = httpRequestSagaMaker;
	function optimisticUpdateMaker(_ref) {
	  var idKey = _ref.idKey,
	      localUpdateType = _ref.localUpdateType,
	      successType = _ref.successType,
	      errorType = _ref.errorType,
	      remoteUpdateActionCreator = _ref.remoteUpdateActionCreator,
	      localUpdateActionCreator = _ref.localUpdateActionCreator;
	
	
	  return regeneratorRuntime.mark(function _callee2() {
	    var _marked, queueManager, chans, localUpdateAction, id, remoteUpdateAction;
	
	    return regeneratorRuntime.wrap(function _callee2$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            queueManager = function queueManager(chan) {
	              var lastRemoteState, remoteUpdateAction, _ref2, errorAction, successAction, revertLocalUpdateAction;
	
	              return regeneratorRuntime.wrap(function queueManager$(_context2) {
	                while (1) {
	                  switch (_context2.prev = _context2.next) {
	                    case 0:
	                      lastRemoteState = null;
	
	                    case 1:
	                      if (false) {
	                        _context2.next = 26;
	                        break;
	                      }
	
	                      _context2.next = 4;
	                      return (0, _effects.take)(chan);
	
	                    case 4:
	                      remoteUpdateAction = _context2.sent;
	                      _context2.next = 7;
	                      return (0, _effects.put)(remoteUpdateAction);
	
	                    case 7:
	
	                      if (!lastRemoteState) {
	                        lastRemoteState = remoteUpdateAction.stateBeforeLocalUpdate;
	                      }
	
	                      _context2.next = 10;
	                      return (0, _effects.race)({ // eslint-disable-line no-unused-vars
	                        errorAction: (0, _effects.take)(errorType),
	                        successAction: (0, _effects.take)(successType)
	                      });
	
	                    case 10:
	                      _ref2 = _context2.sent;
	                      errorAction = _ref2.errorAction;
	                      successAction = _ref2.successAction;
	
	                      if (!successAction) {
	                        _context2.next = 17;
	                        break;
	                      }
	
	                      lastRemoteState = null;
	                      _context2.next = 24;
	                      break;
	
	                    case 17:
	                      _context2.next = 19;
	                      return (0, _effects.flush)(chan);
	
	                    case 19:
	                      _context2.next = 21;
	                      return (0, _effects.call)(localUpdateActionCreator, lastRemoteState, errorAction);
	
	                    case 21:
	                      revertLocalUpdateAction = _context2.sent;
	                      _context2.next = 24;
	                      return (0, _effects.put)(revertLocalUpdateAction);
	
	                    case 24:
	                      _context2.next = 1;
	                      break;
	
	                    case 26:
	                    case 'end':
	                      return _context2.stop();
	                  }
	                }
	              }, _marked[0], this);
	            };
	
	            _marked = [queueManager].map(regeneratorRuntime.mark);
	            chans = {};
	
	          case 3:
	            if (false) {
	              _context3.next = 23;
	              break;
	            }
	
	            _context3.next = 6;
	            return (0, _effects.take)(localUpdateType);
	
	          case 6:
	            localUpdateAction = _context3.sent;
	            id = localUpdateAction[idKey];
	
	            if (!localUpdateAction.stateBeforeLocalUpdate) {
	              _context3.next = 21;
	              break;
	            }
	
	            _context3.next = 11;
	            return (0, _effects.call)(remoteUpdateActionCreator, localUpdateAction);
	
	          case 11:
	            remoteUpdateAction = _context3.sent;
	
	            if (!remoteUpdateAction) {
	              _context3.next = 21;
	              break;
	            }
	
	            if (chans[id]) {
	              _context3.next = 19;
	              break;
	            }
	
	            _context3.next = 16;
	            return (0, _effects.call)(_reduxSaga.channel);
	
	          case 16:
	            chans[id] = _context3.sent;
	            _context3.next = 19;
	            return (0, _effects.fork)(queueManager, chans[id]);
	
	          case 19:
	            _context3.next = 21;
	            return (0, _effects.put)(chans[id], _extends({}, remoteUpdateAction, {
	              stateBeforeLocalUpdate: localUpdateAction.stateBeforeLocalUpdate
	            }));
	
	          case 21:
	            _context3.next = 3;
	            break;
	
	          case 23:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee2, this);
	  });
	}
	
	function socketRequestWithErrorChecks(socket, method, action) {
	  var type,
	      values,
	      _len2,
	      args,
	      _key2,
	      result,
	      _args4 = arguments;
	
	  return regeneratorRuntime.wrap(function socketRequestWithErrorChecks$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          type = action.type, values = _objectWithoutProperties(action, ['type']); // eslint-disable-line no-unused-vars
	
	          _context4.prev = 1;
	
	          for (_len2 = _args4.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	            args[_key2 - 3] = _args4[_key2];
	          }
	
	          _context4.next = 5;
	          return _effects.call.apply(undefined, [[socket, method]].concat(args));
	
	        case 5:
	          result = _context4.sent;
	          _context4.next = 8;
	          return (0, _effects.put)((0, _actions.successActionFrom)(action, result));
	
	        case 8:
	          _context4.next = 14;
	          break;
	
	        case 10:
	          _context4.prev = 10;
	          _context4.t0 = _context4['catch'](1);
	          _context4.next = 14;
	          return (0, _effects.put)((0, _actions.errorActionFrom)(action, _context4.t0));
	
	        case 14:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked2[0], this, [[1, 10]]);
	}
	
	function navigateToWebsite() {
	  window.location.href = ("http://dev.kooth.com");
	}

/***/ },

/***/ "./src/members/state/__shared__/utils/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPaging = exports.getTextEditing = exports.mountSelectorAt = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _pagingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/pagingMaker.js");
	
	var mountSelectorAt = exports.mountSelectorAt = function mountSelectorAt(path) {
	  var pathParts = path.split('.');
	  var pathPartsLength = pathParts.length;
	
	  return function (selector) {
	    return function (rootState) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var localState = rootState;
	
	      for (var i = 0; i < pathPartsLength; i++) {
	        localState = localState[pathParts[i]];
	      }
	
	      return selector.apply(undefined, [localState].concat(args, [rootState]));
	    };
	  };
	};
	
	var getTextEditing = exports.getTextEditing = function getTextEditing(textEditingState) {
	  var maxChars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (10000);
	
	  var isCharsLimitExceeded = textEditingState.text.length > maxChars;
	
	  return _extends({}, textEditingState, {
	    isSubmitDisabled: textEditingState.isSubmitting || textEditingState.text.length == 0 || isCharsLimitExceeded,
	    isCharsLimitExceeded: isCharsLimitExceeded
	  });
	};
	
	var getPaging = exports.getPaging = function getPaging(pagingState) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (options.threadId) {
	    pagingState = pagingState.byThreadId[options.threadId];
	
	    if (!pagingState) {
	      return _pagingMaker.INITIAL_STATE;
	    }
	  }
	
	  if (options.queryString) {
	    pagingState = pagingState.byQuery[options.queryString];
	
	    if (!pagingState) {
	      return _pagingMaker.INITIAL_STATE;
	    }
	  }
	
	  var _pagingState = pagingState,
	      page = _pagingState.page,
	      pagesCount = _pagingState.pagesCount;
	
	
	  return _extends({}, pagingState, {
	    isPrevActive: page > 1,
	    isNextActive: page < pagesCount
	  });
	};

/***/ },

/***/ "./src/members/state/analytics/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ANALYTICS_OUTLINK_SELECTED = exports.ANALYTICS_OUTLINK_SELECTED = 'ANALYTICS_OUTLINK_SELECTED';
	var analyticsOutlinkSelected = exports.analyticsOutlinkSelected = function analyticsOutlinkSelected(url) {
	  return { type: ANALYTICS_OUTLINK_SELECTED, url: url };
	};

/***/ },

/***/ "./src/members/state/analytics/analyticsTracker.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _piwikWrap = __webpack_require__("./node_modules/piwik-wrap/build/Piwik.js");
	
	var _piwikWrap2 = _interopRequireDefault(_piwikWrap);
	
	var _authStore = __webpack_require__("./src/__shared__/authStore.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	_piwikWrap2.default.init(("http://dev-analytics.kooth.com"), '1').loadScript();
	
	var Tracker = function () {
	    function Tracker() {
	        _classCallCheck(this, Tracker);
	    }
	
	    _createClass(Tracker, [{
	        key: 'processMembersAppAction',
	        value: function processMembersAppAction(action) {
	            if (action.type === "@@router/LOCATION_CHANGE") {
	                var fullPath = action.payload.basename + action.payload.pathname + action.payload.search;
	                _piwikWrap2.default.p.then(function () {
	                    return _piwikWrap2.default.setDocumentTitle(action.payload.pathname);
	                }).then(function () {
	                    return _piwikWrap2.default.setCustomUrl(fullPath.toString());
	                }).then(function () {
	                    return _piwikWrap2.default.trackPageView();
	                }).then(function () {
	                    var auth = (0, _authStore.getAuthData)();
	                    if (auth) {
	                        var _auth$user = auth.user,
	                            yob = _auth$user.yob,
	                            mob = _auth$user.mob;
	
	                        var dob = yob != '' && mob != '' && mob.length == 2 ? yob + '-' + mob : mob != '' && mob.length == 1 ? yob + '-0' + mob : yob;
	                        _piwikWrap2.default.setUserId(auth.user.userName);
	                        _piwikWrap2.default.setCustomVariable(1, 'gender', auth.user.gender, 'visit');
	                        _piwikWrap2.default.setCustomVariable(2, 'dob', dob, 'visit');
	                        _piwikWrap2.default.setCustomVariable(3, 'LA', auth.user.LA, 'visit');
	                        _piwikWrap2.default.setCustomVariable(4, 'subLocation', auth.user.subLocation, 'visit');
	                        _piwikWrap2.default.setCustomVariable(5, 'ethnicity', auth.user.ethnicity, 'visit');
	                        _piwikWrap2.default.setCustomVariable(6, 'ethnicityCategory', auth.user.ethnicityCategory, 'visit');
	                    }
	                });
	            }
	            console.log('Analytics action', action); // eslint-disable-line no-console
	        }
	    }]);
	
	    return Tracker;
	}();
	
	var tracker = new Tracker();
	
	exports.default = tracker;

/***/ },

/***/ "./src/members/state/analytics/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForAnalyticsActions, backgroundSaga].map(regeneratorRuntime.mark);
	
	// eslint-disable-line import/no-unresolved
	
	function watchForAnalyticsActions(analyticsTracker) {
	    var action;
	    return regeneratorRuntime.wrap(function watchForAnalyticsActions$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    if (false) {
	                        _context.next = 8;
	                        break;
	                    }
	
	                    _context.next = 3;
	                    return (0, _effects.take)(['@@router/LOCATION_CHANGE', actions.ANALYTICS_OUTLINK_SELECTED]);
	
	                case 3:
	                    action = _context.sent;
	                    _context.next = 6;
	                    return (0, _effects.call)([analyticsTracker, analyticsTracker.processMembersAppAction], action);
	
	                case 6:
	                    _context.next = 0;
	                    break;
	
	                case 8:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function backgroundSaga(analyticsTracker) {
	    return regeneratorRuntime.wrap(function backgroundSaga$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return [(0, _effects.fork)(watchForAnalyticsActions, analyticsTracker)];
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./src/members/state/auth/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var AUTH_UPDATE = exports.AUTH_UPDATE = 'AUTH_UPDATE';
	var authUpdate = exports.authUpdate = function authUpdate(authData) {
	  return { type: AUTH_UPDATE, authData: authData };
	};
	
	var AUTH_LOGOUT = exports.AUTH_LOGOUT = 'AUTH_LOGOUT';
	var authLogout = exports.authLogout = function authLogout() {
	  return { type: AUTH_LOGOUT };
	};

/***/ },

/***/ "./src/members/state/auth/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.authLogin = authLogin;
	exports.authTokenRefresh = authTokenRefresh;
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	var _authStore = __webpack_require__("./src/__shared__/authStore.js");
	
	function authLogin(_ref) {
	  var userName = _ref.userName,
	      passWord = _ref.passWord,
	      _ref$location = _ref.location,
	      location = _ref$location === undefined ? null : _ref$location;
	
	  var body = { userName: userName, passWord: passWord };
	
	  if (location) {
	    body = _extends({}, body, { location: location });
	  }
	
	  return (0, _api.callApi)('/auth/login', {
	    method: 'POST',
	    body: body
	  }).then(function (json) {
	    (0, _authStore.setAuthData)(json);
	    return json;
	  });
	}
	
	function authTokenRefresh() {
	  return (0, _api.callApi)('/auth/token-refresh', {
	    method: 'POST'
	  }).then(function (json) {
	    (0, _authStore.setAuthData)(json);
	    return json;
	  });
	}

/***/ },

/***/ "./src/members/state/auth/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var INITIAL_STATE = null;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.AUTH_UPDATE:
	      {
	        var _action$authData = action.authData,
	            omit = _action$authData.user,
	            withoutUser = _objectWithoutProperties(_action$authData, ['user']); // eslint-disable-line no-unused-vars
	
	
	        return withoutUser;
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/auth/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.manageToken = manageToken;
	exports.refreshTokenPeriodically = refreshTokenPeriodically;
	exports.watchForLogout = watchForLogout;
	exports.default = backgroundSaga;
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _sagas = __webpack_require__("./src/members/state/__shared__/utils/sagas.js");
	
	var _authStore = __webpack_require__("./src/__shared__/authStore.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [manageToken, refreshTokenPeriodically, watchForLogout, backgroundSaga].map(regeneratorRuntime.mark);
	
	function manageToken(socket) {
	  var refreshTask, action, auth;
	  return regeneratorRuntime.wrap(function manageToken$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(refreshTokenPeriodically, socket);
	
	        case 2:
	          refreshTask = _context.sent;
	
	        case 3:
	          if (false) {
	            _context.next = 16;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.take)('*');
	
	        case 6:
	          action = _context.sent;
	          _context.next = 9;
	          return (0, _effects.select)(_selectors.getAuth);
	
	        case 9:
	          auth = _context.sent;
	
	          if (!(!(0, _authStore.isTokenValid)(auth) || action.error && action.error.httpResponse && action.error.httpResponse.status === 401)) {
	            _context.next = 14;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.cancel)(refreshTask);
	
	        case 13:
	          return _context.abrupt('break', 16);
	
	        case 14:
	          _context.next = 3;
	          break;
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.call)(_sagas.navigateToWebsite);
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function refreshTokenPeriodically(socket) {
	  var authData;
	  return regeneratorRuntime.wrap(function refreshTokenPeriodically$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (false) {
	            _context2.next = 26;
	            break;
	          }
	
	          _context2.prev = 1;
	          _context2.next = 4;
	          return (0, _effects.call)(api.authTokenRefresh);
	
	        case 4:
	          authData = _context2.sent;
	          _context2.next = 7;
	          return (0, _effects.call)([socket, socket.refreshToken], authData.accessToken);
	
	        case 7:
	          _context2.next = 9;
	          return (0, _effects.put)(actions.authUpdate(authData));
	
	        case 9:
	          _context2.next = 22;
	          break;
	
	        case 11:
	          _context2.prev = 11;
	          _context2.t0 = _context2['catch'](1);
	          _context2.next = 15;
	          return (0, _effects.cancelled)();
	
	        case 15:
	          if (!_context2.sent) {
	            _context2.next = 19;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 19:
	          _context2.t0.showInInfoBar = false;
	          _context2.next = 22;
	          return (0, _effects.put)({ type: 'REFRESH_TOKEN_ERROR', error: _context2.t0, errorMessage: 'Could not refresh token.' });
	
	        case 22:
	          _context2.next = 24;
	          return (0, _effects.call)(_reduxSaga.delay, (600000));
	
	        case 24:
	          _context2.next = 0;
	          break;
	
	        case 26:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[1, 11]]);
	}
	
	function watchForLogout() {
	  return regeneratorRuntime.wrap(function watchForLogout$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (false) {
	            _context3.next = 9;
	            break;
	          }
	
	          _context3.next = 3;
	          return (0, _effects.take)(actions.AUTH_LOGOUT);
	
	        case 3:
	          _context3.next = 5;
	          return (0, _effects.call)(_authStore.removeAuthData);
	
	        case 5:
	          _context3.next = 7;
	          return (0, _effects.call)(_sagas.navigateToWebsite);
	
	        case 7:
	          _context3.next = 0;
	          break;
	
	        case 9:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function backgroundSaga(socket) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return [(0, _effects.fork)(manageToken, socket), (0, _effects.fork)(watchForLogout)];
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}

/***/ },

/***/ "./src/members/state/auth/selectors.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getAuth = exports.getAuth = function getAuth(state) {
	  return state.auth;
	};

/***/ },

/***/ "./src/members/state/categories/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CATEGORIES_FETCH = exports.CATEGORIES_FETCH = 'CATEGORIES_FETCH';
	var CATEGORIES_FETCH_SUCCESS = exports.CATEGORIES_FETCH_SUCCESS = 'CATEGORIES_FETCH_SUCCESS';
	var CATEGORIES_FETCH_ERROR = exports.CATEGORIES_FETCH_ERROR = 'CATEGORIES_FETCH_ERROR';
	var categoriesFetch = exports.categoriesFetch = function categoriesFetch(categoriesType) {
	  return { type: CATEGORIES_FETCH, categoriesType: categoriesType };
	};
	
	var CATEGORY_SELECT = exports.CATEGORY_SELECT = 'CATEGORY_SELECT';
	var categorySelect = exports.categorySelect = function categorySelect(categoryType, categoryId) {
	  return { type: CATEGORY_SELECT, categoryType: categoryType, categoryId: categoryId };
	};

/***/ },

/***/ "./src/members/state/categories/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.categoriesFetch = categoriesFetch;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function categoriesFetch(type) {
	  return (0, _api.callApi)('/categories', {
	    query: {
	      type: type
	    }
	  }).then(function (json) {
	    var _normalize = (0, _normalizr.normalize)(json, schemas.categoriesArraySchema),
	        result = _normalize.result,
	        entities = _normalize.entities;
	
	    return { categoriesIds: result, entities: entities };
	  });
	}

/***/ },

/***/ "./src/members/state/categories/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.CATEGORIES_FETCH_SUCCESS],
	  entityType: 'categories'
	});

/***/ },

/***/ "./src/members/state/categories/categorySelection/articles/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _categorySelectionMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/categorySelectionMaker.js");
	
	var _categorySelectionMaker2 = _interopRequireDefault(_categorySelectionMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _categorySelectionMaker2.default)({
	  selectType: actions.CATEGORY_SELECT,
	  idKey: 'categoryId'
	});

/***/ },

/***/ "./src/members/state/categories/categorySelection/forumThreads/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _categorySelectionMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/categorySelectionMaker.js");
	
	var _categorySelectionMaker2 = _interopRequireDefault(_categorySelectionMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _categorySelectionMaker2.default)({
	  selectType: actions.CATEGORY_SELECT,
	  idKey: 'categoryId'
	});

/***/ },

/***/ "./src/members/state/categories/categorySelection/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	var _reducer = __webpack_require__("./src/members/state/categories/categorySelection/articles/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/categories/categorySelection/forumThreads/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('categoryType', {
	  articles: _reducer2.default,
	  forumThreads: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/categories/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/categories/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/categories/categorySelection/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  categorySelection: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/categories/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [backgroundSaga].map(regeneratorRuntime.mark);
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.CATEGORIES_FETCH, request(api.categoriesFetch, 'categoriesType'))];
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ },

/***/ "./src/members/state/categories/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCategorySelected = exports.getCategories = exports.getCategoryById = undefined;
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var mount = (0, _selectors.mountSelectorAt)('categories');
	
	var getCategoryById = exports.getCategoryById = mount(function (localState, categoryId) {
	  return localState.byId[categoryId];
	});
	
	var getCategories = exports.getCategories = mount(function (localState, rootState) {
	  return Object.keys(localState.byId).map(function (categoryId) {
	    return getCategoryById(rootState, categoryId);
	  }).sort(function (category1, category2) {
	    return category1.title.localeCompare(category2.title);
	  });
	});
	
	var getCategorySelected = exports.getCategorySelected = mount(function (localState, categoryType, rootState) {
	  var selectedCategoryId = localState.categorySelection[categoryType].selectedCategory;
	
	  if (!selectedCategoryId) {
	    return null;
	  }
	
	  return getCategoryById(rootState, selectedCategoryId);
	});

/***/ },

/***/ "./src/members/state/chat/actions.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.chatScheduleFetch = exports.CHAT_SCHEDULE_FETCH_ERROR = exports.CHAT_SCHEDULE_FETCH_SUCCESS = exports.CHAT_SCHEDULE_FETCH = exports.chatEmojisHide = exports.CHAT_EMOJIS_HIDE = exports.chatEmojisShow = exports.CHAT_EMOJIS_SHOW = exports.chatResourcesUpdatePossiblePage = exports.CHAT_RESOURCES_UPDATE_POSSIBLE_PAGE = exports.chatResourcesFetch = exports.CHAT_RESOURCES_FETCH_ERROR = exports.CHAT_RESOURCES_FETCH_SUCCESS = exports.CHAT_RESOURCES_FETCH = exports.chatDocumentsReceived = exports.CHAT_DOCUMENTS_RECEIVED = exports.chatWebsitesReceived = exports.CHAT_WEBSITES_RECEIVED = exports.chatQuestionnaireSubmit = exports.CHAT_QUESTIONNAIRE_SUBMIT_ERROR = exports.CHAT_QUESTIONNAIRE_SUBMIT_SUCCESS = exports.CHAT_QUESTIONNAIRE_SUBMIT = exports.chatQuestionnaireUpdate = exports.CHAT_QUESTIONNAIRE_UPDATE = exports.chatQuestionUpdate = exports.CHAT_QUESTION_UPDATE = exports.chatQuestionnairesReceived = exports.CHAT_QUESTIONNAIRES_RECEIVED = exports.chatMessageUpdateWritingIndicator = exports.CHAT_MESSAGE_UPDATE_WRITING_INDICATOR = exports.chatMessageEditingReset = exports.CHAT_MESSAGE_EDITING_RESET = exports.chatMessageEditingUpdateText = exports.CHAT_MESSAGE_EDITING_UPDATE_TEXT = exports.chatMessageRemove = exports.CHAT_MESSAGE_REMOVE = exports.chatMessageAdd = exports.CHAT_MESSAGE_ADD_SUCCESS = exports.CHAT_MESSAGE_ADD = exports.chatActiveStateUpdate = exports.CHAT_ACTIVE_STATE_UPDATE = exports.chatMessagesUpdate = exports.CHAT_MESSAGES_UPDATE = exports.chatClose = exports.CHAT_CLOSE = exports.chatOpen = exports.CHAT_OPEN = exports.chatStateUpdate = exports.CHAT_STATE_UPDATE = exports.chatEnqueueCancel = exports.CHAT_ENQUEUE_CANCEL_ERROR = exports.CHAT_ENQUEUE_CANCEL_SUCCESS = exports.CHAT_ENQUEUE_CANCEL = exports.chatQueueRejectionExpire = exports.CHAT_QUEUE_REJECTION_EXPIRE = exports.chatEnqueue = exports.CHAT_ENQUEUE_ERROR = exports.CHAT_ENQUEUE_SUCCESS = exports.CHAT_ENQUEUE = undefined;
	
	var _actions = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var CHAT_ENQUEUE = exports.CHAT_ENQUEUE = 'CHAT_ENQUEUE';
	var CHAT_ENQUEUE_SUCCESS = exports.CHAT_ENQUEUE_SUCCESS = 'CHAT_ENQUEUE_SUCCESS';
	var CHAT_ENQUEUE_ERROR = exports.CHAT_ENQUEUE_ERROR = 'CHAT_ENQUEUE_ERROR';
	var chatEnqueue = exports.chatEnqueue = function chatEnqueue() {
	  return { type: CHAT_ENQUEUE };
	};
	
	var CHAT_QUEUE_REJECTION_EXPIRE = exports.CHAT_QUEUE_REJECTION_EXPIRE = 'CHAT_QUEUE_REJECTION_EXPIRE';
	var chatQueueRejectionExpire = exports.chatQueueRejectionExpire = function chatQueueRejectionExpire() {
	  return { type: CHAT_QUEUE_REJECTION_EXPIRE };
	};
	
	var CHAT_ENQUEUE_CANCEL = exports.CHAT_ENQUEUE_CANCEL = 'CHAT_ENQUEUE_CANCEL';
	var CHAT_ENQUEUE_CANCEL_SUCCESS = exports.CHAT_ENQUEUE_CANCEL_SUCCESS = 'CHAT_ENQUEUE_CANCEL_SUCCESS';
	var CHAT_ENQUEUE_CANCEL_ERROR = exports.CHAT_ENQUEUE_CANCEL_ERROR = 'CHAT_ENQUEUE_CANCEL_ERROR';
	var chatEnqueueCancel = exports.chatEnqueueCancel = function chatEnqueueCancel() {
	  return { type: CHAT_ENQUEUE_CANCEL };
	};
	
	var CHAT_STATE_UPDATE = exports.CHAT_STATE_UPDATE = 'CHAT_STATE_UPDATE';
	var chatStateUpdate = exports.chatStateUpdate = function chatStateUpdate(chatStateOnServer) {
	  return { type: CHAT_STATE_UPDATE, chatStateOnServer: chatStateOnServer };
	};
	
	var CHAT_OPEN = exports.CHAT_OPEN = 'CHAT_OPEN';
	var chatOpen = exports.chatOpen = function chatOpen() {
	  return { type: CHAT_OPEN };
	};
	
	var CHAT_CLOSE = exports.CHAT_CLOSE = 'CHAT_CLOSE';
	var chatClose = exports.chatClose = function chatClose() {
	  return { type: CHAT_CLOSE };
	};
	
	var CHAT_MESSAGES_UPDATE = exports.CHAT_MESSAGES_UPDATE = 'CHAT_MESSAGES_UPDATE';
	var chatMessagesUpdate = exports.chatMessagesUpdate = function chatMessagesUpdate(result) {
	  var initiatedByServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return { type: CHAT_MESSAGES_UPDATE, result: result, initiatedByServer: initiatedByServer };
	};
	
	var CHAT_ACTIVE_STATE_UPDATE = exports.CHAT_ACTIVE_STATE_UPDATE = 'CHAT_ACTIVE_STATE_UPDATE';
	var chatActiveStateUpdate = exports.chatActiveStateUpdate = function chatActiveStateUpdate(chatActiveState) {
	  return { type: CHAT_ACTIVE_STATE_UPDATE, chatActiveState: chatActiveState };
	};
	
	var CHAT_MESSAGE_ADD = exports.CHAT_MESSAGE_ADD = 'CHAT_MESSAGE_ADD';
	var CHAT_MESSAGE_ADD_SUCCESS = exports.CHAT_MESSAGE_ADD_SUCCESS = 'CHAT_MESSAGE_ADD_SUCCESS';
	var chatMessageAdd = exports.chatMessageAdd = function chatMessageAdd(text) {
	  return {
	    type: CHAT_MESSAGE_ADD,
	    chatMessage: {
	      text: text,
	      id: Math.random().toString(),
	      fromCounsellor: false,
	      createdAt: new Date()
	    }
	  };
	};
	
	var CHAT_MESSAGE_REMOVE = exports.CHAT_MESSAGE_REMOVE = 'CHAT_MESSAGE_REMOVE';
	var chatMessageRemove = exports.chatMessageRemove = function chatMessageRemove(id) {
	  return { type: CHAT_MESSAGE_REMOVE, id: id };
	};
	
	var CHAT_MESSAGE_EDITING_UPDATE_TEXT = exports.CHAT_MESSAGE_EDITING_UPDATE_TEXT = 'CHAT_MESSAGE_EDITING_UPDATE_TEXT';
	var chatMessageEditingUpdateText = exports.chatMessageEditingUpdateText = (0, _actions.textEditingUpdateTextMaker)(CHAT_MESSAGE_EDITING_UPDATE_TEXT);
	
	var CHAT_MESSAGE_EDITING_RESET = exports.CHAT_MESSAGE_EDITING_RESET = 'CHAT_MESSAGE_EDITING_RESET';
	var chatMessageEditingReset = exports.chatMessageEditingReset = function chatMessageEditingReset() {
	  return { type: CHAT_MESSAGE_EDITING_RESET };
	};
	
	var CHAT_MESSAGE_UPDATE_WRITING_INDICATOR = exports.CHAT_MESSAGE_UPDATE_WRITING_INDICATOR = 'CHAT_MESSAGE_UPDATE_WRITING_INDICATOR';
	var chatMessageUpdateWritingIndicator = exports.chatMessageUpdateWritingIndicator = function chatMessageUpdateWritingIndicator(isWriting) {
	  return { type: CHAT_MESSAGE_UPDATE_WRITING_INDICATOR, isWriting: isWriting };
	};
	
	var CHAT_QUESTIONNAIRES_RECEIVED = exports.CHAT_QUESTIONNAIRES_RECEIVED = 'CHAT_QUESTIONNAIRES_RECEIVED';
	var chatQuestionnairesReceived = exports.chatQuestionnairesReceived = function chatQuestionnairesReceived(result) {
	  return { type: CHAT_QUESTIONNAIRES_RECEIVED, result: result };
	};
	
	var CHAT_QUESTION_UPDATE = exports.CHAT_QUESTION_UPDATE = 'CHAT_QUESTION_UPDATE';
	var chatQuestionUpdate = exports.chatQuestionUpdate = function chatQuestionUpdate(chatQuestionnaireId, chatQuestionId, updates) {
	  return { type: CHAT_QUESTION_UPDATE, chatQuestionnaireId: chatQuestionnaireId, chatQuestionId: chatQuestionId, updates: updates };
	};
	
	var CHAT_QUESTIONNAIRE_UPDATE = exports.CHAT_QUESTIONNAIRE_UPDATE = 'CHAT_QUESTIONNAIRE_UPDATE';
	var chatQuestionnaireUpdate = exports.chatQuestionnaireUpdate = function chatQuestionnaireUpdate(chatQuestionnaireId, updates) {
	  return { type: CHAT_QUESTIONNAIRE_UPDATE, chatQuestionnaireId: chatQuestionnaireId, updates: updates };
	};
	
	var CHAT_QUESTIONNAIRE_SUBMIT = exports.CHAT_QUESTIONNAIRE_SUBMIT = 'CHAT_QUESTIONNAIRE_SUBMIT';
	var CHAT_QUESTIONNAIRE_SUBMIT_SUCCESS = exports.CHAT_QUESTIONNAIRE_SUBMIT_SUCCESS = 'CHAT_QUESTIONNAIRE_SUBMIT_SUCCESS';
	var CHAT_QUESTIONNAIRE_SUBMIT_ERROR = exports.CHAT_QUESTIONNAIRE_SUBMIT_ERROR = 'CHAT_QUESTIONNAIRE_SUBMIT_ERROR';
	var chatQuestionnaireSubmit = exports.chatQuestionnaireSubmit = function chatQuestionnaireSubmit(chatQuestionnaire) {
	  return { type: CHAT_QUESTIONNAIRE_SUBMIT, chatQuestionnaire: chatQuestionnaire };
	};
	
	var CHAT_WEBSITES_RECEIVED = exports.CHAT_WEBSITES_RECEIVED = 'CHAT_WEBSITES_RECEIVED';
	var chatWebsitesReceived = exports.chatWebsitesReceived = function chatWebsitesReceived(result) {
	  return { type: CHAT_WEBSITES_RECEIVED, result: result };
	};
	
	var CHAT_DOCUMENTS_RECEIVED = exports.CHAT_DOCUMENTS_RECEIVED = 'CHAT_DOCUMENTS_RECEIVED';
	var chatDocumentsReceived = exports.chatDocumentsReceived = function chatDocumentsReceived(result) {
	  return { type: CHAT_DOCUMENTS_RECEIVED, result: result };
	};
	
	var CHAT_RESOURCES_FETCH = exports.CHAT_RESOURCES_FETCH = 'CHAT_RESOURCES_FETCH';
	var CHAT_RESOURCES_FETCH_SUCCESS = exports.CHAT_RESOURCES_FETCH_SUCCESS = 'CHAT_RESOURCES_FETCH_SUCCESS';
	var CHAT_RESOURCES_FETCH_ERROR = exports.CHAT_RESOURCES_FETCH_ERROR = 'CHAT_RESOURCES_FETCH_ERROR';
	var chatResourcesFetch = exports.chatResourcesFetch = function chatResourcesFetch() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  return { type: CHAT_RESOURCES_FETCH, page: page };
	};
	
	var CHAT_RESOURCES_UPDATE_POSSIBLE_PAGE = exports.CHAT_RESOURCES_UPDATE_POSSIBLE_PAGE = 'MAIL_THREADS_UPDATE_POSSIBLE_PAGE';
	var chatResourcesUpdatePossiblePage = exports.chatResourcesUpdatePossiblePage = function chatResourcesUpdatePossiblePage(possiblePage) {
	  return { type: CHAT_RESOURCES_UPDATE_POSSIBLE_PAGE, possiblePage: possiblePage };
	};
	
	var CHAT_EMOJIS_SHOW = exports.CHAT_EMOJIS_SHOW = 'CHAT_EMOJIS_SHOW';
	var chatEmojisShow = exports.chatEmojisShow = function chatEmojisShow(key) {
	  return { type: CHAT_EMOJIS_SHOW, key: key };
	};
	
	var CHAT_EMOJIS_HIDE = exports.CHAT_EMOJIS_HIDE = 'CHAT_EMOJIS_HIDE';
	var chatEmojisHide = exports.chatEmojisHide = function chatEmojisHide(key) {
	  return { type: CHAT_EMOJIS_HIDE, key: key };
	};
	
	var CHAT_SCHEDULE_FETCH = exports.CHAT_SCHEDULE_FETCH = 'CHAT_SCHEDULE_FETCH';
	var CHAT_SCHEDULE_FETCH_SUCCESS = exports.CHAT_SCHEDULE_FETCH_SUCCESS = 'CHAT_SCHEDULE_FETCH_SUCCESS';
	var CHAT_SCHEDULE_FETCH_ERROR = exports.CHAT_SCHEDULE_FETCH_ERROR = 'CHAT_SCHEDULE_FETCH_ERROR';
	var chatScheduleFetch = exports.chatScheduleFetch = function chatScheduleFetch() {
	  return { type: CHAT_SCHEDULE_FETCH };
	};

/***/ },

/***/ "./src/members/state/chat/activeState/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  counsellor: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.CHAT_ACTIVE_STATE_UPDATE:
	      return _extends({}, action.chatActiveState);
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/chat/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.chatResourcesFetch = chatResourcesFetch;
	exports.chatScheduleFetch = chatScheduleFetch;
	exports.chatQuestionnaireSubmit = chatQuestionnaireSubmit;
	exports.chatStatusFetch = chatStatusFetch;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function chatResourcesFetch(page) {
	  return (0, _api.callApi)('/chat/resources', {
	    query: _extends({}, (0, _api.pageToOffsetParams)(page, (10)))
	  }).then(function (json) {
	    var resources = json.resources,
	        meta = json.meta;
	
	    var _normalize = (0, _normalizr.normalize)(resources, schemas.chatResourcesArraySchema),
	        result = _normalize.result,
	        entities = _normalize.entities;
	
	    return { chatResourcesIds: result, entities: entities, meta: meta };
	  });
	}
	
	function chatScheduleFetch() {
	  return (0, _api.callApi)('/chat/schedule');
	}
	
	function chatQuestionnaireSubmit(chatQuestionnaire) {
	  return (0, _api.callApi)('/questionnaires', {
	    method: 'POST',
	    body: chatQuestionnaire
	  });
	}
	
	function chatStatusFetch() {
	  return (0, _api.callApi)('/chat/status');
	}

/***/ },

/***/ "./src/members/state/chat/chatDocuments/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.CHAT_DOCUMENTS_RECEIVED],
	  entityType: 'chatDocuments'
	});

/***/ },

/***/ "./src/members/state/chat/chatDocuments/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/chat/chatDocuments/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/chat/chatItems/chatMessagesBuffer/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var INITIAL_STATE = [];
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case actions.CHAT_MESSAGES_UPDATE:
	      {
	        if (action.initiatedByServer) {
	          return INITIAL_STATE;
	        }
	
	        return [].concat(_toConsumableArray(state), _toConsumableArray(action.result.chatMessagesIds));
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/chat/chatItems/lastChatMessageId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = 0;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case actions.CHAT_MESSAGES_UPDATE:
	      {
	        if (action.initiatedByServer) {
	          return action.result.lastChatMessageId;
	        }
	
	        return state;
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/chat/chatItems/list/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var INITIAL_STATE = [];
	
	var itemForChatMessageId = function itemForChatMessageId(id) {
	  return { chatMessageId: id };
	};
	var itemForChatDocumentId = function itemForChatDocumentId(id) {
	  return { chatDocumentId: id };
	};
	var itemForChatWebsiteId = function itemForChatWebsiteId(id) {
	  return { chatWebsiteId: id };
	};
	var itemForGoalsIds = function itemForGoalsIds(ids) {
	  return { goalsIds: ids };
	};
	var itemForChatQuestionnaireId = function itemForChatQuestionnaireId(id) {
	  return { chatQuestionnaireId: id };
	};
	var itemsForChatEntities = function itemsForChatEntities(ids, wrapper) {
	  return ids.map(function (id) {
	    return wrapper(id);
	  });
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.CHAT_MESSAGES_UPDATE:
	      return [].concat(_toConsumableArray(state), _toConsumableArray(itemsForChatEntities(action.result.chatMessagesIds, itemForChatMessageId)));
	
	    case actions.CHAT_DOCUMENTS_RECEIVED:
	      return [].concat(_toConsumableArray(state), _toConsumableArray(itemsForChatEntities(action.result.chatDocumentsIds, itemForChatDocumentId)));
	
	    case actions.CHAT_WEBSITES_RECEIVED:
	      return [].concat(_toConsumableArray(state), _toConsumableArray(itemsForChatEntities(action.result.chatWebsitesIds, itemForChatWebsiteId)));
	
	    case actions.GOALS_RECEIVED:
	      {
	        var itemsWithoutGoals = state.filter(function (item) {
	          return !item.goalsIds;
	        });
	
	        return [].concat(_toConsumableArray(itemsWithoutGoals), [itemForGoalsIds(action.result.goalsIds)]);
	      }
	
	    case actions.CHAT_QUESTIONNAIRES_RECEIVED:
	      {
	        var questionnaireId = action.result.chatQuestionnairesIds;
	
	        if (questionnaireId === 'eos') {
	          return state;
	        }
	
	        var itemsWithoutWithThisQuestionnaire = state.filter(function (item) {
	          return !item.chatQuestionnaireId || item.chatQuestionnaireId !== questionnaireId;
	        });
	
	        return [].concat(_toConsumableArray(itemsWithoutWithThisQuestionnaire), [itemForChatQuestionnaireId(questionnaireId)]);
	      }
	
	    case actions.CHAT_STATE_UPDATE:
	      {
	        if (!action.chatStateOnServer.activeChat) {
	          return INITIAL_STATE;
	        }
	
	        return state;
	      }
	
	    case actions.CHAT_MESSAGE_REMOVE:
	      return state.filter(function (item) {
	        return item.chatMessageId && item.chatMessageId !== action.id;
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/chat/chatItems/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/chat/chatItems/list/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/chat/chatItems/lastChatMessageId/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/chat/chatItems/chatMessagesBuffer/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  list: _reducer2.default,
	  lastChatMessageId: _reducer4.default,
	  chatMessagesBuffer: _reducer6.default
	});

/***/ },

/***/ "./src/members/state/chat/chatMessages/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.CHAT_MESSAGES_UPDATE],
	  removeType: actions.CHAT_MESSAGE_REMOVE,
	  entityType: 'chatMessages'
	});

/***/ },

/***/ "./src/members/state/chat/chatMessages/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/chat/chatMessages/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/chat/chatQuestionnaires/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.CHAT_QUESTIONNAIRES_RECEIVED],
	  updateSuccessTypes: [actions.CHAT_QUESTIONNAIRE_UPDATE],
	  entityType: 'chatQuestionnaires',
	  updateKey: 'chatQuestionnaireId'
	});

/***/ },

/***/ "./src/members/state/chat/chatQuestionnaires/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/chat/chatQuestionnaires/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/chat/chatQuestions/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.CHAT_QUESTIONNAIRES_RECEIVED],
	  updateSuccessTypes: [actions.CHAT_QUESTION_UPDATE],
	  entityType: 'chatQuestions',
	  updateKey: 'chatQuestionId'
	});

/***/ },

/***/ "./src/members/state/chat/chatQuestions/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/chat/chatQuestions/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/chat/chatResources/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.CHAT_RESOURCES_FETCH_SUCCESS],
	  entityType: 'chatResources'
	});

/***/ },

/***/ "./src/members/state/chat/chatResources/byPage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byPageMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byPageMaker.js");
	
	var _byPageMaker2 = _interopRequireDefault(_byPageMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byPageMaker2.default)([actions.CHAT_RESOURCES_FETCH_SUCCESS], 'chatResourcesIds');

/***/ },

/***/ "./src/members/state/chat/chatResources/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/chat/chatResources/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/chat/chatResources/byPage/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  byPage: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/chat/chatScheduledSessions/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = [];
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.CHAT_SCHEDULE_FETCH:
	      {
	        return INITIAL_STATE;
	      }
	
	    case actions.CHAT_SCHEDULE_FETCH_SUCCESS:
	      {
	        return action.result.scheduledChatSessions;
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/chat/chatWebsites/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.CHAT_WEBSITES_RECEIVED],
	  entityType: 'chatWebsites'
	});

/***/ },

/***/ "./src/members/state/chat/chatWebsites/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/chat/chatWebsites/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/chat/chatWritingIndicator/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = false;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.CHAT_MESSAGE_UPDATE_WRITING_INDICATOR:
	      {
	        return action.isWriting;
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/chat/emojis/chatMessage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _emojisMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/emojisMaker.js");
	
	var _emojisMaker2 = _interopRequireDefault(_emojisMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _emojisMaker2.default)({
	  showType: actions.CHAT_EMOJIS_SHOW,
	  closeType: actions.CHAT_EMOJIS_HIDE
	});

/***/ },

/***/ "./src/members/state/chat/emojis/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reducer = __webpack_require__("./src/members/state/chat/emojis/chatMessage/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('key', {
	  chatMessage: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/chat/feedbackSubmission/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var INITIAL_STATE = {
	  answeredChatQuestionsIds: [],
	  isSubmitting: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  var chatQuestionnaireId = action.chatQuestionnaireId;
	
	  if (!chatQuestionnaireId && action.chatQuestionnaire) {
	    chatQuestionnaireId = action.chatQuestionnaire.id;
	  }
	
	  if (!chatQuestionnaireId || chatQuestionnaireId !== 'eos') {
	    return state;
	  }
	
	  switch (action.type) {
	    case actions.CHAT_QUESTIONNAIRE_SUBMIT:
	      return _extends({}, state, {
	        isSubmitting: true
	      });
	
	    case actions.CHAT_QUESTIONNAIRE_SUBMIT_SUCCESS:
	    case actions.CHAT_QUESTIONNAIRE_SUBMIT_ERROR:
	      return _extends({}, state, {
	        isSubmitting: false
	      });
	
	    case actions.CHAT_QUESTION_UPDATE:
	      {
	        if (state.answeredChatQuestionsIds.indexOf(action.chatQuestionId) < 0) {
	          return _extends({}, state, {
	            answeredChatQuestionsIds: [].concat(_toConsumableArray(state.answeredChatQuestionsIds), [action.chatQuestionId])
	          });
	        }
	
	        return state;
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/chat/paging/chatResources/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _pagingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/pagingMaker.js");
	
	var _pagingMaker2 = _interopRequireDefault(_pagingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _pagingMaker2.default)({
	  fetchType: actions.CHAT_RESOURCES_FETCH,
	  fetchSuccessType: actions.CHAT_RESOURCES_FETCH_SUCCESS,
	  fetchErrorType: actions.CHAT_RESOURCES_FETCH_ERROR,
	  possiblePageUpdateType: actions.CHAT_RESOURCES_UPDATE_POSSIBLE_PAGE
	});

/***/ },

/***/ "./src/members/state/chat/paging/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/chat/paging/chatResources/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  chatResources: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/chat/queueRejection/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  isRejected: false,
	  reason: null,
	  expirationDate: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case actions.CHAT_ENQUEUE_ERROR:
	      {
	        if (!action.error.isRejected) {
	          return state;
	        }
	
	        return {
	          isRejected: true,
	          reason: action.error.message,
	          expirationDate: action.error.expirationDate
	        };
	      }
	
	    case actions.CHAT_QUEUE_REJECTION_EXPIRE:
	      return INITIAL_STATE;
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/chat/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/chat/state/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/chat/chatMessages/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/chat/chatItems/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("./src/members/state/chat/activeState/reducer.js");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__("./src/members/state/chat/chatQuestionnaires/reducer.js");
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	var _reducer11 = __webpack_require__("./src/members/state/chat/chatQuestions/reducer.js");
	
	var _reducer12 = _interopRequireDefault(_reducer11);
	
	var _reducer13 = __webpack_require__("./src/members/state/chat/feedbackSubmission/reducer.js");
	
	var _reducer14 = _interopRequireDefault(_reducer13);
	
	var _reducer15 = __webpack_require__("./src/members/state/chat/chatDocuments/reducer.js");
	
	var _reducer16 = _interopRequireDefault(_reducer15);
	
	var _reducer17 = __webpack_require__("./src/members/state/chat/chatWebsites/reducer.js");
	
	var _reducer18 = _interopRequireDefault(_reducer17);
	
	var _reducer19 = __webpack_require__("./src/members/state/chat/chatScheduledSessions/reducer.js");
	
	var _reducer20 = _interopRequireDefault(_reducer19);
	
	var _reducer21 = __webpack_require__("./src/members/state/chat/chatWritingIndicator/reducer.js");
	
	var _reducer22 = _interopRequireDefault(_reducer21);
	
	var _reducer23 = __webpack_require__("./src/members/state/chat/queueRejection/reducer.js");
	
	var _reducer24 = _interopRequireDefault(_reducer23);
	
	var _reducer25 = __webpack_require__("./src/members/state/chat/chatResources/reducer.js");
	
	var _reducer26 = _interopRequireDefault(_reducer25);
	
	var _reducer27 = __webpack_require__("./src/members/state/chat/paging/reducer.js");
	
	var _reducer28 = _interopRequireDefault(_reducer27);
	
	var _reducer29 = __webpack_require__("./src/members/state/chat/textEditing/reducer.js");
	
	var _reducer30 = _interopRequireDefault(_reducer29);
	
	var _reducer31 = __webpack_require__("./src/members/state/chat/emojis/reducer.js");
	
	var _reducer32 = _interopRequireDefault(_reducer31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  state: _reducer2.default,
	  chatMessages: _reducer4.default,
	  chatQuestionnaires: _reducer10.default,
	  chatQuestions: _reducer12.default,
	  chatItems: _reducer6.default,
	  activeState: _reducer8.default,
	  feedbackSubmission: _reducer14.default,
	  chatDocuments: _reducer16.default,
	  chatWebsites: _reducer18.default,
	  chatScheduledSessions: _reducer20.default,
	  chatWritingIndicator: _reducer22.default,
	  queueRejection: _reducer24.default,
	  chatResources: _reducer26.default,
	  paging: _reducer28.default,
	  textEditing: _reducer30.default,
	  emojis: _reducer32.default
	});

/***/ },

/***/ "./src/members/state/chat/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.watchForFeedbackDecline = watchForFeedbackDecline;
	exports.updateChatQuestion = updateChatQuestion;
	exports.filterUpdatedChatMessages = filterUpdatedChatMessages;
	exports.refreshChatQueueRejectionExpiration = refreshChatQueueRejectionExpiration;
	exports.watchForChatSessionRequests = watchForChatSessionRequests;
	exports.addChatMessage = addChatMessage;
	exports.updateChatWritingIndicator = updateChatWritingIndicator;
	exports.actionForReceivingChatDocument = actionForReceivingChatDocument;
	exports.actionForReceivingChatWebsite = actionForReceivingChatWebsite;
	exports.actionForReceivingGoals = actionForReceivingGoals;
	exports.actionForReceivingChatQuestionnaire = actionForReceivingChatQuestionnaire;
	exports.manageChatActiveStateUpdate = manageChatActiveStateUpdate;
	exports.default = backgroundSaga;
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	var _actions2 = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var _sagas = __webpack_require__("./src/members/state/__shared__/utils/sagas.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _marked = [watchForFeedbackDecline, updateChatQuestion, refreshChatQueueRejectionExpiration, watchForChatSessionRequests, addChatMessage, updateChatWritingIndicator, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForFeedbackDecline() {
	  var action, chatQuestionnaire;
	  return regeneratorRuntime.wrap(function watchForFeedbackDecline$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)(actions.CHAT_QUESTIONNAIRE_UPDATE);
	
	        case 3:
	          action = _context.sent;
	
	          if (!(action.chatQuestionnaireId === 'eos' && action.updates.declined)) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.select)(_selectors.getChatQuestionnaire, action.chatQuestionnaireId);
	
	        case 7:
	          chatQuestionnaire = _context.sent;
	          _context.next = 10;
	          return (0, _effects.put)(actions.chatQuestionnaireSubmit(chatQuestionnaire));
	
	        case 10:
	          _context.next = 0;
	          break;
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function updateChatQuestion(socket, action) {
	  var chatQuestionnaire;
	  return regeneratorRuntime.wrap(function updateChatQuestion$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (!(action.chatQuestionnaireId !== 'eos')) {
	            _context2.next = 6;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _effects.select)(_selectors.getChatQuestionnaire, action.chatQuestionnaireId);
	
	        case 3:
	          chatQuestionnaire = _context2.sent;
	          _context2.next = 6;
	          return (0, _effects.call)(_sagas.socketRequestWithErrorChecks, socket, socket.chatQuestionnaireSubmit, action, chatQuestionnaire);
	
	        case 6:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function filterUpdatedChatMessages(chatMessages, chatMessagesBuffer) {
	  var _normalize = (0, _normalizr.normalize)(chatMessages, schemas.chatMessagesArraySchema),
	      result = _normalize.result,
	      entities = _normalize.entities;
	
	  var filteredChatMessagesIds = result.filter(function (chatMessageId) {
	    var chatMessage = entities.chatMessages[chatMessageId];
	    var bufferedChatMessagesTexts = chatMessagesBuffer.map(function (bufferedChatMessage) {
	      return bufferedChatMessage.text;
	    });
	
	    return chatMessage.fromCounsellor || bufferedChatMessagesTexts.indexOf(chatMessage.text) < 0;
	  });
	
	  var filteredEntities = {
	    chatMessages: {}
	  };
	
	  filteredChatMessagesIds.forEach(function (chatMessageId) {
	    return filteredEntities.chatMessages[chatMessageId] = entities.chatMessages[chatMessageId];
	  });
	
	  return {
	    chatMessagesIds: filteredChatMessagesIds,
	    entities: filteredEntities,
	    lastChatMessageId: result[result.length - 1]
	  };
	}
	
	function refreshChatQueueRejectionExpiration(ban) {
	  var expirationDate, error, errorAction;
	  return regeneratorRuntime.wrap(function refreshChatQueueRejectionExpiration$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          expirationDate = new Date(ban.expiresAtTimestamp);
	
	        case 1:
	          if (false) {
	            _context3.next = 17;
	            break;
	          }
	
	          // eslint-disable-line no-constant-condition
	          error = new Error(ban.reason);
	
	          error.isRejected = true;
	          error.expirationDate = new Date(ban.expiresAtTimestamp);
	          error.showInInfoBar = false;
	
	          errorAction = (0, _actions2.errorActionFrom)(actions.chatEnqueue(), error);
	          _context3.next = 9;
	          return (0, _effects.put)(errorAction);
	
	        case 9:
	          _context3.next = 11;
	          return (0, _effects.call)(_reduxSaga.delay, (60000));
	
	        case 11:
	          if (!(Date.now() > expirationDate.getTime())) {
	            _context3.next = 15;
	            break;
	          }
	
	          _context3.next = 14;
	          return (0, _effects.put)(actions.chatQueueRejectionExpire());
	
	        case 14:
	          return _context3.abrupt('break', 17);
	
	        case 15:
	          _context3.next = 1;
	          break;
	
	        case 17:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchForChatSessionRequests(socket) {
	  var action, _ref, request, cancelAction;
	
	  return regeneratorRuntime.wrap(function watchForChatSessionRequests$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          if (false) {
	            _context4.next = 18;
	            break;
	          }
	
	          _context4.next = 3;
	          return (0, _effects.take)([actions.CHAT_ENQUEUE, actions.CHAT_ENQUEUE_CANCEL]);
	
	        case 3:
	          action = _context4.sent;
	
	          if (!(action.type === actions.CHAT_ENQUEUE_CANCEL)) {
	            _context4.next = 8;
	            break;
	          }
	
	          _context4.next = 7;
	          return (0, _effects.call)(_sagas.socketRequestWithErrorChecks, socket, socket.chatEnqueueCancel, action);
	
	        case 7:
	          return _context4.abrupt('continue', 0);
	
	        case 8:
	          _context4.next = 10;
	          return (0, _effects.race)({ // eslint-disable-line no-unused-vars
	            request: (0, _sagas.socketRequestWithErrorChecks)(socket, socket.chatEnqueue, action),
	            cancelAction: (0, _effects.take)(actions.CHAT_ENQUEUE_CANCEL)
	          });
	
	        case 10:
	          _ref = _context4.sent;
	          request = _ref.request;
	          cancelAction = _ref.cancelAction;
	
	          if (!cancelAction) {
	            _context4.next = 16;
	            break;
	          }
	
	          _context4.next = 16;
	          return (0, _effects.call)(_sagas.socketRequestWithErrorChecks, socket, socket.chatEnqueueCancel, cancelAction);
	
	        case 16:
	          _context4.next = 0;
	          break;
	
	        case 18:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function addChatMessage(socket, addAction) {
	  var chatMessage, updateAction;
	  return regeneratorRuntime.wrap(function addChatMessage$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          chatMessage = addAction.chatMessage;
	          updateAction = actions.chatMessagesUpdate({
	            chatMessagesIds: [chatMessage.id],
	            entities: {
	              chatMessages: _defineProperty({}, chatMessage.id, chatMessage)
	            }
	          }, false);
	          _context5.next = 4;
	          return (0, _effects.put)(updateAction);
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.put)(actions.chatMessageEditingReset());
	
	        case 6:
	          _context5.prev = 6;
	          _context5.next = 9;
	          return (0, _effects.call)([socket, socket.chatSendMessage], { text: chatMessage.text });
	
	        case 9:
	          _context5.next = 19;
	          break;
	
	        case 11:
	          _context5.prev = 11;
	          _context5.t0 = _context5['catch'](6);
	          _context5.next = 15;
	          return (0, _effects.put)(actions.chatMessageRemove(chatMessage.id));
	
	        case 15:
	          _context5.next = 17;
	          return (0, _effects.put)(actions.chatMessageEditingUpdateText({ text: chatMessage.text }));
	
	        case 17:
	          _context5.next = 19;
	          return (0, _effects.put)((0, _actions2.errorActionFrom)(updateAction, _context5.t0));
	
	        case 19:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this, [[6, 11]]);
	}
	
	function updateChatWritingIndicator(socket, updateAction) {
	  var isWriting;
	  return regeneratorRuntime.wrap(function updateChatWritingIndicator$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          isWriting = updateAction.isWriting;
	
	          if (!isWriting) {
	            _context6.next = 6;
	            break;
	          }
	
	          _context6.next = 4;
	          return (0, _effects.call)([socket, socket.chatStartWritingMessage]);
	
	        case 4:
	          _context6.next = 8;
	          break;
	
	        case 6:
	          _context6.next = 8;
	          return (0, _effects.call)([socket, socket.chatStopWritingMessage]);
	
	        case 8:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}
	
	function actionForReceivingChatDocument(panel) {
	  var entity = _extends({
	    id: Date.now()
	  }, panel.data);
	
	  var action = actions.chatDocumentsReceived({
	    chatDocumentsIds: [entity.id],
	    entities: {
	      chatDocuments: _defineProperty({}, entity.id, entity)
	    }
	  });
	
	  return action;
	}
	
	function actionForReceivingChatWebsite(panel) {
	  var entity = _extends({
	    id: Date.now()
	  }, panel.data);
	
	  var action = actions.chatWebsitesReceived({
	    chatWebsitesIds: [entity.id],
	    entities: {
	      chatWebsites: _defineProperty({}, entity.id, _extends({}, panel.metadata, entity))
	    }
	  });
	
	  return action;
	}
	
	function actionForReceivingGoals(panel, chatItems) {
	  var filteredChatItems = chatItems.filter(function (chatItem) {
	    return chatItem.goals;
	  });
	  var receivedGoals = panel.data.map(function (goal) {
	    return _extends({}, goal, {
	      updatedAt: new Date(goal.updatedAt)
	    });
	  });
	  var shouldUpdateGoals = true;
	
	  if (filteredChatItems.length > 0) {
	    var currentGoals = filteredChatItems[0].goals;
	    shouldUpdateGoals = JSON.stringify(receivedGoals, removeUpdateAtReplacer) != JSON.stringify(currentGoals, removeUpdateAtReplacer);
	  }
	
	  if (shouldUpdateGoals) {
	    var goalsIds = receivedGoals.map(function (goal) {
	      return goal.id;
	    });
	    var goalIdToObjectPairs = receivedGoals.map(function (goal) {
	      return _defineProperty({}, goal.id, goal);
	    });
	    var goals = Object.assign.apply(Object, [{}].concat(_toConsumableArray(goalIdToObjectPairs)));
	
	    var action = actions.goalsReceived({
	      goalsIds: goalsIds,
	      entities: {
	        goals: goals
	      }
	    });
	
	    return action;
	  }
	
	  return null;
	}
	
	function actionForReceivingChatQuestionnaire(panel, chatItems) {
	  var receivedQuestionnaire = _extends({}, panel.data, {
	    updatedAt: new Date(panel.data.updatedAt)
	  });
	
	  var filteredChatItems = chatItems.filter(function (chatItem) {
	    return chatItem.chatQuestionnaire && chatItem.chatQuestionnaire.id === receivedQuestionnaire.id;
	  });
	  var shouldUpdateChatQuestionnaire = true;
	
	  if (filteredChatItems.length > 0) {
	    var currentQuestionnaire = filteredChatItems[0].chatQuestionnaire;
	
	    shouldUpdateChatQuestionnaire = JSON.stringify(receivedQuestionnaire, removeUpdateAtReplacer) != JSON.stringify(currentQuestionnaire, removeUpdateAtReplacer);
	  }
	
	  if (shouldUpdateChatQuestionnaire) {
	    var _normalize2 = (0, _normalizr.normalize)(receivedQuestionnaire, schemas.chatQuestionnaireSchema),
	        result = _normalize2.result,
	        entities = _normalize2.entities;
	
	    var action = actions.chatQuestionnairesReceived({ chatQuestionnairesIds: result, entities: entities });
	
	    return action;
	  }
	
	  return null;
	}
	
	function removeUpdateAtReplacer(key, value) {
	  if (key === 'updatedAt') {
	    return undefined;
	  }
	
	  return value;
	}
	
	function manageChatActiveStateUpdate(panel, chatItems) {
	  var actionCreatorForReceiving = {
	    'DOCUMENT': actionForReceivingChatDocument,
	    'WEBSITE': actionForReceivingChatWebsite,
	    'GOALS': actionForReceivingGoals,
	    'QUESTIONNAIRE': actionForReceivingChatQuestionnaire
	  };
	
	  var action = actionCreatorForReceiving[panel.type](panel, chatItems);
	
	  return action;
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.CHAT_QUESTIONNAIRE_SUBMIT, request(api.chatQuestionnaireSubmit, 'chatQuestionnaire')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.CHAT_RESOURCES_FETCH, request(api.chatResourcesFetch, 'page')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.CHAT_SCHEDULE_FETCH, request(api.chatScheduleFetch)), (0, _effects.fork)(_reduxSaga.takeLatest, actions.CHAT_QUESTION_UPDATE, updateChatQuestion, socket), (0, _effects.fork)(_reduxSaga.takeEvery, actions.CHAT_MESSAGE_ADD, addChatMessage, socket), (0, _effects.fork)(_reduxSaga.takeEvery, actions.CHAT_MESSAGE_UPDATE_WRITING_INDICATOR, updateChatWritingIndicator, socket), (0, _effects.fork)(watchForFeedbackDecline), (0, _effects.fork)(watchForChatSessionRequests, socket)];
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}

/***/ },

/***/ "./src/members/state/chat/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getChatItems = exports.getChatEmojis = exports.getFirstChatScheduledSessionStartDate = exports.getChatResources = exports.getChatFeedbackIsFilled = exports.getChatFeedbackSubmission = exports.getChatQuestionnaire = exports.getChatActiveState = exports.getChatLastMessageId = exports.getChatMessagesBuffer = exports.getChatQuestionnairesById = exports.getChatQuestionsById = exports.getChatItemsNormalized = exports.getChatWebsitesById = exports.getChatMessagesById = exports.getChatDocumentsById = exports.getChatWritingIndicator = exports.getChatState = exports.getChatQueueRejection = exports.getChatPaging = exports.getChatTextEditing = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var _goals = __webpack_require__("./src/members/__shared__/selectors/goals.js");
	
	var goalSelectors = _interopRequireWildcard(_goals);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mount = (0, _selectors.mountSelectorAt)('chat');
	
	var getChatTextEditing = exports.getChatTextEditing = mount(function (localState, key) {
	  return (0, _selectors.getTextEditing)(localState.textEditing[key]);
	});
	
	var getChatPaging = exports.getChatPaging = mount(function (localState, key, options) {
	  return (0, _selectors.getPaging)(localState.paging[key], options);
	});
	
	var getChatQueueRejection = exports.getChatQueueRejection = mount(function (localState) {
	  return localState.queueRejection;
	});
	
	var getChatState = exports.getChatState = mount(function (localState) {
	  var chatState = localState.state;
	  var stringValue = void 0;
	
	  if (!chatState.isOnline) {
	    stringValue = 'OFFLINE';
	  } else if (chatState.isActive) {
	    if (!chatState.didOpenChat) {
	      stringValue = 'ACTIVE_NOT_STARTED';
	    } else {
	      stringValue = 'ACTIVE_STARTED';
	    }
	  } else if (chatState.waitingToCancelEnqueue) {
	    stringValue = 'WAITING_TO_CANCEL_ENQUEUE';
	  } else if (chatState.isQueued) {
	    stringValue = 'QUEUED';
	  } else if (chatState.waitingToEnqueue) {
	    stringValue = 'WAITING_TO_ENQUEUE';
	  } else {
	    stringValue = 'ONLINE';
	  }
	
	  return _extends({}, chatState, {
	    stringValue: stringValue
	  });
	});
	
	var getChatWritingIndicator = exports.getChatWritingIndicator = mount(function (localState) {
	  return localState.chatWritingIndicator;
	});
	
	var getChatDocumentsById = exports.getChatDocumentsById = mount(function (localState) {
	  return localState.chatDocuments.byId;
	});
	
	var getChatMessagesById = exports.getChatMessagesById = mount(function (localState) {
	  return localState.chatMessages.byId;
	});
	
	var getChatWebsitesById = exports.getChatWebsitesById = mount(function (localState) {
	  return localState.chatWebsites.byId;
	});
	
	var getChatItemsNormalized = exports.getChatItemsNormalized = mount(function (localState) {
	  return localState.chatItems.list;
	});
	
	var getChatQuestionsById = exports.getChatQuestionsById = mount(function (localState) {
	  return localState.chatQuestions.byId;
	});
	
	var getChatQuestionnairesById = exports.getChatQuestionnairesById = mount(function (localState) {
	  return localState.chatQuestionnaires.byId;
	});
	
	var getChatMessagesBuffer = exports.getChatMessagesBuffer = mount(function (localState) {
	  var chatMessagesIds = localState.chatItems.chatMessagesBuffer;
	
	  return chatMessagesIds.map(function (id) {
	    return localState.chatMessages.byId[id];
	  });
	});
	
	var getChatLastMessageId = exports.getChatLastMessageId = mount(function (localState) {
	  return localState.chatItems.lastChatMessageId;
	});
	
	var getChatActiveState = exports.getChatActiveState = mount(function (localState) {
	  return localState.activeState;
	});
	
	var getChatQuestionnaire = exports.getChatQuestionnaire = mount(function (localState, id) {
	  var chatQuestionnaire = localState.chatQuestionnaires.byId[id];
	
	  if (!chatQuestionnaire) {
	    return null;
	  }
	
	  var questions = chatQuestionnaire.questions.map(function (id) {
	    return localState.chatQuestions.byId[id];
	  });
	
	  return _extends({}, chatQuestionnaire, {
	    questions: questions
	  });
	});
	
	var getChatFeedbackSubmission = exports.getChatFeedbackSubmission = mount(function (localState) {
	  return localState.feedbackSubmission;
	});
	
	var getChatFeedbackIsFilled = exports.getChatFeedbackIsFilled = mount(function (localState, rootState) {
	  var chatQuestionnaire = getChatQuestionnaire(rootState, 'eos');
	
	  if (!chatQuestionnaire) {
	    return false;
	  }
	
	  var feedbackSubmission = getChatFeedbackSubmission(rootState);
	
	  return chatQuestionnaire.questions.length === feedbackSubmission.answeredChatQuestionsIds.length;
	});
	
	var getChatResourcesIdsForPage = mount(function (localState, props) {
	  var page = props.page;
	
	
	  var chatResourcesIds = localState.chatResources.byPage[page];
	
	  if (!chatResourcesIds) {
	    return [];
	  }
	
	  if (!props.limit) {
	    return chatResourcesIds;
	  }
	
	  return chatResourcesIds.slice(0, Math.min(chatResourcesIds.length, props.limit));
	});
	
	var getChatResourcesById = mount(function (localState) {
	  return localState.chatResources.byId;
	});
	
	var getChatResources = exports.getChatResources = (0, _reselect.createSelector)([getChatResourcesIdsForPage, getChatResourcesById], function (chatResourcesIdsForPage, chatResourcesById) {
	  return chatResourcesIdsForPage.map(function (id) {
	    var chatResource = chatResourcesById[id];
	
	    return chatResource;
	  });
	});
	
	var getFirstChatScheduledSessionStartDate = exports.getFirstChatScheduledSessionStartDate = mount(function (localState) {
	  return localState.chatScheduledSessions[0] && localState.chatScheduledSessions[0].startDate;
	});
	
	var getChatEmojis = exports.getChatEmojis = mount(function (localState, key) {
	  return localState.emojis[key];
	});
	
	var getChatItems = exports.getChatItems = (0, _reselect.createSelector)([getChatItemsNormalized, getChatMessagesById, getChatDocumentsById, getChatWebsitesById, goalSelectors.getGoalsById, getChatQuestionnairesById, getChatQuestionsById], function (chatItemsNormalized, chatMessagesById, chatDocumentsById, chatWebsitesById, goalsById, chatQuestionnairesById, chatQuestionsById) {
	
	  return chatItemsNormalized.map(function (chatItemNormalized) {
	    if (chatItemNormalized.chatMessageId !== undefined) {
	      return { chatMessage: chatMessagesById[chatItemNormalized.chatMessageId] };
	    }
	
	    if (chatItemNormalized.chatDocumentId !== undefined) {
	      return { chatDocument: chatDocumentsById[chatItemNormalized.chatDocumentId] };
	    }
	
	    if (chatItemNormalized.chatWebsiteId !== undefined) {
	      return { chatWebsite: chatWebsitesById[chatItemNormalized.chatWebsiteId] };
	    }
	
	    if (chatItemNormalized.goalsIds !== undefined) {
	      return { goals: chatItemNormalized.goalsIds.map(function (id) {
	          return goalsById[id];
	        }) };
	    }
	
	    if (chatItemNormalized.chatQuestionnaireId !== undefined) {
	      var questionnaire = chatQuestionnairesById[chatItemNormalized.chatQuestionnaireId];
	      var questions = questionnaire.questions.map(function (id) {
	        return chatQuestionsById[id];
	      });
	
	      return {
	        chatQuestionnaire: _extends({}, questionnaire, {
	          questions: questions
	        })
	      };
	    }
	  });
	});

/***/ },

/***/ "./src/members/state/chat/state/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  waitingToEnqueue: false,
	  waitingToCancelEnqueue: false,
	  isQueued: false,
	  isActive: false,
	  isOnline: false,
	  unreadMessagesCount: 0,
	  isWaitingForFeedback: false,
	  isOpened: false,
	  didOpenChat: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.CHAT_ENQUEUE:
	      return _extends({}, state, {
	        waitingToEnqueue: true,
	        didOpenChat: false,
	        isWaitingForFeedback: false,
	        unreadMessagesCount: 0
	      });
	
	    case actions.CHAT_ENQUEUE_SUCCESS:
	      return _extends({}, state, {
	        isQueued: true,
	        waitingToEnqueue: false
	      });
	
	    case actions.CHAT_ENQUEUE_ERROR:
	      return _extends({}, state, {
	        isQueued: false,
	        waitingToEnqueue: false
	      });
	
	    case actions.CHAT_ENQUEUE_CANCEL:
	      return _extends({}, state, {
	        waitingToCancelEnqueue: true
	      });
	
	    case actions.CHAT_ENQUEUE_CANCEL_SUCCESS:
	      return _extends({}, state, {
	        waitingToCancelEnqueue: false,
	        isQueued: false,
	        isActive: false
	      });
	
	    case actions.CHAT_ENQUEUE_CANCEL_ERROR:
	      return _extends({}, state, {
	        waitingToCancelEnqueue: false,
	        isQueued: true,
	        isActive: false
	      });
	
	    case actions.CHAT_STATE_UPDATE:
	      {
	        var isActive = action.chatStateOnServer.activeChat;
	
	        return _extends({}, state, {
	          waitingToEnqueue: false,
	          waitingToCancelEnqueue: false,
	          isQueued: action.chatStateOnServer.queued,
	          isOnline: action.chatStateOnServer.online,
	          isActive: isActive,
	          isWaitingForFeedback: state.isActive && !isActive
	        });
	      }
	
	    case actions.CHAT_MESSAGES_UPDATE:
	      {
	        var unreadMessagesCount = state.unreadMessagesCount;
	
	        if (!state.isOpened) {
	          var chatMessagesById = action.result.entities.chatMessages;
	          var chatMessagesFromCounsellor = Object.keys(chatMessagesById).map(function (id) {
	            return chatMessagesById[id];
	          }).filter(function (chatMessage) {
	            return chatMessage.fromCounsellor;
	          });
	
	          unreadMessagesCount += chatMessagesFromCounsellor.length;
	        }
	
	        return _extends({}, state, {
	          unreadMessagesCount: unreadMessagesCount
	        });
	      }
	
	    case actions.CHAT_WEBSITES_RECEIVED:
	    case actions.CHAT_DOCUMENTS_RECEIVED:
	    case actions.GOALS_RECEIVED:
	    case actions.CHAT_QUESTIONNAIRES_RECEIVED:
	      {
	        if (action.type === actions.CHAT_QUESTIONNAIRES_RECEIVED) {
	          if (action.result.chatQuestionnairesIds === 'eos') {
	            return state;
	          }
	        }
	        return _extends({}, state, {
	          unreadMessagesCount: state.unreadMessagesCount + 1
	        });
	      }
	
	    case actions.CHAT_QUESTIONNAIRE_SUBMIT_SUCCESS:
	      {
	        if (action.chatQuestionnaire.id === 'eos') {
	          return _extends({}, state, {
	            isWaitingForFeedback: false
	          });
	        }
	
	        return state;
	      }
	
	    case actions.CHAT_OPEN:
	      return _extends({}, state, {
	        isOpened: true,
	        didOpenChat: true,
	        unreadMessagesCount: 0
	      });
	
	    case actions.CHAT_CLOSE:
	      return _extends({}, state, {
	        isOpened: false
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/chat/textEditing/chatMessage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _textEditingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/textEditingMaker.js");
	
	var _textEditingMaker2 = _interopRequireDefault(_textEditingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _textEditingMaker2.default)({
	  submitType: actions.CHAT_MESSAGE_ADD,
	  submitSuccessType: actions.CHAT_MESSAGE_ADD,
	  updateTextType: actions.CHAT_MESSAGE_EDITING_UPDATE_TEXT,
	  resetType: actions.CHAT_MESSAGE_EDITING_RESET
	});

/***/ },

/***/ "./src/members/state/chat/textEditing/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/chat/textEditing/chatMessage/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  chatMessage: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/comments/actions.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.commentsResetLiveList = exports.COMMENTS_RESET_LIVE_LIST = exports.commentsChangeSort = exports.COMMENTS_CHANGE_SORT = exports.commentMarkAsUseful = exports.COMMENT_MARK_AS_USEFUL_ERROR = exports.COMMENT_MARK_AS_USEFUL_SUCCESS = exports.COMMENT_MARK_AS_USEFUL = exports.commentsUpdatePossiblePage = exports.COMMENTS_UPDATE_POSSIBLE_PAGE = exports.commentsResetRepliesRelatedProperties = exports.COMMENTS_RESET_REPLIES_RELATED_PROPERTIES = exports.commentCreate = exports.COMMENT_CREATE_ERROR = exports.COMMENT_CREATE_SUCCESS = exports.COMMENT_CREATE = exports.commentReset = exports.COMMENT_RESET = exports.commentExpand = exports.COMMENT_EXPAND = exports.commentUpdateText = exports.COMMENT_UPDATE_TEXT = exports.commentEmojisHide = exports.COMMENT_EMOJIS_HIDE = exports.commentEmojisShow = exports.COMMENT_EMOJIS_SHOW = exports.commentReplyCancel = exports.COMMENT_REPLY_CANCEL = exports.commentReplyBegin = exports.COMMENT_REPLY_BEGIN = exports.commentUpdate = exports.COMMENT_UPDATE = exports.commentsReceived = exports.COMMENTS_RECEIVED = exports.commentsFetch = exports.COMMENTS_FETCH_ERROR = exports.COMMENTS_FETCH_SUCCESS = exports.COMMENTS_FETCH = undefined;
	
	var _actions = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var COMMENTS_FETCH = exports.COMMENTS_FETCH = 'COMMENTS_FETCH';
	var COMMENTS_FETCH_SUCCESS = exports.COMMENTS_FETCH_SUCCESS = 'COMMENTS_FETCH_SUCCESS';
	var COMMENTS_FETCH_ERROR = exports.COMMENTS_FETCH_ERROR = 'COMMENTS_FETCH_ERROR';
	var commentsFetch = exports.commentsFetch = function commentsFetch() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var pageSize = arguments[1];
	  var commentsQuery = arguments[2];
	  var isForLiveList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	  return {
	    type: COMMENTS_FETCH,
	    page: page,
	    pageSize: pageSize,
	    resourceType: commentsQuery.resourceType,
	    resourceId: commentsQuery.resourceId,
	    commentsQuery: commentsQuery,
	    commentsQueryString: JSON.stringify(commentsQuery),
	    isForLiveList: isForLiveList
	  };
	};
	
	var COMMENTS_RECEIVED = exports.COMMENTS_RECEIVED = 'COMMENTS_RECEIVED';
	var commentsReceived = exports.commentsReceived = function commentsReceived(result) {
	  var isForLiveList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return { type: COMMENTS_RECEIVED, result: result, isForLiveList: isForLiveList };
	};
	
	var COMMENT_UPDATE = exports.COMMENT_UPDATE = 'COMMENT_UPDATE';
	var commentUpdate = exports.commentUpdate = function commentUpdate(commentId, stateBeforeLocalUpdate, updates) {
	  return {
	    type: COMMENT_UPDATE,
	    commentId: commentId,
	    stateBeforeLocalUpdate: stateBeforeLocalUpdate,
	    updates: updates
	  };
	};
	
	var COMMENT_REPLY_BEGIN = exports.COMMENT_REPLY_BEGIN = 'COMMENT_REPLY_BEGIN';
	var commentReplyBegin = exports.commentReplyBegin = function commentReplyBegin(commentId) {
	  return { type: COMMENT_REPLY_BEGIN, commentId: commentId };
	};
	
	var COMMENT_REPLY_CANCEL = exports.COMMENT_REPLY_CANCEL = 'COMMENT_REPLY_CANCEL';
	var commentReplyCancel = exports.commentReplyCancel = function commentReplyCancel() {
	  return { type: COMMENT_REPLY_CANCEL };
	};
	
	var COMMENT_EMOJIS_SHOW = exports.COMMENT_EMOJIS_SHOW = 'COMMENT_EMOJIS_SHOW';
	var commentEmojisShow = exports.commentEmojisShow = function commentEmojisShow(key) {
	  return { type: COMMENT_EMOJIS_SHOW, key: key };
	};
	
	var COMMENT_EMOJIS_HIDE = exports.COMMENT_EMOJIS_HIDE = 'COMMENT_EMOJIS_HIDE';
	var commentEmojisHide = exports.commentEmojisHide = function commentEmojisHide(key) {
	  return { type: COMMENT_EMOJIS_HIDE, key: key };
	};
	
	var COMMENT_UPDATE_TEXT = exports.COMMENT_UPDATE_TEXT = 'COMMENT_UPDATE_TEXT';
	var commentUpdateText = exports.commentUpdateText = (0, _actions.textEditingUpdateTextMaker)(COMMENT_UPDATE_TEXT);
	
	var COMMENT_EXPAND = exports.COMMENT_EXPAND = 'COMMENT_EXPAND';
	var commentExpand = exports.commentExpand = function commentExpand(key) {
	  return { type: COMMENT_EXPAND, key: key };
	};
	
	var COMMENT_RESET = exports.COMMENT_RESET = 'COMMENT_RESET';
	var commentReset = exports.commentReset = function commentReset(key) {
	  return { type: COMMENT_RESET, key: key };
	};
	
	var COMMENT_CREATE = exports.COMMENT_CREATE = 'COMMENT_CREATE';
	var COMMENT_CREATE_SUCCESS = exports.COMMENT_CREATE_SUCCESS = 'COMMENT_CREATE_SUCCESS';
	var COMMENT_CREATE_ERROR = exports.COMMENT_CREATE_ERROR = 'COMMENT_CREATE_ERROR';
	var commentCreate = exports.commentCreate = function commentCreate(text, key, resourceType, resourceId, successTitle, successMessage) {
	  return {
	    type: COMMENT_CREATE,
	    text: text,
	    key: key,
	    resourceType: resourceType,
	    resourceId: resourceId,
	    successTitle: successTitle,
	    successMessage: successMessage
	  };
	};
	
	var COMMENTS_RESET_REPLIES_RELATED_PROPERTIES = exports.COMMENTS_RESET_REPLIES_RELATED_PROPERTIES = 'COMMENTS_RESET_REPLIES_RELATED_PROPERTIES';
	var commentsResetRepliesRelatedProperties = exports.commentsResetRepliesRelatedProperties = function commentsResetRepliesRelatedProperties() {
	  return { type: COMMENTS_RESET_REPLIES_RELATED_PROPERTIES };
	};
	
	var COMMENTS_UPDATE_POSSIBLE_PAGE = exports.COMMENTS_UPDATE_POSSIBLE_PAGE = 'COMMENTS_UPDATE_POSSIBLE_PAGE';
	var commentsUpdatePossiblePage = exports.commentsUpdatePossiblePage = function commentsUpdatePossiblePage(possiblePage, commentsQuery) {
	  return {
	    type: COMMENTS_UPDATE_POSSIBLE_PAGE,
	    possiblePage: possiblePage,
	    commentsQuery: commentsQuery,
	    commentsQueryString: JSON.stringify(commentsQuery)
	  };
	};
	
	var COMMENT_MARK_AS_USEFUL = exports.COMMENT_MARK_AS_USEFUL = 'COMMENT_MARK_AS_USEFUL';
	var COMMENT_MARK_AS_USEFUL_SUCCESS = exports.COMMENT_MARK_AS_USEFUL_SUCCESS = 'COMMENT_MARK_AS_USEFUL_SUCCESS';
	var COMMENT_MARK_AS_USEFUL_ERROR = exports.COMMENT_MARK_AS_USEFUL_ERROR = 'COMMENT_MARK_AS_USEFUL_ERROR';
	var commentMarkAsUseful = exports.commentMarkAsUseful = function commentMarkAsUseful(commentId, resourceType, useful) {
	  return { type: COMMENT_MARK_AS_USEFUL, commentId: commentId, resourceType: resourceType, useful: useful };
	};
	
	var COMMENTS_CHANGE_SORT = exports.COMMENTS_CHANGE_SORT = 'COMMENTS_CHANGE_SORT';
	var commentsChangeSort = exports.commentsChangeSort = function commentsChangeSort(value) {
	  return { type: COMMENTS_CHANGE_SORT, value: value };
	};
	
	var COMMENTS_RESET_LIVE_LIST = exports.COMMENTS_RESET_LIVE_LIST = 'COMMENTS_RESET_LIVE_LIST';
	var commentsResetLiveList = exports.commentsResetLiveList = function commentsResetLiveList() {
	  return { type: COMMENTS_RESET_LIVE_LIST };
	};

/***/ },

/***/ "./src/members/state/comments/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.commentsFetch = commentsFetch;
	exports.commentCreate = commentCreate;
	exports.commentMarkAsUseful = commentMarkAsUseful;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	var _commentsResourceTypes = __webpack_require__("./src/members/__shared__/commentsResourceTypes.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function commentsFetch(page, pageSize, _ref) {
	  var resourceType = _ref.resourceType,
	      resourceId = _ref.resourceId,
	      _ref$sort = _ref.sort,
	      sort = _ref$sort === undefined ? 'recent' : _ref$sort,
	      _ref$dateOffset = _ref.dateOffset,
	      dateOffset = _ref$dateOffset === undefined ? null : _ref$dateOffset;
	
	  var query = _extends({
	    resourceType: resourceType,
	    resourceId: resourceId
	  }, (0, _api.pageToOffsetParams)(page, pageSize));
	
	  if (dateOffset) {
	    query = _extends({}, query, { dateOffset: dateOffset });
	  } else {
	    query = _extends({}, query, { sort: sort });
	  }
	
	  return (0, _api.callApi)('/comments', { query: query }).then(function (json) {
	    var comments = json.comments,
	        meta = json.meta;
	
	    var _normalize = (0, _normalizr.normalize)(comments, schemas.commentsArraySchema),
	        result = _normalize.result,
	        entities = _normalize.entities;
	
	    if (comments.length > 0) {
	      Object.keys(entities.comments).forEach(function (commentId) {
	        var comment = entities.comments[commentId];
	
	        comment.resourceType = resourceType;
	        comment.resourceId = resourceId;
	        comment.repliesQueryString = JSON.stringify({
	          resourceId: comment.id,
	          resourceType: (0, _commentsResourceTypes.findCommentRepliesType)(resourceType)
	        });
	      });
	    }
	
	    return { commentsIds: result, entities: entities, meta: meta };
	  });
	}
	
	function commentCreate(text, resourceType, resourceId) {
	  return (0, _api.callApi)('/comments', {
	    method: 'POST',
	    body: {
	      text: text,
	      resourceType: resourceType,
	      resourceId: resourceId
	    }
	  });
	}
	
	function commentMarkAsUseful(commentId, resourceType, useful) {
	  return (0, _api.callApi)('/comments/' + resourceType + '/' + commentId + '/useful', {
	    method: 'POST',
	    body: {
	      useful: useful
	    }
	  });
	}

/***/ },

/***/ "./src/members/state/comments/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.COMMENTS_FETCH_SUCCESS, actions.COMMENTS_RECEIVED],
	  updateSuccessTypes: [actions.COMMENT_UPDATE],
	  updateKey: 'commentId',
	  entityType: 'comments'
	});

/***/ },

/***/ "./src/members/state/comments/byQuery/byPage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byPageMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byPageMaker.js");
	
	var _byPageMaker2 = _interopRequireDefault(_byPageMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byPageMaker2.default)([actions.COMMENTS_FETCH_SUCCESS], 'commentsIds');

/***/ },

/***/ "./src/members/state/comments/byQuery/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/comments/byQuery/byPage/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('commentsQueryString', (0, _redux.combineReducers)({ byPage: _reducer2.default }));

/***/ },

/***/ "./src/members/state/comments/emojis/firstLevel/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _emojisMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/emojisMaker.js");
	
	var _emojisMaker2 = _interopRequireDefault(_emojisMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _emojisMaker2.default)({
	  showType: actions.COMMENT_EMOJIS_SHOW,
	  closeType: actions.COMMENT_EMOJIS_HIDE
	});

/***/ },

/***/ "./src/members/state/comments/emojis/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reducer = __webpack_require__("./src/members/state/comments/emojis/secondLevel/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/comments/emojis/firstLevel/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('key', {
	  secondLevel: _reducer2.default,
	  firstLevel: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/comments/emojis/secondLevel/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _emojisMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/emojisMaker.js");
	
	var _emojisMaker2 = _interopRequireDefault(_emojisMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _emojisMaker2.default)({
	  showType: actions.COMMENT_EMOJIS_SHOW,
	  closeType: actions.COMMENT_EMOJIS_HIDE
	});

/***/ },

/***/ "./src/members/state/comments/live/endReached/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = false;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case actions.COMMENTS_FETCH_SUCCESS:
	      // We are getting older comments
	      return action.isForLiveList && action.result.commentsIds.length == 0;
	
	    case actions.COMMENTS_RESET_LIVE_LIST:
	      return false;
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/comments/live/list/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var INITIAL_STATE = [];
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.COMMENTS_RECEIVED:
	      {
	        // We are getting new comments
	        if (action.isForLiveList) {
	          var unseenIds = action.result.commentsIds.filter(function (commentId) {
	            return !state.includes(commentId);
	          });
	
	          return [].concat(_toConsumableArray(unseenIds), _toConsumableArray(state));
	        }
	
	        return state;
	      }
	
	    case actions.COMMENTS_FETCH_SUCCESS:
	      {
	        // We are getting older comments
	        if (action.isForLiveList) {
	          return [].concat(_toConsumableArray(state), _toConsumableArray(action.result.commentsIds));
	        }
	
	        return state;
	      }
	
	    case actions.COMMENTS_RESET_LIVE_LIST:
	      return [];
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/comments/live/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/comments/live/endReached/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/comments/live/list/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  endReached: _reducer2.default,
	  list: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/comments/paging/byQuery/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _pagingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/pagingMaker.js");
	
	var _pagingMaker2 = _interopRequireDefault(_pagingMaker);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byKeyMaker2.default)('commentsQueryString', (0, _pagingMaker2.default)({
	  fetchType: actions.COMMENTS_FETCH,
	  fetchSuccessType: actions.COMMENTS_FETCH_SUCCESS,
	  fetchErrorType: actions.COMMENTS_FETCH_ERROR,
	  possiblePageUpdateType: actions.COMMENTS_UPDATE_POSSIBLE_PAGE
	}));

/***/ },

/***/ "./src/members/state/comments/paging/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/comments/paging/byQuery/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byQuery: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/comments/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/comments/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/comments/byQuery/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/comments/paging/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("./src/members/state/comments/textEditing/reducer.js");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__("./src/members/state/comments/emojis/reducer.js");
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	var _reducer11 = __webpack_require__("./src/members/state/comments/sort/reducer.js");
	
	var _reducer12 = _interopRequireDefault(_reducer11);
	
	var _reducer13 = __webpack_require__("./src/members/state/comments/live/reducer.js");
	
	var _reducer14 = _interopRequireDefault(_reducer13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  byQuery: _reducer4.default,
	  paging: _reducer6.default,
	  textEditing: _reducer8.default,
	  emojis: _reducer10.default,
	  sort: _reducer12.default,
	  live: _reducer14.default
	});

/***/ },

/***/ "./src/members/state/comments/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForCommentsFetchedSuccessfully = watchForCommentsFetchedSuccessfully;
	exports.watchForCommentsReplying = watchForCommentsReplying;
	exports.watchForResettingRepliesRelatedProperties = watchForResettingRepliesRelatedProperties;
	exports.watchForHighlightedComments = watchForHighlightedComments;
	exports.watchForSuccessfullyCreatedComment = watchForSuccessfullyCreatedComment;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _sagas = __webpack_require__("./src/members/state/__shared__/utils/sagas.js");
	
	var _commentsResourceTypes = __webpack_require__("./src/members/__shared__/commentsResourceTypes.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForCommentsFetchedSuccessfully, watchForCommentsReplying, watchForResettingRepliesRelatedProperties, watchForHighlightedComments, watchForSuccessfullyCreatedComment, backgroundSaga].map(regeneratorRuntime.mark);
	
	var idsWithRepliesRelatedProps = [];
	
	function watchForCommentsFetchedSuccessfully() {
	  var fetchSuccessAction;
	  return regeneratorRuntime.wrap(function watchForCommentsFetchedSuccessfully$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)(actions.COMMENTS_FETCH_SUCCESS);
	
	        case 3:
	          fetchSuccessAction = _context.sent;
	
	          if (!(0, _commentsResourceTypes.isCommentReply)(fetchSuccessAction.resourceType)) {
	            _context.next = 8;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)(actions.commentUpdate(fetchSuccessAction.resourceId, null, { replies: fetchSuccessAction.result.commentsIds }));
	
	        case 7:
	          idsWithRepliesRelatedProps.push(fetchSuccessAction.resourceId);
	
	        case 8:
	          _context.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function watchForCommentsReplying() {
	  var previousCommentId, replyAction, currentCommentId, comment, nestedComment;
	  return regeneratorRuntime.wrap(function watchForCommentsReplying$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          previousCommentId = null;
	
	        case 1:
	          if (false) {
	            _context2.next = 31;
	            break;
	          }
	
	          _context2.next = 4;
	          return (0, _effects.take)([actions.COMMENT_REPLY_BEGIN, actions.COMMENT_REPLY_CANCEL]);
	
	        case 4:
	          replyAction = _context2.sent;
	
	          if (!previousCommentId) {
	            _context2.next = 13;
	            break;
	          }
	
	          _context2.next = 8;
	          return (0, _effects.put)(actions.commentUpdate(previousCommentId, null, { isBeingRepliedTo: false }));
	
	        case 8:
	          _context2.next = 10;
	          return (0, _effects.put)(actions.commentEmojisHide('secondLevel'));
	
	        case 10:
	          _context2.next = 12;
	          return (0, _effects.put)(actions.commentReset('secondLevel'));
	
	        case 12:
	
	          previousCommentId = null;
	
	        case 13:
	          if (!(replyAction.type == actions.COMMENT_REPLY_BEGIN)) {
	            _context2.next = 29;
	            break;
	          }
	
	          currentCommentId = replyAction.commentId;
	          _context2.next = 17;
	          return (0, _effects.select)(_selectors.getCommentById, replyAction.commentId);
	
	        case 17:
	          comment = _context2.sent;
	
	          if (!(0, _commentsResourceTypes.isCommentReply)(comment.resourceType)) {
	            _context2.next = 25;
	            break;
	          }
	
	          currentCommentId = comment.resourceId;
	          _context2.next = 22;
	          return (0, _effects.select)(_selectors.getCommentById, replyAction.commentId);
	
	        case 22:
	          nestedComment = _context2.sent;
	          _context2.next = 25;
	          return (0, _effects.put)(actions.commentUpdateText({ text: '@' + nestedComment.author.userName + ' ', key: 'secondLevel' }));
	
	        case 25:
	          _context2.next = 27;
	          return (0, _effects.put)(actions.commentUpdate(currentCommentId, null, { isBeingRepliedTo: true }));
	
	        case 27:
	          idsWithRepliesRelatedProps.push(currentCommentId);
	
	          previousCommentId = currentCommentId;
	
	        case 29:
	          _context2.next = 1;
	          break;
	
	        case 31:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function watchForResettingRepliesRelatedProperties() {
	  var i, id, action;
	  return regeneratorRuntime.wrap(function watchForResettingRepliesRelatedProperties$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (false) {
	            _context3.next = 14;
	            break;
	          }
	
	          _context3.next = 3;
	          return (0, _effects.take)(actions.COMMENTS_RESET_REPLIES_RELATED_PROPERTIES);
	
	        case 3:
	          i = 0;
	
	        case 4:
	          if (!(i < idsWithRepliesRelatedProps.length)) {
	            _context3.next = 12;
	            break;
	          }
	
	          id = idsWithRepliesRelatedProps[i];
	          action = actions.commentUpdate(id, null, {
	            replies: null,
	            isBeingRepliedTo: false
	          });
	          _context3.next = 9;
	          return (0, _effects.put)(action);
	
	        case 9:
	          i++;
	          _context3.next = 4;
	          break;
	
	        case 12:
	          _context3.next = 0;
	          break;
	
	        case 14:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchForHighlightedComments() {
	  var action, comment;
	  return regeneratorRuntime.wrap(function watchForHighlightedComments$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          if (false) {
	            _context4.next = 17;
	            break;
	          }
	
	          _context4.next = 3;
	          return (0, _effects.take)(actions.COMMENT_UPDATE);
	
	        case 3:
	          action = _context4.sent;
	
	          if (!action.updates.isHighlighted) {
	            _context4.next = 15;
	            break;
	          }
	
	          _context4.next = 7;
	          return (0, _effects.call)(_reduxSaga.delay, 1000);
	
	        case 7:
	          _context4.next = 9;
	          return (0, _effects.select)(_selectors.getCommentById, action.commentId);
	
	        case 9:
	          comment = _context4.sent;
	          _context4.next = 12;
	          return (0, _effects.put)(actions.commentUpdate(action.commentId, null, { isHighlighted: false }));
	
	        case 12:
	          if (!(0, _commentsResourceTypes.isCommentReply)(comment.resourceType)) {
	            _context4.next = 15;
	            break;
	          }
	
	          _context4.next = 15;
	          return (0, _effects.put)(actions.commentUpdate(comment.resourceId, null, { hasHighlightedReply: false }));
	
	        case 15:
	          _context4.next = 0;
	          break;
	
	        case 17:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	var markAsUseful = (0, _sagas.optimisticUpdateMaker)({
	  idKey: 'commentId',
	  localUpdateType: actions.COMMENT_UPDATE,
	  errorType: actions.COMMENT_MARK_AS_USEFUL_ERROR,
	  successType: actions.COMMENT_MARK_AS_USEFUL_SUCCESS,
	  remoteUpdateActionCreator: regeneratorRuntime.mark(function remoteUpdateActionCreator(localUpdateAction) {
	    var comment;
	    return regeneratorRuntime.wrap(function remoteUpdateActionCreator$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            if (!(localUpdateAction.updates && localUpdateAction.updates.useful !== undefined)) {
	              _context5.next = 3;
	              break;
	            }
	
	            comment = localUpdateAction.stateBeforeLocalUpdate;
	            return _context5.abrupt('return', actions.commentMarkAsUseful(localUpdateAction.commentId, comment.resourceType, localUpdateAction.updates.useful));
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, remoteUpdateActionCreator, this);
	  }),
	  localUpdateActionCreator: regeneratorRuntime.mark(function localUpdateActionCreator(lastRemoteState, errorAction) {
	    return regeneratorRuntime.wrap(function localUpdateActionCreator$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', actions.commentUpdate(errorAction.commentId, null, lastRemoteState));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, localUpdateActionCreator, this);
	  })
	});
	
	function watchForSuccessfullyCreatedComment() {
	  var action;
	  return regeneratorRuntime.wrap(function watchForSuccessfullyCreatedComment$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          if (false) {
	            _context7.next = 12;
	            break;
	          }
	
	          _context7.next = 3;
	          return (0, _effects.take)(actions.COMMENT_CREATE_SUCCESS);
	
	        case 3:
	          action = _context7.sent;
	          _context7.next = 6;
	          return (0, _effects.put)(actions.infoShow('success', action.successMessage, action.successTitle));
	
	        case 6:
	          _context7.next = 8;
	          return (0, _effects.put)(actions.commentReplyCancel());
	
	        case 8:
	          _context7.next = 10;
	          return (0, _effects.put)(actions.commentReset('firstLevel'));
	
	        case 10:
	          _context7.next = 0;
	          break;
	
	        case 12:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeEvery, actions.COMMENTS_FETCH, request(api.commentsFetch, 'page', 'pageSize', 'commentsQuery')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.COMMENT_CREATE, request(api.commentCreate, 'text', 'resourceType', 'resourceId')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.COMMENT_MARK_AS_USEFUL, request(api.commentMarkAsUseful, 'commentId', 'resourceType', 'useful')), (0, _effects.fork)(watchForCommentsFetchedSuccessfully), (0, _effects.fork)(watchForCommentsReplying), (0, _effects.fork)(watchForResettingRepliesRelatedProperties), (0, _effects.fork)(markAsUseful), (0, _effects.fork)(watchForHighlightedComments), (0, _effects.fork)(watchForSuccessfullyCreatedComment)];
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[5], this);
	}

/***/ },

/***/ "./src/__shared__/authStore.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasValidToken = hasValidToken;
	exports.getAuthData = getAuthData;
	exports.setAuthData = setAuthData;
	exports.removeAuthData = removeAuthData;
	
	var timestampInSeconds = function timestampInSeconds(timestampInMilliseconds) {
	  return Math.floor(timestampInMilliseconds / 1000);
	};
	
	var isTokenValid = exports.isTokenValid = function isTokenValid(authData) {
	  return authData.expiresAtTimestamp > timestampInSeconds(Date.now());
	};
	
	function hasValidToken() {
	  var authData = getAuthData();
	
	  if (!authData) {
	    return false;
	  }
	
	  return isTokenValid(authData);
	}
	
	function getAuthData() {
	  var data = localStorage.getItem('authData');
	
	  if (!data) {
	    return null;
	  }
	
	  try {
	    return JSON.parse(data);
	  } catch (error) {
	    return null;
	  }
	}
	
	function setAuthData(data) {
	  localStorage.setItem('authData', JSON.stringify(data));
	}
	
	function removeAuthData() {
	  localStorage.removeItem('authData');
	}

/***/ },

/***/ "./src/members/state/comments/sort/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = 'recent';
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.COMMENTS_CHANGE_SORT:
	      return action.value;
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/comments/textEditing/firstLevel/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _textEditingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/textEditingMaker.js");
	
	var _textEditingMaker2 = _interopRequireDefault(_textEditingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _textEditingMaker2.default)({
	  submitType: actions.COMMENT_CREATE,
	  submitSuccessType: actions.COMMENT_CREATE_SUCCESS,
	  submitErrorType: actions.COMMENT_CREATE_ERROR,
	  updateTextType: actions.COMMENT_UPDATE_TEXT,
	  expandType: actions.COMMENT_EXPAND,
	  resetType: actions.COMMENT_RESET
	});

/***/ },

/***/ "./src/members/state/comments/textEditing/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	var _reducer = __webpack_require__("./src/members/state/comments/textEditing/firstLevel/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/comments/textEditing/secondLevel/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('key', {
	  firstLevel: _reducer2.default,
	  secondLevel: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/comments/textEditing/secondLevel/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _textEditingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/textEditingMaker.js");
	
	var _textEditingMaker2 = _interopRequireDefault(_textEditingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _textEditingMaker2.default)({
	  submitType: actions.COMMENT_CREATE,
	  submitSuccessType: actions.COMMENT_CREATE_SUCCESS,
	  submitErrorType: actions.COMMENT_CREATE_ERROR,
	  updateTextType: actions.COMMENT_UPDATE_TEXT,
	  expandType: actions.COMMENT_EXPAND,
	  resetType: actions.COMMENT_RESET
	});

/***/ },

/***/ "./src/members/state/f2f/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var F2F_STATUS_FETCH = exports.F2F_STATUS_FETCH = 'F2F_STATUS_FETCH';
	var F2F_STATUS_FETCH_SUCCESS = exports.F2F_STATUS_FETCH_SUCCESS = 'F2F_STATUS_FETCH_SUCCESS';
	var F2F_STATUS_FETCH_ERROR = exports.F2F_STATUS_FETCH_ERROR = 'F2F_STATUS_FETCH_ERROR';
	var f2fStatusFetch = exports.f2fStatusFetch = function f2fStatusFetch() {
	  return { type: F2F_STATUS_FETCH };
	};
	
	var F2F_LANGUAGES_FETCH = exports.F2F_LANGUAGES_FETCH = 'F2F_LANGUAGES_FETCH';
	var F2F_LANGUAGES_FETCH_SUCCESS = exports.F2F_LANGUAGES_FETCH_SUCCESS = 'F2F_LANGUAGES_FETCH_SUCCESS';
	var F2F_LANGUAGES_FETCH_ERROR = exports.F2F_LANGUAGES_FETCH_ERROR = 'F2F_LANGUAGES_FETCH_ERROR';
	var f2fLanguagesFetch = exports.f2fLanguagesFetch = function f2fLanguagesFetch() {
	  return { type: F2F_LANGUAGES_FETCH };
	};
	
	var F2F_LOCATIONS_FETCH = exports.F2F_LOCATIONS_FETCH = 'F2F_LOCATIONS_FETCH';
	var F2F_LOCATIONS_FETCH_SUCCESS = exports.F2F_LOCATIONS_FETCH_SUCCESS = 'F2F_LOCATIONS_FETCH_SUCCESS';
	var F2F_LOCATIONS_FETCH_ERROR = exports.F2F_LOCATIONS_FETCH_ERROR = 'F2F_LOCATIONS_FETCH_ERROR';
	var f2fLocationsFetch = exports.f2fLocationsFetch = function f2fLocationsFetch() {
	  return { type: F2F_LOCATIONS_FETCH };
	};
	
	var F2F_SCHOOLS_FETCH = exports.F2F_SCHOOLS_FETCH = 'F2F_SCHOOLS_FETCH';
	var F2F_SCHOOLS_FETCH_SUCCESS = exports.F2F_SCHOOLS_FETCH_SUCCESS = 'F2F_SCHOOLS_FETCH_SUCCESS';
	var F2F_SCHOOLS_FETCH_ERROR = exports.F2F_SCHOOLS_FETCH_ERROR = 'F2F_SCHOOLS_FETCH_ERROR';
	var f2fSchoolsFetch = exports.f2fSchoolsFetch = function f2fSchoolsFetch() {
	  return { type: F2F_SCHOOLS_FETCH };
	};
	
	var F2F_REFERRAL_CREATE = exports.F2F_REFERRAL_CREATE = 'F2F_REFERRAL_CREATE';
	var F2F_REFERRAL_CREATE_SUCCESS = exports.F2F_REFERRAL_CREATE_SUCCESS = 'F2F_REFERRAL_CREATE_SUCCESS';
	var F2F_REFERRAL_CREATE_ERROR = exports.F2F_REFERRAL_CREATE_ERROR = 'F2F_REFERRAL_CREATE_ERROR';
	var f2fReferralCreate = exports.f2fReferralCreate = function f2fReferralCreate(data, resolve, reject, successMessage) {
	  return { type: F2F_REFERRAL_CREATE, data: data, resolve: resolve, reject: reject, successMessage: successMessage };
	};
	
	var F2F_FIELD_VALIDATE = exports.F2F_FIELD_VALIDATE = 'F2F_FIELD_VALIDATE';
	var F2F_FIELD_VALIDATE_SUCCESS = exports.F2F_FIELD_VALIDATE_SUCCESS = 'F2F_FIELD_VALIDATE_SUCCESS';
	var F2F_FIELD_VALIDATE_ERROR = exports.F2F_FIELD_VALIDATE_ERROR = 'F2F_FIELD_VALIDATE_ERROR';
	var f2fFieldValidate = exports.f2fFieldValidate = function f2fFieldValidate(field, value, resolve, reject) {
	  return { type: F2F_FIELD_VALIDATE, field: field, value: value, resolve: resolve, reject: reject };
	};

/***/ },

/***/ "./src/members/state/f2f/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.f2fStatusFetch = f2fStatusFetch;
	exports.f2fLanguagesFetch = f2fLanguagesFetch;
	exports.f2fLocationsFetch = f2fLocationsFetch;
	exports.f2fScoolsFetch = f2fScoolsFetch;
	exports.f2fReferralCreate = f2fReferralCreate;
	exports.f2fFieldValidate = f2fFieldValidate;
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function f2fStatusFetch() {
	  return (0, _api.callApi)('/f2f');
	}
	
	function f2fLanguagesFetch() {
	  return (0, _api.callApi)('/f2f/languages');
	}
	
	function f2fLocationsFetch() {
	  return (0, _api.callApi)('/f2f/locations');
	}
	
	function f2fScoolsFetch() {
	  return (0, _api.callApi)('/f2f/schools');
	}
	
	function f2fReferralCreate(data) {
	  return (0, _api.callApi)('/f2f', {
	    method: 'POST',
	    body: _extends({}, data)
	  });
	}
	
	function f2fFieldValidate(field, value) {
	  return (0, _api.callApi)('/f2f/check-' + field, {
	    query: _defineProperty({}, field, value)
	  });
	}

/***/ },

/***/ "./src/members/state/f2f/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  isFetching: false,
	  isAvailable: false,
	  services: [],
	  languages: [],
	  locations: [],
	  schools: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.F2F_STATUS_FETCH:
	      {
	        return _extends({}, state, {
	          isFetching: true
	        });
	      }
	
	    case actions.F2F_STATUS_FETCH_SUCCESS:
	      {
	        return _extends({}, state, {
	          isAvailable: action.result.available,
	          isFetching: false,
	          services: action.result.services
	        });
	      }
	
	    case actions.F2F_STATUS_FETCH_ERROR:
	      {
	        return _extends({}, state, {
	          isFetching: false
	        });
	      }
	
	    case actions.F2F_LANGUAGES_FETCH_SUCCESS:
	      {
	        return _extends({}, state, {
	          languages: action.result
	        });
	      }
	
	    case actions.F2F_LOCATIONS_FETCH_SUCCESS:
	      {
	        return _extends({}, state, {
	          locations: action.result
	        });
	      }
	
	    case actions.F2F_SCHOOLS_FETCH_SUCCESS:
	      {
	        return _extends({}, state, {
	          schools: action.result
	        });
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/f2f/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForF2FFieldValidate = watchForF2FFieldValidate;
	exports.watchForF2FReferralCreate = watchForF2FReferralCreate;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _reduxForm = __webpack_require__("./node_modules/redux-form/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForF2FFieldValidate, watchForF2FReferralCreate, backgroundSaga].map(regeneratorRuntime.mark);
	
	var convertFormErrors = function convertFormErrors(errors) {
	  return errors.reduce(function (errorsObject, error) {
	    if (error.dataPath) {
	      var key = error.dataPath.split('.')[1];
	      errorsObject[key] = error.message;
	    } else {
	      errorsObject['_error'] = error.message;
	    }
	    return errorsObject;
	  }, {});
	};
	
	function watchForF2FFieldValidate() {
	  var action, field, value, resolve, reject, formErrors;
	  return regeneratorRuntime.wrap(function watchForF2FFieldValidate$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 20;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)(actions.F2F_FIELD_VALIDATE);
	
	        case 3:
	          action = _context.sent;
	          field = action.field, value = action.value, resolve = action.resolve, reject = action.reject;
	          _context.prev = 5;
	          _context.next = 8;
	          return (0, _effects.call)(api.f2fFieldValidate, field, value);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.call)(resolve);
	
	        case 10:
	          _context.next = 18;
	          break;
	
	        case 12:
	          _context.prev = 12;
	          _context.t0 = _context['catch'](5);
	          formErrors = _context.t0;
	
	          if (_context.t0.json && _context.t0.json.errors) {
	            formErrors = convertFormErrors(_context.t0.json.errors);
	          }
	          _context.next = 18;
	          return (0, _effects.call)(reject, formErrors);
	
	        case 18:
	          _context.next = 0;
	          break;
	
	        case 20:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[5, 12]]);
	}
	
	function watchForF2FReferralCreate() {
	  var action, data, _resolve, _reject, formErrors;
	
	  return regeneratorRuntime.wrap(function watchForF2FReferralCreate$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (false) {
	            _context2.next = 24;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _effects.take)(actions.F2F_REFERRAL_CREATE);
	
	        case 3:
	          action = _context2.sent;
	          data = action.data, _resolve = action.resolve, _reject = action.reject;
	          _context2.prev = 5;
	          _context2.next = 8;
	          return (0, _effects.call)(api.f2fReferralCreate, data);
	
	        case 8:
	          _context2.next = 10;
	          return (0, _effects.call)(_resolve);
	
	        case 10:
	          _context2.next = 12;
	          return (0, _effects.put)((0, _reduxForm.reset)('referral'));
	
	        case 12:
	          _context2.next = 14;
	          return (0, _effects.put)(actions.infoShow('success', action.successMessage));
	
	        case 14:
	          _context2.next = 22;
	          break;
	
	        case 16:
	          _context2.prev = 16;
	          _context2.t0 = _context2['catch'](5);
	          formErrors = _context2.t0;
	
	          if (_context2.t0.json && _context2.t0.json.errors) {
	            formErrors = convertFormErrors(_context2.t0.json.errors);
	          }
	
	          _context2.next = 22;
	          return (0, _effects.call)(_reject, new _reduxForm.SubmissionError(formErrors));
	
	        case 22:
	          _context2.next = 0;
	          break;
	
	        case 24:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[5, 16]]);
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.F2F_STATUS_FETCH, request(api.f2fStatusFetch)), (0, _effects.fork)(_reduxSaga.takeLatest, actions.F2F_LANGUAGES_FETCH, request(api.f2fLanguagesFetch)), (0, _effects.fork)(_reduxSaga.takeLatest, actions.F2F_LOCATIONS_FETCH, request(api.f2fLocationsFetch)), (0, _effects.fork)(_reduxSaga.takeLatest, actions.F2F_SCHOOLS_FETCH, request(api.f2fScoolsFetch)), (0, _effects.fork)(watchForF2FFieldValidate), (0, _effects.fork)(watchForF2FReferralCreate)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },

/***/ "./src/members/state/f2f/selectors.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getF2F = exports.getF2F = function getF2F(state) {
	  return state.f2f;
	};

/***/ },

/***/ "./src/members/state/feed/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FEED_FETCH = exports.FEED_FETCH = 'FEED_FETCH';
	var FEED_FETCH_SUCCESS = exports.FEED_FETCH_SUCCESS = 'FEED_FETCH_SUCCESS';
	var FEED_FETCH_ERROR = exports.FEED_FETCH_ERROR = 'FEED_FETCH_ERROR';
	var feedFetch = exports.feedFetch = function feedFetch() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var isManualFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return { type: FEED_FETCH, page: page, isManualFetch: isManualFetch };
	};
	
	var FEED_RECEIVED = exports.FEED_RECEIVED = 'FEED_RECEIVED';
	var feedReceived = exports.feedReceived = function feedReceived() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var isManualFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var result = arguments[2];
	  return { type: FEED_RECEIVED, page: page, isManualFetch: isManualFetch, result: result };
	};
	
	var FEED_QUESTIONNAIRES_RECEIVED = exports.FEED_QUESTIONNAIRES_RECEIVED = 'FEED_QUESTIONNAIRES_RECEIVED';
	var feedQuestionnairesReceived = exports.feedQuestionnairesReceived = function feedQuestionnairesReceived(result) {
	  return { type: FEED_QUESTIONNAIRES_RECEIVED, result: result };
	};
	
	var FEED_QUESTIONNAIRE_UPDATE = exports.FEED_QUESTIONNAIRE_UPDATE = 'FEED_QUESTIONNAIRE_UPDATE';
	var feedQuestionnaireUpdate = exports.feedQuestionnaireUpdate = function feedQuestionnaireUpdate(feedQuestionnaireId, updates) {
	  return { type: FEED_QUESTIONNAIRE_UPDATE, feedQuestionnaireId: feedQuestionnaireId, updates: updates };
	};
	
	var FEED_QUESTION_UPDATE = exports.FEED_QUESTION_UPDATE = 'FEED_QUESTION_UPDATE';
	var feedQuestionUpdate = exports.feedQuestionUpdate = function feedQuestionUpdate(feedQuestionnaireId, feedQuestionId, updates) {
	  return { type: FEED_QUESTION_UPDATE, feedQuestionnaireId: feedQuestionnaireId, feedQuestionId: feedQuestionId, updates: updates };
	};
	
	var FEED_QUESTIONNAIRE_SUBMIT = exports.FEED_QUESTIONNAIRE_SUBMIT = 'FEED_QUESTIONNAIRE_SUBMIT';
	var FEED_QUESTIONNAIRE_SUBMIT_SUCCESS = exports.FEED_QUESTIONNAIRE_SUBMIT_SUCCESS = 'FEED_QUESTIONNAIRE_SUBMIT_SUCCESS';
	var FEED_QUESTIONNAIRE_SUBMIT_ERROR = exports.FEED_QUESTIONNAIRE_SUBMIT_ERROR = 'FEED_QUESTIONNAIRE_SUBMIT_ERROR';
	var feedQuestionnaireSubmit = exports.feedQuestionnaireSubmit = function feedQuestionnaireSubmit(feedQuestionnaire) {
	  return { type: FEED_QUESTIONNAIRE_SUBMIT, feedQuestionnaire: feedQuestionnaire };
	};

/***/ },

/***/ "./src/members/state/feed/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.feedFetch = feedFetch;
	exports.feedQuestionnaireSubmit = feedQuestionnaireSubmit;
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	function feedFetch(page) {
	  return (0, _api.callApi)('/mykooth/feed', {
	    query: _extends({}, (0, _api.pageToOffsetParams)(page, (10)))
	  }).then(function (json) {
	    var feed = json.feed,
	        meta = json.meta;
	
	
	    var finalFeed = feed.map(function (feedItem) {
	      var chat = feedItem.chat,
	          interests = feedItem.interests,
	          journal = feedItem.journal,
	          goals = feedItem.goals,
	          questionnaire = feedItem.questionnaire;
	
	      if (chat) return _extends({}, feedItem, { chat: _extends({}, feedItem.chat, { id: 0 }) });
	      if (interests) return _extends({}, feedItem, { interests: _extends({}, feedItem.interests, { id: 0 }) });
	      if (journal) return _extends({}, feedItem, { journal: _extends({}, feedItem.journal, { id: 0 }) });
	      if (goals) return _extends({}, feedItem, { goals: _extends({}, feedItem.goals, { id: 0 }) });
	      if (questionnaire) return _extends({}, feedItem, { questionnaire: _extends({}, feedItem.questionnaire) });
	      return feedItem;
	    });
	
	    return { feedItems: finalFeed, meta: meta };
	  });
	}
	
	function feedQuestionnaireSubmit(feedQuestionnaire) {
	  return (0, _api.callApi)('/questionnaires', {
	    method: 'POST',
	    body: feedQuestionnaire
	  });
	}

/***/ },

/***/ "./src/members/state/feed/feedQuestionnaires/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.FEED_QUESTIONNAIRES_RECEIVED],
	  updateSuccessTypes: [actions.FEED_QUESTIONNAIRE_UPDATE],
	  entityType: 'questionnaires',
	  updateKey: 'feedQuestionnairesIds'
	});

/***/ },

/***/ "./src/members/state/feed/feedQuestionnaires/feedQuestionnairesSubmission/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _booleanMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/booleanMaker.js");
	
	var _booleanMaker2 = _interopRequireDefault(_booleanMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _booleanMaker2.default)({
	  booleanName: 'isSubmitting',
	  trueTypes: [actions.FEED_QUESTIONNAIRE_SUBMIT],
	  falseTypes: [actions.FEED_QUESTIONNAIRE_SUBMIT_SUCCESS, actions.FEED_QUESTIONNAIRE_SUBMIT_ERROR]
	});

/***/ },

/***/ "./src/members/state/feed/feedQuestionnaires/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/feed/feedQuestionnaires/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/feed/feedQuestionnaires/feedQuestionnairesSubmission/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  feedQuestionnairesSubmission: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/feed/feedQuestions/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.FEED_QUESTIONNAIRES_RECEIVED],
	  updateSuccessTypes: [actions.FEED_QUESTION_UPDATE],
	  entityType: 'questions',
	  updateKey: 'feedQuestionId'
	});

/***/ },

/***/ "./src/members/state/feed/feedQuestions/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/feed/feedQuestions/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/feed/list/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var INITIAL_STATE = [];
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.FEED_RECEIVED:
	      {
	        var feedItemsNormalized = action.result.feedItems.map(function (feedItem) {
	          var chat = feedItem.chat,
	              interests = feedItem.interests,
	              journal = feedItem.journal,
	              article = feedItem.article,
	              goals = feedItem.goals,
	              questionnaire = feedItem.questionnaire;
	
	          if (chat) return { chatId: chat.id };
	          if (interests) return { interestsId: interests.id };
	          if (journal) return { journalId: journal.id };
	          if (article) return { articleId: article.id };
	          if (goals) return { goalsId: goals.id };
	          if (questionnaire) return { questionnaireId: questionnaire.id };
	        });
	
	        if (action.page === 1) {
	          return feedItemsNormalized;
	        }
	
	        return [].concat(_toConsumableArray(state), _toConsumableArray(feedItemsNormalized));
	      }
	
	    // remove the journal entry form item after an entry has been successfully created
	    case actions.JOURNAL_ENTRY_CREATE_SUCCESS:
	      {
	        return state.filter(function (feedItem) {
	          return feedItem.journalId === undefined;
	        });
	      }
	
	    // remove the feed questionnaire after an it has been successfully sent
	    case actions.FEED_QUESTIONNAIRE_SUBMIT_SUCCESS:
	      {
	        return state.filter(function (feedItem) {
	          return feedItem.questionnaireId === undefined;
	        });
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/feed/paging/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  page: 0,
	  totalCount: 0,
	  isFetching: false,
	  hasFetchedManually: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.FEED_FETCH:
	      {
	        var newPage = action.page || state.page;
	        return _extends({}, state, {
	          isFetching: true,
	          page: newPage
	        });
	      }
	
	    case actions.FEED_RECEIVED:
	      {
	        return _extends({}, state, {
	          isFetching: false,
	          totalCount: action.result.meta.count,
	          hasFetchedManually: action.isManualFetch
	        });
	      }
	
	    case actions.FEED_FETCH_ERROR:
	      {
	        return _extends({}, state, {
	          isFetching: false
	        });
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/feed/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/feed/widgets/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/feed/list/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/feed/paging/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("./src/members/state/feed/feedQuestionnaires/reducer.js");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__("./src/members/state/feed/feedQuestions/reducer.js");
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  list: _reducer4.default,
	  paging: _reducer6.default,
	  widgets: _reducer2.default,
	  feedQuestionnaires: _reducer8.default,
	  feedQuestions: _reducer10.default
	});

/***/ },

/***/ "./src/members/state/feed/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForFeedFetchSuccess = watchForFeedFetchSuccess;
	exports.watchForFeedRefetch = watchForFeedRefetch;
	exports.watchForFeedQuestionnaireSucessfulSubmission = watchForFeedQuestionnaireSucessfulSubmission;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForFeedFetchSuccess, watchForFeedRefetch, watchForFeedQuestionnaireSucessfulSubmission, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForFeedFetchSuccess() {
	  var fetchAction, feedItems, feedGoals, feedQuestionnaire, feedArticles, normalizedGoals, _normalize, result, entities, normalizedArticles;
	
	  return regeneratorRuntime.wrap(function watchForFeedFetchSuccess$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)(actions.FEED_FETCH_SUCCESS);
	
	        case 3:
	          fetchAction = _context.sent;
	          feedItems = fetchAction.result.feedItems;
	          feedGoals = feedItems.find(function (feedItem) {
	            return feedItem.goals;
	          });
	          feedQuestionnaire = feedItems.find(function (feedItem) {
	            return feedItem.questionnaire;
	          });
	          feedArticles = feedItems.filter(function (feedItem) {
	            return feedItem.article;
	          });
	
	          if (!feedGoals) {
	            _context.next = 12;
	            break;
	          }
	
	          normalizedGoals = (0, _normalizr.normalize)(feedGoals.goals.goals, schemas.goalsArraySchema);
	          _context.next = 12;
	          return (0, _effects.put)(actions.goalsFetchSuccess({
	            goalIds: normalizedGoals.result,
	            entities: {
	              goals: normalizedGoals.entities.goals
	            }
	          }));
	
	        case 12:
	          if (!feedQuestionnaire) {
	            _context.next = 16;
	            break;
	          }
	
	          _normalize = (0, _normalizr.normalize)(feedQuestionnaire.questionnaire, schemas.questionnaireSchema), result = _normalize.result, entities = _normalize.entities;
	          _context.next = 16;
	          return (0, _effects.put)(actions.feedQuestionnairesReceived({ feedQuestionnairesIds: result, entities: entities }));
	
	        case 16:
	          if (!feedArticles) {
	            _context.next = 20;
	            break;
	          }
	
	          normalizedArticles = (0, _normalizr.normalize)(feedArticles.map(function (article) {
	            return article.article;
	          }), schemas.magazineArticlesArraySchema);
	          _context.next = 20;
	          return (0, _effects.put)(actions.magazineArticlesReceived({
	            magazineArticlesIds: normalizedArticles.result,
	            entities: {
	              magazineArticles: normalizedArticles.entities.magazineArticles
	            }
	          }));
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.put)(actions.feedReceived(fetchAction.page, fetchAction.isManualFetch, fetchAction.result));
	
	        case 22:
	          _context.next = 0;
	          break;
	
	        case 24:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function watchForFeedRefetch() {
	  return regeneratorRuntime.wrap(function watchForFeedRefetch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (false) {
	            _context2.next = 7;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _effects.take)([actions.JOURNAL_ENTRY_CREATE_SUCCESS, actions.FEED_QUESTIONNAIRE_SUBMIT_SUCCESS]);
	
	        case 3:
	          _context2.next = 5;
	          return (0, _effects.put)(actions.feedFetch());
	
	        case 5:
	          _context2.next = 0;
	          break;
	
	        case 7:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function watchForFeedQuestionnaireSucessfulSubmission() {
	  return regeneratorRuntime.wrap(function watchForFeedQuestionnaireSucessfulSubmission$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (false) {
	            _context3.next = 7;
	            break;
	          }
	
	          _context3.next = 3;
	          return (0, _effects.take)(actions.FEED_QUESTIONNAIRE_SUBMIT_SUCCESS);
	
	        case 3:
	          _context3.next = 5;
	          return (0, _effects.put)(actions.infoShow('success', 'You have succesfully submitted your answers!'));
	
	        case 5:
	          _context3.next = 0;
	          break;
	
	        case 7:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.FEED_FETCH, request(api.feedFetch, 'page')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.FEED_QUESTIONNAIRE_SUBMIT, request(api.feedQuestionnaireSubmit, 'feedQuestionnaire')), (0, _effects.fork)(watchForFeedFetchSuccess), (0, _effects.fork)(watchForFeedQuestionnaireSucessfulSubmission), (0, _effects.fork)(watchForFeedRefetch)];
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}

/***/ },

/***/ "./src/members/state/feed/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFeedItems = exports.getFeedQuestionsById = exports.getFeedQuestionnairesIsSubmitting = exports.getFeedQuestionnairesById = exports.getFeedItemsNormalized = exports.getFeedWidgets = exports.getFeedPaging = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var _goals = __webpack_require__("./src/members/__shared__/selectors/goals.js");
	
	var goalsSelectors = _interopRequireWildcard(_goals);
	
	var _magazine = __webpack_require__("./src/members/__shared__/selectors/magazine.js");
	
	var magazineSelectors = _interopRequireWildcard(_magazine);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mount = (0, _selectors.mountSelectorAt)('feed');
	
	var getFeedPaging = exports.getFeedPaging = mount(function (localState) {
	  return localState.paging;
	});
	
	var getFeedWidgets = exports.getFeedWidgets = mount(function (localState) {
	  return localState.widgets;
	});
	
	var getFeedItemsNormalized = exports.getFeedItemsNormalized = mount(function (localState) {
	  return localState.list;
	});
	
	var getFeedQuestionnairesById = exports.getFeedQuestionnairesById = mount(function (localState) {
	  return localState.feedQuestionnaires.byId;
	});
	
	var getFeedQuestionnairesIsSubmitting = exports.getFeedQuestionnairesIsSubmitting = mount(function (localState) {
	  return localState.feedQuestionnaires.feedQuestionnairesSubmission.isSubmitting;
	});
	
	var getFeedQuestionsById = exports.getFeedQuestionsById = mount(function (localState) {
	  return localState.feedQuestions.byId;
	});
	
	var getFeedItems = exports.getFeedItems = (0, _reselect.createSelector)([getFeedItemsNormalized, getFeedWidgets, getFeedQuestionnairesById, getFeedQuestionsById, goalsSelectors.getGoalsById, magazineSelectors.getMagazineArticlesById], function (feedItemsNormalized, feedWidgets, feedQuestionnairesById, feedQuestionsById, goalsById, magazineArticlesById) {
	
	  return feedItemsNormalized.map(function (feedItemNormalized) {
	
	    if (feedItemNormalized.chatId !== undefined) {
	      return { feedChat: feedWidgets.chat[feedItemNormalized.chatId] };
	    }
	
	    if (feedItemNormalized.interestsId !== undefined) {
	      return { feedInterests: feedWidgets.interests[feedItemNormalized.interestsId] };
	    }
	
	    if (feedItemNormalized.journalId !== undefined) {
	      var feedJournal = feedWidgets.journal[feedItemNormalized.journalId];
	      return {
	        feedJournal: _extends({}, feedJournal, {
	          emojis: feedJournal.emojis.map(function (emoji) {
	            return emoji.emoji;
	          })
	        })
	      };
	    }
	
	    if (feedItemNormalized.goalsId !== undefined) {
	      var feedGoals = feedWidgets.goals[feedItemNormalized.goalsId];
	      return {
	        feedGoals: _extends({}, feedGoals, {
	          goals: feedGoals.goals.map(function (goalId) {
	            return goalsById[goalId];
	          })
	        })
	      };
	    }
	
	    if (feedItemNormalized.questionnaireId !== undefined) {
	      var questionnaire = feedQuestionnairesById[feedItemNormalized.questionnaireId];
	      var questions = questionnaire.questions.map(function (id) {
	        return feedQuestionsById[id];
	      });
	
	      return {
	        feedQuestionnaire: _extends({}, questionnaire, {
	          questions: questions
	        })
	      };
	    }
	
	    if (feedItemNormalized.articleId !== undefined) {
	      return { magazineArticle: magazineArticlesById[feedItemNormalized.articleId] };
	    }
	  });
	});

/***/ },

/***/ "./src/members/state/feed/widgets/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  chat: {},
	  interests: {},
	  journal: {},
	  goals: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.FEED_RECEIVED:
	      {
	        var newState = _extends({}, state);
	
	        action.result.feedItems.forEach(function (feedItem) {
	          var chat = feedItem.chat,
	              interests = feedItem.interests,
	              journal = feedItem.journal,
	              goals = feedItem.goals;
	
	          if (chat) {
	            newState.chat[feedItem.chat.id] = feedItem.chat;
	          }
	          if (interests) {
	            newState.interests[feedItem.interests.id] = feedItem.interests;
	          }
	          if (journal) {
	            newState.journal[feedItem.journal.id] = feedItem.journal;
	          }
	          if (goals) {
	            // for the actual goals inside - store only the ids here
	            newState.goals[feedItem.goals.id] = _extends({}, feedItem.goals, {
	              goals: feedItem.goals.goals.map(function (goal) {
	                return goal.id;
	              })
	            });
	          }
	        });
	
	        return _extends({}, state, newState);
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/feedback/actions.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.feedbackCreate = exports.FEEDBACK_CREATE_ERROR = exports.FEEDBACK_CREATE_SUCCESS = exports.FEEDBACK_CREATE = exports.feedbackEmojisHide = exports.FEEDBACK_EMOJIS_HIDE = exports.feedbackEmojisShow = exports.FEEDBACK_EMOJIS_SHOW = exports.feedbackEditingReset = exports.FEEDBACK_EDITING_RESET = exports.feedbackEditingUpdateText = exports.FEEDBACK_EDITING_UPDATE_TEXT = exports.feedbackEditingUpdateSubject = exports.FEEDBACK_EDITING_UPDATE_SUBJECT = undefined;
	
	var _actions = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var FEEDBACK_EDITING_UPDATE_SUBJECT = exports.FEEDBACK_EDITING_UPDATE_SUBJECT = 'FEEDBACK_EDITING_UPDATE_SUBJECT';
	var feedbackEditingUpdateSubject = exports.feedbackEditingUpdateSubject = function feedbackEditingUpdateSubject(subject) {
	  return { type: FEEDBACK_EDITING_UPDATE_SUBJECT, subject: subject };
	};
	
	var FEEDBACK_EDITING_UPDATE_TEXT = exports.FEEDBACK_EDITING_UPDATE_TEXT = 'FEEDBACK_EDITING_UPDATE_TEXT';
	var feedbackEditingUpdateText = exports.feedbackEditingUpdateText = (0, _actions.textEditingUpdateTextMaker)(FEEDBACK_EDITING_UPDATE_TEXT);
	
	var FEEDBACK_EDITING_RESET = exports.FEEDBACK_EDITING_RESET = 'FEEDBACK_EDITING_RESET';
	var feedbackEditingReset = exports.feedbackEditingReset = function feedbackEditingReset() {
	  return { type: FEEDBACK_EDITING_RESET };
	};
	
	var FEEDBACK_EMOJIS_SHOW = exports.FEEDBACK_EMOJIS_SHOW = 'FEEDBACK_EMOJIS_SHOW';
	var feedbackEmojisShow = exports.feedbackEmojisShow = function feedbackEmojisShow(key) {
	  return { type: FEEDBACK_EMOJIS_SHOW, key: key };
	};
	
	var FEEDBACK_EMOJIS_HIDE = exports.FEEDBACK_EMOJIS_HIDE = 'FEEDBACK_EMOJIS_HIDE';
	var feedbackEmojisHide = exports.feedbackEmojisHide = function feedbackEmojisHide(key) {
	  return { type: FEEDBACK_EMOJIS_HIDE, key: key };
	};
	
	var FEEDBACK_CREATE = exports.FEEDBACK_CREATE = 'FEEDBACK_CREATE';
	var FEEDBACK_CREATE_SUCCESS = exports.FEEDBACK_CREATE_SUCCESS = 'FEEDBACK_CREATE_SUCCESS';
	var FEEDBACK_CREATE_ERROR = exports.FEEDBACK_CREATE_ERROR = 'FEEDBACK_CREATE_ERROR';
	var feedbackCreate = exports.feedbackCreate = function feedbackCreate(subject, text, successMessage) {
	  return { type: FEEDBACK_CREATE, subject: subject, text: text, successMessage: successMessage };
	};

/***/ },

/***/ "./src/members/state/feedback/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.feedbackCreate = feedbackCreate;
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	function feedbackCreate(subject, text) {
	  return (0, _api.callApi)('/more/feedback', {
	    method: 'POST',
	    body: {
	      subject: subject,
	      text: text
	    }
	  });
	}

/***/ },

/***/ "./src/members/state/feedback/emojis/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _emojisMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/emojisMaker.js");
	
	var _emojisMaker2 = _interopRequireDefault(_emojisMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _emojisMaker2.default)({
	  showType: actions.FEEDBACK_EMOJIS_SHOW,
	  closeType: actions.FEEDBACK_EMOJIS_HIDE
	});

/***/ },

/***/ "./src/members/state/feedback/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/feedback/textEditing/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/feedback/emojis/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/feedback/subject/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  textEditing: _reducer2.default,
	  emojis: _reducer4.default,
	  subject: _reducer6.default
	});

/***/ },

/***/ "./src/members/state/feedback/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForSuccessfullyCreatedFeedback = watchForSuccessfullyCreatedFeedback;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForSuccessfullyCreatedFeedback, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForSuccessfullyCreatedFeedback() {
	  var action;
	  return regeneratorRuntime.wrap(function watchForSuccessfullyCreatedFeedback$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)(actions.FEEDBACK_CREATE_SUCCESS);
	
	        case 3:
	          action = _context.sent;
	          _context.next = 6;
	          return (0, _effects.put)(actions.feedbackEditingReset());
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)(actions.infoShow('success', action.successMessage));
	
	        case 8:
	          _context.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.FEEDBACK_CREATE, request(api.feedbackCreate, 'subject', 'text')), (0, _effects.fork)(watchForSuccessfullyCreatedFeedback)];
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },

/***/ "./src/members/state/feedback/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFeedbackEmojis = exports.getFeedbackTextEditing = exports.getFeedbackSubject = undefined;
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var mount = (0, _selectors.mountSelectorAt)('feedback');
	
	var getFeedbackSubject = exports.getFeedbackSubject = mount(function (localState) {
	  return localState.subject;
	});
	
	var getFeedbackTextEditing = exports.getFeedbackTextEditing = mount(function (localState) {
	  return (0, _selectors.getTextEditing)(localState.textEditing);
	});
	
	var getFeedbackEmojis = exports.getFeedbackEmojis = mount(function (localState) {
	  return localState.emojis;
	});

/***/ },

/***/ "./src/members/state/feedback/subject/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _subjectMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/subjectMaker.js");
	
	var _subjectMaker2 = _interopRequireDefault(_subjectMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _subjectMaker2.default)({
	  updateType: actions.FEEDBACK_EDITING_UPDATE_SUBJECT,
	  resetType: actions.FEEDBACK_EDITING_RESET
	});

/***/ },

/***/ "./src/members/state/feedback/textEditing/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _textEditingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/textEditingMaker.js");
	
	var _textEditingMaker2 = _interopRequireDefault(_textEditingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _textEditingMaker2.default)({
	  submitType: actions.FEEDBACK_CREATE,
	  submitSuccessType: actions.FEEDBACK_CREATE_SUCCESS,
	  submitErrorType: actions.FEEDBACK_CREATE_ERROR,
	  updateTextType: actions.FEEDBACK_EDITING_UPDATE_TEXT,
	  resetType: actions.FEEDBACK_EDITING_RESET
	});

/***/ },

/***/ "./src/members/state/forum/actions.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forumThreadUnwatch = exports.FORUM_THREAD_UNWATCH = exports.forumThreadWatch = exports.FORUM_THREAD_WATCH = exports.forumStatusUpdate = exports.FORUM_STATUS_UPDATE = exports.forumContributeEditingExpand = exports.FORUM_CONTRIBUTE_EDITING_EXPAND = exports.forumContributeEditingReset = exports.FORUM_CONTRIBUTE_EDITING_RESET = exports.forumContributeEditingUpdateText = exports.FORUM_CONTRIBUTE_EDITING_UPDATE_TEXT = exports.forumContributeEditingUpdateSubject = exports.FORUM_CONTRIBUTE_EDITING_UPDATE_SUBJECT = exports.forumEmojisHide = exports.FORUM_EMOJIS_HIDE = exports.forumEmojisShow = exports.FORUM_EMOJIS_SHOW = exports.forumThreadCreate = exports.FORUM_THREAD_CREATE_ERROR = exports.FORUM_THREAD_CREATE_SUCCESS = exports.FORUM_THREAD_CREATE = exports.forumThreadUpdate = exports.FORUM_THREAD_UPDATE = exports.forumThreadFollow = exports.FORUM_THREAD_FOLLOW_ERROR = exports.FORUM_THREAD_FOLLOW_SUCCESS = exports.FORUM_THREAD_FOLLOW = exports.forumThreadProfileFetch = exports.FORUM_THREAD_PROFILE_FETCH_ERROR = exports.FORUM_THREAD_PROFILE_FETCH_SUCCESS = exports.FORUM_THREAD_PROFILE_FETCH = exports.forumThreadsUpdatePossiblePage = exports.FORUM_THREADS_UPDATE_POSSIBLE_PAGE = exports.forumThreadsReceived = exports.FORUM_THREADS_RECEIVED = exports.forumSidebarThreadsFetch = exports.FORUM_SIDEBAR_THREADS_FETCH_ERROR = exports.FORUM_SIDEBAR_THREADS_FETCH_SUCCESS = exports.FORUM_SIDEBAR_THREADS_FETCH = exports.forumThreadsFetch = exports.FORUM_THREADS_FETCH_ERROR = exports.FORUM_THREADS_FETCH_SUCCESS = exports.FORUM_THREADS_FETCH = undefined;
	
	var _actions = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var FORUM_THREADS_FETCH = exports.FORUM_THREADS_FETCH = 'FORUM_THREADS_FETCH';
	var FORUM_THREADS_FETCH_SUCCESS = exports.FORUM_THREADS_FETCH_SUCCESS = 'FORUM_THREADS_FETCH_SUCCESS';
	var FORUM_THREADS_FETCH_ERROR = exports.FORUM_THREADS_FETCH_ERROR = 'FORUM_THREADS_FETCH_ERROR';
	var forumThreadsFetch = exports.forumThreadsFetch = function forumThreadsFetch() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var query = arguments[1];
	  var forumThreadsQueryString = arguments[2];
	  return { type: FORUM_THREADS_FETCH, page: page, query: query, forumThreadsQueryString: forumThreadsQueryString };
	};
	
	var FORUM_SIDEBAR_THREADS_FETCH = exports.FORUM_SIDEBAR_THREADS_FETCH = 'FORUM_SIDEBAR_THREADS_FETCH';
	var FORUM_SIDEBAR_THREADS_FETCH_SUCCESS = exports.FORUM_SIDEBAR_THREADS_FETCH_SUCCESS = 'FORUM_SIDEBAR_THREADS_FETCH_SUCCESS';
	var FORUM_SIDEBAR_THREADS_FETCH_ERROR = exports.FORUM_SIDEBAR_THREADS_FETCH_ERROR = 'FORUM_SIDEBAR_THREADS_FETCH_ERROR';
	var forumSidebarThreadsFetch = exports.forumSidebarThreadsFetch = function forumSidebarThreadsFetch() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var query = arguments[1];
	  var forumThreadsQueryString = arguments[2];
	  return { type: FORUM_SIDEBAR_THREADS_FETCH, page: page, query: query, forumThreadsQueryString: forumThreadsQueryString };
	};
	
	var FORUM_THREADS_RECEIVED = exports.FORUM_THREADS_RECEIVED = 'FORUM_THREADS_RECEIVED';
	var forumThreadsReceived = exports.forumThreadsReceived = function forumThreadsReceived(result) {
	  return { type: FORUM_THREADS_RECEIVED, result: result };
	};
	
	var FORUM_THREADS_UPDATE_POSSIBLE_PAGE = exports.FORUM_THREADS_UPDATE_POSSIBLE_PAGE = 'FORUM_THREADS_UPDATE_POSSIBLE_PAGE';
	var forumThreadsUpdatePossiblePage = exports.forumThreadsUpdatePossiblePage = function forumThreadsUpdatePossiblePage(possiblePage, forumThreadsQueryString) {
	  return { type: FORUM_THREADS_UPDATE_POSSIBLE_PAGE, possiblePage: possiblePage, forumThreadsQueryString: forumThreadsQueryString };
	};
	
	var FORUM_THREAD_PROFILE_FETCH = exports.FORUM_THREAD_PROFILE_FETCH = 'FORUM_THREAD_PROFILE_FETCH';
	var FORUM_THREAD_PROFILE_FETCH_SUCCESS = exports.FORUM_THREAD_PROFILE_FETCH_SUCCESS = 'FORUM_THREAD_PROFILE_FETCH_SUCCESS';
	var FORUM_THREAD_PROFILE_FETCH_ERROR = exports.FORUM_THREAD_PROFILE_FETCH_ERROR = 'FORUM_THREAD_PROFILE_FETCH_ERROR';
	var forumThreadProfileFetch = exports.forumThreadProfileFetch = function forumThreadProfileFetch(forumThreadId) {
	  return { type: FORUM_THREAD_PROFILE_FETCH, forumThreadId: forumThreadId };
	};
	
	var FORUM_THREAD_FOLLOW = exports.FORUM_THREAD_FOLLOW = 'FORUM_THREAD_FOLLOW';
	var FORUM_THREAD_FOLLOW_SUCCESS = exports.FORUM_THREAD_FOLLOW_SUCCESS = 'FORUM_THREAD_FOLLOW_SUCCESS';
	var FORUM_THREAD_FOLLOW_ERROR = exports.FORUM_THREAD_FOLLOW_ERROR = 'FORUM_THREAD_FOLLOW_ERROR';
	var forumThreadFollow = exports.forumThreadFollow = function forumThreadFollow(forumThreadId, followed) {
	  return { type: FORUM_THREAD_FOLLOW, forumThreadId: forumThreadId, followed: followed };
	};
	
	var FORUM_THREAD_UPDATE = exports.FORUM_THREAD_UPDATE = 'FORUM_THREAD_UPDATE';
	var forumThreadUpdate = exports.forumThreadUpdate = function forumThreadUpdate(forumThreadId, stateBeforeLocalUpdate, updates) {
	  return {
	    type: FORUM_THREAD_UPDATE,
	    stateBeforeLocalUpdate: stateBeforeLocalUpdate,
	    forumThreadId: forumThreadId,
	    updates: updates
	  };
	};
	
	var FORUM_THREAD_CREATE = exports.FORUM_THREAD_CREATE = 'FORUM_THREAD_CREATE';
	var FORUM_THREAD_CREATE_SUCCESS = exports.FORUM_THREAD_CREATE_SUCCESS = 'FORUM_THREAD_CREATE_SUCCESS';
	var FORUM_THREAD_CREATE_ERROR = exports.FORUM_THREAD_CREATE_ERROR = 'FORUM_THREAD_CREATE_ERROR';
	var forumThreadCreate = exports.forumThreadCreate = function forumThreadCreate(forumThreadProps) {
	  return { type: FORUM_THREAD_CREATE, forumThreadProps: forumThreadProps };
	};
	
	var FORUM_EMOJIS_SHOW = exports.FORUM_EMOJIS_SHOW = 'FORUM_EMOJIS_SHOW';
	var forumEmojisShow = exports.forumEmojisShow = function forumEmojisShow(key) {
	  return { type: FORUM_EMOJIS_SHOW, key: key };
	};
	
	var FORUM_EMOJIS_HIDE = exports.FORUM_EMOJIS_HIDE = 'FORUM_EMOJIS_HIDE';
	var forumEmojisHide = exports.forumEmojisHide = function forumEmojisHide(key) {
	  return { type: FORUM_EMOJIS_HIDE, key: key };
	};
	
	var FORUM_CONTRIBUTE_EDITING_UPDATE_SUBJECT = exports.FORUM_CONTRIBUTE_EDITING_UPDATE_SUBJECT = 'FORUM_CONTRIBUTE_EDITING_UPDATE_SUBJECT';
	var forumContributeEditingUpdateSubject = exports.forumContributeEditingUpdateSubject = function forumContributeEditingUpdateSubject(subject) {
	  return { type: FORUM_CONTRIBUTE_EDITING_UPDATE_SUBJECT, subject: subject };
	};
	
	var FORUM_CONTRIBUTE_EDITING_UPDATE_TEXT = exports.FORUM_CONTRIBUTE_EDITING_UPDATE_TEXT = 'FORUM_CONTRIBUTE_EDITING_UPDATE_TEXT';
	var forumContributeEditingUpdateText = exports.forumContributeEditingUpdateText = (0, _actions.textEditingUpdateTextMaker)(FORUM_CONTRIBUTE_EDITING_UPDATE_TEXT);
	
	var FORUM_CONTRIBUTE_EDITING_RESET = exports.FORUM_CONTRIBUTE_EDITING_RESET = 'FORUM_CONTRIBUTE_EDITING_RESET';
	var forumContributeEditingReset = exports.forumContributeEditingReset = function forumContributeEditingReset() {
	  return { type: FORUM_CONTRIBUTE_EDITING_RESET };
	};
	
	var FORUM_CONTRIBUTE_EDITING_EXPAND = exports.FORUM_CONTRIBUTE_EDITING_EXPAND = 'FORUM_CONTRIBUTE_EDITING_EXPAND';
	var forumContributeEditingExpand = exports.forumContributeEditingExpand = function forumContributeEditingExpand() {
	  return { type: FORUM_CONTRIBUTE_EDITING_EXPAND };
	};
	
	var FORUM_STATUS_UPDATE = exports.FORUM_STATUS_UPDATE = 'FORUM_STATUS_UPDATE';
	var forumStatusUpdate = exports.forumStatusUpdate = function forumStatusUpdate(status) {
	  return { type: FORUM_STATUS_UPDATE, status: status };
	};
	
	var FORUM_THREAD_WATCH = exports.FORUM_THREAD_WATCH = 'FORUM_THREAD_WATCH';
	var forumThreadWatch = exports.forumThreadWatch = function forumThreadWatch(forumThread) {
	  return { type: FORUM_THREAD_WATCH, forumThread: forumThread };
	};
	
	var FORUM_THREAD_UNWATCH = exports.FORUM_THREAD_UNWATCH = 'FORUM_THREAD_UNWATCH';
	var forumThreadUnwatch = exports.forumThreadUnwatch = function forumThreadUnwatch(forumThread) {
	  return { type: FORUM_THREAD_UNWATCH, forumThread: forumThread };
	};

/***/ },

/***/ "./src/members/state/forum/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.forumThreadsFetch = forumThreadsFetch;
	exports.forumThreadProfileFetch = forumThreadProfileFetch;
	exports.forumThreadFollow = forumThreadFollow;
	exports.forumThreadCreate = forumThreadCreate;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function forumThreadsFetch(page) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$sort = _ref.sort,
	      sort = _ref$sort === undefined ? 'popular' : _ref$sort,
	      _ref$live = _ref.live,
	      live = _ref$live === undefined ? false : _ref$live,
	      _ref$following = _ref.following,
	      following = _ref$following === undefined ? false : _ref$following,
	      _ref$askKooth = _ref.askKooth,
	      askKooth = _ref$askKooth === undefined ? false : _ref$askKooth,
	      _ref$pageSize = _ref.pageSize,
	      pageSize = _ref$pageSize === undefined ? (10) : _ref$pageSize,
	      _ref$topic = _ref.topic,
	      topic = _ref$topic === undefined ? [] : _ref$topic;
	
	  return (0, _api.callApi)('/forum/threads', {
	    query: _extends({
	      sort: sort,
	      live: live,
	      askKooth: askKooth,
	      following: following,
	      topic: topic
	    }, (0, _api.pageToOffsetParams)(page, pageSize))
	  }).then(function (json) {
	    var forumThreads = json.forumThreads,
	        meta = json.meta;
	
	    var _normalize = (0, _normalizr.normalize)(forumThreads, schemas.forumThreadsArraySchema),
	        result = _normalize.result,
	        entities = _normalize.entities;
	
	    return { forumThreadsIds: result, entities: entities, meta: meta };
	  });
	}
	
	function forumThreadProfileFetch(forumThreadId) {
	  return (0, _api.callApi)('/forum/threads/' + forumThreadId).then(function (json) {
	    var entities = {
	      forumThreads: _defineProperty({}, forumThreadId, json)
	    };
	
	    return { forumThreadsIds: [forumThreadId], entities: entities };
	  });
	}
	
	function forumThreadFollow(forumThreadId, following) {
	  return (0, _api.callApi)('/forum/threads/' + forumThreadId + '/following', {
	    method: 'POST',
	    body: {
	      following: following
	    }
	  });
	}
	
	function forumThreadCreate(_ref2) {
	  var title = _ref2.title,
	      text = _ref2.text,
	      _ref2$askKooth = _ref2.askKooth,
	      askKooth = _ref2$askKooth === undefined ? false : _ref2$askKooth;
	
	  return (0, _api.callApi)('/forum/threads', {
	    method: 'POST',
	    body: {
	      title: title,
	      text: text,
	      askKooth: askKooth
	    }
	  });
	}

/***/ },

/***/ "./src/members/state/forum/contributeSubject/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _subjectMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/subjectMaker.js");
	
	var _subjectMaker2 = _interopRequireDefault(_subjectMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _subjectMaker2.default)({
	  updateType: actions.FORUM_CONTRIBUTE_EDITING_UPDATE_SUBJECT,
	  resetType: actions.FORUM_CONTRIBUTE_EDITING_RESET
	});

/***/ },

/***/ "./src/members/state/forum/emojis/forumContribute/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _emojisMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/emojisMaker.js");
	
	var _emojisMaker2 = _interopRequireDefault(_emojisMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _emojisMaker2.default)({
	  showType: actions.FORUM_EMOJIS_SHOW,
	  closeType: actions.FORUM_EMOJIS_HIDE
	});

/***/ },

/***/ "./src/members/state/forum/emojis/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reducer = __webpack_require__("./src/members/state/forum/emojis/forumContribute/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('key', {
	  forumContribute: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/forum/forumThreads/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.FORUM_THREADS_FETCH_SUCCESS, actions.FORUM_THREAD_PROFILE_FETCH_SUCCESS, actions.FORUM_SIDEBAR_THREADS_FETCH_SUCCESS, actions.FORUM_THREADS_RECEIVED],
	  updateSuccessTypes: [actions.FORUM_THREAD_UPDATE],
	  updateKey: 'forumThreadId',
	  entityType: 'forumThreads'
	});

/***/ },

/***/ "./src/members/state/forum/forumThreads/byQuery/byPage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byPageMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byPageMaker.js");
	
	var _byPageMaker2 = _interopRequireDefault(_byPageMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byPageMaker2.default)([actions.FORUM_THREADS_FETCH_SUCCESS, actions.FORUM_SIDEBAR_THREADS_FETCH_SUCCESS], 'forumThreadsIds');

/***/ },

/***/ "./src/members/state/forum/forumThreads/byQuery/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/forum/forumThreads/byQuery/byPage/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('forumThreadsQueryString', (0, _redux.combineReducers)({ byPage: _reducer2.default }));

/***/ },

/***/ "./src/members/state/forum/forumThreads/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/forum/forumThreads/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/forum/forumThreads/byQuery/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  byQuery: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/forum/paging/forumThreads/byQuery/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _pagingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/pagingMaker.js");
	
	var _pagingMaker2 = _interopRequireDefault(_pagingMaker);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byKeyMaker2.default)('forumThreadsQueryString', (0, _pagingMaker2.default)({
	  fetchType: actions.FORUM_THREADS_FETCH,
	  fetchSuccessType: actions.FORUM_THREADS_FETCH_SUCCESS,
	  fetchErrorType: actions.FORUM_THREADS_FETCH_ERROR,
	  possiblePageUpdateType: actions.FORUM_THREADS_UPDATE_POSSIBLE_PAGE
	}));

/***/ },

/***/ "./src/members/state/forum/paging/forumThreads/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/forum/paging/forumThreads/byQuery/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byQuery: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/forum/paging/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/forum/paging/forumThreads/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  forumThreads: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/forum/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/forum/forumThreads/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/forum/paging/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/forum/emojis/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("./src/members/state/forum/contributeSubject/reducer.js");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__("./src/members/state/forum/textEditing/reducer.js");
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	var _reducer11 = __webpack_require__("./src/members/state/forum/status/reducer.js");
	
	var _reducer12 = _interopRequireDefault(_reducer11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  forumThreads: _reducer2.default,
	  paging: _reducer4.default,
	  emojis: _reducer6.default,
	  contributeSubject: _reducer8.default,
	  textEditing: _reducer10.default,
	  status: _reducer12.default
	});

/***/ },

/***/ "./src/members/state/forum/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForForumQueryChange = watchForForumQueryChange;
	exports.watchForSuccessfullyCreatedForumThread = watchForSuccessfullyCreatedForumThread;
	exports.watchForWatchOrUnwatch = watchForWatchOrUnwatch;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	var _forumQueries = __webpack_require__("./src/members/__shared__/forumQueries.js");
	
	var _forumQueries2 = _interopRequireDefault(_forumQueries);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _forumLiveStatus = __webpack_require__("./src/members/__shared__/forumLiveStatus.js");
	
	var _sagas = __webpack_require__("./src/members/state/__shared__/utils/sagas.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForForumQueryChange, loadSidePanel, watchForSuccessfullyCreatedForumThread, watchForWatchOrUnwatch, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForForumQueryChange() {
	  var task, _ref, payload, isForumFilteredThreadsList, isForumThreadProfile, isAskKooth, query, queryString, page, paging;
	
	  return regeneratorRuntime.wrap(function watchForForumQueryChange$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          task = null;
	
	        case 1:
	          if (false) {
	            _context.next = 32;
	            break;
	          }
	
	          _context.next = 4;
	          return (0, _effects.take)('@@router/LOCATION_CHANGE');
	
	        case 4:
	          _ref = _context.sent;
	          payload = _ref.payload;
	          isForumFilteredThreadsList = payload.pathname === '/forum';
	          isForumThreadProfile = payload.pathname.indexOf('/forum/threads/') === 0;
	          isAskKooth = payload.pathname === '/forum/ask-kooth';
	
	          if (!(isForumFilteredThreadsList || isForumThreadProfile || isAskKooth)) {
	            _context.next = 30;
	            break;
	          }
	
	          if (!task) {
	            _context.next = 14;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.cancel)(task);
	
	        case 13:
	          task = null;
	
	        case 14:
	          if (!(isForumFilteredThreadsList || isAskKooth)) {
	            _context.next = 26;
	            break;
	          }
	
	          query = void 0;
	
	
	          if (isForumFilteredThreadsList) {
	            query = (0, _forumQueries.normalizeForumQuery)(payload.query);
	          } else {
	            query = { askKooth: 'true' };
	          }
	
	          queryString = JSON.stringify(query);
	          page = 1;
	
	          if (!(payload.action === 'POP')) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 22;
	          return (0, _effects.select)(_selectors.getForumPaging, 'forumThreads', { queryString: queryString });
	
	        case 22:
	          paging = _context.sent;
	
	          page = paging.page;
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.put)(actions.forumThreadsFetch(page, query, queryString));
	
	        case 26:
	          if (!isForumThreadProfile) {
	            _context.next = 30;
	            break;
	          }
	
	          _context.next = 29;
	          return (0, _effects.fork)(loadSidePanel);
	
	        case 29:
	          task = _context.sent;
	
	        case 30:
	          _context.next = 1;
	          break;
	
	        case 32:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function loadSidePanel() {
	  var query, queryString;
	  return regeneratorRuntime.wrap(function loadSidePanel$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          query = _forumQueries2.default['Popular'];
	          queryString = JSON.stringify(query);
	          _context2.next = 4;
	          return (0, _effects.put)(actions.forumSidebarThreadsFetch(1, query, queryString));
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	var follow = (0, _sagas.optimisticUpdateMaker)({
	  idKey: 'forumThreadId',
	  localUpdateType: actions.FORUM_THREAD_UPDATE,
	  successType: actions.FORUM_THREAD_FOLLOW_SUCCESS,
	  errorType: actions.FORUM_THREAD_FOLLOW_ERROR,
	  remoteUpdateActionCreator: regeneratorRuntime.mark(function remoteUpdateActionCreator(localUpdateAction) {
	    return regeneratorRuntime.wrap(function remoteUpdateActionCreator$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            if (!(localUpdateAction.updates.followed !== undefined)) {
	              _context3.next = 2;
	              break;
	            }
	
	            return _context3.abrupt('return', actions.forumThreadFollow(localUpdateAction.forumThreadId, localUpdateAction.updates.followed));
	
	          case 2:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, remoteUpdateActionCreator, this);
	  }),
	  localUpdateActionCreator: regeneratorRuntime.mark(function localUpdateActionCreator(lastRemoteState, errorAction) {
	    return regeneratorRuntime.wrap(function localUpdateActionCreator$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', actions.forumThreadUpdate(errorAction.forumThreadId, null, lastRemoteState));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, localUpdateActionCreator, this);
	  })
	});
	
	function watchForSuccessfullyCreatedForumThread() {
	  return regeneratorRuntime.wrap(function watchForSuccessfullyCreatedForumThread$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          if (false) {
	            _context5.next = 9;
	            break;
	          }
	
	          _context5.next = 3;
	          return (0, _effects.take)(actions.FORUM_THREAD_CREATE_SUCCESS);
	
	        case 3:
	          _context5.next = 5;
	          return (0, _effects.put)(actions.forumContributeEditingReset());
	
	        case 5:
	          _context5.next = 7;
	          return (0, _effects.put)(actions.infoShow('success', 'Your post was successfully sent!'));
	
	        case 7:
	          _context5.next = 0;
	          break;
	
	        case 9:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchForWatchOrUnwatch(socket) {
	  var action, forumThread;
	  return regeneratorRuntime.wrap(function watchForWatchOrUnwatch$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          if (false) {
	            _context6.next = 19;
	            break;
	          }
	
	          _context6.next = 3;
	          return (0, _effects.take)([actions.FORUM_THREAD_WATCH, actions.FORUM_THREAD_UNWATCH]);
	
	        case 3:
	          action = _context6.sent;
	          forumThread = action.forumThread;
	
	          if (!(action.type === actions.FORUM_THREAD_WATCH)) {
	            _context6.next = 15;
	            break;
	          }
	
	          if (!(0, _forumLiveStatus.isLiveNow)(forumThread)) {
	            _context6.next = 11;
	            break;
	          }
	
	          _context6.next = 9;
	          return (0, _effects.call)(_sagas.socketRequestWithErrorChecks, socket, socket.forumThreadWatch, action, forumThread.id);
	
	        case 9:
	          _context6.next = 13;
	          break;
	
	        case 11:
	          _context6.next = 13;
	          return (0, _effects.put)((0, _reactRouterRedux.replace)('/forum/lobby/' + forumThread.id));
	
	        case 13:
	          _context6.next = 17;
	          break;
	
	        case 15:
	          _context6.next = 17;
	          return (0, _effects.call)(_sagas.socketRequestWithErrorChecks, socket, socket.forumThreadUnwatch, action, forumThread.id);
	
	        case 17:
	          _context6.next = 0;
	          break;
	
	        case 19:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.FORUM_THREADS_FETCH, request(api.forumThreadsFetch, 'page', 'query')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.FORUM_SIDEBAR_THREADS_FETCH, request(api.forumThreadsFetch, 'page', 'query')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.FORUM_THREAD_PROFILE_FETCH, request(api.forumThreadProfileFetch, 'forumThreadId')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.FORUM_THREAD_FOLLOW, request(api.forumThreadFollow, 'forumThreadId', 'followed')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.FORUM_THREAD_CREATE, request(api.forumThreadCreate, 'forumThreadProps')), (0, _effects.fork)(watchForForumQueryChange), (0, _effects.fork)(follow), (0, _effects.fork)(watchForSuccessfullyCreatedForumThread), (0, _effects.fork)(watchForWatchOrUnwatch, socket)];
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },

/***/ "./src/members/state/forum/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getForumStatus = exports.getForumEmojis = exports.getForumTextEditing = exports.getForumContributeSubject = exports.getForumThread = exports.getForumPaging = exports.getForumThreadsGrouped = exports.getForumThreadsOnSidebar = exports.getForumThreadsOnFrontPage = exports.getForumThreadsById = exports.getForumThreadsIds = undefined;
	
	var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var _forumLiveStatus = __webpack_require__("./src/members/__shared__/forumLiveStatus.js");
	
	var mount = (0, _selectors.mountSelectorAt)('forum');
	
	var getForumThreadsIds = exports.getForumThreadsIds = mount(function (localState, props) {
	  var queryString = props.queryString,
	      page = props.page;
	
	  var pagesForQuery = localState.forumThreads.byQuery[queryString];
	
	  if (!pagesForQuery) {
	    return [];
	  }
	
	  var forumThreadsIds = pagesForQuery.byPage[page];
	
	  if (!forumThreadsIds) {
	    return [];
	  }
	
	  return forumThreadsIds;
	});
	
	var getForumThreadsById = exports.getForumThreadsById = mount(function (localState) {
	  return localState.forumThreads.byId;
	});
	
	var forumThreadsSelectorMaker = function forumThreadsSelectorMaker() {
	  return (0, _reselect.createSelector)([getForumThreadsIds, getForumThreadsById], function (forumThreadsIds, forumThreadsdById) {
	    return forumThreadsIds.map(function (id) {
	      return forumThreadsdById[id];
	    });
	  });
	};
	
	var getForumThreadsOnFrontPage = exports.getForumThreadsOnFrontPage = forumThreadsSelectorMaker();
	
	var getForumThreadsOnSidebar = exports.getForumThreadsOnSidebar = forumThreadsSelectorMaker();
	
	var getForumThreadsGrouped = exports.getForumThreadsGrouped = (0, _reselect.createSelector)([getForumThreadsOnFrontPage], function (forumThreads) {
	  var endedForumThreads = [];
	  var currentlyLiveForumThreads = [];
	  var startingSoonForumThreads = [];
	
	  forumThreads.forEach(function (forumThread) {
	    var group = currentlyLiveForumThreads;
	
	    if ((0, _forumLiveStatus.hasEnded)(forumThread)) {
	      group = endedForumThreads;
	    } else if ((0, _forumLiveStatus.isSoonToBeLive)(forumThread)) {
	      group = startingSoonForumThreads;
	    }
	
	    group.push(forumThread);
	  });
	
	  startingSoonForumThreads.reverse();
	  return {
	    endedForumThreads: endedForumThreads,
	    currentlyLiveForumThreads: currentlyLiveForumThreads,
	    startingSoonForumThreads: startingSoonForumThreads
	  };
	});
	
	var getForumPaging = exports.getForumPaging = mount(function (localState, key, options) {
	  return (0, _selectors.getPaging)(localState.paging[key], options);
	});
	
	var getForumThread = exports.getForumThread = mount(function (localState, id) {
	  return localState.forumThreads.byId[id];
	});
	
	var getForumContributeSubject = exports.getForumContributeSubject = mount(function (localState) {
	  return localState.contributeSubject;
	});
	
	var getForumTextEditing = exports.getForumTextEditing = mount(function (localState, key) {
	  return (0, _selectors.getTextEditing)(localState.textEditing[key]);
	});
	
	var getForumEmojis = exports.getForumEmojis = mount(function (localState, key) {
	  return localState.emojis[key];
	});
	
	var getForumStatus = exports.getForumStatus = mount(function (localState) {
	  return localState.status;
	});

/***/ },

/***/ "./src/members/state/forum/status/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  hasRunningLiveThreads: false,
	  localWatchedThreadId: null,
	  remoteWatchedThreadId: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.FORUM_STATUS_UPDATE:
	      {
	        // This update comes from the server.
	        var _action$status = action.status,
	            live = _action$status.live,
	            thread = _action$status.thread;
	
	
	        return _extends({}, state, {
	          hasRunningLiveThreads: live.length > 0,
	          remoteWatchedThreadId: thread
	        });
	      }
	
	    case actions.FORUM_THREAD_WATCH:
	      return _extends({}, state, {
	        localWatchedThreadId: action.forumThread.id
	      });
	
	    case actions.FORUM_THREAD_UNWATCH:
	      return _extends({}, state, {
	        localWatchedThreadId: null
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/forum/textEditing/forumContribute/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _textEditingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/textEditingMaker.js");
	
	var _textEditingMaker2 = _interopRequireDefault(_textEditingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _textEditingMaker2.default)({
	  submitType: actions.FORUM_THREAD_CREATE,
	  submitSuccessType: actions.FORUM_THREAD_CREATE_SUCCESS,
	  submitErrorType: actions.FORUM_THREAD_CREATE_ERROR,
	  updateTextType: actions.FORUM_CONTRIBUTE_EDITING_UPDATE_TEXT,
	  resetType: actions.FORUM_CONTRIBUTE_EDITING_RESET,
	  expandType: actions.FORUM_CONTRIBUTE_EDITING_EXPAND
	});

/***/ },

/***/ "./src/members/state/forum/textEditing/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/forum/textEditing/forumContribute/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  forumContribute: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/goals/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var GOALS_FETCH = exports.GOALS_FETCH = 'GOALS_FETCH';
	var GOALS_FETCH_SUCCESS = exports.GOALS_FETCH_SUCCESS = 'GOALS_FETCH_SUCCESS';
	var GOALS_FETCH_ERROR = exports.GOALS_FETCH_ERROR = 'GOALS_FETCH_ERROR';
	var goalsFetch = exports.goalsFetch = function goalsFetch(query) {
	  return { type: GOALS_FETCH, query: query };
	};
	var goalsFetchSuccess = exports.goalsFetchSuccess = function goalsFetchSuccess(result, query) {
	  return { type: GOALS_FETCH_SUCCESS, result: result, query: query };
	};
	
	var GOAL_UPDATE = exports.GOAL_UPDATE = 'GOAL_UPDATE';
	var goalUpdate = exports.goalUpdate = function goalUpdate(goalId, goal, updates, source) {
	  return {
	    type: GOAL_UPDATE,
	    goalId: goalId,
	    stateBeforeLocalUpdate: goal,
	    updates: _extends({}, updates, {
	      updatedAt: new Date()
	    }),
	    source: source
	  };
	};
	
	var GOAL_CHANGE_SCORE = exports.GOAL_CHANGE_SCORE = 'GOAL_CHANGE_SCORE';
	var GOAL_CHANGE_SCORE_SUCCESS = exports.GOAL_CHANGE_SCORE_SUCCESS = 'GOAL_CHANGE_SCORE_SUCCESS';
	var GOAL_CHANGE_SCORE_ERROR = exports.GOAL_CHANGE_SCORE_ERROR = 'GOAL_CHANGE_SCORE_ERROR';
	var goalChangeScore = exports.goalChangeScore = function goalChangeScore(goalId, score, source) {
	  return { type: GOAL_CHANGE_SCORE, goalId: goalId, score: score, source: source };
	};
	
	var GOAL_ADDING_SHOW = exports.GOAL_ADDING_SHOW = 'GOAL_ADDING_SHOW';
	var goalAddingShow = exports.goalAddingShow = function goalAddingShow() {
	  return { type: GOAL_ADDING_SHOW };
	};
	
	var GOAL_ADDING_HIDE = exports.GOAL_ADDING_HIDE = 'GOAL_ADDING_HIDE';
	var goalAddingHide = exports.goalAddingHide = function goalAddingHide() {
	  return { type: GOAL_ADDING_HIDE };
	};
	
	var GOAL_ADDING_UPDATE = exports.GOAL_ADDING_UPDATE = 'GOAL_ADDING_UPDATE';
	var goalAddingUpdate = exports.goalAddingUpdate = function goalAddingUpdate(value) {
	  return { type: GOAL_ADDING_UPDATE, value: value };
	};
	
	var GOAL_CREATE = exports.GOAL_CREATE = 'GOAL_CREATE';
	var GOAL_CREATE_SUCCESS = exports.GOAL_CREATE_SUCCESS = 'GOAL_CREATE_SUCCESS';
	var GOAL_CREATE_ERROR = exports.GOAL_CREATE_ERROR = 'GOAL_CREATE_ERROR';
	var goalCreate = exports.goalCreate = function goalCreate(goal, source, successTitle, successMessage) {
	  return { type: GOAL_CREATE, goal: goal, source: source, successTitle: successTitle, successMessage: successMessage };
	};
	
	var GOALS_RECEIVED = exports.GOALS_RECEIVED = 'GOALS_RECEIVED';
	var goalsReceived = exports.goalsReceived = function goalsReceived(result) {
	  return { type: GOALS_RECEIVED, result: result };
	};

/***/ },

/***/ "./src/members/state/goals/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.goalsFetch = goalsFetch;
	exports.goalChangeScore = goalChangeScore;
	exports.goalCreate = goalCreate;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function goalsFetch(query) {
	  return (0, _api.callApi)('/more/goals', query).then(function (json) {
	    var goals = json.goals,
	        meta = json.meta;
	
	    // We need to be able to sort the goals
	
	    goals.forEach(function (goal) {
	      goal.updatedAt = new Date(goal.updatedAt);
	    });
	
	    var _normalize = (0, _normalizr.normalize)(goals, schemas.goalsArraySchema),
	        result = _normalize.result,
	        entities = _normalize.entities;
	
	    return { goalIds: result, entities: entities, meta: meta };
	  });
	}
	
	function goalChangeScore(goalId, score, source) {
	  return (0, _api.callApi)('/more/goals/' + goalId, {
	    method: 'PATCH',
	    body: {
	      score: score,
	      source: source,
	      updatedAt: new Date()
	    }
	  });
	}
	
	function goalCreate(goal, source) {
	  return (0, _api.callApi)('/more/goals', {
	    method: 'POST',
	    body: { goal: goal, source: source }
	  });
	}

/***/ },

/***/ "./src/members/state/goals/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.GOALS_FETCH_SUCCESS, actions.GOALS_RECEIVED],
	  entityType: 'goals',
	  updateSuccessTypes: [actions.GOAL_UPDATE],
	  updateKey: 'goalId'
	});

/***/ },

/***/ "./src/members/state/goals/goalAdding/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  isInputVisible: false,
	  goalText: ''
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.GOAL_ADDING_SHOW:
	      {
	        return _extends({}, state, {
	          isInputVisible: true
	        });
	      }
	
	    case actions.GOAL_ADDING_HIDE:
	      {
	        return _extends({}, state, {
	          goalText: '',
	          isInputVisible: false
	        });
	      }
	
	    case actions.GOAL_ADDING_UPDATE:
	      {
	        return _extends({}, state, {
	          goalText: action.value
	        });
	      }
	
	    case actions.GOAL_CREATE_SUCCESS:
	      {
	        return _extends({}, state, {
	          goalText: '',
	          isInputVisible: false
	        });
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/goals/goalsFetching/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _booleanMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/booleanMaker.js");
	
	var _booleanMaker2 = _interopRequireDefault(_booleanMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _booleanMaker2.default)({
	  booleanName: 'isFetching',
	  trueTypes: [actions.GOALS_FETCH],
	  falseTypes: [actions.GOALS_FETCH_SUCCESS, actions.GOALS_FETCH_ERROR]
	});

/***/ },

/***/ "./src/members/state/goals/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/goals/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/goals/goalAdding/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/goals/goalsFetching/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  goalAdding: _reducer4.default,
	  goalsFetching: _reducer6.default
	});

/***/ },

/***/ "./src/members/state/goals/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForGoalCreateSuccess = watchForGoalCreateSuccess;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _sagas = __webpack_require__("./src/members/state/__shared__/utils/sagas.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForGoalCreateSuccess, backgroundSaga].map(regeneratorRuntime.mark);
	
	var update = (0, _sagas.optimisticUpdateMaker)({
	  idKey: 'goalId',
	  localUpdateType: actions.GOAL_UPDATE,
	  successType: actions.GOAL_CHANGE_SCORE_SUCCESS,
	  errorType: actions.GOAL_CHANGE_SCORE_ERROR,
	  remoteUpdateActionCreator: regeneratorRuntime.mark(function remoteUpdateActionCreator(localUpdateAction) {
	    return regeneratorRuntime.wrap(function remoteUpdateActionCreator$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (!(localUpdateAction.updates.score !== undefined)) {
	              _context.next = 2;
	              break;
	            }
	
	            return _context.abrupt('return', actions.goalChangeScore(localUpdateAction.goalId, localUpdateAction.updates.score, localUpdateAction.source));
	
	          case 2:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, remoteUpdateActionCreator, this);
	  }),
	  localUpdateActionCreator: regeneratorRuntime.mark(function localUpdateActionCreator(lastRemoteState, errorAction) {
	    return regeneratorRuntime.wrap(function localUpdateActionCreator$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', actions.goalUpdate(errorAction.goalId, null, lastRemoteState));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, localUpdateActionCreator, this);
	  })
	});
	
	function watchForGoalCreateSuccess() {
	  var action, successTitle, successMessage, profile, infoBarTitle, _ref, timeout, cancelAction;
	
	  return regeneratorRuntime.wrap(function watchForGoalCreateSuccess$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (false) {
	            _context3.next = 21;
	            break;
	          }
	
	          _context3.next = 3;
	          return (0, _effects.take)(actions.GOAL_CREATE_SUCCESS);
	
	        case 3:
	          action = _context3.sent;
	          successTitle = action.successTitle, successMessage = action.successMessage;
	          _context3.next = 7;
	          return (0, _effects.select)(_selectors.getUserProfile);
	
	        case 7:
	          profile = _context3.sent;
	          infoBarTitle = profile.userName ? successTitle + ' ' + profile.userName + '!' : successTitle;
	          _context3.next = 11;
	          return (0, _effects.put)(actions.infoShow('success', successMessage, infoBarTitle));
	
	        case 11:
	          _context3.next = 13;
	          return (0, _effects.race)({ // eslint-disable-line no-unused-vars
	            timeout: (0, _effects.call)(_reduxSaga.delay, (4000)),
	            cancelAction: (0, _effects.take)(actions.INFO_CLOSE)
	          });
	
	        case 13:
	          _ref = _context3.sent;
	          timeout = _ref.timeout;
	          cancelAction = _ref.cancelAction;
	
	          if (!timeout) {
	            _context3.next = 19;
	            break;
	          }
	
	          _context3.next = 19;
	          return (0, _effects.put)(actions.infoClose('success'));
	
	        case 19:
	          _context3.next = 0;
	          break;
	
	        case 21:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return [(0, _effects.fork)(update), (0, _effects.fork)(_reduxSaga.takeLatest, actions.GOALS_FETCH, request(api.goalsFetch, 'query')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.GOAL_CHANGE_SCORE, request(api.goalChangeScore, 'goalId', 'score', 'source')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.GOAL_CREATE, request(api.goalCreate, 'goal', 'source')), (0, _effects.fork)(watchForGoalCreateSuccess)];
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },

/***/ "./src/members/state/goals/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGoalsFetching = exports.getGoalAdding = exports.getGoal = exports.getGoals = exports.getGoalsById = undefined;
	
	var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var mount = (0, _selectors.mountSelectorAt)('goals');
	
	var getGoalsById = exports.getGoalsById = mount(function (localState) {
	  return localState.byId;
	});
	
	var getGoals = exports.getGoals = (0, _reselect.createSelector)(getGoalsById, function (goalsById) {
	  return Object.keys(goalsById).map(function (key) {
	    return goalsById[key];
	  });
	});
	
	var getGoal = exports.getGoal = mount(function (localState, id) {
	  return localState.byId[id];
	});
	
	var getGoalAdding = exports.getGoalAdding = mount(function (localState) {
	  return localState.goalAdding;
	});
	
	var getGoalsFetching = exports.getGoalsFetching = mount(function (localState) {
	  return localState.goalsFetching;
	});

/***/ },

/***/ "./src/members/state/info/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INFO_SHOW = exports.INFO_SHOW = 'INFO_SHOW';
	var infoShow = exports.infoShow = function infoShow(key, message) {
	  var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  return { type: INFO_SHOW, message: message, title: title, key: key };
	};
	
	var INFO_CLOSE = exports.INFO_CLOSE = 'INFO_CLOSE';
	var infoClose = exports.infoClose = function infoClose(key) {
	  return { type: INFO_CLOSE, key: key };
	};

/***/ },

/***/ "./src/members/state/info/connectionState/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _infoMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/infoMaker.js");
	
	var _infoMaker2 = _interopRequireDefault(_infoMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _infoMaker2.default)({
	  showType: actions.INFO_SHOW,
	  closeType: actions.INFO_CLOSE
	});

/***/ },

/***/ "./src/members/state/info/errors/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _infoMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/infoMaker.js");
	
	var _infoMaker2 = _interopRequireDefault(_infoMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _infoMaker2.default)({
	  showType: actions.INFO_SHOW,
	  closeType: actions.INFO_CLOSE
	});

/***/ },

/***/ "./src/members/state/info/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reducer = __webpack_require__("./src/members/state/info/errors/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/info/connectionState/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/info/success/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('key', {
	  errors: _reducer2.default,
	  connectionState: _reducer4.default,
	  success: _reducer6.default
	});

/***/ },

/***/ "./src/members/state/info/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForLocationChange = watchForLocationChange;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForLocationChange, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForLocationChange() {
	  return regeneratorRuntime.wrap(function watchForLocationChange$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)('@@router/LOCATION_CHANGE');
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.put)(actions.infoClose('success'));
	
	        case 5:
	          _context.next = 0;
	          break;
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function backgroundSaga() {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return [(0, _effects.fork)(watchForLocationChange)];
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },

/***/ "./src/members/state/info/selectors.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getInfoState = exports.getInfoState = function getInfoState(state, key) {
	  return state.info[key];
	};

/***/ },

/***/ "./src/members/state/info/success/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _infoMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/infoMaker.js");
	
	var _infoMaker2 = _interopRequireDefault(_infoMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _infoMaker2.default)({
	  showType: actions.INFO_SHOW,
	  closeType: actions.INFO_CLOSE
	});

/***/ },

/***/ "./src/members/state/journal/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var JOURNAL_ENTRIES_FETCH = exports.JOURNAL_ENTRIES_FETCH = 'JOURNAL_ENTRIES_FETCH';
	var JOURNAL_ENTRIES_FETCH_SUCCESS = exports.JOURNAL_ENTRIES_FETCH_SUCCESS = 'JOURNAL_ENTRIES_FETCH_SUCCESS';
	var JOURNAL_ENTRIES_FETCH_ERROR = exports.JOURNAL_ENTRIES_FETCH_ERROR = 'JOURNAL_ENTRIES_FETCH_ERROR';
	var journalEntriesFetch = exports.journalEntriesFetch = function journalEntriesFetch() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  return { type: JOURNAL_ENTRIES_FETCH, page: page };
	};
	
	var JOURNAL_ENTRIES_UPDATE_POSSIBLE_PAGE = exports.JOURNAL_ENTRIES_UPDATE_POSSIBLE_PAGE = 'JOURNAL_ENTRIES_UPDATE_POSSIBLE_PAGE';
	var journalEntriesUpdatePossiblePage = exports.journalEntriesUpdatePossiblePage = function journalEntriesUpdatePossiblePage(possiblePage) {
	  return { type: JOURNAL_ENTRIES_UPDATE_POSSIBLE_PAGE, possiblePage: possiblePage };
	};
	
	var JOURNAL_ENTRY_CREATE = exports.JOURNAL_ENTRY_CREATE = 'JOURNAL_ENTRY_CREATE';
	var JOURNAL_ENTRY_CREATE_SUCCESS = exports.JOURNAL_ENTRY_CREATE_SUCCESS = 'JOURNAL_ENTRY_CREATE_SUCCESS';
	var JOURNAL_ENTRY_CREATE_ERROR = exports.JOURNAL_ENTRY_CREATE_ERROR = 'JOURNAL_ENTRY_CREATE_ERROR';
	var journalEntryCreate = exports.journalEntryCreate = function journalEntryCreate(emoji, text) {
	  var successMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  return { type: JOURNAL_ENTRY_CREATE, emoji: emoji, text: text, successMessage: successMessage };
	};
	
	var JOURNAL_EMOJIS_FETCH = exports.JOURNAL_EMOJIS_FETCH = 'JOURNAL_EMOJIS_FETCH';
	var JOURNAL_EMOJIS_FETCH_SUCCESS = exports.JOURNAL_EMOJIS_FETCH_SUCCESS = 'JOURNAL_EMOJIS_FETCH_SUCCESS';
	var JOURNAL_EMOJIS_FETCH_ERROR = exports.JOURNAL_EMOJIS_FETCH_ERROR = 'JOURNAL_EMOJIS_FETCH_ERROR';
	var journalEmojisFetch = exports.journalEmojisFetch = function journalEmojisFetch() {
	  return { type: JOURNAL_EMOJIS_FETCH };
	};
	
	var JOURNAL_CREATION_CHANGE = exports.JOURNAL_CREATION_CHANGE = "JOURNAL_CREATION_CHANGE";
	var journalCreationChange = exports.journalCreationChange = function journalCreationChange(updates) {
	  return { type: JOURNAL_CREATION_CHANGE, updates: updates };
	};

/***/ },

/***/ "./src/members/state/journal/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.journalEmojisFetch = journalEmojisFetch;
	exports.journalEntriesFetch = journalEntriesFetch;
	exports.journalEntryCreate = journalEntryCreate;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function journalEmojisFetch() {
	  return (0, _api.callApi)('/more/journal/emojis').then(function (json) {
	    return json.map(function (emoji) {
	      return emoji.emoji;
	    });
	  });
	}
	
	function journalEntriesFetch(page) {
	  return (0, _api.callApi)('/more/journal', {
	    query: _extends({}, (0, _api.pageToOffsetParams)(page, (10)))
	  }).then(function (json) {
	    var journals = json.journals,
	        meta = json.meta;
	
	    var _normalize = (0, _normalizr.normalize)(journals, schemas.journalEntriesArraySchema),
	        result = _normalize.result,
	        entities = _normalize.entities;
	
	    return { journalEntriesIds: result, entities: entities, meta: meta };
	  });
	}
	
	function journalEntryCreate(emoji, text) {
	  return (0, _api.callApi)('/more/journal', {
	    method: 'POST',
	    body: {
	      emoji: emoji,
	      text: text
	    }
	  });
	}

/***/ },

/***/ "./src/members/state/journal/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.JOURNAL_ENTRIES_FETCH_SUCCESS],
	  entityType: 'journalEntries'
	});

/***/ },

/***/ "./src/members/state/journal/byPage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byPageMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byPageMaker.js");
	
	var _byPageMaker2 = _interopRequireDefault(_byPageMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byPageMaker2.default)([actions.JOURNAL_ENTRIES_FETCH_SUCCESS], 'journalEntriesIds');

/***/ },

/***/ "./src/members/state/journal/creation/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  text: '',
	  emoji: null,
	  isSubmitting: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.JOURNAL_CREATION_CHANGE:
	      {
	        return _extends({}, state, action.updates);
	      }
	
	    case actions.JOURNAL_ENTRY_CREATE:
	      {
	        return _extends({}, state, {
	          isSubmitting: true
	        });
	      }
	
	    case actions.JOURNAL_ENTRY_CREATE_SUCCESS:
	      {
	        return _extends({}, INITIAL_STATE);
	      }
	
	    case actions.JOURNAL_ENTRY_CREATE_ERROR:
	      {
	        return _extends({}, state, {
	          isSubmitting: false
	        });
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/journal/emojis/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  emojis: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.JOURNAL_EMOJIS_FETCH_SUCCESS:
	      {
	        return _extends({}, state, {
	          emojis: action.result
	        });
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/journal/paging/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _pagingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/pagingMaker.js");
	
	var _pagingMaker2 = _interopRequireDefault(_pagingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _pagingMaker2.default)({
	  fetchType: actions.JOURNAL_ENTRIES_FETCH,
	  fetchSuccessType: actions.JOURNAL_ENTRIES_FETCH_SUCCESS,
	  fetchErrorType: actions.JOURNAL_ENTRIES_FETCH_ERROR,
	  possiblePageUpdateType: actions.JOURNAL_ENTRIES_UPDATE_POSSIBLE_PAGE
	});

/***/ },

/***/ "./src/members/state/journal/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/journal/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/journal/byPage/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/journal/paging/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("./src/members/state/journal/emojis/reducer.js");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__("./src/members/state/journal/creation/reducer.js");
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  byPage: _reducer4.default,
	  paging: _reducer6.default,
	  emojis: _reducer8.default,
	  creation: _reducer10.default
	});

/***/ },

/***/ "./src/members/state/journal/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForCreatedJournalEntry = watchForCreatedJournalEntry;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForCreatedJournalEntry, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForCreatedJournalEntry() {
	  var action;
	  return regeneratorRuntime.wrap(function watchForCreatedJournalEntry$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)(actions.JOURNAL_ENTRY_CREATE_SUCCESS);
	
	        case 3:
	          action = _context.sent;
	          _context.next = 6;
	          return (0, _effects.put)(actions.journalEntriesFetch(1));
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)(actions.infoShow('success', action.successMessage));
	
	        case 8:
	          _context.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.JOURNAL_ENTRIES_FETCH, request(api.journalEntriesFetch, 'page')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.JOURNAL_ENTRY_CREATE, request(api.journalEntryCreate, 'emoji', 'text')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.JOURNAL_EMOJIS_FETCH, request(api.journalEmojisFetch)), (0, _effects.fork)(watchForCreatedJournalEntry)];
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },

/***/ "./src/members/state/journal/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getJournalPaging = exports.getJournalEntries = exports.getJournalCreation = exports.getJournalEmojis = undefined;
	
	var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var mount = (0, _selectors.mountSelectorAt)('journal');
	
	var getJournalEmojis = exports.getJournalEmojis = mount(function (localState) {
	  return localState.emojis;
	});
	
	var getJournalCreation = exports.getJournalCreation = mount(function (localState) {
	  return localState.creation;
	});
	
	var getJournalEntriesById = mount(function (localState) {
	  return localState.byId;
	});
	
	var getJournalEntriesIdsForPage = mount(function (localState, props) {
	  var page = props.page;
	
	  var journalEntriesIds = localState.byPage[page];
	  if (!journalEntriesIds) {
	    return [];
	  }
	
	  return journalEntriesIds;
	});
	
	var getJournalEntries = exports.getJournalEntries = (0, _reselect.createSelector)([getJournalEntriesIdsForPage, getJournalEntriesById], function (journalEntriesIdsForPage, journalEntriesById) {
	  return journalEntriesIdsForPage.map(function (key) {
	    return journalEntriesById[key];
	  });
	});
	
	var getJournalPaging = exports.getJournalPaging = mount(function (localState, key, options) {
	  return (0, _selectors.getPaging)(localState.paging, options);
	});

/***/ },

/***/ "./src/members/state/lastTimeRefresh/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TIME_REFRESH = exports.TIME_REFRESH = 'TIME_REFRESH';
	var timeRefresh = exports.timeRefresh = function timeRefresh() {
	  return { type: TIME_REFRESH };
	};

/***/ },

/***/ "./src/members/state/lastTimeRefresh/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _lastTimeRefreshMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/lastTimeRefreshMaker.js");
	
	var _lastTimeRefreshMaker2 = _interopRequireDefault(_lastTimeRefreshMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _lastTimeRefreshMaker2.default)(actions.TIME_REFRESH);

/***/ },

/***/ "./src/members/state/lastTimeRefresh/selectors.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getTimeLastRefresh = exports.getTimeLastRefresh = function getTimeLastRefresh(state) {
	  return state.lastTimeRefresh;
	};

/***/ },

/***/ "./src/members/state/links/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LINKS_FETCH = exports.LINKS_FETCH = 'LINKS_FETCH';
	var LINKS_FETCH_SUCCESS = exports.LINKS_FETCH_SUCCESS = 'LINKS_FETCH_SUCCESS';
	var LINKS_FETCH_ERROR = exports.LINKS_FETCH_ERROR = 'LINKS_FETCH_ERROR';
	var linksFetch = exports.linksFetch = function linksFetch() {
	  return { type: LINKS_FETCH };
	};

/***/ },

/***/ "./src/members/state/links/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linksFetch = linksFetch;
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	function linksFetch() {
	  return (0, _api.callApi)('/more/links');
	}

/***/ },

/***/ "./src/members/state/links/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  isFetching: false,
	  links: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.LINKS_FETCH:
	      {
	        return _extends({}, state, {
	          isFetching: true
	        });
	      }
	
	    case actions.LINKS_FETCH_ERROR:
	      {
	        return _extends({}, state, {
	          isFetching: false
	        });
	      }
	
	    case actions.LINKS_FETCH_SUCCESS:
	      {
	        return _extends({}, state, {
	          isFetching: false,
	          links: action.result
	        });
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/links/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [backgroundSaga].map(regeneratorRuntime.mark);
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.LINKS_FETCH, request(api.linksFetch))];
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ },

/***/ "./src/members/state/links/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLinks = undefined;
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var mount = (0, _selectors.mountSelectorAt)('links');
	
	var getLinks = exports.getLinks = mount(function (localState) {
	  return localState;
	});

/***/ },

/***/ "./src/members/state/localAuthorities/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.localAuthorityByIdFetch = localAuthorityByIdFetch;
	exports.subLocationsFetchByLAID = subLocationsFetchByLAID;
	exports.localAuthoritiesFetch = localAuthoritiesFetch;
	exports.universitiesFetch = universitiesFetch;
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	function localAuthorityByIdFetch(LAID) {
	  return (0, _api.callApi)('/user/local-authorities/' + LAID);
	}
	
	function subLocationsFetchByLAID(LAID) {
	  return (0, _api.callApi)('/user/locations/' + LAID);
	}
	
	function localAuthoritiesFetch() {
	  return (0, _api.callApi)('/user/local-authorities');
	}
	
	function universitiesFetch() {
	  return (0, _api.callApi)('/user/universities');
	}

/***/ },

/***/ "./src/members/state/magazine/actions.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.magazineArticleFavourite = exports.MAGAZINE_ARTICLE_FAVOURITE_ERROR = exports.MAGAZINE_ARTICLE_FAVOURITE_SUCCESS = exports.MAGAZINE_ARTICLE_FAVOURITE = exports.magazineArticleFollow = exports.MAGAZINE_ARTICLE_FOLLOW_ERROR = exports.MAGAZINE_ARTICLE_FOLLOW_SUCCESS = exports.MAGAZINE_ARTICLE_FOLLOW = exports.magazineArticleUpdate = exports.MAGAZINE_ARTICLE_UPDATE = exports.magazineArticleCreate = exports.MAGAZINE_ARTICLE_CREATE_ERROR = exports.MAGAZINE_ARTICLE_CREATE_SUCCESS = exports.MAGAZINE_ARTICLE_CREATE = exports.magazineEmojisHide = exports.MAGAZINE_EMOJIS_HIDE = exports.magazineEmojisShow = exports.MAGAZINE_EMOJIS_SHOW = exports.magazineContributeEditingReset = exports.MAGAZINE_CONTRIBUTE_EDITING_RESET = exports.magazineContributeEditingUpdateText = exports.MAGAZINE_CONTRIBUTE_EDITING_UPDATE_TEXT = exports.magazineContributeEditingUpdateSubject = exports.MAGAZINE_CONTRIBUTE_EDITING_UPDATE_SUBJECT = exports.magazineArticlesReceived = exports.MAGAZINE_ARTICLES_RECEIVED = exports.magazineArticleProfileFetch = exports.MAGAZINE_ARTICLE_PROFILE_FETCH_ERROR = exports.MAGAZINE_ARTICLE_PROFILE_FETCH_SUCCESS = exports.MAGAZINE_ARTICLE_PROFILE_FETCH = exports.magazineArticlesUpdatePossiblePage = exports.MAGAZINE_ARTICLES_UPDATE_POSSIBLE_PAGE = exports.magazineSidebarArticlesFetch = exports.MAGAZINE_SIDEBAR_ARTICLES_FETCH_ERROR = exports.MAGAZINE_SIDEBAR_ARTICLES_FETCH_SUCCESS = exports.MAGAZINE_SIDEBAR_ARTICLES_FETCH = exports.magazineArticlesFetch = exports.MAGAZINE_ARTICLES_FETCH_ERROR = exports.MAGAZINE_ARTICLES_FETCH_SUCCESS = exports.MAGAZINE_ARTICLES_FETCH = undefined;
	
	var _actions = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var MAGAZINE_ARTICLES_FETCH = exports.MAGAZINE_ARTICLES_FETCH = 'MAGAZINE_ARTICLES_FETCH';
	var MAGAZINE_ARTICLES_FETCH_SUCCESS = exports.MAGAZINE_ARTICLES_FETCH_SUCCESS = 'MAGAZINE_ARTICLES_FETCH_SUCCESS';
	var MAGAZINE_ARTICLES_FETCH_ERROR = exports.MAGAZINE_ARTICLES_FETCH_ERROR = 'MAGAZINE_ARTICLES_FETCH_ERROR';
	var magazineArticlesFetch = exports.magazineArticlesFetch = function magazineArticlesFetch() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var query = arguments[1];
	  var queryString = arguments[2];
	  return { type: MAGAZINE_ARTICLES_FETCH, page: page, query: query, queryString: queryString };
	};
	
	var MAGAZINE_SIDEBAR_ARTICLES_FETCH = exports.MAGAZINE_SIDEBAR_ARTICLES_FETCH = 'MAGAZINE_SIDEBAR_ARTICLES_FETCH';
	var MAGAZINE_SIDEBAR_ARTICLES_FETCH_SUCCESS = exports.MAGAZINE_SIDEBAR_ARTICLES_FETCH_SUCCESS = 'MAGAZINE_SIDEBAR_ARTICLES_FETCH_SUCCESS';
	var MAGAZINE_SIDEBAR_ARTICLES_FETCH_ERROR = exports.MAGAZINE_SIDEBAR_ARTICLES_FETCH_ERROR = 'MAGAZINE_SIDEBAR_ARTICLES_FETCH_ERROR';
	var magazineSidebarArticlesFetch = exports.magazineSidebarArticlesFetch = function magazineSidebarArticlesFetch() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var query = arguments[1];
	  var queryString = arguments[2];
	  return { type: MAGAZINE_SIDEBAR_ARTICLES_FETCH, page: page, query: query, queryString: queryString };
	};
	
	var MAGAZINE_ARTICLES_UPDATE_POSSIBLE_PAGE = exports.MAGAZINE_ARTICLES_UPDATE_POSSIBLE_PAGE = 'MAGAZINE_ARTICLES_UPDATE_POSSIBLE_PAGE';
	var magazineArticlesUpdatePossiblePage = exports.magazineArticlesUpdatePossiblePage = function magazineArticlesUpdatePossiblePage(possiblePage, queryString) {
	  return { type: MAGAZINE_ARTICLES_UPDATE_POSSIBLE_PAGE, possiblePage: possiblePage, queryString: queryString };
	};
	
	var MAGAZINE_ARTICLE_PROFILE_FETCH = exports.MAGAZINE_ARTICLE_PROFILE_FETCH = 'MAGAZINE_ARTICLE_PROFILE_FETCH';
	var MAGAZINE_ARTICLE_PROFILE_FETCH_SUCCESS = exports.MAGAZINE_ARTICLE_PROFILE_FETCH_SUCCESS = 'MAGAZINE_ARTICLE_PROFILE_FETCH_SUCCESS';
	var MAGAZINE_ARTICLE_PROFILE_FETCH_ERROR = exports.MAGAZINE_ARTICLE_PROFILE_FETCH_ERROR = 'MAGAZINE_ARTICLE_PROFILE_FETCH_ERROR';
	var magazineArticleProfileFetch = exports.magazineArticleProfileFetch = function magazineArticleProfileFetch(magazineArticleId) {
	  return { type: MAGAZINE_ARTICLE_PROFILE_FETCH, magazineArticleId: magazineArticleId };
	};
	
	var MAGAZINE_ARTICLES_RECEIVED = exports.MAGAZINE_ARTICLES_RECEIVED = 'MAGAZINE_ARTICLES_RECEIVED';
	var magazineArticlesReceived = exports.magazineArticlesReceived = function magazineArticlesReceived(result) {
	  return { type: MAGAZINE_ARTICLES_RECEIVED, result: result };
	};
	
	var MAGAZINE_CONTRIBUTE_EDITING_UPDATE_SUBJECT = exports.MAGAZINE_CONTRIBUTE_EDITING_UPDATE_SUBJECT = 'MAGAZINE_CONTRIBUTE_EDITING_UPDATE_SUBJECT';
	var magazineContributeEditingUpdateSubject = exports.magazineContributeEditingUpdateSubject = function magazineContributeEditingUpdateSubject(subject) {
	  return { type: MAGAZINE_CONTRIBUTE_EDITING_UPDATE_SUBJECT, subject: subject };
	};
	
	var MAGAZINE_CONTRIBUTE_EDITING_UPDATE_TEXT = exports.MAGAZINE_CONTRIBUTE_EDITING_UPDATE_TEXT = 'MAGAZINE_CONTRIBUTE_EDITING_UPDATE_TEXT';
	var magazineContributeEditingUpdateText = exports.magazineContributeEditingUpdateText = (0, _actions.textEditingUpdateTextMaker)(MAGAZINE_CONTRIBUTE_EDITING_UPDATE_TEXT);
	
	var MAGAZINE_CONTRIBUTE_EDITING_RESET = exports.MAGAZINE_CONTRIBUTE_EDITING_RESET = 'MAGAZINE_CONTRIBUTE_EDITING_RESET';
	var magazineContributeEditingReset = exports.magazineContributeEditingReset = function magazineContributeEditingReset() {
	  return { type: MAGAZINE_CONTRIBUTE_EDITING_RESET };
	};
	
	var MAGAZINE_EMOJIS_SHOW = exports.MAGAZINE_EMOJIS_SHOW = 'MAGAZINE_EMOJIS_SHOW';
	var magazineEmojisShow = exports.magazineEmojisShow = function magazineEmojisShow(key) {
	  return { type: MAGAZINE_EMOJIS_SHOW, key: key };
	};
	
	var MAGAZINE_EMOJIS_HIDE = exports.MAGAZINE_EMOJIS_HIDE = 'MAGAZINE_EMOJIS_HIDE';
	var magazineEmojisHide = exports.magazineEmojisHide = function magazineEmojisHide(key) {
	  return { type: MAGAZINE_EMOJIS_HIDE, key: key };
	};
	
	var MAGAZINE_ARTICLE_CREATE = exports.MAGAZINE_ARTICLE_CREATE = 'MAGAZINE_ARTICLE_CREATE';
	var MAGAZINE_ARTICLE_CREATE_SUCCESS = exports.MAGAZINE_ARTICLE_CREATE_SUCCESS = 'MAGAZINE_ARTICLE_CREATE_SUCCESS';
	var MAGAZINE_ARTICLE_CREATE_ERROR = exports.MAGAZINE_ARTICLE_CREATE_ERROR = 'MAGAZINE_ARTICLE_CREATE_ERROR';
	var magazineArticleCreate = exports.magazineArticleCreate = function magazineArticleCreate(title, text, successMessage) {
	  return { type: MAGAZINE_ARTICLE_CREATE, title: title, text: text, successMessage: successMessage };
	};
	
	var MAGAZINE_ARTICLE_UPDATE = exports.MAGAZINE_ARTICLE_UPDATE = 'MAGAZINE_ARTICLE_UPDATE';
	var magazineArticleUpdate = exports.magazineArticleUpdate = function magazineArticleUpdate(magazineArticleId, stateBeforeLocalUpdate, updates) {
	  return {
	    type: MAGAZINE_ARTICLE_UPDATE,
	    stateBeforeLocalUpdate: stateBeforeLocalUpdate,
	    magazineArticleId: magazineArticleId,
	    updates: updates
	  };
	};
	
	var MAGAZINE_ARTICLE_FOLLOW = exports.MAGAZINE_ARTICLE_FOLLOW = 'MAGAZINE_ARTICLE_FOLLOW';
	var MAGAZINE_ARTICLE_FOLLOW_SUCCESS = exports.MAGAZINE_ARTICLE_FOLLOW_SUCCESS = 'MAGAZINE_ARTICLE_FOLLOW_SUCCESS';
	var MAGAZINE_ARTICLE_FOLLOW_ERROR = exports.MAGAZINE_ARTICLE_FOLLOW_ERROR = 'MAGAZINE_ARTICLE_FOLLOW_ERROR';
	var magazineArticleFollow = exports.magazineArticleFollow = function magazineArticleFollow(magazineArticleId, followed) {
	  return { type: MAGAZINE_ARTICLE_FOLLOW, magazineArticleId: magazineArticleId, followed: followed };
	};
	
	var MAGAZINE_ARTICLE_FAVOURITE = exports.MAGAZINE_ARTICLE_FAVOURITE = 'MAGAZINE_ARTICLE_FAVOURITE';
	var MAGAZINE_ARTICLE_FAVOURITE_SUCCESS = exports.MAGAZINE_ARTICLE_FAVOURITE_SUCCESS = 'MAGAZINE_ARTICLE_FAVOURITE_SUCCESS';
	var MAGAZINE_ARTICLE_FAVOURITE_ERROR = exports.MAGAZINE_ARTICLE_FAVOURITE_ERROR = 'MAGAZINE_ARTICLE_FAVOURITE_ERROR';
	var magazineArticleFavourite = exports.magazineArticleFavourite = function magazineArticleFavourite(magazineArticleId, favourite) {
	  return { type: MAGAZINE_ARTICLE_FAVOURITE, magazineArticleId: magazineArticleId, favourite: favourite };
	};

/***/ },

/***/ "./src/members/state/magazine/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.magazineArticlesFetch = magazineArticlesFetch;
	exports.magazineArticleProfileFetch = magazineArticleProfileFetch;
	exports.magazineArticleCreate = magazineArticleCreate;
	exports.magazineArticleFollow = magazineArticleFollow;
	exports.magazineArticleFavourite = magazineArticleFavourite;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function magazineArticlesFetch(page) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$sort = _ref.sort,
	      sort = _ref$sort === undefined ? 'recent' : _ref$sort,
	      _ref$local = _ref.local,
	      local = _ref$local === undefined ? false : _ref$local,
	      _ref$following = _ref.following,
	      following = _ref$following === undefined ? false : _ref$following,
	      _ref$favourite = _ref.favourite,
	      favourite = _ref$favourite === undefined ? false : _ref$favourite,
	      _ref$topic = _ref.topic,
	      topic = _ref$topic === undefined ? [] : _ref$topic;
	
	  return (0, _api.callApi)('/article', {
	    query: _extends({
	      sort: sort,
	      local: local,
	      following: following,
	      favourite: favourite,
	      topic: topic
	    }, (0, _api.pageToOffsetParams)(page, (10)))
	  }).then(function (json) {
	    var articles = json.articles,
	        meta = json.meta;
	
	    var _normalize = (0, _normalizr.normalize)(articles, schemas.magazineArticlesArraySchema),
	        result = _normalize.result,
	        entities = _normalize.entities;
	
	    return { magazineArticlesIds: result, entities: entities, meta: meta };
	  });
	}
	
	function magazineArticleProfileFetch(magazineArticleId) {
	  return (0, _api.callApi)('/article/' + magazineArticleId).then(function (json) {
	    var entities = {
	      magazineArticles: _defineProperty({}, magazineArticleId, json)
	    };
	
	    return { magazineArticlesIds: [magazineArticleId], entities: entities };
	  });
	}
	
	function magazineArticleCreate(title, text) {
	  return (0, _api.callApi)('/article', {
	    method: 'POST',
	    body: {
	      title: title,
	      text: text
	    }
	  });
	}
	
	function magazineArticleFollow(magazineArticleId, following) {
	  return (0, _api.callApi)('/article/' + magazineArticleId + '/following', {
	    method: 'POST',
	    body: {
	      following: following
	    }
	  });
	}
	
	function magazineArticleFavourite(magazineArticleId, favourite) {
	  return (0, _api.callApi)('/article/' + magazineArticleId + '/favourite', {
	    method: 'POST',
	    body: {
	      favourite: favourite
	    }
	  });
	}

/***/ },

/***/ "./src/members/state/magazine/emojis/magazineContribute/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _emojisMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/emojisMaker.js");
	
	var _emojisMaker2 = _interopRequireDefault(_emojisMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _emojisMaker2.default)({
	  showType: actions.MAGAZINE_EMOJIS_SHOW,
	  closeType: actions.MAGAZINE_EMOJIS_HIDE
	});

/***/ },

/***/ "./src/members/state/magazine/emojis/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reducer = __webpack_require__("./src/members/state/magazine/emojis/magazineContribute/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('key', {
	  magazineContribute: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/magazine/magazineArticles/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.MAGAZINE_ARTICLES_FETCH_SUCCESS, actions.MAGAZINE_ARTICLES_RECEIVED, actions.MAGAZINE_ARTICLE_PROFILE_FETCH_SUCCESS, actions.MAGAZINE_SIDEBAR_ARTICLES_FETCH_SUCCESS],
	  updateSuccessTypes: [actions.MAGAZINE_ARTICLE_UPDATE],
	  updateKey: 'magazineArticleId',
	  entityType: 'magazineArticles'
	});

/***/ },

/***/ "./src/members/state/magazine/magazineArticles/byQuery/byPage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byPageMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byPageMaker.js");
	
	var _byPageMaker2 = _interopRequireDefault(_byPageMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byPageMaker2.default)([actions.MAGAZINE_ARTICLES_FETCH_SUCCESS, actions.MAGAZINE_SIDEBAR_ARTICLES_FETCH_SUCCESS], 'magazineArticlesIds');

/***/ },

/***/ "./src/members/state/magazine/magazineArticles/byQuery/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/magazine/magazineArticles/byQuery/byPage/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('queryString', (0, _redux.combineReducers)({ byPage: _reducer2.default }));

/***/ },

/***/ "./src/members/state/magazine/magazineArticles/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/magazine/magazineArticles/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/magazine/magazineArticles/byQuery/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  byQuery: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/magazine/magazineContribute/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _subjectMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/subjectMaker.js");
	
	var _subjectMaker2 = _interopRequireDefault(_subjectMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _subjectMaker2.default)({
	  updateType: actions.MAGAZINE_CONTRIBUTE_EDITING_UPDATE_SUBJECT,
	  resetType: actions.MAGAZINE_CONTRIBUTE_EDITING_RESET
	});

/***/ },

/***/ "./src/members/state/magazine/paging/magazineArticles/byQuery/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _pagingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/pagingMaker.js");
	
	var _pagingMaker2 = _interopRequireDefault(_pagingMaker);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byKeyMaker2.default)('queryString', (0, _pagingMaker2.default)({
	  fetchType: actions.MAGAZINE_ARTICLES_FETCH,
	  fetchSuccessType: actions.MAGAZINE_ARTICLES_FETCH_SUCCESS,
	  fetchErrorType: actions.MAGAZINE_ARTICLES_FETCH_ERROR,
	  possiblePageUpdateType: actions.MAGAZINE_ARTICLES_UPDATE_POSSIBLE_PAGE
	}));

/***/ },

/***/ "./src/members/state/magazine/paging/magazineArticles/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/magazine/paging/magazineArticles/byQuery/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byQuery: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/magazine/paging/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/magazine/paging/magazineArticles/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  magazineArticles: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/magazine/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/magazine/magazineArticles/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/magazine/magazineContribute/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/magazine/textEditing/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("./src/members/state/magazine/paging/reducer.js");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__("./src/members/state/magazine/emojis/reducer.js");
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  magazineArticles: _reducer2.default,
	  magazineContribute: _reducer4.default,
	  textEditing: _reducer6.default,
	  paging: _reducer8.default,
	  emojis: _reducer10.default
	});

/***/ },

/***/ "./src/members/state/magazine/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForMagazineQueryChange = watchForMagazineQueryChange;
	exports.watchForSuccessfullyCreatedArticle = watchForSuccessfullyCreatedArticle;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	var _magazineQueries = __webpack_require__("./src/members/__shared__/magazineQueries.js");
	
	var _magazineQueries2 = _interopRequireDefault(_magazineQueries);
	
	var _sagas = __webpack_require__("./src/members/state/__shared__/utils/sagas.js");
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForMagazineQueryChange, loadSidePanel, watchForSuccessfullyCreatedArticle, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForMagazineQueryChange() {
	  var task, _ref, payload, isArticlesList, isArticleProfile, queryString, query, page, paging;
	
	  return regeneratorRuntime.wrap(function watchForMagazineQueryChange$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          task = void 0;
	
	        case 1:
	          if (false) {
	            _context.next = 29;
	            break;
	          }
	
	          _context.next = 4;
	          return (0, _effects.take)('@@router/LOCATION_CHANGE');
	
	        case 4:
	          _ref = _context.sent;
	          payload = _ref.payload;
	          isArticlesList = ['/magazine', '/magazine/'].indexOf(payload.pathname) >= 0;
	          isArticleProfile = payload.pathname.indexOf('/magazine/articles/') === 0;
	
	          if (!(isArticlesList || isArticleProfile)) {
	            _context.next = 27;
	            break;
	          }
	
	          if (!task) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 12;
	          return (0, _effects.cancel)(task);
	
	        case 12:
	          queryString = null;
	
	          if (!isArticlesList) {
	            _context.next = 24;
	            break;
	          }
	
	          query = (0, _magazineQueries.normalizeMagazineQuery)(payload.query);
	
	          queryString = JSON.stringify(query);
	
	          page = 1;
	
	          if (!(payload.action === 'POP')) {
	            _context.next = 22;
	            break;
	          }
	
	          _context.next = 20;
	          return (0, _effects.select)(_selectors.getMagazinePaging, 'magazineArticles', { queryString: queryString });
	
	        case 20:
	          paging = _context.sent;
	
	          page = paging.page;
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.put)(actions.magazineArticlesFetch(page, query, queryString));
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.fork)(loadSidePanel, queryString);
	
	        case 26:
	          task = _context.sent;
	
	        case 27:
	          _context.next = 1;
	          break;
	
	        case 29:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function loadSidePanel(currentQueryString) {
	  var queriesKeys, otherFetches, maxOtherQueriesToMake, i, query, queryString;
	  return regeneratorRuntime.wrap(function loadSidePanel$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.call)(_reduxSaga.delay, 1000);
	
	        case 2:
	          queriesKeys = Object.keys(_magazineQueries2.default);
	          otherFetches = [];
	          maxOtherQueriesToMake = 2;
	
	
	          for (i = 0; i < queriesKeys.length; i++) {
	            query = _magazineQueries2.default[queriesKeys[i]].query;
	            queryString = JSON.stringify(query);
	
	
	            if (otherFetches.length < maxOtherQueriesToMake && queryString !== currentQueryString) {
	              otherFetches.push((0, _effects.put)(actions.magazineSidebarArticlesFetch(1, query, queryString)));
	            }
	          }
	
	          _context2.next = 8;
	          return otherFetches;
	
	        case 8:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function watchForSuccessfullyCreatedArticle() {
	  var action;
	  return regeneratorRuntime.wrap(function watchForSuccessfullyCreatedArticle$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (false) {
	            _context3.next = 10;
	            break;
	          }
	
	          _context3.next = 3;
	          return (0, _effects.take)(actions.MAGAZINE_ARTICLE_CREATE_SUCCESS);
	
	        case 3:
	          action = _context3.sent;
	          _context3.next = 6;
	          return (0, _effects.put)(actions.magazineContributeEditingReset());
	
	        case 6:
	          _context3.next = 8;
	          return (0, _effects.put)(actions.infoShow('success', action.successMessage));
	
	        case 8:
	          _context3.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	var follow = (0, _sagas.optimisticUpdateMaker)({
	  idKey: 'magazineArticleId',
	  localUpdateType: actions.MAGAZINE_ARTICLE_UPDATE,
	  successType: actions.MAGAZINE_ARTICLE_FOLLOW_SUCCESS,
	  errorType: actions.MAGAZINE_ARTICLE_FOLLOW_ERROR,
	  remoteUpdateActionCreator: regeneratorRuntime.mark(function remoteUpdateActionCreator(localUpdateAction) {
	    return regeneratorRuntime.wrap(function remoteUpdateActionCreator$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            if (!(localUpdateAction.updates.followed !== undefined)) {
	              _context4.next = 2;
	              break;
	            }
	
	            return _context4.abrupt('return', actions.magazineArticleFollow(localUpdateAction.magazineArticleId, localUpdateAction.updates.followed));
	
	          case 2:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, remoteUpdateActionCreator, this);
	  }),
	  localUpdateActionCreator: regeneratorRuntime.mark(function localUpdateActionCreator(lastRemoteState, errorAction) {
	    return regeneratorRuntime.wrap(function localUpdateActionCreator$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', actions.magazineArticleUpdate(errorAction.magazineArticleId, null, lastRemoteState));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, localUpdateActionCreator, this);
	  })
	});
	
	var favourite = (0, _sagas.optimisticUpdateMaker)({
	  idKey: 'magazineArticleId',
	  localUpdateType: actions.MAGAZINE_ARTICLE_UPDATE,
	  successType: actions.MAGAZINE_ARTICLE_FAVOURITE_SUCCESS,
	  errorType: actions.MAGAZINE_ARTICLE_FAVOURITE_ERROR,
	  remoteUpdateActionCreator: regeneratorRuntime.mark(function remoteUpdateActionCreator(localUpdateAction) {
	    return regeneratorRuntime.wrap(function remoteUpdateActionCreator$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            if (!(localUpdateAction.updates.favourite !== undefined)) {
	              _context6.next = 2;
	              break;
	            }
	
	            return _context6.abrupt('return', actions.magazineArticleFavourite(localUpdateAction.magazineArticleId, localUpdateAction.updates.favourite));
	
	          case 2:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, remoteUpdateActionCreator, this);
	  }),
	  localUpdateActionCreator: regeneratorRuntime.mark(function localUpdateActionCreator(lastRemoteState, errorAction) {
	    return regeneratorRuntime.wrap(function localUpdateActionCreator$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', actions.magazineArticleUpdate(errorAction.magazineArticleId, null, lastRemoteState));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, localUpdateActionCreator, this);
	  })
	});
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.MAGAZINE_ARTICLE_CREATE, request(api.magazineArticleCreate, 'title', 'text')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.MAGAZINE_ARTICLE_FOLLOW, request(api.magazineArticleFollow, 'magazineArticleId', 'followed')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.MAGAZINE_ARTICLE_FAVOURITE, request(api.magazineArticleFavourite, 'magazineArticleId', 'favourite')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.MAGAZINE_ARTICLES_FETCH, request(api.magazineArticlesFetch, 'page', 'query')), (0, _effects.fork)(_reduxSaga.takeEvery, actions.MAGAZINE_SIDEBAR_ARTICLES_FETCH, request(api.magazineArticlesFetch, 'page', 'query')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.MAGAZINE_ARTICLE_PROFILE_FETCH, request(api.magazineArticleProfileFetch, 'magazineArticleId')), (0, _effects.fork)(watchForMagazineQueryChange), (0, _effects.fork)(watchForSuccessfullyCreatedArticle), (0, _effects.fork)(favourite), (0, _effects.fork)(follow)];
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[3], this);
	}

/***/ },

/***/ "./src/members/state/magazine/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMagazineEmojis = exports.getMagazineTextEditing = exports.getMagazineContribute = exports.getMagazinePaging = exports.getMagazineArticle = exports.getMagazineArticlesOnSidebar = exports.getMagazineArticlesOnFrontPage = exports.getMagazineArticlesById = exports.getMagazineArticlesIds = undefined;
	
	var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var mount = (0, _selectors.mountSelectorAt)('magazine');
	
	var getMagazineArticlesIds = exports.getMagazineArticlesIds = mount(function (localState, props) {
	  var queryString = props.queryString,
	      page = props.page;
	
	  var pagesForQuery = localState.magazineArticles.byQuery[queryString];
	
	  if (!pagesForQuery) {
	    return [];
	  }
	
	  var magazineArticlesIds = pagesForQuery.byPage[page];
	
	  if (!magazineArticlesIds) {
	    return [];
	  }
	
	  return magazineArticlesIds;
	});
	
	var getMagazineArticlesById = exports.getMagazineArticlesById = mount(function (localState) {
	  return localState.magazineArticles.byId;
	});
	
	var getMagazineArticlesOnFrontPage = exports.getMagazineArticlesOnFrontPage = (0, _reselect.createSelector)([getMagazineArticlesIds, getMagazineArticlesById], function (magazineArticlesIds, magazineArticlesById) {
	  return magazineArticlesIds.map(function (id) {
	    return magazineArticlesById[id];
	  });
	});
	
	var getMagazineArticlesOnSidebar = exports.getMagazineArticlesOnSidebar = (0, _reselect.createSelector)([getMagazineArticlesIds, getMagazineArticlesById], function (magazineArticlesIds, magazineArticlesById) {
	
	  return magazineArticlesIds.map(function (id) {
	    return magazineArticlesById[id];
	  });
	});
	
	var getMagazineArticle = exports.getMagazineArticle = mount(function (localState, id) {
	  return localState.magazineArticles.byId[id];
	});
	
	var getMagazinePaging = exports.getMagazinePaging = mount(function (localState, key, options) {
	  return (0, _selectors.getPaging)(localState.paging[key], options);
	});
	
	var getMagazineContribute = exports.getMagazineContribute = mount(function (localState) {
	  return localState.magazineContribute;
	});
	
	var getMagazineTextEditing = exports.getMagazineTextEditing = mount(function (localState, key) {
	  return (0, _selectors.getTextEditing)(localState.textEditing[key]);
	});
	
	var getMagazineEmojis = exports.getMagazineEmojis = mount(function (localState, key) {
	  return localState.emojis[key];
	});

/***/ },

/***/ "./src/members/state/magazine/textEditing/magazineContribute/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _textEditingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/textEditingMaker.js");
	
	var _textEditingMaker2 = _interopRequireDefault(_textEditingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _textEditingMaker2.default)({
	  submitType: actions.MAGAZINE_ARTICLE_CREATE,
	  submitSuccessType: actions.MAGAZINE_ARTICLE_CREATE_SUCCESS,
	  submitErrorType: actions.MAGAZINE_ARTICLE_CREATE_ERROR,
	  updateTextType: actions.MAGAZINE_CONTRIBUTE_EDITING_UPDATE_TEXT,
	  resetType: actions.MAGAZINE_CONTRIBUTE_EDITING_RESET
	});

/***/ },

/***/ "./src/members/state/magazine/textEditing/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/magazine/textEditing/magazineContribute/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  magazineContribute: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/mail/actions.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mailEmojisHide = exports.MAIL_EMOJIS_HIDE = exports.mailEmojisShow = exports.MAIL_EMOJIS_SHOW = exports.mailThreadMessageEditingReset = exports.MAIL_THREAD_MESSAGE_EDITING_RESET = exports.mailThreadMessageEditingExpand = exports.MAIL_THREAD_MESSAGE_EDITING_EXPAND = exports.mailThreadMessageEditingUpdateText = exports.MAIL_THREAD_MESSAGE_EDITING_UPDATE_TEXT = exports.mailThreadMessageCreate = exports.MAIL_THREAD_MESSAGE_CREATE_ERROR = exports.MAIL_THREAD_MESSAGE_CREATE_SUCCESS = exports.MAIL_THREAD_MESSAGE_CREATE = exports.mailThreadMessagesUpdatePossiblePage = exports.MAIL_THREAD_MESSAGES_UPDATE_POSSIBLE_PAGE = exports.mailThreadMessagesFetch = exports.MAIL_THREAD_MESSAGES_FETCH_ERROR = exports.MAIL_THREAD_MESSAGES_FETCH_SUCCESS = exports.MAIL_THREAD_MESSAGES_FETCH = exports.mailThreadMessageUpdate = exports.MAIL_THREAD_MESSAGE_UPDATE_ERROR = exports.MAIL_THREAD_MESSAGE_UPDATE_SUCCESS = exports.MAIL_THREAD_MESSAGE_UPDATE = exports.mailMessageTheTeam = exports.MAIL_MESSAGE_THE_TEAM_ERROR = exports.MAIL_MESSAGE_THE_TEAM_SUCCESS = exports.MAIL_MESSAGE_THE_TEAM = exports.mailmailMessageTheTeamEditingReset = exports.MAIL_MESSAGE_THE_TEAM_EDITING_RESET = exports.mailmailMessageTheTeamEditingUpdateText = exports.MAIL_MESSAGE_THE_TEAM_EDITING_UPDATE_TEXT = exports.mailThreadsUpdatePossiblePage = exports.MAIL_THREADS_UPDATE_POSSIBLE_PAGE = exports.mailThreadsFetch = exports.MAIL_THREADS_FETCH_ERROR = exports.MAIL_THREADS_FETCH_SUCCESS = exports.MAIL_THREADS_FETCH = undefined;
	
	var _actions = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var MAIL_THREADS_FETCH = exports.MAIL_THREADS_FETCH = 'MAIL_THREADS_FETCH';
	var MAIL_THREADS_FETCH_SUCCESS = exports.MAIL_THREADS_FETCH_SUCCESS = 'MAIL_THREADS_FETCH_SUCCESS';
	var MAIL_THREADS_FETCH_ERROR = exports.MAIL_THREADS_FETCH_ERROR = 'MAIL_THREADS_FETCH_ERROR';
	var mailThreadsFetch = exports.mailThreadsFetch = function mailThreadsFetch() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  return { type: MAIL_THREADS_FETCH, page: page };
	};
	
	var MAIL_THREADS_UPDATE_POSSIBLE_PAGE = exports.MAIL_THREADS_UPDATE_POSSIBLE_PAGE = 'MAIL_THREADS_UPDATE_POSSIBLE_PAGE';
	var mailThreadsUpdatePossiblePage = exports.mailThreadsUpdatePossiblePage = function mailThreadsUpdatePossiblePage(possiblePage) {
	  return { type: MAIL_THREADS_UPDATE_POSSIBLE_PAGE, possiblePage: possiblePage };
	};
	
	var MAIL_MESSAGE_THE_TEAM_EDITING_UPDATE_TEXT = exports.MAIL_MESSAGE_THE_TEAM_EDITING_UPDATE_TEXT = 'MAIL_MESSAGE_THE_TEAM_EDITING_UPDATE_TEXT';
	var mailmailMessageTheTeamEditingUpdateText = exports.mailmailMessageTheTeamEditingUpdateText = (0, _actions.textEditingUpdateTextMaker)(MAIL_MESSAGE_THE_TEAM_EDITING_UPDATE_TEXT);
	
	var MAIL_MESSAGE_THE_TEAM_EDITING_RESET = exports.MAIL_MESSAGE_THE_TEAM_EDITING_RESET = 'MAIL_MESSAGE_THE_TEAM_EDITING_RESET';
	var mailmailMessageTheTeamEditingReset = exports.mailmailMessageTheTeamEditingReset = function mailmailMessageTheTeamEditingReset() {
	  return { type: MAIL_MESSAGE_THE_TEAM_EDITING_RESET };
	};
	
	var MAIL_MESSAGE_THE_TEAM = exports.MAIL_MESSAGE_THE_TEAM = 'MAIL_MESSAGE_THE_TEAM';
	var MAIL_MESSAGE_THE_TEAM_SUCCESS = exports.MAIL_MESSAGE_THE_TEAM_SUCCESS = 'MAIL_MESSAGE_THE_TEAM_SUCCESS';
	var MAIL_MESSAGE_THE_TEAM_ERROR = exports.MAIL_MESSAGE_THE_TEAM_ERROR = 'MAIL_MESSAGE_THE_TEAM_ERROR';
	var mailMessageTheTeam = exports.mailMessageTheTeam = function mailMessageTheTeam(text) {
	  return { type: MAIL_MESSAGE_THE_TEAM, text: text };
	};
	
	var MAIL_THREAD_MESSAGE_UPDATE = exports.MAIL_THREAD_MESSAGE_UPDATE = 'MAIL_THREAD_MESSAGE_UPDATE';
	var MAIL_THREAD_MESSAGE_UPDATE_SUCCESS = exports.MAIL_THREAD_MESSAGE_UPDATE_SUCCESS = 'MAIL_THREAD_MESSAGE_UPDATE_SUCCESS';
	var MAIL_THREAD_MESSAGE_UPDATE_ERROR = exports.MAIL_THREAD_MESSAGE_UPDATE_ERROR = 'MAIL_THREAD_MESSAGE_UPDATE_ERROR';
	
	var mailThreadMessageUpdate = exports.mailThreadMessageUpdate = function mailThreadMessageUpdate(threadId, threadMessageId, updates) {
	  return { type: MAIL_THREAD_MESSAGE_UPDATE, threadId: threadId, threadMessageId: threadMessageId, updates: updates };
	};
	
	var MAIL_THREAD_MESSAGES_FETCH = exports.MAIL_THREAD_MESSAGES_FETCH = 'MAIL_THREAD_MESSAGES_FETCH';
	var MAIL_THREAD_MESSAGES_FETCH_SUCCESS = exports.MAIL_THREAD_MESSAGES_FETCH_SUCCESS = 'MAIL_THREAD_MESSAGES_FETCH_SUCCESS';
	var MAIL_THREAD_MESSAGES_FETCH_ERROR = exports.MAIL_THREAD_MESSAGES_FETCH_ERROR = 'MAIL_THREAD_MESSAGES_FETCH_ERROR';
	var mailThreadMessagesFetch = exports.mailThreadMessagesFetch = function mailThreadMessagesFetch(threadId) {
	  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return { type: MAIL_THREAD_MESSAGES_FETCH, threadId: threadId, page: page };
	};
	
	var MAIL_THREAD_MESSAGES_UPDATE_POSSIBLE_PAGE = exports.MAIL_THREAD_MESSAGES_UPDATE_POSSIBLE_PAGE = 'MAIL_THREAD_MESSAGES_UPDATE_POSSIBLE_PAGE';
	var mailThreadMessagesUpdatePossiblePage = exports.mailThreadMessagesUpdatePossiblePage = function mailThreadMessagesUpdatePossiblePage(threadId, possiblePage) {
	  return { type: MAIL_THREAD_MESSAGES_UPDATE_POSSIBLE_PAGE, possiblePage: possiblePage, threadId: threadId };
	};
	
	var MAIL_THREAD_MESSAGE_CREATE = exports.MAIL_THREAD_MESSAGE_CREATE = 'MAIL_THREAD_MESSAGE_CREATE';
	var MAIL_THREAD_MESSAGE_CREATE_SUCCESS = exports.MAIL_THREAD_MESSAGE_CREATE_SUCCESS = 'MAIL_THREAD_MESSAGE_CREATE_SUCCESS';
	var MAIL_THREAD_MESSAGE_CREATE_ERROR = exports.MAIL_THREAD_MESSAGE_CREATE_ERROR = 'MAIL_THREAD_MESSAGE_CREATE_ERROR';
	var mailThreadMessageCreate = exports.mailThreadMessageCreate = function mailThreadMessageCreate(threadId, text) {
	  return { type: MAIL_THREAD_MESSAGE_CREATE, threadId: threadId, text: text };
	};
	
	var MAIL_THREAD_MESSAGE_EDITING_UPDATE_TEXT = exports.MAIL_THREAD_MESSAGE_EDITING_UPDATE_TEXT = 'MAIL_THREAD_MESSAGE_EDITING_UPDATE_TEXT';
	var mailThreadMessageEditingUpdateText = exports.mailThreadMessageEditingUpdateText = (0, _actions.textEditingUpdateTextMaker)(MAIL_THREAD_MESSAGE_EDITING_UPDATE_TEXT);
	
	var MAIL_THREAD_MESSAGE_EDITING_EXPAND = exports.MAIL_THREAD_MESSAGE_EDITING_EXPAND = 'MAIL_THREAD_MESSAGE_EDITING_EXPAND';
	var mailThreadMessageEditingExpand = exports.mailThreadMessageEditingExpand = function mailThreadMessageEditingExpand() {
	  return { type: MAIL_THREAD_MESSAGE_EDITING_EXPAND };
	};
	
	var MAIL_THREAD_MESSAGE_EDITING_RESET = exports.MAIL_THREAD_MESSAGE_EDITING_RESET = 'MAIL_THREAD_MESSAGE_EDITING_RESET';
	var mailThreadMessageEditingReset = exports.mailThreadMessageEditingReset = function mailThreadMessageEditingReset() {
	  return { type: MAIL_THREAD_MESSAGE_EDITING_RESET };
	};
	
	var MAIL_EMOJIS_SHOW = exports.MAIL_EMOJIS_SHOW = 'MAIL_EMOJIS_SHOW';
	var mailEmojisShow = exports.mailEmojisShow = function mailEmojisShow(key) {
	  return { type: MAIL_EMOJIS_SHOW, key: key };
	};
	
	var MAIL_EMOJIS_HIDE = exports.MAIL_EMOJIS_HIDE = 'MAIL_EMOJIS_HIDE';
	var mailEmojisHide = exports.mailEmojisHide = function mailEmojisHide(key) {
	  return { type: MAIL_EMOJIS_HIDE, key: key };
	};

/***/ },

/***/ "./src/members/state/mail/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.mailThreadsFetch = mailThreadsFetch;
	exports.mailThreadMessagesFetch = mailThreadMessagesFetch;
	exports.mailMessageTheTeam = mailMessageTheTeam;
	exports.mailThreadMessageUpdate = mailThreadMessageUpdate;
	exports.mailThreadMessageCreate = mailThreadMessageCreate;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function mailThreadsFetch(page) {
	  return (0, _api.callApi)('/mail/threads', {
	    query: _extends({}, (0, _api.pageToOffsetParams)(page, (10)))
	  }).then(function (json) {
	    var threads = json.threads,
	        meta = json.meta;
	
	    var _normalize = (0, _normalizr.normalize)(threads, schemas.threadsArraySchema),
	        result = _normalize.result,
	        entities = _normalize.entities;
	
	    return { threadsIds: result, entities: entities, meta: meta };
	  });
	}
	
	function mailThreadMessagesFetch(threadId, page) {
	  return (0, _api.callApi)('/mail/threads/' + threadId + '/messages', {
	    query: _extends({}, (0, _api.pageToOffsetParams)(page, (10)))
	  }).then(function (json) {
	    var messages = json.messages,
	        meta = json.meta;
	
	    var _normalize2 = (0, _normalizr.normalize)(messages, schemas.threadMessagesArraySchema),
	        result = _normalize2.result,
	        entities = _normalize2.entities;
	
	    return { threadMessagesIds: result, entities: entities, meta: meta };
	  });
	}
	
	function mailMessageTheTeam(text) {
	  return (0, _api.callApi)('/mail/threads/message-the-team', {
	    method: 'POST',
	    body: {
	      text: text
	    }
	  });
	}
	
	function mailThreadMessageUpdate(threadId, threadMessageId, updates) {
	  return (0, _api.callApi)('/mail/threads/' + threadId + '/messages/' + threadMessageId, {
	    method: 'PATCH',
	    body: _extends({}, updates)
	  });
	}
	
	function mailThreadMessageCreate(threadId, text) {
	  return (0, _api.callApi)('/mail/threads/' + threadId + '/messages', {
	    method: 'POST',
	    body: {
	      text: text
	    }
	  });
	}

/***/ },

/***/ "./src/members/state/mail/emojis/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reducer = __webpack_require__("./src/members/state/mail/emojis/teamMessage/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/mail/emojis/replyToMessage/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('key', {
	  teamMessage: _reducer2.default,
	  replyToMessage: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/mail/emojis/replyToMessage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _emojisMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/emojisMaker.js");
	
	var _emojisMaker2 = _interopRequireDefault(_emojisMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _emojisMaker2.default)({
	  showType: actions.MAIL_EMOJIS_SHOW,
	  closeType: actions.MAIL_EMOJIS_HIDE
	});

/***/ },

/***/ "./src/members/state/mail/emojis/teamMessage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _emojisMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/emojisMaker.js");
	
	var _emojisMaker2 = _interopRequireDefault(_emojisMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _emojisMaker2.default)({
	  showType: actions.MAIL_EMOJIS_SHOW,
	  closeType: actions.MAIL_EMOJIS_HIDE
	});

/***/ },

/***/ "./src/members/state/mail/mailThreadMessages/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.MAIL_THREADS_FETCH_SUCCESS, actions.MAIL_THREAD_MESSAGES_FETCH_SUCCESS],
	  updateSuccessTypes: [actions.MAIL_THREAD_MESSAGE_UPDATE_SUCCESS],
	  updateKey: 'threadMessageId',
	  entityType: 'threadMessages'
	});

/***/ },

/***/ "./src/members/state/mail/mailThreadMessages/byThreadId/byPage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _byPageMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byPageMaker.js");
	
	var _byPageMaker2 = _interopRequireDefault(_byPageMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byPageMaker2.default)([actions.MAIL_THREAD_MESSAGES_FETCH_SUCCESS], 'threadMessagesIds');

/***/ },

/***/ "./src/members/state/mail/mailThreadMessages/byThreadId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/mail/mailThreadMessages/byThreadId/byPage/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('threadId', (0, _redux.combineReducers)({ byPage: _reducer2.default }));

/***/ },

/***/ "./src/members/state/mail/mailThreadMessages/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/mail/mailThreadMessages/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/mail/mailThreadMessages/byThreadId/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  byThreadId: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/mail/mailThreads/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.MAIL_THREADS_FETCH_SUCCESS],
	  entityType: 'threads'
	});

/***/ },

/***/ "./src/members/state/mail/mailThreads/byPage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byPageMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byPageMaker.js");
	
	var _byPageMaker2 = _interopRequireDefault(_byPageMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byPageMaker2.default)([actions.MAIL_THREADS_FETCH_SUCCESS], 'threadsIds');

/***/ },

/***/ "./src/members/state/mail/mailThreads/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/mail/mailThreads/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/mail/mailThreads/byPage/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  byPage: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/mail/paging/mailThreadMessages/byThreadId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _pagingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/pagingMaker.js");
	
	var _pagingMaker2 = _interopRequireDefault(_pagingMaker);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byKeyMaker2.default)('threadId', (0, _pagingMaker2.default)({
	  fetchType: actions.MAIL_THREAD_MESSAGES_FETCH,
	  fetchSuccessType: actions.MAIL_THREAD_MESSAGES_FETCH_SUCCESS,
	  fetchErrorType: actions.MAIL_THREAD_MESSAGES_FETCH_ERROR,
	  possiblePageUpdateType: actions.MAIL_THREAD_MESSAGES_UPDATE_POSSIBLE_PAGE
	}));

/***/ },

/***/ "./src/members/state/mail/paging/mailThreadMessages/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/mail/paging/mailThreadMessages/byThreadId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byThreadId: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/mail/paging/mailThreads/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _pagingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/pagingMaker.js");
	
	var _pagingMaker2 = _interopRequireDefault(_pagingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _pagingMaker2.default)({
	  fetchType: actions.MAIL_THREADS_FETCH,
	  fetchSuccessType: actions.MAIL_THREADS_FETCH_SUCCESS,
	  fetchErrorType: actions.MAIL_THREADS_FETCH_ERROR,
	  possiblePageUpdateType: actions.MAIL_THREADS_UPDATE_POSSIBLE_PAGE
	});

/***/ },

/***/ "./src/members/state/mail/paging/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/mail/paging/mailThreads/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/mail/paging/mailThreadMessages/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  mailThreads: _reducer2.default,
	  mailThreadMessages: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/mail/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/mail/mailThreadMessages/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/mail/mailThreads/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/mail/textEditing/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("./src/members/state/mail/paging/reducer.js");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__("./src/members/state/mail/emojis/reducer.js");
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  mailThreadMessages: _reducer2.default,
	  mailThreads: _reducer4.default,
	  textEditing: _reducer6.default,
	  paging: _reducer8.default,
	  emojis: _reducer10.default
	});

/***/ },

/***/ "./src/members/state/mail/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForMailQueryChange = watchForMailQueryChange;
	exports.watchForSentTeamMessage = watchForSentTeamMessage;
	exports.watchForSentThreadMessage = watchForSentThreadMessage;
	exports.refreshMail = refreshMail;
	exports.default = _callee;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var selectors = _interopRequireWildcard(_selectors);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForMailQueryChange, watchForSentTeamMessage, watchForSentThreadMessage, refreshMail, _callee].map(regeneratorRuntime.mark);
	
	function watchForMailQueryChange() {
	  var _ref, payload, isThreadsList, page, paging;
	
	  return regeneratorRuntime.wrap(function watchForMailQueryChange$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 17;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)('@@router/LOCATION_CHANGE');
	
	        case 3:
	          _ref = _context.sent;
	          payload = _ref.payload;
	          isThreadsList = ['/messages', '/messages/'].indexOf(payload.pathname) >= 0;
	
	          if (!isThreadsList) {
	            _context.next = 15;
	            break;
	          }
	
	          page = 1;
	
	          if (!(payload.action === 'POP')) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.select)(selectors.getMailPaging, 'mailThreads');
	
	        case 11:
	          paging = _context.sent;
	
	          page = paging.page;
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)(actions.mailThreadsFetch(page));
	
	        case 15:
	          _context.next = 0;
	          break;
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function watchForSentTeamMessage() {
	  return regeneratorRuntime.wrap(function watchForSentTeamMessage$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (false) {
	            _context2.next = 7;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _effects.take)(actions.MAIL_MESSAGE_THE_TEAM_SUCCESS);
	
	        case 3:
	          _context2.next = 5;
	          return (0, _effects.put)((0, _reactRouterRedux.push)('/messages'));
	
	        case 5:
	          _context2.next = 0;
	          break;
	
	        case 7:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function watchForSentThreadMessage() {
	  var action;
	  return regeneratorRuntime.wrap(function watchForSentThreadMessage$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (false) {
	            _context3.next = 10;
	            break;
	          }
	
	          _context3.next = 3;
	          return (0, _effects.take)(actions.MAIL_THREAD_MESSAGE_CREATE_SUCCESS);
	
	        case 3:
	          action = _context3.sent;
	          _context3.next = 6;
	          return (0, _effects.put)(actions.mailThreadMessagesFetch(action.threadId));
	
	        case 6:
	          _context3.next = 8;
	          return (0, _effects.put)(actions.mailThreadMessageEditingReset(''));
	
	        case 8:
	          _context3.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function refreshMail() {
	  var routing, pathname, entitiesType, action, threadId, paging;
	  return regeneratorRuntime.wrap(function refreshMail$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.routing;
	          });
	
	        case 2:
	          routing = _context4.sent;
	          pathname = routing.locationBeforeTransitions.pathname;
	          entitiesType = null;
	          action = null;
	
	
	          if (pathname.indexOf('/messages/threads/') >= 0) {
	            threadId = Number(pathname.slice(pathname.lastIndexOf('/') + 1));
	
	            action = actions.mailThreadMessagesFetch(threadId);
	            entitiesType = 'mailThreadMessages';
	          } else if (pathname === '/messages') {
	            action = actions.mailThreadsFetch();
	            entitiesType = 'mailThreads';
	          }
	
	          if (!entitiesType) {
	            _context4.next = 14;
	            break;
	          }
	
	          _context4.next = 10;
	          return (0, _effects.select)(selectors.getMailPaging, entitiesType);
	
	        case 10:
	          paging = _context4.sent;
	
	          if (!(paging.page == 1)) {
	            _context4.next = 14;
	            break;
	          }
	
	          _context4.next = 14;
	          return (0, _effects.put)(action);
	
	        case 14:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function _callee(socket, request) {
	  return regeneratorRuntime.wrap(function _callee$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.MAIL_THREADS_FETCH, request(api.mailThreadsFetch, 'page')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.MAIL_THREAD_MESSAGES_FETCH, request(api.mailThreadMessagesFetch, 'threadId', 'page')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.MAIL_MESSAGE_THE_TEAM, request(api.mailMessageTheTeam, 'text')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.MAIL_THREAD_MESSAGE_UPDATE, request(api.mailThreadMessageUpdate, 'threadId', 'threadMessageId', 'updates')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.MAIL_THREAD_MESSAGE_CREATE, request(api.mailThreadMessageCreate, 'threadId', 'text')), (0, _effects.fork)(watchForSentTeamMessage), (0, _effects.fork)(watchForSentThreadMessage), (0, _effects.fork)(watchForMailQueryChange)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },

/***/ "./src/members/state/mail/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMailEmojis = exports.getMailPaging = exports.getMailTextEditing = exports.getMailThreadMessages = exports.getMailThreadMessagesIds = exports.getMailThreads = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var mount = (0, _selectors.mountSelectorAt)('mail');
	
	var getMailThreadsIdsForPage = mount(function (localState, props) {
	  var page = props.page;
	
	
	  var threadsIds = localState.mailThreads.byPage[page];
	
	  if (!threadsIds) {
	    return [];
	  }
	
	  return threadsIds;
	});
	
	var getMailThreadMessagesById = mount(function (localState) {
	  return localState.mailThreadMessages.byId;
	});
	
	var getMailThreadsById = mount(function (localState) {
	  return localState.mailThreads.byId;
	});
	
	var getMailThreads = exports.getMailThreads = (0, _reselect.createSelector)([getMailThreadsIdsForPage, getMailThreadsById, getMailThreadMessagesById], function (threadsIdsForPage, threadsById, threadMessagesById) {
	  return threadsIdsForPage.map(function (threadId) {
	    var thread = threadsById[threadId];
	
	    return _extends({}, thread, {
	      latestMessage: threadMessagesById[thread.latestMessage]
	    });
	  });
	});
	
	var getMailThreadMessagesIds = exports.getMailThreadMessagesIds = mount(function (localState, props) {
	  var threadId = props.threadId,
	      page = props.page;
	
	  var pagesForThread = localState.mailThreadMessages.byThreadId[threadId];
	
	  if (!pagesForThread) {
	    return [];
	  }
	
	  var threadMessagesIds = pagesForThread.byPage[page];
	
	  if (!threadMessagesIds) {
	    return [];
	  }
	
	  return threadMessagesIds;
	});
	
	var getMailThreadMessages = exports.getMailThreadMessages = (0, _reselect.createSelector)([getMailThreadMessagesIds, getMailThreadMessagesById], function (threadMessagesIds, threadMessagesById) {
	  return threadMessagesIds.map(function (threadMessageId) {
	    return threadMessagesById[threadMessageId];
	  });
	});
	
	var getMailTextEditing = exports.getMailTextEditing = mount(function (localState, key) {
	  return (0, _selectors.getTextEditing)(localState.textEditing[key]);
	});
	
	var getMailPaging = exports.getMailPaging = mount(function (localState, key, options) {
	  return (0, _selectors.getPaging)(localState.paging[key], options);
	});
	
	var getMailEmojis = exports.getMailEmojis = mount(function (localState, key) {
	  return localState.emojis[key];
	});

/***/ },

/***/ "./src/members/state/mail/textEditing/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/mail/textEditing/replyToMessage/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/mail/textEditing/teamMessage/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  replyToMessage: _reducer2.default,
	  teamMessage: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/mail/textEditing/replyToMessage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _textEditingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/textEditingMaker.js");
	
	var _textEditingMaker2 = _interopRequireDefault(_textEditingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _textEditingMaker2.default)({
	  submitType: actions.MAIL_THREAD_MESSAGE_CREATE,
	  submitSuccessType: actions.MAIL_THREAD_MESSAGE_CREATE_SUCCESS,
	  submitErrorType: actions.MAIL_THREAD_MESSAGE_CREATE_ERROR,
	  updateTextType: actions.MAIL_THREAD_MESSAGE_EDITING_UPDATE_TEXT,
	  expandType: actions.MAIL_THREAD_MESSAGE_EDITING_EXPAND,
	  resetType: actions.MAIL_THREAD_MESSAGE_EDITING_RESET
	});

/***/ },

/***/ "./src/members/state/mail/textEditing/teamMessage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _textEditingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/textEditingMaker.js");
	
	var _textEditingMaker2 = _interopRequireDefault(_textEditingMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _textEditingMaker2.default)({
	  submitType: actions.MAIL_MESSAGE_THE_TEAM,
	  submitSuccessType: actions.MAIL_MESSAGE_THE_TEAM_SUCCESS,
	  submitErrorType: actions.MAIL_MESSAGE_THE_TEAM_ERROR,
	  updateTextType: actions.MAIL_MESSAGE_THE_TEAM_EDITING_UPDATE_TEXT,
	  resetType: actions.MAIL_MESSAGE_THE_TEAM_EDITING_RESET
	});

/***/ },

/***/ "./src/members/state/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	var _reduxForm = __webpack_require__("./node_modules/redux-form/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/search/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/info/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/chat/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("./src/members/state/auth/reducer.js");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__("./src/members/state/user/reducer.js");
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	var _reducer11 = __webpack_require__("./src/members/state/mail/reducer.js");
	
	var _reducer12 = _interopRequireDefault(_reducer11);
	
	var _reducer13 = __webpack_require__("./src/members/state/magazine/reducer.js");
	
	var _reducer14 = _interopRequireDefault(_reducer13);
	
	var _reducer15 = __webpack_require__("./src/members/state/lastTimeRefresh/reducer.js");
	
	var _reducer16 = _interopRequireDefault(_reducer15);
	
	var _reducer17 = __webpack_require__("./src/members/state/categories/reducer.js");
	
	var _reducer18 = _interopRequireDefault(_reducer17);
	
	var _reducer19 = __webpack_require__("./src/members/state/topics/reducer.js");
	
	var _reducer20 = _interopRequireDefault(_reducer19);
	
	var _reducer21 = __webpack_require__("./src/members/state/goals/reducer.js");
	
	var _reducer22 = _interopRequireDefault(_reducer21);
	
	var _reducer23 = __webpack_require__("./src/members/state/journal/reducer.js");
	
	var _reducer24 = _interopRequireDefault(_reducer23);
	
	var _reducer25 = __webpack_require__("./src/members/state/feedback/reducer.js");
	
	var _reducer26 = _interopRequireDefault(_reducer25);
	
	var _reducer27 = __webpack_require__("./src/members/state/comments/reducer.js");
	
	var _reducer28 = _interopRequireDefault(_reducer27);
	
	var _reducer29 = __webpack_require__("./src/members/state/feed/reducer.js");
	
	var _reducer30 = _interopRequireDefault(_reducer29);
	
	var _reducer31 = __webpack_require__("./src/members/state/f2f/reducer.js");
	
	var _reducer32 = _interopRequireDefault(_reducer31);
	
	var _reducer33 = __webpack_require__("./src/members/state/links/reducer.js");
	
	var _reducer34 = _interopRequireDefault(_reducer33);
	
	var _reducer35 = __webpack_require__("./src/members/state/forum/reducer.js");
	
	var _reducer36 = _interopRequireDefault(_reducer35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  form: _reduxForm.reducer,
	  info: _reducer4.default,
	  search: _reducer2.default,
	  routing: _reactRouterRedux.routerReducer,
	  chat: _reducer6.default,
	  auth: _reducer8.default,
	  mail: _reducer12.default,
	  magazine: _reducer14.default,
	  lastTimeRefresh: _reducer16.default,
	  user: _reducer10.default,
	  categories: _reducer18.default,
	  topics: _reducer20.default,
	  goals: _reducer22.default,
	  journal: _reducer24.default,
	  feedback: _reducer26.default,
	  comments: _reducer28.default,
	  feed: _reducer30.default,
	  f2f: _reducer32.default,
	  links: _reducer34.default,
	  forum: _reducer36.default
	});

/***/ },

/***/ "./src/members/state/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.manageDataEvent = manageDataEvent;
	exports.manageConnectionStateEvents = manageConnectionStateEvents;
	exports.watchForEventsFromServer = watchForEventsFromServer;
	exports.refreshListsItems = refreshListsItems;
	exports.default = backgroundSaga;
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	var _selectors = __webpack_require__("./src/members/__shared__/selectors/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _socket = __webpack_require__("./src/members/state/__shared__/socket.js");
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _sagas = __webpack_require__("./src/members/state/__shared__/utils/sagas.js");
	
	var _authStore = __webpack_require__("./src/__shared__/authStore.js");
	
	var _actions2 = __webpack_require__("./src/members/state/__shared__/utils/actions.js");
	
	var _sagas2 = __webpack_require__("./src/members/state/auth/sagas.js");
	
	var _sagas3 = _interopRequireDefault(_sagas2);
	
	var _sagas4 = __webpack_require__("./src/members/state/comments/sagas.js");
	
	var _sagas5 = _interopRequireDefault(_sagas4);
	
	var _sagas6 = __webpack_require__("./src/members/state/mail/sagas.js");
	
	var _sagas7 = _interopRequireDefault(_sagas6);
	
	var _sagas8 = __webpack_require__("./src/members/state/magazine/sagas.js");
	
	var _sagas9 = _interopRequireDefault(_sagas8);
	
	var _sagas10 = __webpack_require__("./src/members/state/user/sagas.js");
	
	var _sagas11 = _interopRequireDefault(_sagas10);
	
	var _sagas12 = __webpack_require__("./src/members/state/journal/sagas.js");
	
	var _sagas13 = _interopRequireDefault(_sagas12);
	
	var _sagas14 = __webpack_require__("./src/members/state/topics/sagas.js");
	
	var _sagas15 = _interopRequireDefault(_sagas14);
	
	var _sagas16 = __webpack_require__("./src/members/state/feedback/sagas.js");
	
	var _sagas17 = _interopRequireDefault(_sagas16);
	
	var _sagas18 = __webpack_require__("./src/members/state/goals/sagas.js");
	
	var _sagas19 = _interopRequireDefault(_sagas18);
	
	var _sagas20 = __webpack_require__("./src/members/state/categories/sagas.js");
	
	var _sagas21 = _interopRequireDefault(_sagas20);
	
	var _sagas22 = __webpack_require__("./src/members/state/f2f/sagas.js");
	
	var _sagas23 = _interopRequireDefault(_sagas22);
	
	var _sagas24 = __webpack_require__("./src/members/state/links/sagas.js");
	
	var _sagas25 = _interopRequireDefault(_sagas24);
	
	var _sagas26 = __webpack_require__("./src/members/state/feed/sagas.js");
	
	var _sagas27 = _interopRequireDefault(_sagas26);
	
	var _sagas28 = __webpack_require__("./src/members/state/search/sagas.js");
	
	var _sagas29 = _interopRequireDefault(_sagas28);
	
	var _sagas30 = __webpack_require__("./src/members/state/info/sagas.js");
	
	var _sagas31 = _interopRequireDefault(_sagas30);
	
	var _sagas32 = __webpack_require__("./src/members/state/chat/sagas.js");
	
	var _sagas33 = _interopRequireDefault(_sagas32);
	
	var _sagas34 = __webpack_require__("./src/members/state/analytics/sagas.js");
	
	var _sagas35 = _interopRequireDefault(_sagas34);
	
	var _analyticsTracker = __webpack_require__("./src/members/state/analytics/analyticsTracker.js");
	
	var _analyticsTracker2 = _interopRequireDefault(_analyticsTracker);
	
	var _sagas36 = __webpack_require__("./src/members/state/forum/sagas.js");
	
	var _sagas37 = _interopRequireDefault(_sagas36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForErrors, manageDataEvent, manageConnectionStateEvents, watchForEventsFromServer, refreshListsItems, watchForCreatedArticlesOrForumThreads, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForErrors() {
	  var action, httpResponse;
	  return regeneratorRuntime.wrap(function watchForErrors$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 20;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)('*');
	
	        case 3:
	          action = _context.sent;
	
	          if (action.error) {
	            _context.next = 6;
	            break;
	          }
	
	          return _context.abrupt('continue', 0);
	
	        case 6:
	          if (!(action.error.showInInfoBar === false)) {
	            _context.next = 8;
	            break;
	          }
	
	          return _context.abrupt('continue', 0);
	
	        case 8:
	          if (!action.type.startsWith('redux-form')) {
	            _context.next = 10;
	            break;
	          }
	
	          return _context.abrupt('continue', 0);
	
	        case 10:
	          if (!action.causedByURLChange) {
	            _context.next = 16;
	            break;
	          }
	
	          httpResponse = action.error.httpResponse;
	
	          if (!(httpResponse && httpResponse.status === 404)) {
	            _context.next = 16;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.put)((0, _reactRouterRedux.push)('/404'));
	
	        case 15:
	          return _context.abrupt('continue', 0);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.put)(actions.infoShow('errors', action.errorMessage));
	
	        case 18:
	          _context.next = 0;
	          break;
	
	        case 20:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function manageDataEvent(event, socket) {
	  var forumStatus, chatMessagesBuffer, dataForChatMessagesNotInBuffer, panel, chatItems, action, lastChatMessageId, lastLiveCommentApprovedTime, questionnaire, _normalize, result, entities, comments, _normalize2, _result, _entities;
	
	  return regeneratorRuntime.wrap(function manageDataEvent$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (!(event.data.path === 'chat.state')) {
	            _context2.next = 8;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _effects.put)(actions.chatStateUpdate(event.data.body));
	
	        case 3:
	          if (!event.data.body.ban) {
	            _context2.next = 6;
	            break;
	          }
	
	          _context2.next = 6;
	          return (0, _effects.call)(_sagas32.refreshChatQueueRejectionExpiration, event.data.body.ban);
	
	        case 6:
	          _context2.next = 82;
	          break;
	
	        case 8:
	          if (!(event.data.path === 'mail.state')) {
	            _context2.next = 13;
	            break;
	          }
	
	          _context2.next = 11;
	          return (0, _effects.call)(_sagas6.refreshMail);
	
	        case 11:
	          _context2.next = 82;
	          break;
	
	        case 13:
	          if (!(event.data.path === 'forum.state')) {
	            _context2.next = 25;
	            break;
	          }
	
	          _context2.next = 16;
	          return (0, _effects.put)(actions.forumStatusUpdate(event.data.body));
	
	        case 16:
	          if (!event.data.body.watching) {
	            _context2.next = 23;
	            break;
	          }
	
	          _context2.next = 19;
	          return (0, _effects.select)(_selectors.getForumStatus);
	
	        case 19:
	          forumStatus = _context2.sent;
	
	          if (forumStatus.localWatchedThreadId) {
	            _context2.next = 23;
	            break;
	          }
	
	          _context2.next = 23;
	          return (0, _effects.put)(actions.forumThreadUnwatch(forumStatus.remoteWatchedThreadId));
	
	        case 23:
	          _context2.next = 82;
	          break;
	
	        case 25:
	          if (!(event.data.path === 'chat.new-messages')) {
	            _context2.next = 35;
	            break;
	          }
	
	          _context2.next = 28;
	          return (0, _effects.select)(_selectors.getChatMessagesBuffer);
	
	        case 28:
	          chatMessagesBuffer = _context2.sent;
	          dataForChatMessagesNotInBuffer = (0, _sagas32.filterUpdatedChatMessages)(event.data.body, chatMessagesBuffer);
	
	          if (!(dataForChatMessagesNotInBuffer.chatMessagesIds.length > 0)) {
	            _context2.next = 33;
	            break;
	          }
	
	          _context2.next = 33;
	          return (0, _effects.put)(actions.chatMessagesUpdate(dataForChatMessagesNotInBuffer));
	
	        case 33:
	          _context2.next = 82;
	          break;
	
	        case 35:
	          if (!(event.data.path === 'chat.active-state')) {
	            _context2.next = 51;
	            break;
	          }
	
	          _context2.next = 38;
	          return (0, _effects.put)(actions.chatActiveStateUpdate(event.data.body));
	
	        case 38:
	          panel = event.data.body.panel;
	
	          if (!panel) {
	            _context2.next = 49;
	            break;
	          }
	
	          _context2.next = 42;
	          return (0, _effects.select)(_selectors.getChatItems);
	
	        case 42:
	          chatItems = _context2.sent;
	          _context2.next = 45;
	          return (0, _effects.call)(_sagas32.manageChatActiveStateUpdate, panel, chatItems);
	
	        case 45:
	          action = _context2.sent;
	
	          if (!action) {
	            _context2.next = 49;
	            break;
	          }
	
	          _context2.next = 49;
	          return (0, _effects.put)(action);
	
	        case 49:
	          _context2.next = 82;
	          break;
	
	        case 51:
	          if (!(event.data.path === 'chat.get-last-seen-message-id')) {
	            _context2.next = 59;
	            break;
	          }
	
	          _context2.next = 54;
	          return (0, _effects.select)(_selectors.getChatLastMessageId);
	
	        case 54:
	          lastChatMessageId = _context2.sent;
	          _context2.next = 57;
	          return (0, _effects.call)([socket, socket.respond], event.data.id, lastChatMessageId);
	
	        case 57:
	          _context2.next = 82;
	          break;
	
	        case 59:
	          if (!(event.data.path === 'forum.get-last-seen-message-time')) {
	            _context2.next = 67;
	            break;
	          }
	
	          _context2.next = 62;
	          return (0, _effects.select)(_selectors.getCommentLiveListLastApprovedTime);
	
	        case 62:
	          lastLiveCommentApprovedTime = _context2.sent;
	          _context2.next = 65;
	          return (0, _effects.call)([socket, socket.respond], event.data.id, lastLiveCommentApprovedTime);
	
	        case 65:
	          _context2.next = 82;
	          break;
	
	        case 67:
	          if (!(event.data.path === 'chat.eos')) {
	            _context2.next = 74;
	            break;
	          }
	
	          questionnaire = event.data.body;
	          _normalize = (0, _normalizr.normalize)(questionnaire, schemas.chatQuestionnaireSchema), result = _normalize.result, entities = _normalize.entities;
	          _context2.next = 72;
	          return (0, _effects.put)(actions.chatQuestionnairesReceived({ chatQuestionnairesIds: result, entities: entities }));
	
	        case 72:
	          _context2.next = 82;
	          break;
	
	        case 74:
	          if (!(event.data.path === 'forum.new-messages')) {
	            _context2.next = 82;
	            break;
	          }
	
	          comments = event.data.body.messages;
	          _normalize2 = (0, _normalizr.normalize)(comments, schemas.commentsArraySchema), _result = _normalize2.result, _entities = _normalize2.entities;
	
	          if (!(comments.length >= (20))) {
	            _context2.next = 80;
	            break;
	          }
	
	          _context2.next = 80;
	          return (0, _effects.put)(actions.commentsResetLiveList());
	
	        case 80:
	          _context2.next = 82;
	          return (0, _effects.put)(actions.commentsReceived({ commentsIds: _result, entities: _entities }, true));
	
	        case 82:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function manageConnectionStateEvents(event) {
	  return regeneratorRuntime.wrap(function manageConnectionStateEvents$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (!(event.type === 'open')) {
	            _context3.next = 5;
	            break;
	          }
	
	          _context3.next = 3;
	          return (0, _effects.put)(actions.infoClose('connectionState'));
	
	        case 3:
	          _context3.next = 7;
	          break;
	
	        case 5:
	          _context3.next = 7;
	          return (0, _effects.put)(actions.infoShow('connectionState', event.statusMessage));
	
	        case 7:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchForEventsFromServer(socket) {
	  var chan, event, auth;
	  return regeneratorRuntime.wrap(function watchForEventsFromServer$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.call)([socket, socket.getEventChannel]);
	
	        case 2:
	          chan = _context4.sent;
	
	        case 3:
	          if (false) {
	            _context4.next = 25;
	            break;
	          }
	
	          _context4.next = 6;
	          return (0, _effects.take)(chan);
	
	        case 6:
	          event = _context4.sent;
	
	          if (!(event.type === 'data')) {
	            _context4.next = 12;
	            break;
	          }
	
	          _context4.next = 10;
	          return (0, _effects.fork)(manageDataEvent, event, socket);
	
	        case 10:
	          _context4.next = 23;
	          break;
	
	        case 12:
	          if (!(_socket.CONNECTION_STATE_EVENTS.indexOf(event.type) >= 0)) {
	            _context4.next = 23;
	            break;
	          }
	
	          _context4.next = 15;
	          return (0, _effects.select)(_selectors.getAuth);
	
	        case 15:
	          auth = _context4.sent;
	
	          if (!(0, _authStore.isTokenValid)(auth)) {
	            _context4.next = 21;
	            break;
	          }
	
	          _context4.next = 19;
	          return (0, _effects.call)(manageConnectionStateEvents, event);
	
	        case 19:
	          _context4.next = 23;
	          break;
	
	        case 21:
	          _context4.next = 23;
	          return (0, _effects.call)(_sagas.navigateToWebsite);
	
	        case 23:
	          _context4.next = 3;
	          break;
	
	        case 25:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function refreshListsItems() {
	  return regeneratorRuntime.wrap(function refreshListsItems$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          if (false) {
	            _context5.next = 7;
	            break;
	          }
	
	          _context5.next = 3;
	          return (0, _effects.call)(_reduxSaga.delay, (60000));
	
	        case 3:
	          _context5.next = 5;
	          return (0, _effects.put)(actions.timeRefresh());
	
	        case 5:
	          _context5.next = 0;
	          break;
	
	        case 7:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function watchForCreatedArticlesOrForumThreads() {
	  return regeneratorRuntime.wrap(function watchForCreatedArticlesOrForumThreads$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          if (false) {
	            _context6.next = 7;
	            break;
	          }
	
	          _context6.next = 3;
	          return (0, _effects.take)([actions.MAGAZINE_ARTICLE_CREATE_SUCCESS, actions.FORUM_THREAD_CREATE_SUCCESS]);
	
	        case 3:
	          _context6.next = 5;
	          return (0, _effects.call)([window, window.scrollTo], 0, 0);
	
	        case 5:
	          _context6.next = 0;
	          break;
	
	        case 7:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}
	
	function backgroundSaga() {
	  var socket, request, boundedFork;
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          socket = new _socket2.default((0, _authStore.getAuthData)().accessToken);
	          request = (0, _sagas.httpRequestSagaMaker)(_actions2.successActionFrom, _actions2.errorActionFrom);
	
	          boundedFork = function boundedFork(saga) {
	            return (0, _effects.fork)(saga, socket, request);
	          };
	
	          _context7.next = 5;
	          return [boundedFork(_sagas3.default), boundedFork(_sagas5.default), boundedFork(_sagas7.default), boundedFork(_sagas9.default), boundedFork(_sagas11.default), boundedFork(_sagas13.default), boundedFork(_sagas15.default), boundedFork(_sagas17.default), boundedFork(_sagas33.default), boundedFork(_sagas19.default), boundedFork(_sagas21.default), boundedFork(_sagas23.default), boundedFork(_sagas27.default), boundedFork(_sagas29.default), boundedFork(_sagas25.default), boundedFork(_sagas37.default), boundedFork(_sagas31.default), (0, _effects.fork)(watchForCreatedArticlesOrForumThreads), (0, _effects.fork)(refreshListsItems), (0, _effects.fork)(watchForEventsFromServer, socket), (0, _effects.fork)(watchForErrors), (0, _effects.fork)(_sagas35.default, _analyticsTracker2.default)];
	
	        case 5:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}

/***/ },

/***/ "./src/members/state/search/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SEARCH_SHOW = exports.SEARCH_SHOW = 'SEARCH_SHOW';
	var searchShow = exports.searchShow = function searchShow() {
	  return { type: SEARCH_SHOW };
	};
	
	var SEARCH_HIDE = exports.SEARCH_HIDE = 'SEARCH_HIDE';
	var searchHide = exports.searchHide = function searchHide() {
	  return { type: SEARCH_HIDE };
	};
	
	var SEARCH_UPDATE_QUERY = exports.SEARCH_UPDATE_QUERY = 'SEARCH_UPDATE_QUERY';
	var searchUpdateQuery = exports.searchUpdateQuery = function searchUpdateQuery(query) {
	  return { type: SEARCH_UPDATE_QUERY, query: query };
	};
	
	var SEARCH_INITIATE = exports.SEARCH_INITIATE = 'SEARCH_INITIATE';
	var searchInitiate = exports.searchInitiate = function searchInitiate(term) {
	  return { type: SEARCH_INITIATE, term: term };
	};
	
	var SEARCH_ITEMS_FETCH = exports.SEARCH_ITEMS_FETCH = 'SEARCH_ITEMS_FETCH';
	var SEARCH_ITEMS_FETCH_SUCCESS = exports.SEARCH_ITEMS_FETCH_SUCCESS = 'SEARCH_ITEMS_FETCH_SUCCESS';
	var SEARCH_ITEMS_FETCH_ERROR = exports.SEARCH_ITEMS_FETCH_ERROR = 'SEARCH_ITEMS_FETCH_ERROR';
	var searchItemsFetch = exports.searchItemsFetch = function searchItemsFetch() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var query = arguments[1];
	  var searchQueryString = arguments[2];
	  return { type: SEARCH_ITEMS_FETCH, page: page, query: query, searchQueryString: searchQueryString };
	};
	
	var SEARCH_RESULTS_RECEIVED = exports.SEARCH_RESULTS_RECEIVED = 'SEARCH_RESULTS_RECEIVED';
	var searchResultsReceived = exports.searchResultsReceived = function searchResultsReceived(page, result, query, searchQueryString) {
	  return { type: SEARCH_RESULTS_RECEIVED, page: page, result: result, query: query, searchQueryString: searchQueryString };
	};
	
	var SEARCH_UPDATE_POSSIBLE_PAGE = exports.SEARCH_UPDATE_POSSIBLE_PAGE = 'SEARCH_UPDATE_POSSIBLE_PAGE';
	var searchUpdatePossiblePage = exports.searchUpdatePossiblePage = function searchUpdatePossiblePage(possiblePage, searchQueryString) {
	  return { type: SEARCH_UPDATE_POSSIBLE_PAGE, possiblePage: possiblePage, searchQueryString: searchQueryString };
	};
	
	var SEARCH_CHANGE_TAB = exports.SEARCH_CHANGE_TAB = 'SEARCH_CHANGE_TAB';
	var searchChangeTab = exports.searchChangeTab = function searchChangeTab(tab) {
	  return { type: SEARCH_CHANGE_TAB, tab: tab };
	};

/***/ },

/***/ "./src/members/state/search/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.searchItemsFetch = searchItemsFetch;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	var _commentsResourceTypes = __webpack_require__("./src/members/__shared__/commentsResourceTypes.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function searchItemsFetch(page, query) {
	  var resourceTypes = '';
	  if (query.category === 'magazine') resourceTypes = (0, _commentsResourceTypes.findRowByCommentsOwnerType)('article');
	  if (query.category === 'forum') resourceTypes = (0, _commentsResourceTypes.findRowByCommentsOwnerType)('forumThread');
	
	  return (0, _api.callApi)('/search', {
	    query: _extends({}, (0, _api.pageToOffsetParams)(page, (10)), {
	      term: query.term,
	      resourceTypes: resourceTypes
	    })
	  }).then(function (json) {
	    var results = json.results,
	        meta = json.meta;
	
	
	    var searchResults = (0, _normalizr.normalize)(results, schemas.searchResultsArraySchema);
	
	    return { searchResults: searchResults, meta: meta };
	  });
	}

/***/ },

/***/ "./src/members/state/search/bar/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  visible: false,
	  query: ''
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.SEARCH_SHOW:
	      return _extends({}, state, { query: '', visible: true });
	
	    case actions.SEARCH_HIDE:
	      return _extends({}, state, { visible: false });
	
	    case actions.SEARCH_UPDATE_QUERY:
	      return _extends({}, state, { query: action.query });
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/search/paging/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/search/paging/results/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  results: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/search/paging/results/byQuery/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _pagingMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/pagingMaker.js");
	
	var _pagingMaker2 = _interopRequireDefault(_pagingMaker);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = (0, _byKeyMaker2.default)('searchQueryString', (0, _pagingMaker2.default)({
	  fetchType: actions.SEARCH_ITEMS_FETCH,
	  fetchSuccessType: actions.SEARCH_RESULTS_RECEIVED,
	  fetchErrorType: actions.SEARCH_ITEMS_FETCH_ERROR,
	  possiblePageUpdateType: actions.SEARCH_UPDATE_POSSIBLE_PAGE
	}));

/***/ },

/***/ "./src/members/state/search/paging/results/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/search/paging/results/byQuery/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byQuery: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/search/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/search/bar/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/search/results/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/search/paging/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("./src/members/state/search/tabs/reducer.js");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  bar: _reducer2.default,
	  results: _reducer4.default,
	  paging: _reducer6.default,
	  tabs: _reducer8.default
	});

/***/ },

/***/ "./src/members/state/search/results/byQuery/byPage/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byPageMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byPageMaker.js");
	
	var _byPageMaker2 = _interopRequireDefault(_byPageMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byPageMaker2.default)([actions.SEARCH_RESULTS_RECEIVED], 'searchResultsIds');

/***/ },

/***/ "./src/members/state/search/results/byQuery/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/search/results/byQuery/byPage/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _byKeyMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byKeyMaker.js");
	
	var _byKeyMaker2 = _interopRequireDefault(_byKeyMaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byKeyMaker2.default)('searchQueryString', (0, _redux.combineReducers)({ byPage: _reducer2.default }));

/***/ },

/***/ "./src/members/state/search/results/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/search/results/byQuery/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byQuery: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/search/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForSearchInitiate = watchForSearchInitiate;
	exports.watchForSearchItemsFetchSuccess = watchForSearchItemsFetchSuccess;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForSearchInitiate, watchForSearchItemsFetchSuccess, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForSearchInitiate() {
	  var action;
	  return regeneratorRuntime.wrap(function watchForSearchInitiate$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)(actions.SEARCH_INITIATE);
	
	        case 3:
	          action = _context.sent;
	
	          if (!(action.term.length >= (3))) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)((0, _reactRouterRedux.push)({ pathname: '/search', search: '?term=' + action.term }));
	
	        case 7:
	          _context.next = 11;
	          break;
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)(actions.infoShow('errors', 'Please try searching for at least 3 characters.'));
	
	        case 11:
	          _context.next = 0;
	          break;
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function watchForSearchItemsFetchSuccess() {
	  var action, searchResults, comments, magazineArticles, forumThreads;
	  return regeneratorRuntime.wrap(function watchForSearchItemsFetchSuccess$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (false) {
	            _context2.next = 21;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _effects.take)(actions.SEARCH_ITEMS_FETCH_SUCCESS);
	
	        case 3:
	          action = _context2.sent;
	          searchResults = action.result.searchResults;
	          comments = searchResults.entities.comments;
	          magazineArticles = searchResults.entities.magazineArticles;
	          forumThreads = searchResults.entities.forumThreads;
	
	          // notify the corresponding byId reducers
	
	          if (!magazineArticles) {
	            _context2.next = 11;
	            break;
	          }
	
	          _context2.next = 11;
	          return (0, _effects.put)(actions.magazineArticlesReceived({
	            magazineArticlesIds: Object.keys(magazineArticles),
	            entities: { magazineArticles: magazineArticles }
	          }));
	
	        case 11:
	          if (!comments) {
	            _context2.next = 14;
	            break;
	          }
	
	          _context2.next = 14;
	          return (0, _effects.put)(actions.commentsReceived({
	            commentsIds: Object.keys(comments),
	            entities: { comments: comments }
	          }));
	
	        case 14:
	          if (!forumThreads) {
	            _context2.next = 17;
	            break;
	          }
	
	          _context2.next = 17;
	          return (0, _effects.put)(actions.forumThreadsReceived({
	            forumThreadsIds: Object.keys(forumThreads),
	            entities: { forumThreads: forumThreads }
	          }));
	
	        case 17:
	          _context2.next = 19;
	          return (0, _effects.put)(actions.searchResultsReceived(action.page, {
	            searchResultsIds: action.result.searchResults.result.map(function (result) {
	              return result.schema + '-' + result.id;
	            }),
	            meta: action.result.meta
	          }, action.query, action.searchQueryString));
	
	        case 19:
	          _context2.next = 0;
	          break;
	
	        case 21:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(watchForSearchInitiate), (0, _effects.fork)(_reduxSaga.takeEvery, actions.SEARCH_ITEMS_FETCH, request(api.searchItemsFetch, 'page', 'query')), (0, _effects.fork)(watchForSearchItemsFetchSuccess)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },

/***/ "./src/members/state/search/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSearchResults = exports.getSearchBarState = exports.getSearchResultsIds = exports.getSearchTotalCounts = exports.getSearchTabs = exports.getSearchPaging = exports.getSearchBar = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // import { createSelector } from 'reselect';
	
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");
	
	var _commentsResourceTypes = __webpack_require__("./src/members/__shared__/commentsResourceTypes.js");
	
	var _comments = __webpack_require__("./src/members/__shared__/selectors/comments.js");
	
	var commentsSelectors = _interopRequireWildcard(_comments);
	
	var _forum = __webpack_require__("./src/members/__shared__/selectors/forum.js");
	
	var forumSelectors = _interopRequireWildcard(_forum);
	
	var _magazine = __webpack_require__("./src/members/__shared__/selectors/magazine.js");
	
	var magazineSelectors = _interopRequireWildcard(_magazine);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mount = (0, _selectors.mountSelectorAt)('search');
	
	var getSearchBar = exports.getSearchBar = mount(function (localState) {
	  return localState.bar;
	});
	
	var getSearchPaging = exports.getSearchPaging = mount(function (localState, key, options) {
	  return (0, _selectors.getPaging)(localState.paging[key], options);
	});
	
	var getSearchTabs = exports.getSearchTabs = mount(function (localState) {
	  return localState.tabs;
	});
	
	var getSearchTotalCounts = exports.getSearchTotalCounts = mount(function (localState, key, term) {
	  var magazineQueryString = JSON.stringify({ term: term, category: 'magazine' });
	  var forumQueryString = JSON.stringify({ term: term, category: 'forum' });
	
	  return {
	    magazineTotalCount: (0, _selectors.getPaging)(localState.paging[key], { queryString: magazineQueryString }).totalCount,
	    forumTotalCount: (0, _selectors.getPaging)(localState.paging[key], { queryString: forumQueryString }).totalCount
	  };
	});
	
	var getSearchResultsIds = exports.getSearchResultsIds = mount(function (localState, props) {
	  var queryString = props.queryString,
	      page = props.page;
	
	  var pagesForQuery = localState.results.byQuery[queryString];
	
	  if (!pagesForQuery) {
	    return [];
	  }
	
	  var searchResultsIds = pagesForQuery.byPage[page];
	
	  if (!searchResultsIds) {
	    return [];
	  }
	
	  return searchResultsIds;
	});
	
	var getSearchBarState = exports.getSearchBarState = function getSearchBarState(state) {
	  return state.search;
	};
	
	var getSearchResults = exports.getSearchResults = (0, _reselect.createSelector)([getSearchResultsIds, magazineSelectors.getMagazineArticlesById, commentsSelectors.getCommentsById, forumSelectors.getForumThreadsById], function (searchItemsNormalized, magazineArticlesById, commentsById, forumThreadsById) {
	  return searchItemsNormalized.map(function (searchItemNormalized) {
	    var _searchItemNormalized = searchItemNormalized.split('-'),
	        _searchItemNormalized2 = _slicedToArray(_searchItemNormalized, 2),
	        resourceType = _searchItemNormalized2[0],
	        resourceId = _searchItemNormalized2[1];
	
	    var finalResourceId = parseInt(resourceId, 10);
	
	    // The API search results with a resourceType which maps to the actual type
	    if (resourceType === 'article') return { article: magazineArticlesById[finalResourceId] };
	    if (resourceType === 'forumThread') return { forumThread: forumThreadsById[finalResourceId] };
	    if ((0, _commentsResourceTypes.isComment)(resourceType)) return { comment: commentsById[finalResourceId] };
	    return {};
	  });
	});

/***/ },

/***/ "./src/members/state/search/tabs/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  selectedTab: '',
	  isFetching: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.SEARCH_ITEMS_FETCH:
	      return _extends({}, state, { selectedTab: '', isFetching: true });
	
	    case actions.SEARCH_ITEMS_FETCH_ERROR:
	      return _extends({}, state, { isFetching: false });
	
	    case actions.SEARCH_RESULTS_RECEIVED:
	      {
	        var hasItems = action.result.meta.count > 0;
	        var tabFromAction = hasItems ? action.query.category : state.selectedTab;
	        var selectedTab = state.selectedTab || tabFromAction;
	        return _extends({}, state, {
	          isFetching: false,
	          selectedTab: selectedTab
	        });
	      }
	
	    case actions.SEARCH_CHANGE_TAB:
	      return _extends({}, state, { selectedTab: action.tab });
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/store.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configureStore = configureStore;
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _sagas = __webpack_require__("./src/members/state/sagas.js");
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(browserHistory, authData, initialState) {
	  var sagaMiddleware = (0, _reduxSaga2.default)();
	
	  var middleware = [(0, _reactRouterRedux.routerMiddleware)(browserHistory), sagaMiddleware];
	
	  var middlewareEnhancer = _redux.applyMiddleware.apply(undefined, middleware);
	
	  if (false) {
	    middlewareEnhancer = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : function (f) {
	      return f;
	    });
	  }
	
	  var store = (0, _redux.createStore)(_reducer2.default, initialState, middlewareEnhancer);
	
	  if (false) {
	    module.hot.accept('./reducer', function () {
	      var nextReducer = require('./reducer').default; // eslint-disable-line global-require
	      store.replaceReducer(nextReducer);
	    });
	  }
	
	  store.dispatch((0, _actions.authUpdate)(authData));
	  sagaMiddleware.run(_sagas2.default);
	
	  return store;
	}

/***/ },

/***/ "./src/members/state/topics/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TOPICS_FETCH = exports.TOPICS_FETCH = 'TOPICS_FETCH';
	var TOPICS_FETCH_SUCCESS = exports.TOPICS_FETCH_SUCCESS = 'TOPICS_FETCH_SUCCESS';
	var TOPICS_FETCH_ERROR = exports.TOPICS_FETCH_ERROR = 'TOPICS_FETCH_ERROR';
	var topicsFetch = exports.topicsFetch = function topicsFetch(topicsType, categoryId) {
	  return { type: TOPICS_FETCH, topicsType: topicsType, categoryId: categoryId };
	};
	
	var TOPIC_UPDATE = exports.TOPIC_UPDATE = 'TOPIC_UPDATE';
	var TOPIC_UPDATE_SUCCESS = exports.TOPIC_UPDATE_SUCCESS = 'TOPIC_UPDATE_SUCCESS';
	var TOPIC_UPDATE_ERROR = exports.TOPIC_UPDATE_ERROR = 'TOPIC_UPDATE_ERROR';
	var topicUpdate = exports.topicUpdate = function topicUpdate(id, updates) {
	  return { type: TOPIC_UPDATE, id: id, updates: updates };
	};
	
	var TOPIC_UPDATE_REVERT = exports.TOPIC_UPDATE_REVERT = 'TOPIC_UPDATE_REVERT';
	var topicUpdateRevert = exports.topicUpdateRevert = function topicUpdateRevert(id, updates) {
	  return { type: TOPIC_UPDATE_REVERT, id: id, updates: updates };
	};

/***/ },

/***/ "./src/members/state/topics/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.topicsFetch = topicsFetch;
	exports.topicUpdate = topicUpdate;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function topicsFetch(type, category) {
	  return (0, _api.callApi)('/topics', {
	    query: {
	      type: type,
	      category: category
	    }
	  }).then(function (json) {
	    var _normalize = (0, _normalizr.normalize)(json, schemas.topicsArraySchema),
	        result = _normalize.result,
	        entities = _normalize.entities;
	
	    return { topicsIds: result, entities: entities };
	  });
	}
	
	function topicUpdate(id, updates) {
	  return (0, _api.callApi)('/topics', {
	    method: 'PATCH',
	    body: _extends({
	      id: id
	    }, updates)
	  });
	}

/***/ },

/***/ "./src/members/state/topics/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.TOPICS_FETCH_SUCCESS],
	  updateSuccessTypes: [actions.TOPIC_UPDATE, actions.TOPIC_UPDATE_REVERT],
	  entityType: 'topics',
	  updateKey: 'id'
	});

/***/ },

/***/ "./src/members/state/topics/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/topics/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default
	});

/***/ },

/***/ "./src/members/state/topics/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForTopicUpdateError = watchForTopicUpdateError;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForTopicUpdateError, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForTopicUpdateError() {
	  var action, updates;
	  return regeneratorRuntime.wrap(function watchForTopicUpdateError$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)(actions.TOPIC_UPDATE_ERROR);
	
	        case 3:
	          action = _context.sent;
	          updates = {
	            interestedIn: !action.updates.interestedIn
	          };
	          _context.next = 7;
	          return (0, _effects.put)(actions.topicUpdateRevert(action.id, updates));
	
	        case 7:
	          _context.next = 0;
	          break;
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.TOPICS_FETCH, request(api.topicsFetch, 'topicsType', 'categoryId')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.TOPIC_UPDATE, request(api.topicUpdate, 'id', 'updates')), (0, _effects.fork)(watchForTopicUpdateError)];
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },

/***/ "./src/members/state/topics/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTopics = exports.getTopicById = undefined;
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var mount = (0, _selectors.mountSelectorAt)('topics');
	
	var getTopicById = exports.getTopicById = mount(function (localState, topicId) {
	  return localState.byId[topicId];
	});
	
	var getTopics = exports.getTopics = mount(function (localState, categoryId, rootState) {
	  if (!categoryId) {
	    return [];
	  }
	
	  return Object.keys(localState.byId).map(function (topicId) {
	    return getTopicById(rootState, topicId);
	  }).filter(function (topic) {
	    return topic.categoryId == categoryId;
	  }).sort(function (topic1, topic2) {
	    return topic1.title.localeCompare(topic2.title);
	  });
	});

/***/ },

/***/ "./src/members/state/user/actions.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var USER_UPDATE = exports.USER_UPDATE = 'USER_UPDATE';
	var USER_UPDATE_SUCCESS = exports.USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
	var USER_UPDATE_ERROR = exports.USER_UPDATE_ERROR = 'USER_UPDATE_ERROR';
	var userUpdate = exports.userUpdate = function userUpdate(updates) {
	  var showInInfoBar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  var avatarUrl = arguments[2];
	  var successMessage = arguments[3];
	  return {
	    type: USER_UPDATE,
	    updates: updates,
	    errorOptions: { showInInfoBar: showInInfoBar },
	    avatarUrl: avatarUrl,
	    successMessage: successMessage
	  };
	};
	
	var USER_UPDATE_RESET = exports.USER_UPDATE_RESET = 'USER_UPDATE_RESET';
	var userUpdateReset = exports.userUpdateReset = function userUpdateReset() {
	  return { type: USER_UPDATE_RESET };
	};
	
	var USER_AVATARS_FETCH = exports.USER_AVATARS_FETCH = 'USER_AVATARS_FETCH';
	var USER_AVATARS_FETCH_SUCCESS = exports.USER_AVATARS_FETCH_SUCCESS = 'USER_AVATARS_FETCH_SUCCESS';
	var USER_AVATARS_FETCH_ERROR = exports.USER_AVATARS_FETCH_ERROR = 'USER_AVATARS_FETCH_ERROR';
	var userAvatarsFetch = exports.userAvatarsFetch = function userAvatarsFetch() {
	  return { type: USER_AVATARS_FETCH };
	};
	
	var USER_AVATARS_CHANGE_ACTIVE = exports.USER_AVATARS_CHANGE_ACTIVE = 'USER_AVATARS_CHANGE_ACTIVE';
	var userAvatarsChangeActive = exports.userAvatarsChangeActive = function userAvatarsChangeActive(avatarId) {
	  return { type: USER_AVATARS_CHANGE_ACTIVE, avatarId: avatarId };
	};

/***/ },

/***/ "./src/members/state/user/api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.userReferrersFetch = userReferrersFetch;
	exports.userEthnicitiesFetch = userEthnicitiesFetch;
	exports.userLocalAuthoritiesFetch = userLocalAuthoritiesFetch;
	exports.userLocationsFetch = userLocationsFetch;
	exports.userAvatarsFetch = userAvatarsFetch;
	exports.userSignupQuestionnaireFetch = userSignupQuestionnaireFetch;
	exports.userVerifyEmail = userVerifyEmail;
	exports.userValidateToken = userValidateToken;
	exports.userCheckUsername = userCheckUsername;
	exports.userCheckPassword = userCheckPassword;
	exports.userUpdate = userUpdate;
	exports.userCreate = userCreate;
	
	var _normalizr = __webpack_require__("./node_modules/normalizr/lib/index.js");
	
	var _schemas = __webpack_require__("./src/members/state/__shared__/schemas.js");
	
	var schemas = _interopRequireWildcard(_schemas);
	
	var _api = __webpack_require__("./src/members/state/__shared__/utils/api.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function userReferrersFetch() {
	  return (0, _api.callApi)('/user/referrers');
	}
	
	function userEthnicitiesFetch() {
	  return (0, _api.callApi)('/user/ethnicities');
	}
	
	function userLocalAuthoritiesFetch() {
	  return (0, _api.callApi)('/user/local-authorities');
	}
	
	function userLocationsFetch(location) {
	  return (0, _api.callApi)('/user/location', {
	    query: {
	      location: location
	    }
	  });
	}
	
	function userAvatarsFetch() {
	  return (0, _api.callApi)('/user/avatars').then(function (json) {
	    var _normalize = (0, _normalizr.normalize)(json, schemas.userAvatarsArraySchema),
	        result = _normalize.result,
	        entities = _normalize.entities;
	
	    return { userAvatarIds: result, entities: entities };
	  });
	}
	
	function userSignupQuestionnaireFetch(LAID) {
	  return (0, _api.callApi)('/user/registration/questionnaire', {
	    query: {
	      LAID: LAID
	    }
	  });
	}
	
	function userVerifyEmail(email) {
	  return (0, _api.callApi)('/user/email-verification', {
	    query: {
	      email: email
	    }
	  });
	}
	
	function userValidateToken(token) {
	  return (0, _api.callApi)('/user/validate-token', {
	    query: {
	      token: token
	    }
	  });
	}
	
	function userCheckUsername(userName) {
	  return (0, _api.callApi)('/user/check-username', {
	    query: {
	      userName: userName
	    }
	  });
	}
	
	function userCheckPassword(passWord) {
	  return (0, _api.callApi)('/user/check-password', {
	    query: {
	      passWord: passWord
	    }
	  });
	}
	
	function userUpdate(updates) {
	  return (0, _api.callApi)('/user', {
	    method: 'PATCH',
	    body: _extends({}, updates)
	  });
	}
	
	function userCreate(_ref) {
	  var userName = _ref.userName,
	      passWord = _ref.passWord,
	      sublocationId = _ref.sublocationId,
	      sex = _ref.sex,
	      ethnicity = _ref.ethnicity,
	      yearOfBirth = _ref.yearOfBirth,
	      monthOfBirth = _ref.monthOfBirth,
	      referrer = _ref.referrer,
	      startYear = _ref.startYear,
	      startMonth = _ref.startMonth,
	      endYear = _ref.endYear,
	      endMonth = _ref.endMonth,
	      token = _ref.token,
	      questionnaire = _ref.questionnaire;
	
	
	  var body = {
	    userName: userName,
	    passWord: passWord,
	    sublocationId: sublocationId,
	    sex: sex,
	    ethnicity: ethnicity,
	    yearOfBirth: yearOfBirth,
	    monthOfBirth: monthOfBirth,
	    referrer: referrer
	  };
	
	  if (startYear !== undefined) body.startYear = startYear;
	  if (startMonth !== undefined) body.startMonth = startMonth;
	  if (endYear !== undefined) body.endYear = endYear;
	  if (endMonth !== undefined) body.endMonth = endMonth;
	  if (token !== undefined) body.token = token;
	  if ((typeof questionnaire === 'undefined' ? 'undefined' : _typeof(questionnaire)) === Object) body.questionnaire = questionnaire;
	
	  return (0, _api.callApi)('/user', {
	    method: 'POST',
	    body: body
	  });
	}

/***/ },

/***/ "./src/members/state/user/avatarSelection/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  isFetching: false,
	  isSubmitting: false,
	  initialAvatarId: null,
	  selectedAvatarId: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.AUTH_UPDATE:
	      {
	        var currentUserAvatarId = action.authData.user.avatar.id;
	        return _extends({}, state, {
	          selectedAvatarId: currentUserAvatarId,
	          initialAvatarId: currentUserAvatarId
	        });
	      }
	
	    case actions.USER_UPDATE_SUCCESS:
	      {
	        var avatarChanged = action.updates.avatar !== undefined;
	        var _currentUserAvatarId = avatarChanged ? action.updates.avatar : state.initialAvatarId;
	        return _extends({}, state, {
	          isSubmitting: false,
	          initialAvatarId: _currentUserAvatarId,
	          selectedAvatarId: _currentUserAvatarId
	        });
	      }
	
	    case actions.USER_AVATARS_FETCH:
	      {
	        return _extends({}, state, {
	          isFetching: true
	        });
	      }
	
	    case actions.USER_AVATARS_FETCH_SUCCESS:
	      {
	        var initialAvatarId = state.initialAvatarId;
	        return _extends({}, state, {
	          isFetching: false,
	          selectedAvatarId: initialAvatarId
	        });
	      }
	    case actions.USER_AVATARS_FETCH_ERROR:
	      {
	        return _extends({}, state, {
	          isFetching: false
	        });
	      }
	
	    case actions.USER_AVATARS_CHANGE_ACTIVE:
	      {
	        return _extends({}, state, {
	          selectedAvatarId: action.avatarId
	        });
	      }
	
	    case actions.USER_UPDATE:
	      {
	        return _extends({}, state, {
	          isSubmitting: true
	        });
	      }
	
	    case actions.USER_UPDATE_ERROR:
	      {
	        return _extends({}, state, {
	          isSubmitting: false
	        });
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/user/avatars/byId/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _byIdMaker = __webpack_require__("./src/members/state/__shared__/reducersMakers/byIdMaker.js");
	
	var _byIdMaker2 = _interopRequireDefault(_byIdMaker);
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _byIdMaker2.default)({
	  fetchSuccessTypes: [actions.USER_AVATARS_FETCH_SUCCESS],
	  resetType: actions.USER_AVATARS_FETCH,
	  entityType: 'userAvatars'
	});

/***/ },

/***/ "./src/members/state/user/avatars/ids/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = [];
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.USER_AVATARS_FETCH:
	      {
	        return INITIAL_STATE;
	      }
	
	    case actions.USER_AVATARS_FETCH_SUCCESS:
	      {
	        return action.result.userAvatarIds;
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/user/avatars/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/user/avatars/byId/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/user/avatars/ids/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  byId: _reducer2.default,
	  ids: _reducer4.default
	});

/***/ },

/***/ "./src/members/state/user/passwordUpdate/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = {
	  isPasswordUpdating: false,
	  serverPasswordError: ''
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.USER_UPDATE:
	      {
	        return _extends({}, state, {
	          isPasswordUpdating: true
	        });
	      }
	
	    case actions.USER_UPDATE_SUCCESS:
	      {
	        return _extends({}, state, {
	          isPasswordUpdating: false,
	          serverPasswordError: ''
	        });
	      }
	    case actions.USER_UPDATE_ERROR:
	      {
	        return _extends({}, state, {
	          isPasswordUpdating: false,
	          serverPasswordError: action.error ? action.error.message : ''
	        });
	      }
	
	    case actions.USER_UPDATE_RESET:
	      {
	        return INITIAL_STATE;
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/user/profile/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var INITIAL_STATE = null;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.AUTH_UPDATE:
	      {
	        return action.authData.user;
	      }
	
	    case actions.USER_UPDATE_SUCCESS:
	      {
	        if (action.updates.avatar) {
	          return _extends({}, state, {
	            avatar: {
	              id: action.updates.avatar,
	              url: action.avatarUrl
	            }
	          });
	        }
	
	        return state;
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },

/***/ "./src/members/state/user/reducer.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _reducer = __webpack_require__("./src/members/state/user/profile/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__("./src/members/state/user/passwordUpdate/reducer.js");
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__("./src/members/state/user/avatars/reducer.js");
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__("./src/members/state/user/avatarSelection/reducer.js");
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  profile: _reducer2.default,
	  passwordUpdate: _reducer4.default,
	  avatars: _reducer6.default,
	  avatarSelection: _reducer8.default
	});

/***/ },

/***/ "./src/members/state/user/sagas.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchForUserUpdate = watchForUserUpdate;
	exports.default = backgroundSaga;
	
	var _effects = __webpack_require__("./node_modules/redux-saga/effects.js");
	
	var _reactRouterRedux = __webpack_require__("./node_modules/react-router-redux/lib/index.js");
	
	var _reduxForm = __webpack_require__("./node_modules/redux-form/lib/index.js");
	
	var _reduxSaga = __webpack_require__("./node_modules/redux-saga/lib/index.js");
	
	var _actions = __webpack_require__("./src/members/__shared__/actions.js");
	
	var actions = _interopRequireWildcard(_actions);
	
	var _api = __webpack_require__("./src/__shared__/api.js");
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchForUserUpdate, backgroundSaga].map(regeneratorRuntime.mark);
	
	function watchForUserUpdate() {
	  var action;
	  return regeneratorRuntime.wrap(function watchForUserUpdate$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 17;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.take)(actions.USER_UPDATE_SUCCESS);
	
	        case 3:
	          action = _context.sent;
	
	          if (!action.updates) {
	            _context.next = 15;
	            break;
	          }
	
	          if (!action.updates.avatar) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 8;
	          return (0, _effects.put)((0, _reactRouterRedux.push)('/settings'));
	
	        case 8:
	          _context.next = 15;
	          break;
	
	        case 10:
	          if (!action.updates.passWord) {
	            _context.next = 15;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.put)(actions.infoShow('success', action.successMessage));
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)((0, _reduxForm.reset)('userSettings'));
	
	        case 15:
	          _context.next = 0;
	          break;
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function backgroundSaga(socket, request) {
	  return regeneratorRuntime.wrap(function backgroundSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return [(0, _effects.fork)(_reduxSaga.takeLatest, actions.USER_UPDATE, request(api.userUpdate, 'updates')), (0, _effects.fork)(_reduxSaga.takeLatest, actions.USER_AVATARS_FETCH, request(api.userAvatarsFetch, 'avatars')), (0, _effects.fork)(watchForUserUpdate)];
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },

/***/ "./src/members/state/user/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUserAvatars = exports.getUserAvatarSelection = exports.getUserProfile = exports.getUserPasswordUpdate = undefined;
	
	var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var mount = (0, _selectors.mountSelectorAt)('user');
	
	var getUserPasswordUpdate = exports.getUserPasswordUpdate = mount(function (localState) {
	  return localState.passwordUpdate;
	});
	
	var getUserProfile = exports.getUserProfile = mount(function (localState) {
	  return localState.profile;
	});
	
	var getUserAvatarSelection = exports.getUserAvatarSelection = mount(function (localState) {
	  return localState.avatarSelection;
	});
	
	var getUserAvatarsById = mount(function (localState) {
	  return localState.avatars.byId;
	});
	
	var getUserAvatarsIds = mount(function (localState) {
	  return localState.avatars.ids;
	});
	
	var getUserAvatars = exports.getUserAvatars = (0, _reselect.createSelector)([getUserAvatarsById, getUserAvatarsIds], function (userAvatarsById, userAvatarsIds) {
	  return userAvatarsIds.map(function (key) {
	    return userAvatarsById[key];
	  });
	});

/***/ },

/***/ "./src/__shared__/styles/Button.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/__shared__/styles/Link.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/__shared__/styles/MainFooter.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatBubble/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatResources/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatFeedback/ChatFeedbackQuestion/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatFeedback/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/ChatDocument/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/ChatGoals/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/ChatMessage/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/ChatWebsite/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatItems/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatTextInput/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatWindow/ChatWritingIndicator/styles.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/ChatWindow/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Feed/FeedButtonItem/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Feed/FeedGoals/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Feed/FeedQuestionnaire/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Feed/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Feedback/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Forum/ForumAskKooth/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Forum/ForumFilteredThreadsList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Forum/ForumLiveThreadLobby/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Forum/ForumLiveThreadsList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Forum/ForumThreadProfile/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Forum/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Interests/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Journal/JournalEntry/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Journal/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Links/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Magazine/MagazineArticleProfile/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Magazine/MagazineArticlesList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Magazine/MagazineCategories/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Magazine/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Mail/MailTeamMessageEditor/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessageEditor/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Mail/MailThreadMessagesList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/ChatInfo/ChatInfoScheduledSession/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/ChatInfo/ChatState/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/ChatInfo/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/MailThreadsListHeader/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Mail/MailThreadsList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Mail/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/MainNavigation/MainNavigationDropdownHeader/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/MainNavigation/MainNavigationItem/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/MainNavigation/MainNavigationSearchBar/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/MainNavigation/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/More/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/ReferralFormProviderList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Referral/ReferralForm/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/Search/SearchComment/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/UserGoals/UserGoalsAddGoal/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/UserGoals/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/UserSettings/UserSettingsAvatarHeader/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/UserSettings/UserSettingsChangeAvatar/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/UserSettings/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/Accordion/AccordionCheckbox/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/Accordion/AccordionItem/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/Accordion/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/ArticleOuter/Article/ArticleImage/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/ArticleOuter/Article/ArticlePreview/ArticleMeta/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/ArticleOuter/Article/ArticlePreview/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/ArticleOuter/Article/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/ArticleOuter/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/CommentsList/Comment/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/CommentsList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/Contribute/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/DateInput/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/DetailLabel/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/Emojis/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/EmptyArticle/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/InfoBar/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/NoEntries/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/PageSelector/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/Questionnaire/QuestionnaireQuestion/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/Questionnaire/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/RepliesList/RepliesListContentMain/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/RepliesList/RepliesListContentSticky/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/RepliesList/Reply/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/RepliesList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/ResourcesList/Resource/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/ResourcesList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/ResourcesListLoading/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/Sidebar/SidebarGroup/SidebarGroupItem/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/Sidebar/SidebarGroup/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/Sidebar/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/SubNavigation/SubNavigationItem/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/SubNavigation/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/TextArea/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/TextEditor/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/components/UserAvatar/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/containers/ForumThreadsList/ForumThread/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/containers/ForumThreadsList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/containers/Goals/Goal/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/containers/Goals/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/containers/JournalEntryForm/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/Main/__shared__/containers/ResourceCommentsList/style.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./src/members/members.scss":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ "./assets/favicons/favicon.ico":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "favicon.ico";

/***/ },

/***/ "./src/.modernizrrc":
/***/ function(module, exports) {

	;(function(window){
	/*! modernizr 3.3.1 (Custom Build) | MIT *
	 * http://modernizr.com/download/?-inputtypes !*/
	!function(e,t,n){function o(e,t){return typeof e===t}function i(){var e,t,n,i,a,l,u;for(var c in s)if(s.hasOwnProperty(c)){if(e=[],t=s[c],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(i=o(t.fn,"function")?t.fn():t.fn,a=0;a<e.length;a++)l=e[a],u=l.split("."),1===u.length?Modernizr[u[0]]=i:(!Modernizr[u[0]]||Modernizr[u[0]]instanceof Boolean||(Modernizr[u[0]]=new Boolean(Modernizr[u[0]])),Modernizr[u[0]][u[1]]=i),r.push((i?"":"no-")+u.join("-"))}}function a(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):c?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}var s=[],l={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){s.push({name:e,fn:t,options:n})},addAsyncTest:function(e){s.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var r=[],u=t.documentElement,c="svg"===u.nodeName.toLowerCase(),f=a("input"),p="search tel url email datetime date month week time datetime-local number range color".split(" "),d={};Modernizr.inputtypes=function(e){for(var o,i,a,s=e.length,l="1)",r=0;s>r;r++)f.setAttribute("type",o=e[r]),a="text"!==f.type&&"style"in f,a&&(f.value=l,f.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(o)&&f.style.WebkitAppearance!==n?(u.appendChild(f),i=t.defaultView,a=i.getComputedStyle&&"textfield"!==i.getComputedStyle(f,null).WebkitAppearance&&0!==f.offsetHeight,u.removeChild(f)):/^(search|tel)$/.test(o)||(a=/^(url|email)$/.test(o)?f.checkValidity&&f.checkValidity()===!1:f.value!=l)),d[e[r]]=!!a;return d}(p),i(),delete l.addTest,delete l.addAsyncTest;for(var m=0;m<Modernizr._q.length;m++)Modernizr._q[m]();e.Modernizr=Modernizr}(window,document);
	module.exports = window.Modernizr;
	})(window);

/***/ },

/***/ "./src/members/state/comments/selectors.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCommentsSort = exports.getCommentById = exports.getCommentsEmojis = exports.getCommentsTextEditing = exports.getNestedCommentsPagingState = exports.getCommentsPaging = exports.getCommentLiveListLastApprovedTime = exports.getCommentsIsLiveListEndReached = exports.getOldestLiveComment = exports.getNewestLiveComment = exports.getComments = exports.getCommentsById = exports.getCommentsIds = undefined;
	
	var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");
	
	var _selectors = __webpack_require__("./src/members/state/__shared__/utils/selectors.js");
	
	var mount = (0, _selectors.mountSelectorAt)('comments');
	
	var getCommentsIds = exports.getCommentsIds = mount(function (localState, props) {
	  var queryString = props.queryString,
	      page = props.page,
	      live = props.live;
	
	
	  if (live) {
	    return localState.live.list;
	  }
	
	  var pagesForQuery = localState.byQuery[queryString];
	  if (!pagesForQuery) return [];
	
	  var commentsIds = pagesForQuery.byPage[page];
	  if (!commentsIds) return [];
	
	  return commentsIds;
	});
	
	var getCommentsById = exports.getCommentsById = mount(function (localState) {
	  return localState.byId;
	});
	
	var getComments = exports.getComments = (0, _reselect.createSelector)([getCommentsIds, getCommentsById], function (commentsIds, commentsById) {
	
	  return commentsIds.map(function (commentId) {
	    return commentsById[commentId];
	  });
	});
	
	var getNewestLiveComment = exports.getNewestLiveComment = mount(function (localState, rootState) {
	  var comments = getComments(rootState, { live: true });
	  return comments.length > 0 ? comments[0] : null;
	});
	
	var getOldestLiveComment = exports.getOldestLiveComment = mount(function (localState, rootState) {
	  var comments = getComments(rootState, { live: true });
	  return comments.length > 0 ? comments[comments.length - 1] : null;
	});
	
	var getCommentsIsLiveListEndReached = exports.getCommentsIsLiveListEndReached = mount(function (localState) {
	  return localState.live.endReached;
	});
	
	var getCommentLiveListLastApprovedTime = exports.getCommentLiveListLastApprovedTime = mount(function (localState, rootState) {
	  return getNewestLiveComment(rootState) || 0;
	});
	
	var getCommentsPaging = exports.getCommentsPaging = mount(function (localState, key, options) {
	  return (0, _selectors.getPaging)(localState.paging, options);
	});
	
	var getNestedCommentsPagingState = exports.getNestedCommentsPagingState = mount(function (localState) {
	  return localState.paging.byQuery;
	});
	
	var getCommentsTextEditing = exports.getCommentsTextEditing = mount(function (localState, key) {
	  return (0, _selectors.getTextEditing)(localState.textEditing[key]);
	});
	
	var getCommentsEmojis = exports.getCommentsEmojis = mount(function (localState, key) {
	  return localState.emojis[key];
	});
	
	var getCommentById = exports.getCommentById = mount(function (localState, id) {
	  return localState.byId[id];
	});
	
	var getCommentsSort = exports.getCommentsSort = mount(function (localState) {
	  return localState.sort;
	});

/***/ }

});


/** WEBPACK FOOTER **
 ** members.bundle.3cbaae58845518a814e6.js
 **/